function PxLoaderImage(e, t, n, i) {
    var r = this, a = null;
    this.img = new Image(), void 0 !== i && (this.img.crossOrigin = i), this.tags = t, 
    this.priority = n;
    var o = function() {
        "complete" === r.img.readyState && (u(), a.onLoad(r));
    }, s = function() {
        u(), a.onLoad(r);
    }, c = function() {
        u(), a.onError(r);
    }, u = function() {
        r.unbind("load", s), r.unbind("readystatechange", o), r.unbind("error", c);
    };
    this.start = function(t) {
        a = t, r.bind("load", s), r.bind("readystatechange", o), r.bind("error", c), r.img.src = e;
    }, this.checkStatus = function() {
        r.img.complete && (u(), a.onLoad(r));
    }, this.onTimeout = function() {
        u(), r.img.complete ? a.onLoad(r) : a.onTimeout(r);
    }, this.getName = function() {
        return e;
    }, this.bind = function(e, t) {
        r.img.addEventListener ? r.img.addEventListener(e, t, !1) : r.img.attachEvent && r.img.attachEvent("on" + e, t);
    }, this.unbind = function(e, t) {
        r.img.removeEventListener ? r.img.removeEventListener(e, t, !1) : r.img.detachEvent && r.img.detachEvent("on" + e, t);
    };
}

!function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.moment = t();
}(this, function() {
    "use strict";
    function e() {
        return zn.apply(null, arguments);
    }
    function t(e) {
        zn = e;
    }
    function n(e) {
        return "[object Array]" === Object.prototype.toString.call(e);
    }
    function i(e) {
        return e instanceof Date || "[object Date]" === Object.prototype.toString.call(e);
    }
    function r(e, t) {
        var n, i = [];
        for (n = 0; n < e.length; ++n) i.push(t(e[n], n));
        return i;
    }
    function a(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }
    function o(e, t) {
        for (var n in t) a(t, n) && (e[n] = t[n]);
        return a(t, "toString") && (e.toString = t.toString), a(t, "valueOf") && (e.valueOf = t.valueOf), 
        e;
    }
    function s(e, t, n, i) {
        return Me(e, t, n, i, !0).utc();
    }
    function c() {
        return {
            empty: !1,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: !1,
            invalidMonth: null,
            invalidFormat: !1,
            userInvalidated: !1,
            iso: !1
        };
    }
    function u(e) {
        return null == e._pf && (e._pf = c()), e._pf;
    }
    function l(e) {
        if (null == e._isValid) {
            var t = u(e);
            e._isValid = !(isNaN(e._d.getTime()) || !(t.overflow < 0) || t.empty || t.invalidMonth || t.invalidWeekday || t.nullInput || t.invalidFormat || t.userInvalidated), 
            e._strict && (e._isValid = e._isValid && 0 === t.charsLeftOver && 0 === t.unusedTokens.length && void 0 === t.bigHour);
        }
        return e._isValid;
    }
    function f(e) {
        var t = s(NaN);
        return null != e ? o(u(t), e) : u(t).userInvalidated = !0, t;
    }
    function d(e, t) {
        var n, i, r;
        if ("undefined" != typeof t._isAMomentObject && (e._isAMomentObject = t._isAMomentObject), 
        "undefined" != typeof t._i && (e._i = t._i), "undefined" != typeof t._f && (e._f = t._f), 
        "undefined" != typeof t._l && (e._l = t._l), "undefined" != typeof t._strict && (e._strict = t._strict), 
        "undefined" != typeof t._tzm && (e._tzm = t._tzm), "undefined" != typeof t._isUTC && (e._isUTC = t._isUTC), 
        "undefined" != typeof t._offset && (e._offset = t._offset), "undefined" != typeof t._pf && (e._pf = u(t)), 
        "undefined" != typeof t._locale && (e._locale = t._locale), In.length > 0) for (n in In) i = In[n], 
        r = t[i], "undefined" != typeof r && (e[i] = r);
        return e;
    }
    function h(t) {
        d(this, t), this._d = new Date(null != t._d ? t._d.getTime() : NaN), jn === !1 && (jn = !0, 
        e.updateOffset(this), jn = !1);
    }
    function p(e) {
        return e instanceof h || null != e && null != e._isAMomentObject;
    }
    function m(e) {
        return e < 0 ? Math.ceil(e) : Math.floor(e);
    }
    function g(e) {
        var t = +e, n = 0;
        return 0 !== t && isFinite(t) && (n = m(t)), n;
    }
    function v(e, t, n) {
        var i, r = Math.min(e.length, t.length), a = Math.abs(e.length - t.length), o = 0;
        for (i = 0; i < r; i++) (n && e[i] !== t[i] || !n && g(e[i]) !== g(t[i])) && o++;
        return o + a;
    }
    function y() {}
    function A(e) {
        return e ? e.toLowerCase().replace("_", "-") : e;
    }
    function _(e) {
        for (var t, n, i, r, a = 0; a < e.length; ) {
            for (r = A(e[a]).split("-"), t = r.length, n = A(e[a + 1]), n = n ? n.split("-") : null; t > 0; ) {
                if (i = b(r.slice(0, t).join("-"))) return i;
                if (n && n.length >= t && v(r, n, !0) >= t - 1) break;
                t--;
            }
            a++;
        }
        return null;
    }
    function b(e) {
        var t = null;
        if (!Bn[e] && "undefined" != typeof module && module && module.exports) try {
            t = Ln._abbr, require("./locale/" + e), T(t);
        } catch (n) {}
        return Bn[e];
    }
    function T(e, t) {
        var n;
        return e && (n = "undefined" == typeof t ? w(e) : x(e, t), n && (Ln = n)), Ln._abbr;
    }
    function x(e, t) {
        return null !== t ? (t.abbr = e, Bn[e] = Bn[e] || new y(), Bn[e].set(t), T(e), Bn[e]) : (delete Bn[e], 
        null);
    }
    function w(e) {
        var t;
        if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e) return Ln;
        if (!n(e)) {
            if (t = b(e)) return t;
            e = [ e ];
        }
        return _(e);
    }
    function k(e, t) {
        var n = e.toLowerCase();
        Rn[n] = Rn[n + "s"] = Rn[t] = e;
    }
    function E(e) {
        return "string" == typeof e ? Rn[e] || Rn[e.toLowerCase()] : void 0;
    }
    function S(e) {
        var t, n, i = {};
        for (n in e) a(e, n) && (t = E(n), t && (i[t] = e[n]));
        return i;
    }
    function M(t, n) {
        return function(i) {
            return null != i ? (P(this, t, i), e.updateOffset(this, n), this) : C(this, t);
        };
    }
    function C(e, t) {
        return e._d["get" + (e._isUTC ? "UTC" : "") + t]();
    }
    function P(e, t, n) {
        return e._d["set" + (e._isUTC ? "UTC" : "") + t](n);
    }
    function D(e, t) {
        var n;
        if ("object" == typeof e) for (n in e) this.set(n, e[n]); else if (e = E(e), "function" == typeof this[e]) return this[e](t);
        return this;
    }
    function O(e, t, n) {
        var i = "" + Math.abs(e), r = t - i.length, a = e >= 0;
        return (a ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, r)).toString().substr(1) + i;
    }
    function N(e, t, n, i) {
        var r = i;
        "string" == typeof i && (r = function() {
            return this[i]();
        }), e && (Wn[e] = r), t && (Wn[t[0]] = function() {
            return O(r.apply(this, arguments), t[1], t[2]);
        }), n && (Wn[n] = function() {
            return this.localeData().ordinal(r.apply(this, arguments), e);
        });
    }
    function z(e) {
        return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
    }
    function L(e) {
        var t, n, i = e.match(Fn);
        for (t = 0, n = i.length; t < n; t++) Wn[i[t]] ? i[t] = Wn[i[t]] : i[t] = z(i[t]);
        return function(r) {
            var a = "";
            for (t = 0; t < n; t++) a += i[t] instanceof Function ? i[t].call(r, e) : i[t];
            return a;
        };
    }
    function I(e, t) {
        return e.isValid() ? (t = j(t, e.localeData()), qn[t] = qn[t] || L(t), qn[t](e)) : e.localeData().invalidDate();
    }
    function j(e, t) {
        function n(e) {
            return t.longDateFormat(e) || e;
        }
        var i = 5;
        for (Yn.lastIndex = 0; i >= 0 && Yn.test(e); ) e = e.replace(Yn, n), Yn.lastIndex = 0, 
        i -= 1;
        return e;
    }
    function B(e) {
        return "function" == typeof e && "[object Function]" === Object.prototype.toString.call(e);
    }
    function R(e, t, n) {
        ri[e] = B(t) ? t : function(e) {
            return e && n ? n : t;
        };
    }
    function F(e, t) {
        return a(ri, e) ? ri[e](t._strict, t._locale) : new RegExp(Y(e));
    }
    function Y(e) {
        return e.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(e, t, n, i, r) {
            return t || n || i || r;
        }).replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function q(e, t) {
        var n, i = t;
        for ("string" == typeof e && (e = [ e ]), "number" == typeof t && (i = function(e, n) {
            n[t] = g(e);
        }), n = 0; n < e.length; n++) ai[e[n]] = i;
    }
    function W(e, t) {
        q(e, function(e, n, i, r) {
            i._w = i._w || {}, t(e, i._w, i, r);
        });
    }
    function H(e, t, n) {
        null != t && a(ai, e) && ai[e](t, n._a, n, e);
    }
    function V(e, t) {
        return new Date(Date.UTC(e, t + 1, 0)).getUTCDate();
    }
    function G(e) {
        return this._months[e.month()];
    }
    function U(e) {
        return this._monthsShort[e.month()];
    }
    function X(e, t, n) {
        var i, r, a;
        for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), 
        i = 0; i < 12; i++) {
            if (r = s([ 2e3, i ]), n && !this._longMonthsParse[i] && (this._longMonthsParse[i] = new RegExp("^" + this.months(r, "").replace(".", "") + "$", "i"), 
            this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(r, "").replace(".", "") + "$", "i")), 
            n || this._monthsParse[i] || (a = "^" + this.months(r, "") + "|^" + this.monthsShort(r, ""), 
            this._monthsParse[i] = new RegExp(a.replace(".", ""), "i")), n && "MMMM" === t && this._longMonthsParse[i].test(e)) return i;
            if (n && "MMM" === t && this._shortMonthsParse[i].test(e)) return i;
            if (!n && this._monthsParse[i].test(e)) return i;
        }
    }
    function K(e, t) {
        var n;
        return "string" == typeof t && (t = e.localeData().monthsParse(t), "number" != typeof t) ? e : (n = Math.min(e.date(), V(e.year(), t)), 
        e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, n), e);
    }
    function $(t) {
        return null != t ? (K(this, t), e.updateOffset(this, !0), this) : C(this, "Month");
    }
    function Q() {
        return V(this.year(), this.month());
    }
    function Z(e) {
        var t, n = e._a;
        return n && u(e).overflow === -2 && (t = n[si] < 0 || n[si] > 11 ? si : n[ci] < 1 || n[ci] > V(n[oi], n[si]) ? ci : n[ui] < 0 || n[ui] > 24 || 24 === n[ui] && (0 !== n[li] || 0 !== n[fi] || 0 !== n[di]) ? ui : n[li] < 0 || n[li] > 59 ? li : n[fi] < 0 || n[fi] > 59 ? fi : n[di] < 0 || n[di] > 999 ? di : -1, 
        u(e)._overflowDayOfYear && (t < oi || t > ci) && (t = ci), u(e).overflow = t), e;
    }
    function J(t) {
        e.suppressDeprecationWarnings === !1 && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + t);
    }
    function ee(e, t) {
        var n = !0;
        return o(function() {
            return n && (J(e + "\n" + new Error().stack), n = !1), t.apply(this, arguments);
        }, t);
    }
    function te(e, t) {
        mi[e] || (J(t), mi[e] = !0);
    }
    function ne(e) {
        var t, n, i = e._i, r = gi.exec(i);
        if (r) {
            for (u(e).iso = !0, t = 0, n = vi.length; t < n; t++) if (vi[t][1].exec(i)) {
                e._f = vi[t][0];
                break;
            }
            for (t = 0, n = yi.length; t < n; t++) if (yi[t][1].exec(i)) {
                e._f += (r[6] || " ") + yi[t][0];
                break;
            }
            i.match(ti) && (e._f += "Z"), be(e);
        } else e._isValid = !1;
    }
    function ie(t) {
        var n = Ai.exec(t._i);
        return null !== n ? void (t._d = new Date(+n[1])) : (ne(t), void (t._isValid === !1 && (delete t._isValid, 
        e.createFromInputFallback(t))));
    }
    function re(e, t, n, i, r, a, o) {
        var s = new Date(e, t, n, i, r, a, o);
        return e < 1970 && s.setFullYear(e), s;
    }
    function ae(e) {
        var t = new Date(Date.UTC.apply(null, arguments));
        return e < 1970 && t.setUTCFullYear(e), t;
    }
    function oe(e) {
        return se(e) ? 366 : 365;
    }
    function se(e) {
        return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
    }
    function ce() {
        return se(this.year());
    }
    function ue(e, t, n) {
        var i, r = n - t, a = n - e.day();
        return a > r && (a -= 7), a < r - 7 && (a += 7), i = Ce(e).add(a, "d"), {
            week: Math.ceil(i.dayOfYear() / 7),
            year: i.year()
        };
    }
    function le(e) {
        return ue(e, this._week.dow, this._week.doy).week;
    }
    function fe() {
        return this._week.dow;
    }
    function de() {
        return this._week.doy;
    }
    function he(e) {
        var t = this.localeData().week(this);
        return null == e ? t : this.add(7 * (e - t), "d");
    }
    function pe(e) {
        var t = ue(this, 1, 4).week;
        return null == e ? t : this.add(7 * (e - t), "d");
    }
    function me(e, t, n, i, r) {
        var a, o = 6 + r - i, s = ae(e, 0, 1 + o), c = s.getUTCDay();
        return c < r && (c += 7), n = null != n ? 1 * n : r, a = 1 + o + 7 * (t - 1) - c + n, 
        {
            year: a > 0 ? e : e - 1,
            dayOfYear: a > 0 ? a : oe(e - 1) + a
        };
    }
    function ge(e) {
        var t = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return null == e ? t : this.add(e - t, "d");
    }
    function ve(e, t, n) {
        return null != e ? e : null != t ? t : n;
    }
    function ye(e) {
        var t = new Date();
        return e._useUTC ? [ t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate() ] : [ t.getFullYear(), t.getMonth(), t.getDate() ];
    }
    function Ae(e) {
        var t, n, i, r, a = [];
        if (!e._d) {
            for (i = ye(e), e._w && null == e._a[ci] && null == e._a[si] && _e(e), e._dayOfYear && (r = ve(e._a[oi], i[oi]), 
            e._dayOfYear > oe(r) && (u(e)._overflowDayOfYear = !0), n = ae(r, 0, e._dayOfYear), 
            e._a[si] = n.getUTCMonth(), e._a[ci] = n.getUTCDate()), t = 0; t < 3 && null == e._a[t]; ++t) e._a[t] = a[t] = i[t];
            for (;t < 7; t++) e._a[t] = a[t] = null == e._a[t] ? 2 === t ? 1 : 0 : e._a[t];
            24 === e._a[ui] && 0 === e._a[li] && 0 === e._a[fi] && 0 === e._a[di] && (e._nextDay = !0, 
            e._a[ui] = 0), e._d = (e._useUTC ? ae : re).apply(null, a), null != e._tzm && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), 
            e._nextDay && (e._a[ui] = 24);
        }
    }
    function _e(e) {
        var t, n, i, r, a, o, s;
        t = e._w, null != t.GG || null != t.W || null != t.E ? (a = 1, o = 4, n = ve(t.GG, e._a[oi], ue(Ce(), 1, 4).year), 
        i = ve(t.W, 1), r = ve(t.E, 1)) : (a = e._locale._week.dow, o = e._locale._week.doy, 
        n = ve(t.gg, e._a[oi], ue(Ce(), a, o).year), i = ve(t.w, 1), null != t.d ? (r = t.d, 
        r < a && ++i) : r = null != t.e ? t.e + a : a), s = me(n, i, r, o, a), e._a[oi] = s.year, 
        e._dayOfYear = s.dayOfYear;
    }
    function be(t) {
        if (t._f === e.ISO_8601) return void ne(t);
        t._a = [], u(t).empty = !0;
        var n, i, r, a, o, s = "" + t._i, c = s.length, l = 0;
        for (r = j(t._f, t._locale).match(Fn) || [], n = 0; n < r.length; n++) a = r[n], 
        i = (s.match(F(a, t)) || [])[0], i && (o = s.substr(0, s.indexOf(i)), o.length > 0 && u(t).unusedInput.push(o), 
        s = s.slice(s.indexOf(i) + i.length), l += i.length), Wn[a] ? (i ? u(t).empty = !1 : u(t).unusedTokens.push(a), 
        H(a, i, t)) : t._strict && !i && u(t).unusedTokens.push(a);
        u(t).charsLeftOver = c - l, s.length > 0 && u(t).unusedInput.push(s), u(t).bigHour === !0 && t._a[ui] <= 12 && t._a[ui] > 0 && (u(t).bigHour = void 0), 
        t._a[ui] = Te(t._locale, t._a[ui], t._meridiem), Ae(t), Z(t);
    }
    function Te(e, t, n) {
        var i;
        return null == n ? t : null != e.meridiemHour ? e.meridiemHour(t, n) : null != e.isPM ? (i = e.isPM(n), 
        i && t < 12 && (t += 12), i || 12 !== t || (t = 0), t) : t;
    }
    function xe(e) {
        var t, n, i, r, a;
        if (0 === e._f.length) return u(e).invalidFormat = !0, void (e._d = new Date(NaN));
        for (r = 0; r < e._f.length; r++) a = 0, t = d({}, e), null != e._useUTC && (t._useUTC = e._useUTC), 
        t._f = e._f[r], be(t), l(t) && (a += u(t).charsLeftOver, a += 10 * u(t).unusedTokens.length, 
        u(t).score = a, (null == i || a < i) && (i = a, n = t));
        o(e, n || t);
    }
    function we(e) {
        if (!e._d) {
            var t = S(e._i);
            e._a = [ t.year, t.month, t.day || t.date, t.hour, t.minute, t.second, t.millisecond ], 
            Ae(e);
        }
    }
    function ke(e) {
        var t = new h(Z(Ee(e)));
        return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
    }
    function Ee(e) {
        var t = e._i, r = e._f;
        return e._locale = e._locale || w(e._l), null === t || void 0 === r && "" === t ? f({
            nullInput: !0
        }) : ("string" == typeof t && (e._i = t = e._locale.preparse(t)), p(t) ? new h(Z(t)) : (n(r) ? xe(e) : r ? be(e) : i(t) ? e._d = t : Se(e), 
        e));
    }
    function Se(t) {
        var a = t._i;
        void 0 === a ? t._d = new Date() : i(a) ? t._d = new Date(+a) : "string" == typeof a ? ie(t) : n(a) ? (t._a = r(a.slice(0), function(e) {
            return parseInt(e, 10);
        }), Ae(t)) : "object" == typeof a ? we(t) : "number" == typeof a ? t._d = new Date(a) : e.createFromInputFallback(t);
    }
    function Me(e, t, n, i, r) {
        var a = {};
        return "boolean" == typeof n && (i = n, n = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = r, 
        a._l = n, a._i = e, a._f = t, a._strict = i, ke(a);
    }
    function Ce(e, t, n, i) {
        return Me(e, t, n, i, !1);
    }
    function Pe(e, t) {
        var i, r;
        if (1 === t.length && n(t[0]) && (t = t[0]), !t.length) return Ce();
        for (i = t[0], r = 1; r < t.length; ++r) t[r].isValid() && !t[r][e](i) || (i = t[r]);
        return i;
    }
    function De() {
        var e = [].slice.call(arguments, 0);
        return Pe("isBefore", e);
    }
    function Oe() {
        var e = [].slice.call(arguments, 0);
        return Pe("isAfter", e);
    }
    function Ne(e) {
        var t = S(e), n = t.year || 0, i = t.quarter || 0, r = t.month || 0, a = t.week || 0, o = t.day || 0, s = t.hour || 0, c = t.minute || 0, u = t.second || 0, l = t.millisecond || 0;
        this._milliseconds = +l + 1e3 * u + 6e4 * c + 36e5 * s, this._days = +o + 7 * a, 
        this._months = +r + 3 * i + 12 * n, this._data = {}, this._locale = w(), this._bubble();
    }
    function ze(e) {
        return e instanceof Ne;
    }
    function Le(e, t) {
        N(e, 0, 0, function() {
            var e = this.utcOffset(), n = "+";
            return e < 0 && (e = -e, n = "-"), n + O(~~(e / 60), 2) + t + O(~~e % 60, 2);
        });
    }
    function Ie(e) {
        var t = (e || "").match(ti) || [], n = t[t.length - 1] || [], i = (n + "").match(wi) || [ "-", 0, 0 ], r = +(60 * i[1]) + g(i[2]);
        return "+" === i[0] ? r : -r;
    }
    function je(t, n) {
        var r, a;
        return n._isUTC ? (r = n.clone(), a = (p(t) || i(t) ? +t : +Ce(t)) - +r, r._d.setTime(+r._d + a), 
        e.updateOffset(r, !1), r) : Ce(t).local();
    }
    function Be(e) {
        return 15 * -Math.round(e._d.getTimezoneOffset() / 15);
    }
    function Re(t, n) {
        var i, r = this._offset || 0;
        return null != t ? ("string" == typeof t && (t = Ie(t)), Math.abs(t) < 16 && (t = 60 * t), 
        !this._isUTC && n && (i = Be(this)), this._offset = t, this._isUTC = !0, null != i && this.add(i, "m"), 
        r !== t && (!n || this._changeInProgress ? tt(this, $e(t - r, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, 
        e.updateOffset(this, !0), this._changeInProgress = null)), this) : this._isUTC ? r : Be(this);
    }
    function Fe(e, t) {
        return null != e ? ("string" != typeof e && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
    }
    function Ye(e) {
        return this.utcOffset(0, e);
    }
    function qe(e) {
        return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Be(this), "m")), 
        this;
    }
    function We() {
        return this._tzm ? this.utcOffset(this._tzm) : "string" == typeof this._i && this.utcOffset(Ie(this._i)), 
        this;
    }
    function He(e) {
        return e = e ? Ce(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0;
    }
    function Ve() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function Ge() {
        if ("undefined" != typeof this._isDSTShifted) return this._isDSTShifted;
        var e = {};
        if (d(e, this), e = Ee(e), e._a) {
            var t = e._isUTC ? s(e._a) : Ce(e._a);
            this._isDSTShifted = this.isValid() && v(e._a, t.toArray()) > 0;
        } else this._isDSTShifted = !1;
        return this._isDSTShifted;
    }
    function Ue() {
        return !this._isUTC;
    }
    function Xe() {
        return this._isUTC;
    }
    function Ke() {
        return this._isUTC && 0 === this._offset;
    }
    function $e(e, t) {
        var n, i, r, o = e, s = null;
        return ze(e) ? o = {
            ms: e._milliseconds,
            d: e._days,
            M: e._months
        } : "number" == typeof e ? (o = {}, t ? o[t] = e : o.milliseconds = e) : (s = ki.exec(e)) ? (n = "-" === s[1] ? -1 : 1, 
        o = {
            y: 0,
            d: g(s[ci]) * n,
            h: g(s[ui]) * n,
            m: g(s[li]) * n,
            s: g(s[fi]) * n,
            ms: g(s[di]) * n
        }) : (s = Ei.exec(e)) ? (n = "-" === s[1] ? -1 : 1, o = {
            y: Qe(s[2], n),
            M: Qe(s[3], n),
            d: Qe(s[4], n),
            h: Qe(s[5], n),
            m: Qe(s[6], n),
            s: Qe(s[7], n),
            w: Qe(s[8], n)
        }) : null == o ? o = {} : "object" == typeof o && ("from" in o || "to" in o) && (r = Je(Ce(o.from), Ce(o.to)), 
        o = {}, o.ms = r.milliseconds, o.M = r.months), i = new Ne(o), ze(e) && a(e, "_locale") && (i._locale = e._locale), 
        i;
    }
    function Qe(e, t) {
        var n = e && parseFloat(e.replace(",", "."));
        return (isNaN(n) ? 0 : n) * t;
    }
    function Ze(e, t) {
        var n = {
            milliseconds: 0,
            months: 0
        };
        return n.months = t.month() - e.month() + 12 * (t.year() - e.year()), e.clone().add(n.months, "M").isAfter(t) && --n.months, 
        n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
    }
    function Je(e, t) {
        var n;
        return t = je(t, e), e.isBefore(t) ? n = Ze(e, t) : (n = Ze(t, e), n.milliseconds = -n.milliseconds, 
        n.months = -n.months), n;
    }
    function et(e, t) {
        return function(n, i) {
            var r, a;
            return null === i || isNaN(+i) || (te(t, "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period)."), 
            a = n, n = i, i = a), n = "string" == typeof n ? +n : n, r = $e(n, i), tt(this, r, e), 
            this;
        };
    }
    function tt(t, n, i, r) {
        var a = n._milliseconds, o = n._days, s = n._months;
        r = null == r || r, a && t._d.setTime(+t._d + a * i), o && P(t, "Date", C(t, "Date") + o * i), 
        s && K(t, C(t, "Month") + s * i), r && e.updateOffset(t, o || s);
    }
    function nt(e, t) {
        var n = e || Ce(), i = je(n, this).startOf("day"), r = this.diff(i, "days", !0), a = r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
        return this.format(t && t[a] || this.localeData().calendar(a, this, Ce(n)));
    }
    function it() {
        return new h(this);
    }
    function rt(e, t) {
        var n;
        return t = E("undefined" != typeof t ? t : "millisecond"), "millisecond" === t ? (e = p(e) ? e : Ce(e), 
        +this > +e) : (n = p(e) ? +e : +Ce(e), n < +this.clone().startOf(t));
    }
    function at(e, t) {
        var n;
        return t = E("undefined" != typeof t ? t : "millisecond"), "millisecond" === t ? (e = p(e) ? e : Ce(e), 
        +this < +e) : (n = p(e) ? +e : +Ce(e), +this.clone().endOf(t) < n);
    }
    function ot(e, t, n) {
        return this.isAfter(e, n) && this.isBefore(t, n);
    }
    function st(e, t) {
        var n;
        return t = E(t || "millisecond"), "millisecond" === t ? (e = p(e) ? e : Ce(e), +this === +e) : (n = +Ce(e), 
        +this.clone().startOf(t) <= n && n <= +this.clone().endOf(t));
    }
    function ct(e, t, n) {
        var i, r, a = je(e, this), o = 6e4 * (a.utcOffset() - this.utcOffset());
        return t = E(t), "year" === t || "month" === t || "quarter" === t ? (r = ut(this, a), 
        "quarter" === t ? r /= 3 : "year" === t && (r /= 12)) : (i = this - a, r = "second" === t ? i / 1e3 : "minute" === t ? i / 6e4 : "hour" === t ? i / 36e5 : "day" === t ? (i - o) / 864e5 : "week" === t ? (i - o) / 6048e5 : i), 
        n ? r : m(r);
    }
    function ut(e, t) {
        var n, i, r = 12 * (t.year() - e.year()) + (t.month() - e.month()), a = e.clone().add(r, "months");
        return t - a < 0 ? (n = e.clone().add(r - 1, "months"), i = (t - a) / (a - n)) : (n = e.clone().add(r + 1, "months"), 
        i = (t - a) / (n - a)), -(r + i);
    }
    function lt() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function ft() {
        var e = this.clone().utc();
        return 0 < e.year() && e.year() <= 9999 ? "function" == typeof Date.prototype.toISOString ? this.toDate().toISOString() : I(e, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]") : I(e, "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
    }
    function dt(t) {
        var n = I(this, t || e.defaultFormat);
        return this.localeData().postformat(n);
    }
    function ht(e, t) {
        return this.isValid() ? $e({
            to: this,
            from: e
        }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
    }
    function pt(e) {
        return this.from(Ce(), e);
    }
    function mt(e, t) {
        return this.isValid() ? $e({
            from: this,
            to: e
        }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
    }
    function gt(e) {
        return this.to(Ce(), e);
    }
    function vt(e) {
        var t;
        return void 0 === e ? this._locale._abbr : (t = w(e), null != t && (this._locale = t), 
        this);
    }
    function yt() {
        return this._locale;
    }
    function At(e) {
        switch (e = E(e)) {
          case "year":
            this.month(0);

          case "quarter":
          case "month":
            this.date(1);

          case "week":
          case "isoWeek":
          case "day":
            this.hours(0);

          case "hour":
            this.minutes(0);

          case "minute":
            this.seconds(0);

          case "second":
            this.milliseconds(0);
        }
        return "week" === e && this.weekday(0), "isoWeek" === e && this.isoWeekday(1), "quarter" === e && this.month(3 * Math.floor(this.month() / 3)), 
        this;
    }
    function _t(e) {
        return e = E(e), void 0 === e || "millisecond" === e ? this : this.startOf(e).add(1, "isoWeek" === e ? "week" : e).subtract(1, "ms");
    }
    function bt() {
        return +this._d - 6e4 * (this._offset || 0);
    }
    function Tt() {
        return Math.floor(+this / 1e3);
    }
    function xt() {
        return this._offset ? new Date(+this) : this._d;
    }
    function wt() {
        var e = this;
        return [ e.year(), e.month(), e.date(), e.hour(), e.minute(), e.second(), e.millisecond() ];
    }
    function kt() {
        var e = this;
        return {
            years: e.year(),
            months: e.month(),
            date: e.date(),
            hours: e.hours(),
            minutes: e.minutes(),
            seconds: e.seconds(),
            milliseconds: e.milliseconds()
        };
    }
    function Et() {
        return l(this);
    }
    function St() {
        return o({}, u(this));
    }
    function Mt() {
        return u(this).overflow;
    }
    function Ct(e, t) {
        N(0, [ e, e.length ], 0, t);
    }
    function Pt(e, t, n) {
        return ue(Ce([ e, 11, 31 + t - n ]), t, n).week;
    }
    function Dt(e) {
        var t = ue(this, this.localeData()._week.dow, this.localeData()._week.doy).year;
        return null == e ? t : this.add(e - t, "y");
    }
    function Ot(e) {
        var t = ue(this, 1, 4).year;
        return null == e ? t : this.add(e - t, "y");
    }
    function Nt() {
        return Pt(this.year(), 1, 4);
    }
    function zt() {
        var e = this.localeData()._week;
        return Pt(this.year(), e.dow, e.doy);
    }
    function Lt(e) {
        return null == e ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e - 1) + this.month() % 3);
    }
    function It(e, t) {
        return "string" != typeof e ? e : isNaN(e) ? (e = t.weekdaysParse(e), "number" == typeof e ? e : null) : parseInt(e, 10);
    }
    function jt(e) {
        return this._weekdays[e.day()];
    }
    function Bt(e) {
        return this._weekdaysShort[e.day()];
    }
    function Rt(e) {
        return this._weekdaysMin[e.day()];
    }
    function Ft(e) {
        var t, n, i;
        for (this._weekdaysParse = this._weekdaysParse || [], t = 0; t < 7; t++) if (this._weekdaysParse[t] || (n = Ce([ 2e3, 1 ]).day(t), 
        i = "^" + this.weekdays(n, "") + "|^" + this.weekdaysShort(n, "") + "|^" + this.weekdaysMin(n, ""), 
        this._weekdaysParse[t] = new RegExp(i.replace(".", ""), "i")), this._weekdaysParse[t].test(e)) return t;
    }
    function Yt(e) {
        var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        return null != e ? (e = It(e, this.localeData()), this.add(e - t, "d")) : t;
    }
    function qt(e) {
        var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return null == e ? t : this.add(e - t, "d");
    }
    function Wt(e) {
        return null == e ? this.day() || 7 : this.day(this.day() % 7 ? e : e - 7);
    }
    function Ht(e, t) {
        N(e, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), t);
        });
    }
    function Vt(e, t) {
        return t._meridiemParse;
    }
    function Gt(e) {
        return "p" === (e + "").toLowerCase().charAt(0);
    }
    function Ut(e, t, n) {
        return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
    }
    function Xt(e, t) {
        t[di] = g(1e3 * ("0." + e));
    }
    function Kt() {
        return this._isUTC ? "UTC" : "";
    }
    function $t() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    function Qt(e) {
        return Ce(1e3 * e);
    }
    function Zt() {
        return Ce.apply(null, arguments).parseZone();
    }
    function Jt(e, t, n) {
        var i = this._calendar[e];
        return "function" == typeof i ? i.call(t, n) : i;
    }
    function en(e) {
        var t = this._longDateFormat[e], n = this._longDateFormat[e.toUpperCase()];
        return t || !n ? t : (this._longDateFormat[e] = n.replace(/MMMM|MM|DD|dddd/g, function(e) {
            return e.slice(1);
        }), this._longDateFormat[e]);
    }
    function tn() {
        return this._invalidDate;
    }
    function nn(e) {
        return this._ordinal.replace("%d", e);
    }
    function rn(e) {
        return e;
    }
    function an(e, t, n, i) {
        var r = this._relativeTime[n];
        return "function" == typeof r ? r(e, t, n, i) : r.replace(/%d/i, e);
    }
    function on(e, t) {
        var n = this._relativeTime[e > 0 ? "future" : "past"];
        return "function" == typeof n ? n(t) : n.replace(/%s/i, t);
    }
    function sn(e) {
        var t, n;
        for (n in e) t = e[n], "function" == typeof t ? this[n] = t : this["_" + n] = t;
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + "|" + /\d{1,2}/.source);
    }
    function cn(e, t, n, i) {
        var r = w(), a = s().set(i, t);
        return r[n](a, e);
    }
    function un(e, t, n, i, r) {
        if ("number" == typeof e && (t = e, e = void 0), e = e || "", null != t) return cn(e, t, n, r);
        var a, o = [];
        for (a = 0; a < i; a++) o[a] = cn(e, a, n, r);
        return o;
    }
    function ln(e, t) {
        return un(e, t, "months", 12, "month");
    }
    function fn(e, t) {
        return un(e, t, "monthsShort", 12, "month");
    }
    function dn(e, t) {
        return un(e, t, "weekdays", 7, "day");
    }
    function hn(e, t) {
        return un(e, t, "weekdaysShort", 7, "day");
    }
    function pn(e, t) {
        return un(e, t, "weekdaysMin", 7, "day");
    }
    function mn() {
        var e = this._data;
        return this._milliseconds = Ki(this._milliseconds), this._days = Ki(this._days), 
        this._months = Ki(this._months), e.milliseconds = Ki(e.milliseconds), e.seconds = Ki(e.seconds), 
        e.minutes = Ki(e.minutes), e.hours = Ki(e.hours), e.months = Ki(e.months), e.years = Ki(e.years), 
        this;
    }
    function gn(e, t, n, i) {
        var r = $e(t, n);
        return e._milliseconds += i * r._milliseconds, e._days += i * r._days, e._months += i * r._months, 
        e._bubble();
    }
    function vn(e, t) {
        return gn(this, e, t, 1);
    }
    function yn(e, t) {
        return gn(this, e, t, -1);
    }
    function An(e) {
        return e < 0 ? Math.floor(e) : Math.ceil(e);
    }
    function _n() {
        var e, t, n, i, r, a = this._milliseconds, o = this._days, s = this._months, c = this._data;
        return a >= 0 && o >= 0 && s >= 0 || a <= 0 && o <= 0 && s <= 0 || (a += 864e5 * An(Tn(s) + o), 
        o = 0, s = 0), c.milliseconds = a % 1e3, e = m(a / 1e3), c.seconds = e % 60, t = m(e / 60), 
        c.minutes = t % 60, n = m(t / 60), c.hours = n % 24, o += m(n / 24), r = m(bn(o)), 
        s += r, o -= An(Tn(r)), i = m(s / 12), s %= 12, c.days = o, c.months = s, c.years = i, 
        this;
    }
    function bn(e) {
        return 4800 * e / 146097;
    }
    function Tn(e) {
        return 146097 * e / 4800;
    }
    function xn(e) {
        var t, n, i = this._milliseconds;
        if (e = E(e), "month" === e || "year" === e) return t = this._days + i / 864e5, 
        n = this._months + bn(t), "month" === e ? n : n / 12;
        switch (t = this._days + Math.round(Tn(this._months)), e) {
          case "week":
            return t / 7 + i / 6048e5;

          case "day":
            return t + i / 864e5;

          case "hour":
            return 24 * t + i / 36e5;

          case "minute":
            return 1440 * t + i / 6e4;

          case "second":
            return 86400 * t + i / 1e3;

          case "millisecond":
            return Math.floor(864e5 * t) + i;

          default:
            throw new Error("Unknown unit " + e);
        }
    }
    function wn() {
        return this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * g(this._months / 12);
    }
    function kn(e) {
        return function() {
            return this.as(e);
        };
    }
    function En(e) {
        return e = E(e), this[e + "s"]();
    }
    function Sn(e) {
        return function() {
            return this._data[e];
        };
    }
    function Mn() {
        return m(this.days() / 7);
    }
    function Cn(e, t, n, i, r) {
        return r.relativeTime(t || 1, !!n, e, i);
    }
    function Pn(e, t, n) {
        var i = $e(e).abs(), r = fr(i.as("s")), a = fr(i.as("m")), o = fr(i.as("h")), s = fr(i.as("d")), c = fr(i.as("M")), u = fr(i.as("y")), l = r < dr.s && [ "s", r ] || 1 === a && [ "m" ] || a < dr.m && [ "mm", a ] || 1 === o && [ "h" ] || o < dr.h && [ "hh", o ] || 1 === s && [ "d" ] || s < dr.d && [ "dd", s ] || 1 === c && [ "M" ] || c < dr.M && [ "MM", c ] || 1 === u && [ "y" ] || [ "yy", u ];
        return l[2] = t, l[3] = +e > 0, l[4] = n, Cn.apply(null, l);
    }
    function Dn(e, t) {
        return void 0 !== dr[e] && (void 0 === t ? dr[e] : (dr[e] = t, !0));
    }
    function On(e) {
        var t = this.localeData(), n = Pn(this, !e, t);
        return e && (n = t.pastFuture(+this, n)), t.postformat(n);
    }
    function Nn() {
        var e, t, n, i = hr(this._milliseconds) / 1e3, r = hr(this._days), a = hr(this._months);
        e = m(i / 60), t = m(e / 60), i %= 60, e %= 60, n = m(a / 12), a %= 12;
        var o = n, s = a, c = r, u = t, l = e, f = i, d = this.asSeconds();
        return d ? (d < 0 ? "-" : "") + "P" + (o ? o + "Y" : "") + (s ? s + "M" : "") + (c ? c + "D" : "") + (u || l || f ? "T" : "") + (u ? u + "H" : "") + (l ? l + "M" : "") + (f ? f + "S" : "") : "P0D";
    }
    var zn, Ln, In = e.momentProperties = [], jn = !1, Bn = {}, Rn = {}, Fn = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, Yn = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, qn = {}, Wn = {}, Hn = /\d/, Vn = /\d\d/, Gn = /\d{3}/, Un = /\d{4}/, Xn = /[+-]?\d{6}/, Kn = /\d\d?/, $n = /\d{1,3}/, Qn = /\d{1,4}/, Zn = /[+-]?\d{1,6}/, Jn = /\d+/, ei = /[+-]?\d+/, ti = /Z|[+-]\d\d:?\d\d/gi, ni = /[+-]?\d+(\.\d{1,3})?/, ii = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i, ri = {}, ai = {}, oi = 0, si = 1, ci = 2, ui = 3, li = 4, fi = 5, di = 6;
    N("M", [ "MM", 2 ], "Mo", function() {
        return this.month() + 1;
    }), N("MMM", 0, 0, function(e) {
        return this.localeData().monthsShort(this, e);
    }), N("MMMM", 0, 0, function(e) {
        return this.localeData().months(this, e);
    }), k("month", "M"), R("M", Kn), R("MM", Kn, Vn), R("MMM", ii), R("MMMM", ii), q([ "M", "MM" ], function(e, t) {
        t[si] = g(e) - 1;
    }), q([ "MMM", "MMMM" ], function(e, t, n, i) {
        var r = n._locale.monthsParse(e, i, n._strict);
        null != r ? t[si] = r : u(n).invalidMonth = e;
    });
    var hi = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), pi = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), mi = {};
    e.suppressDeprecationWarnings = !1;
    var gi = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/, vi = [ [ "YYYYYY-MM-DD", /[+-]\d{6}-\d{2}-\d{2}/ ], [ "YYYY-MM-DD", /\d{4}-\d{2}-\d{2}/ ], [ "GGGG-[W]WW-E", /\d{4}-W\d{2}-\d/ ], [ "GGGG-[W]WW", /\d{4}-W\d{2}/ ], [ "YYYY-DDD", /\d{4}-\d{3}/ ] ], yi = [ [ "HH:mm:ss.SSSS", /(T| )\d\d:\d\d:\d\d\.\d+/ ], [ "HH:mm:ss", /(T| )\d\d:\d\d:\d\d/ ], [ "HH:mm", /(T| )\d\d:\d\d/ ], [ "HH", /(T| )\d\d/ ] ], Ai = /^\/?Date\((\-?\d+)/i;
    e.createFromInputFallback = ee("moment construction falls back to js Date. This is discouraged and will be removed in upcoming major release. Please refer to https://github.com/moment/moment/issues/1407 for more info.", function(e) {
        e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
    }), N(0, [ "YY", 2 ], 0, function() {
        return this.year() % 100;
    }), N(0, [ "YYYY", 4 ], 0, "year"), N(0, [ "YYYYY", 5 ], 0, "year"), N(0, [ "YYYYYY", 6, !0 ], 0, "year"), 
    k("year", "y"), R("Y", ei), R("YY", Kn, Vn), R("YYYY", Qn, Un), R("YYYYY", Zn, Xn), 
    R("YYYYYY", Zn, Xn), q([ "YYYYY", "YYYYYY" ], oi), q("YYYY", function(t, n) {
        n[oi] = 2 === t.length ? e.parseTwoDigitYear(t) : g(t);
    }), q("YY", function(t, n) {
        n[oi] = e.parseTwoDigitYear(t);
    }), e.parseTwoDigitYear = function(e) {
        return g(e) + (g(e) > 68 ? 1900 : 2e3);
    };
    var _i = M("FullYear", !1);
    N("w", [ "ww", 2 ], "wo", "week"), N("W", [ "WW", 2 ], "Wo", "isoWeek"), k("week", "w"), 
    k("isoWeek", "W"), R("w", Kn), R("ww", Kn, Vn), R("W", Kn), R("WW", Kn, Vn), W([ "w", "ww", "W", "WW" ], function(e, t, n, i) {
        t[i.substr(0, 1)] = g(e);
    });
    var bi = {
        dow: 0,
        doy: 6
    };
    N("DDD", [ "DDDD", 3 ], "DDDo", "dayOfYear"), k("dayOfYear", "DDD"), R("DDD", $n), 
    R("DDDD", Gn), q([ "DDD", "DDDD" ], function(e, t, n) {
        n._dayOfYear = g(e);
    }), e.ISO_8601 = function() {};
    var Ti = ee("moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548", function() {
        var e = Ce.apply(null, arguments);
        return e < this ? this : e;
    }), xi = ee("moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548", function() {
        var e = Ce.apply(null, arguments);
        return e > this ? this : e;
    });
    Le("Z", ":"), Le("ZZ", ""), R("Z", ti), R("ZZ", ti), q([ "Z", "ZZ" ], function(e, t, n) {
        n._useUTC = !0, n._tzm = Ie(e);
    });
    var wi = /([\+\-]|\d\d)/gi;
    e.updateOffset = function() {};
    var ki = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/, Ei = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;
    $e.fn = Ne.prototype;
    var Si = et(1, "add"), Mi = et(-1, "subtract");
    e.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    var Ci = ee("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(e) {
        return void 0 === e ? this.localeData() : this.locale(e);
    });
    N(0, [ "gg", 2 ], 0, function() {
        return this.weekYear() % 100;
    }), N(0, [ "GG", 2 ], 0, function() {
        return this.isoWeekYear() % 100;
    }), Ct("gggg", "weekYear"), Ct("ggggg", "weekYear"), Ct("GGGG", "isoWeekYear"), 
    Ct("GGGGG", "isoWeekYear"), k("weekYear", "gg"), k("isoWeekYear", "GG"), R("G", ei), 
    R("g", ei), R("GG", Kn, Vn), R("gg", Kn, Vn), R("GGGG", Qn, Un), R("gggg", Qn, Un), 
    R("GGGGG", Zn, Xn), R("ggggg", Zn, Xn), W([ "gggg", "ggggg", "GGGG", "GGGGG" ], function(e, t, n, i) {
        t[i.substr(0, 2)] = g(e);
    }), W([ "gg", "GG" ], function(t, n, i, r) {
        n[r] = e.parseTwoDigitYear(t);
    }), N("Q", 0, 0, "quarter"), k("quarter", "Q"), R("Q", Hn), q("Q", function(e, t) {
        t[si] = 3 * (g(e) - 1);
    }), N("D", [ "DD", 2 ], "Do", "date"), k("date", "D"), R("D", Kn), R("DD", Kn, Vn), 
    R("Do", function(e, t) {
        return e ? t._ordinalParse : t._ordinalParseLenient;
    }), q([ "D", "DD" ], ci), q("Do", function(e, t) {
        t[ci] = g(e.match(Kn)[0], 10);
    });
    var Pi = M("Date", !0);
    N("d", 0, "do", "day"), N("dd", 0, 0, function(e) {
        return this.localeData().weekdaysMin(this, e);
    }), N("ddd", 0, 0, function(e) {
        return this.localeData().weekdaysShort(this, e);
    }), N("dddd", 0, 0, function(e) {
        return this.localeData().weekdays(this, e);
    }), N("e", 0, 0, "weekday"), N("E", 0, 0, "isoWeekday"), k("day", "d"), k("weekday", "e"), 
    k("isoWeekday", "E"), R("d", Kn), R("e", Kn), R("E", Kn), R("dd", ii), R("ddd", ii), 
    R("dddd", ii), W([ "dd", "ddd", "dddd" ], function(e, t, n) {
        var i = n._locale.weekdaysParse(e);
        null != i ? t.d = i : u(n).invalidWeekday = e;
    }), W([ "d", "e", "E" ], function(e, t, n, i) {
        t[i] = g(e);
    });
    var Di = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Oi = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Ni = "Su_Mo_Tu_We_Th_Fr_Sa".split("_");
    N("H", [ "HH", 2 ], 0, "hour"), N("h", [ "hh", 2 ], 0, function() {
        return this.hours() % 12 || 12;
    }), Ht("a", !0), Ht("A", !1), k("hour", "h"), R("a", Vt), R("A", Vt), R("H", Kn), 
    R("h", Kn), R("HH", Kn, Vn), R("hh", Kn, Vn), q([ "H", "HH" ], ui), q([ "a", "A" ], function(e, t, n) {
        n._isPm = n._locale.isPM(e), n._meridiem = e;
    }), q([ "h", "hh" ], function(e, t, n) {
        t[ui] = g(e), u(n).bigHour = !0;
    });
    var zi = /[ap]\.?m?\.?/i, Li = M("Hours", !0);
    N("m", [ "mm", 2 ], 0, "minute"), k("minute", "m"), R("m", Kn), R("mm", Kn, Vn), 
    q([ "m", "mm" ], li);
    var Ii = M("Minutes", !1);
    N("s", [ "ss", 2 ], 0, "second"), k("second", "s"), R("s", Kn), R("ss", Kn, Vn), 
    q([ "s", "ss" ], fi);
    var ji = M("Seconds", !1);
    N("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    }), N(0, [ "SS", 2 ], 0, function() {
        return ~~(this.millisecond() / 10);
    }), N(0, [ "SSS", 3 ], 0, "millisecond"), N(0, [ "SSSS", 4 ], 0, function() {
        return 10 * this.millisecond();
    }), N(0, [ "SSSSS", 5 ], 0, function() {
        return 100 * this.millisecond();
    }), N(0, [ "SSSSSS", 6 ], 0, function() {
        return 1e3 * this.millisecond();
    }), N(0, [ "SSSSSSS", 7 ], 0, function() {
        return 1e4 * this.millisecond();
    }), N(0, [ "SSSSSSSS", 8 ], 0, function() {
        return 1e5 * this.millisecond();
    }), N(0, [ "SSSSSSSSS", 9 ], 0, function() {
        return 1e6 * this.millisecond();
    }), k("millisecond", "ms"), R("S", $n, Hn), R("SS", $n, Vn), R("SSS", $n, Gn);
    var Bi;
    for (Bi = "SSSS"; Bi.length <= 9; Bi += "S") R(Bi, Jn);
    for (Bi = "S"; Bi.length <= 9; Bi += "S") q(Bi, Xt);
    var Ri = M("Milliseconds", !1);
    N("z", 0, 0, "zoneAbbr"), N("zz", 0, 0, "zoneName");
    var Fi = h.prototype;
    Fi.add = Si, Fi.calendar = nt, Fi.clone = it, Fi.diff = ct, Fi.endOf = _t, Fi.format = dt, 
    Fi.from = ht, Fi.fromNow = pt, Fi.to = mt, Fi.toNow = gt, Fi.get = D, Fi.invalidAt = Mt, 
    Fi.isAfter = rt, Fi.isBefore = at, Fi.isBetween = ot, Fi.isSame = st, Fi.isValid = Et, 
    Fi.lang = Ci, Fi.locale = vt, Fi.localeData = yt, Fi.max = xi, Fi.min = Ti, Fi.parsingFlags = St, 
    Fi.set = D, Fi.startOf = At, Fi.subtract = Mi, Fi.toArray = wt, Fi.toObject = kt, 
    Fi.toDate = xt, Fi.toISOString = ft, Fi.toJSON = ft, Fi.toString = lt, Fi.unix = Tt, 
    Fi.valueOf = bt, Fi.year = _i, Fi.isLeapYear = ce, Fi.weekYear = Dt, Fi.isoWeekYear = Ot, 
    Fi.quarter = Fi.quarters = Lt, Fi.month = $, Fi.daysInMonth = Q, Fi.week = Fi.weeks = he, 
    Fi.isoWeek = Fi.isoWeeks = pe, Fi.weeksInYear = zt, Fi.isoWeeksInYear = Nt, Fi.date = Pi, 
    Fi.day = Fi.days = Yt, Fi.weekday = qt, Fi.isoWeekday = Wt, Fi.dayOfYear = ge, Fi.hour = Fi.hours = Li, 
    Fi.minute = Fi.minutes = Ii, Fi.second = Fi.seconds = ji, Fi.millisecond = Fi.milliseconds = Ri, 
    Fi.utcOffset = Re, Fi.utc = Ye, Fi.local = qe, Fi.parseZone = We, Fi.hasAlignedHourOffset = He, 
    Fi.isDST = Ve, Fi.isDSTShifted = Ge, Fi.isLocal = Ue, Fi.isUtcOffset = Xe, Fi.isUtc = Ke, 
    Fi.isUTC = Ke, Fi.zoneAbbr = Kt, Fi.zoneName = $t, Fi.dates = ee("dates accessor is deprecated. Use date instead.", Pi), 
    Fi.months = ee("months accessor is deprecated. Use month instead", $), Fi.years = ee("years accessor is deprecated. Use year instead", _i), 
    Fi.zone = ee("moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779", Fe);
    var Yi = Fi, qi = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    }, Wi = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, Hi = "Invalid date", Vi = "%d", Gi = /\d{1,2}/, Ui = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    }, Xi = y.prototype;
    Xi._calendar = qi, Xi.calendar = Jt, Xi._longDateFormat = Wi, Xi.longDateFormat = en, 
    Xi._invalidDate = Hi, Xi.invalidDate = tn, Xi._ordinal = Vi, Xi.ordinal = nn, Xi._ordinalParse = Gi, 
    Xi.preparse = rn, Xi.postformat = rn, Xi._relativeTime = Ui, Xi.relativeTime = an, 
    Xi.pastFuture = on, Xi.set = sn, Xi.months = G, Xi._months = hi, Xi.monthsShort = U, 
    Xi._monthsShort = pi, Xi.monthsParse = X, Xi.week = le, Xi._week = bi, Xi.firstDayOfYear = de, 
    Xi.firstDayOfWeek = fe, Xi.weekdays = jt, Xi._weekdays = Di, Xi.weekdaysMin = Rt, 
    Xi._weekdaysMin = Ni, Xi.weekdaysShort = Bt, Xi._weekdaysShort = Oi, Xi.weekdaysParse = Ft, 
    Xi.isPM = Gt, Xi._meridiemParse = zi, Xi.meridiem = Ut, T("en", {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(e) {
            var t = e % 10, n = 1 === g(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
            return e + n;
        }
    }), e.lang = ee("moment.lang is deprecated. Use moment.locale instead.", T), e.langData = ee("moment.langData is deprecated. Use moment.localeData instead.", w);
    var Ki = Math.abs, $i = kn("ms"), Qi = kn("s"), Zi = kn("m"), Ji = kn("h"), er = kn("d"), tr = kn("w"), nr = kn("M"), ir = kn("y"), rr = Sn("milliseconds"), ar = Sn("seconds"), or = Sn("minutes"), sr = Sn("hours"), cr = Sn("days"), ur = Sn("months"), lr = Sn("years"), fr = Math.round, dr = {
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        M: 11
    }, hr = Math.abs, pr = Ne.prototype;
    pr.abs = mn, pr.add = vn, pr.subtract = yn, pr.as = xn, pr.asMilliseconds = $i, 
    pr.asSeconds = Qi, pr.asMinutes = Zi, pr.asHours = Ji, pr.asDays = er, pr.asWeeks = tr, 
    pr.asMonths = nr, pr.asYears = ir, pr.valueOf = wn, pr._bubble = _n, pr.get = En, 
    pr.milliseconds = rr, pr.seconds = ar, pr.minutes = or, pr.hours = sr, pr.days = cr, 
    pr.weeks = Mn, pr.months = ur, pr.years = lr, pr.humanize = On, pr.toISOString = Nn, 
    pr.toString = Nn, pr.toJSON = Nn, pr.locale = vt, pr.localeData = yt, pr.toIsoString = ee("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", Nn), 
    pr.lang = Ci, N("X", 0, 0, "unix"), N("x", 0, 0, "valueOf"), R("x", ei), R("X", ni), 
    q("X", function(e, t, n) {
        n._d = new Date(1e3 * parseFloat(e, 10));
    }), q("x", function(e, t, n) {
        n._d = new Date(g(e));
    }), e.version = "2.10.6", t(Ce), e.fn = Yi, e.min = De, e.max = Oe, e.utc = s, e.unix = Qt, 
    e.months = ln, e.isDate = i, e.locale = T, e.invalid = f, e.duration = $e, e.isMoment = p, 
    e.weekdays = dn, e.parseZone = Zt, e.localeData = w, e.isDuration = ze, e.monthsShort = fn, 
    e.weekdaysMin = pn, e.defineLocale = x, e.weekdaysShort = hn, e.normalizeUnits = E, 
    e.relativeTimeThreshold = Dn;
    var mr = e;
    return mr;
}), function(e, t) {
    "object" == typeof module && module.exports ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.Spinner = t();
}(this, function() {
    "use strict";
    function e(e, t) {
        var n, i = document.createElement(e || "div");
        for (n in t) i[n] = t[n];
        return i;
    }
    function t(e) {
        for (var t = 1, n = arguments.length; t < n; t++) e.appendChild(arguments[t]);
        return e;
    }
    function n(e, t, n, i) {
        var r = [ "opacity", t, ~~(100 * e), n, i ].join("-"), a = .01 + n / i * 100, o = Math.max(1 - (1 - e) / t * (100 - a), e), s = u.substring(0, u.indexOf("Animation")).toLowerCase(), c = s && "-" + s + "-" || "";
        return d[r] || (l.insertRule("@" + c + "keyframes " + r + "{0%{opacity:" + o + "}" + a + "%{opacity:" + e + "}" + (a + .01) + "%{opacity:1}" + (a + t) % 100 + "%{opacity:" + e + "}100%{opacity:" + o + "}}", l.cssRules.length), 
        d[r] = 1), r;
    }
    function i(e, t) {
        var n, i, r = e.style;
        if (t = t.charAt(0).toUpperCase() + t.slice(1), void 0 !== r[t]) return t;
        for (i = 0; i < f.length; i++) if (n = f[i] + t, void 0 !== r[n]) return n;
    }
    function r(e, t) {
        for (var n in t) e.style[i(e, n) || n] = t[n];
        return e;
    }
    function a(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var i in n) void 0 === e[i] && (e[i] = n[i]);
        }
        return e;
    }
    function o(e, t) {
        return "string" == typeof e ? e : e[t % e.length];
    }
    function s(e) {
        this.opts = a(e || {}, s.defaults, h);
    }
    function c() {
        function n(t, n) {
            return e("<" + t + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', n);
        }
        l.addRule(".spin-vml", "behavior:url(#default#VML)"), s.prototype.lines = function(e, i) {
            function a() {
                return r(n("group", {
                    coordsize: l + " " + l,
                    coordorigin: -u + " " + -u
                }), {
                    width: l,
                    height: l
                });
            }
            function s(e, s, c) {
                t(d, t(r(a(), {
                    rotation: 360 / i.lines * e + "deg",
                    left: ~~s
                }), t(r(n("roundrect", {
                    arcsize: i.corners
                }), {
                    width: u,
                    height: i.scale * i.width,
                    left: i.scale * i.radius,
                    top: -i.scale * i.width >> 1,
                    filter: c
                }), n("fill", {
                    color: o(i.color, e),
                    opacity: i.opacity
                }), n("stroke", {
                    opacity: 0
                }))));
            }
            var c, u = i.scale * (i.length + i.width), l = 2 * i.scale * u, f = -(i.width + i.length) * i.scale * 2 + "px", d = r(a(), {
                position: "absolute",
                top: f,
                left: f
            });
            if (i.shadow) for (c = 1; c <= i.lines; c++) s(c, -2, "progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)");
            for (c = 1; c <= i.lines; c++) s(c);
            return t(e, d);
        }, s.prototype.opacity = function(e, t, n, i) {
            var r = e.firstChild;
            i = i.shadow && i.lines || 0, r && t + i < r.childNodes.length && (r = r.childNodes[t + i], 
            r = r && r.firstChild, r = r && r.firstChild, r && (r.opacity = n));
        };
    }
    var u, l, f = [ "webkit", "Moz", "ms", "O" ], d = {}, h = {
        lines: 12,
        length: 7,
        width: 5,
        radius: 10,
        scale: 1,
        corners: 1,
        color: "#000",
        opacity: .25,
        rotate: 0,
        direction: 1,
        speed: 1,
        trail: 100,
        fps: 20,
        zIndex: 2e9,
        className: "spinner",
        top: "50%",
        left: "50%",
        shadow: !1,
        hwaccel: !1,
        position: "absolute"
    };
    if (s.defaults = {}, a(s.prototype, {
        spin: function(t) {
            this.stop();
            var n = this, i = n.opts, a = n.el = e(null, {
                className: i.className
            });
            if (r(a, {
                position: i.position,
                width: 0,
                zIndex: i.zIndex,
                left: i.left,
                top: i.top
            }), t && t.insertBefore(a, t.firstChild || null), a.setAttribute("role", "progressbar"), 
            n.lines(a, n.opts), !u) {
                var o, s = 0, c = (i.lines - 1) * (1 - i.direction) / 2, l = i.fps, f = l / i.speed, d = (1 - i.opacity) / (f * i.trail / 100), h = f / i.lines;
                !function p() {
                    s++;
                    for (var e = 0; e < i.lines; e++) o = Math.max(1 - (s + (i.lines - e) * h) % f * d, i.opacity), 
                    n.opacity(a, e * i.direction + c, o, i);
                    n.timeout = n.el && setTimeout(p, ~~(1e3 / l));
                }();
            }
            return n;
        },
        stop: function() {
            var e = this.el;
            return e && (clearTimeout(this.timeout), e.parentNode && e.parentNode.removeChild(e), 
            this.el = void 0), this;
        },
        lines: function(i, a) {
            function s(t, n) {
                return r(e(), {
                    position: "absolute",
                    width: a.scale * (a.length + a.width) + "px",
                    height: a.scale * a.width + "px",
                    background: t,
                    boxShadow: n,
                    transformOrigin: "left",
                    transform: "rotate(" + ~~(360 / a.lines * l + a.rotate) + "deg) translate(" + a.scale * a.radius + "px,0)",
                    borderRadius: (a.corners * a.scale * a.width >> 1) + "px"
                });
            }
            for (var c, l = 0, f = (a.lines - 1) * (1 - a.direction) / 2; l < a.lines; l++) c = r(e(), {
                position: "absolute",
                top: 1 + ~(a.scale * a.width / 2) + "px",
                transform: a.hwaccel ? "translate3d(0,0,0)" : "",
                opacity: a.opacity,
                animation: u && n(a.opacity, a.trail, f + l * a.direction, a.lines) + " " + 1 / a.speed + "s linear infinite"
            }), a.shadow && t(c, r(s("#000", "0 0 4px #000"), {
                top: "2px"
            })), t(i, t(c, s(o(a.color, l), "0 0 1px rgba(0,0,0,.1)")));
            return i;
        },
        opacity: function(e, t, n) {
            t < e.childNodes.length && (e.childNodes[t].style.opacity = n);
        }
    }), "undefined" != typeof document) {
        l = function() {
            var n = e("style", {
                type: "text/css"
            });
            return t(document.getElementsByTagName("head")[0], n), n.sheet || n.styleSheet;
        }();
        var p = r(e("group"), {
            behavior: "url(#default#VML)"
        });
        !i(p, "transform") && p.adj ? c() : u = i(p, "animation");
    }
    return s;
}), !function(e, t) {
    "function" == typeof define && define.amd ? define(t) : "object" == typeof exports ? module.exports = t(require, exports, module) : e.CountUp = t();
}(this, function(e, t, n) {
    var i = function(e, t, n, i, r, a) {
        function o(e) {
            var t, n, i, r, a, o, s = e < 0;
            if (e = Math.abs(e).toFixed(u.decimals), e += "", t = e.split("."), n = t[0], i = t.length > 1 ? u.options.decimal + t[1] : "", 
            u.options.useGrouping) {
                for (r = "", a = 0, o = n.length; a < o; ++a) 0 !== a && a % 3 === 0 && (r = u.options.separator + r), 
                r = n[o - a - 1] + r;
                n = r;
            }
            return u.options.numerals.length && (n = n.replace(/[0-9]/g, function(e) {
                return u.options.numerals[+e];
            }), i = i.replace(/[0-9]/g, function(e) {
                return u.options.numerals[+e];
            })), (s ? "-" : "") + u.options.prefix + n + i + u.options.suffix;
        }
        function s(e, t, n, i) {
            return n * (-Math.pow(2, -10 * e / i) + 1) * 1024 / 1023 + t;
        }
        function c(e) {
            return "number" == typeof e && !isNaN(e);
        }
        var u = this;
        if (u.version = function() {
            return "1.9.3";
        }, u.options = {
            useEasing: !0,
            useGrouping: !0,
            separator: ",",
            decimal: ".",
            easingFn: s,
            formattingFn: o,
            prefix: "",
            suffix: "",
            numerals: []
        }, a && "object" == typeof a) for (var l in u.options) a.hasOwnProperty(l) && null !== a[l] && (u.options[l] = a[l]);
        "" === u.options.separator ? u.options.useGrouping = !1 : u.options.separator = "" + u.options.separator;
        for (var f = 0, d = [ "webkit", "moz", "ms", "o" ], h = 0; h < d.length && !window.requestAnimationFrame; ++h) window.requestAnimationFrame = window[d[h] + "RequestAnimationFrame"], 
        window.cancelAnimationFrame = window[d[h] + "CancelAnimationFrame"] || window[d[h] + "CancelRequestAnimationFrame"];
        window.requestAnimationFrame || (window.requestAnimationFrame = function(e, t) {
            var n = new Date().getTime(), i = Math.max(0, 16 - (n - f)), r = window.setTimeout(function() {
                e(n + i);
            }, i);
            return f = n + i, r;
        }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function(e) {
            clearTimeout(e);
        }), u.initialize = function() {
            return !(!u.initialized && (u.error = "", u.d = "string" == typeof e ? document.getElementById(e) : e, 
            u.d ? (u.startVal = Number(t), u.endVal = Number(n), c(u.startVal) && c(u.endVal) ? (u.decimals = Math.max(0, i || 0), 
            u.dec = Math.pow(10, u.decimals), u.duration = 1e3 * Number(r) || 2e3, u.countDown = u.startVal > u.endVal, 
            u.frameVal = u.startVal, u.initialized = !0, 0) : (u.error = "[CountUp] startVal (" + t + ") or endVal (" + n + ") is not a number", 
            1)) : (u.error = "[CountUp] target is null or undefined", 1)));
        }, u.printValue = function(e) {
            var t = u.options.formattingFn(e);
            "INPUT" === u.d.tagName ? this.d.value = t : "text" === u.d.tagName || "tspan" === u.d.tagName ? this.d.textContent = t : this.d.innerHTML = t;
        }, u.count = function(e) {
            u.startTime || (u.startTime = e), u.timestamp = e;
            var t = e - u.startTime;
            u.remaining = u.duration - t, u.options.useEasing ? u.countDown ? u.frameVal = u.startVal - u.options.easingFn(t, 0, u.startVal - u.endVal, u.duration) : u.frameVal = u.options.easingFn(t, u.startVal, u.endVal - u.startVal, u.duration) : u.countDown ? u.frameVal = u.startVal - (u.startVal - u.endVal) * (t / u.duration) : u.frameVal = u.startVal + (u.endVal - u.startVal) * (t / u.duration), 
            u.countDown ? u.frameVal = u.frameVal < u.endVal ? u.endVal : u.frameVal : u.frameVal = u.frameVal > u.endVal ? u.endVal : u.frameVal, 
            u.frameVal = Math.round(u.frameVal * u.dec) / u.dec, u.printValue(u.frameVal), t < u.duration ? u.rAF = requestAnimationFrame(u.count) : u.callback && u.callback();
        }, u.start = function(e) {
            u.initialize() && (u.callback = e, u.rAF = requestAnimationFrame(u.count));
        }, u.pauseResume = function() {
            u.paused ? (u.paused = !1, delete u.startTime, u.duration = u.remaining, u.startVal = u.frameVal, 
            requestAnimationFrame(u.count)) : (u.paused = !0, cancelAnimationFrame(u.rAF));
        }, u.reset = function() {
            u.paused = !1, delete u.startTime, u.initialized = !1, u.initialize() && (cancelAnimationFrame(u.rAF), 
            u.printValue(u.startVal));
        }, u.update = function(e) {
            if (u.initialize()) {
                if (e = Number(e), !c(e)) return void (u.error = "[CountUp] update() - new endVal is not a number: " + e);
                u.error = "", e !== u.frameVal && (cancelAnimationFrame(u.rAF), u.paused = !1, delete u.startTime, 
                u.startVal = u.frameVal, u.endVal = e, u.countDown = u.startVal > u.endVal, u.rAF = requestAnimationFrame(u.count));
            }
        }, u.initialize() && u.printValue(u.startVal);
    };
    return i;
}), !function(e, t) {
    "use strict";
    "object" == typeof module && module.exports ? module.exports = t(require("moment")) : "function" == typeof define && define.amd ? define([ "moment" ], t) : t(e.moment);
}(this, function(e) {
    "use strict";
    function t(e) {
        return 96 < e ? e - 87 : 64 < e ? e - 29 : e - 48;
    }
    function n(e) {
        var n = 0, i = e.split("."), r = i[0], a = i[1] || "", o = 1, s = 0, c = 1;
        for (45 === e.charCodeAt(0) && (c = -(n = 1)); n < r.length; n++) s = 60 * s + t(r.charCodeAt(n));
        for (n = 0; n < a.length; n++) o /= 60, s += t(a.charCodeAt(n)) * o;
        return s * c;
    }
    function i(e) {
        for (var t = 0; t < e.length; t++) e[t] = n(e[t]);
    }
    function r(e, t) {
        var n, i = [];
        for (n = 0; n < t.length; n++) i[n] = e[t[n]];
        return i;
    }
    function a(e) {
        var t = e.split("|"), n = t[2].split(" "), a = t[3].split(""), o = t[4].split(" ");
        return i(n), i(a), i(o), function(e, t) {
            for (var n = 0; n < t; n++) e[n] = Math.round((e[n - 1] || 0) + 6e4 * e[n]);
            e[t - 1] = 1 / 0;
        }(o, a.length), {
            name: t[0],
            abbrs: r(t[1].split(" "), a),
            offsets: r(n, a),
            untils: o,
            population: 0 | t[5]
        };
    }
    function o(e) {
        e && this._set(a(e));
    }
    function s(e, t) {
        this.name = e, this.zones = t;
    }
    function c(e) {
        var t = e.toTimeString(), n = t.match(/\([a-z ]+\)/i);
        "GMT" === (n = n && n[0] ? (n = n[0].match(/[A-Z]/g)) ? n.join("") : void 0 : (n = t.match(/[A-Z]{3,5}/g)) ? n[0] : void 0) && (n = void 0), 
        this.at = +e, this.abbr = n, this.offset = e.getTimezoneOffset();
    }
    function u(e) {
        this.zone = e, this.offsetScore = 0, this.abbrScore = 0;
    }
    function l(e, t) {
        for (var n, i; i = 6e4 * ((t.at - e.at) / 12e4 | 0); ) (n = new c(new Date(e.at + i))).offset === e.offset ? e = n : t = n;
        return e;
    }
    function f(e, t) {
        return e.offsetScore !== t.offsetScore ? e.offsetScore - t.offsetScore : e.abbrScore !== t.abbrScore ? e.abbrScore - t.abbrScore : e.zone.population !== t.zone.population ? t.zone.population - e.zone.population : t.zone.name.localeCompare(e.zone.name);
    }
    function d(e, t) {
        var n, r;
        for (i(t), n = 0; n < t.length; n++) r = t[n], C[r] = C[r] || {}, C[r][e] = !0;
    }
    function h() {
        try {
            var e = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (e && 3 < e.length) {
                var t = M[p(e)];
                if (t) return t;
                _("Moment Timezone found " + e + " from the Intl api, but did not have that data loaded.");
            }
        } catch (e) {}
        var n, i, r, a = function() {
            var e, t, n, i = new Date().getFullYear() - 2, r = new c(new Date(i, 0, 1)), a = [ r ];
            for (n = 1; n < 48; n++) (t = new c(new Date(i, n, 1))).offset !== r.offset && (e = l(r, t), 
            a.push(e), a.push(new c(new Date(e.at + 6e4)))), r = t;
            for (n = 0; n < 4; n++) a.push(new c(new Date(i + n, 0, 1))), a.push(new c(new Date(i + n, 6, 1)));
            return a;
        }(), o = a.length, s = function(e) {
            var t, n, i, r = e.length, a = {}, o = [];
            for (t = 0; t < r; t++) for (n in i = C[e[t].offset] || {}) i.hasOwnProperty(n) && (a[n] = !0);
            for (t in a) a.hasOwnProperty(t) && o.push(M[t]);
            return o;
        }(a), d = [];
        for (i = 0; i < s.length; i++) {
            for (n = new u(g(s[i]), o), r = 0; r < o; r++) n.scoreOffsetAt(a[r]);
            d.push(n);
        }
        return d.sort(f), 0 < d.length ? d[0].zone.name : void 0;
    }
    function p(e) {
        return (e || "").toLowerCase().replace(/\//g, "_");
    }
    function m(e) {
        var t, n, i, r;
        for ("string" == typeof e && (e = [ e ]), t = 0; t < e.length; t++) r = p(n = (i = e[t].split("|"))[0]), 
        k[r] = e[t], M[r] = n, d(r, i[2].split(" "));
    }
    function g(e, t) {
        e = p(e);
        var n, i = k[e];
        return i instanceof o ? i : "string" == typeof i ? (i = new o(i), k[e] = i) : E[e] && t !== g && (n = g(E[e], g)) ? ((i = k[e] = new o())._set(n), 
        i.name = M[e], i) : null;
    }
    function v(e) {
        var t, n, i, r;
        for ("string" == typeof e && (e = [ e ]), t = 0; t < e.length; t++) i = p((n = e[t].split("|"))[0]), 
        r = p(n[1]), E[i] = r, M[i] = n[0], E[r] = i, M[r] = n[1];
    }
    function y(e) {
        m(e.zones), v(e.links), function(e) {
            var t, n, i, r;
            if (e && e.length) for (t = 0; t < e.length; t++) n = (r = e[t].split("|"))[0].toUpperCase(), 
            i = r[1].split(" "), S[n] = new s(n, i);
        }(e.countries), b.dataVersion = e.version;
    }
    function A(e) {
        var t = "X" === e._f || "x" === e._f;
        return !(!e._a || void 0 !== e._tzm || t);
    }
    function _(e) {
        "undefined" != typeof console && "function" == typeof console.error && console.error(e);
    }
    function b(t) {
        var n = Array.prototype.slice.call(arguments, 0, -1), i = arguments[arguments.length - 1], r = g(i), a = e.utc.apply(null, n);
        return r && !e.isMoment(t) && A(a) && a.add(r.parse(a), "minutes"), a.tz(i), a;
    }
    function T(e) {
        return function() {
            return this._z ? this._z.abbr(this) : e.call(this);
        };
    }
    function x(e) {
        return function() {
            return this._z = null, e.apply(this, arguments);
        };
    }
    void 0 === e.version && e["default"] && (e = e["default"]);
    var w, k = {}, E = {}, S = {}, M = {}, C = {};
    e && "string" == typeof e.version || _("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
    var P = e.version.split("."), D = +P[0], O = +P[1];
    (D < 2 || 2 == D && O < 6) && _("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + e.version + ". See momentjs.com"), 
    o.prototype = {
        _set: function(e) {
            this.name = e.name, this.abbrs = e.abbrs, this.untils = e.untils, this.offsets = e.offsets, 
            this.population = e.population;
        },
        _index: function(e) {
            var t, n = +e, i = this.untils;
            for (t = 0; t < i.length; t++) if (n < i[t]) return t;
        },
        countries: function() {
            var e = this.name;
            return Object.keys(S).filter(function(t) {
                return -1 !== S[t].zones.indexOf(e);
            });
        },
        parse: function(e) {
            var t, n, i, r, a = +e, o = this.offsets, s = this.untils, c = s.length - 1;
            for (r = 0; r < c; r++) if (t = o[r], n = o[r + 1], i = o[r ? r - 1 : r], t < n && b.moveAmbiguousForward ? t = n : i < t && b.moveInvalidForward && (t = i), 
            a < s[r] - 6e4 * t) return o[r];
            return o[c];
        },
        abbr: function(e) {
            return this.abbrs[this._index(e)];
        },
        offset: function(e) {
            return _("zone.offset has been deprecated in favor of zone.utcOffset"), this.offsets[this._index(e)];
        },
        utcOffset: function(e) {
            return this.offsets[this._index(e)];
        }
    }, u.prototype.scoreOffsetAt = function(e) {
        this.offsetScore += Math.abs(this.zone.utcOffset(e.at) - e.offset), this.zone.abbr(e.at).replace(/[^A-Z]/g, "") !== e.abbr && this.abbrScore++;
    }, b.version = "0.5.34", b.dataVersion = "", b._zones = k, b._links = E, b._names = M, 
    b._countries = S, b.add = m, b.link = v, b.load = y, b.zone = g, b.zoneExists = function I(e) {
        return I.didShowError || (I.didShowError = !0, _("moment.tz.zoneExists('" + e + "') has been deprecated in favor of !moment.tz.zone('" + e + "')")), 
        !!g(e);
    }, b.guess = function(e) {
        return w && !e || (w = h()), w;
    }, b.names = function() {
        var e, t = [];
        for (e in M) M.hasOwnProperty(e) && (k[e] || k[E[e]]) && M[e] && t.push(M[e]);
        return t.sort();
    }, b.Zone = o, b.unpack = a, b.unpackBase60 = n, b.needsOffset = A, b.moveInvalidForward = !0, 
    b.moveAmbiguousForward = !1, b.countries = function() {
        return Object.keys(S);
    }, b.zonesForCountry = function(e, t) {
        if (!(e = function(e) {
            return e = e.toUpperCase(), S[e] || null;
        }(e))) return null;
        var n = e.zones.sort();
        return t ? n.map(function(e) {
            return {
                name: e,
                offset: g(e).utcOffset(new Date())
            };
        }) : n;
    };
    var N, z = e.fn;
    e.tz = b, e.defaultZone = null, e.updateOffset = function(t, n) {
        var i, r = e.defaultZone;
        if (void 0 === t._z && (r && A(t) && !t._isUTC && (t._d = e.utc(t._a)._d, t.utc().add(r.parse(t), "minutes")), 
        t._z = r), t._z) if (i = t._z.utcOffset(t), Math.abs(i) < 16 && (i /= 60), void 0 !== t.utcOffset) {
            var a = t._z;
            t.utcOffset(-i, n), t._z = a;
        } else t.zone(i, n);
    }, z.tz = function(t, n) {
        if (t) {
            if ("string" != typeof t) throw new Error("Time zone name must be a string, got " + t + " [" + typeof t + "]");
            return this._z = g(t), this._z ? e.updateOffset(this, n) : _("Moment Timezone has no data for " + t + ". See http://momentjs.com/timezone/docs/#/data-loading/."), 
            this;
        }
        if (this._z) return this._z.name;
    }, z.zoneName = T(z.zoneName), z.zoneAbbr = T(z.zoneAbbr), z.utc = x(z.utc), z.local = x(z.local), 
    z.utcOffset = (N = z.utcOffset, function() {
        return 0 < arguments.length && (this._z = null), N.apply(this, arguments);
    }), e.tz.setDefault = function(t) {
        return (D < 2 || 2 == D && O < 9) && _("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + e.version + "."), 
        e.defaultZone = t ? g(t) : null, e;
    };
    var L = e.momentProperties;
    return "[object Array]" === Object.prototype.toString.call(L) ? (L.push("_z"), L.push("_a")) : L && (L._z = null), 
    y({
        version: "2021e",
        zones: [ "Africa/Abidjan|GMT|0|0||48e5", "Africa/Nairobi|EAT|-30|0||47e5", "Africa/Algiers|CET|-10|0||26e5", "Africa/Lagos|WAT|-10|0||17e6", "Africa/Maputo|CAT|-20|0||26e5", "Africa/Cairo|EET|-20|0||15e6", "Africa/Casablanca|+00 +01|0 -10|0101010101010101010101010101|1QyO0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00|32e5", "Europe/Paris|CET CEST|-10 -20|01010101010101010101010|1QyN0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6", "Africa/Johannesburg|SAST|-20|0||84e5", "Africa/Juba|EAT CAT|-30 -20|01|24nx0|", "Africa/Khartoum|EAT CAT|-30 -20|01|1Usl0|51e5", "Africa/Sao_Tome|GMT WAT|0 -10|010|1UQN0 2q00|", "Africa/Windhoek|CAT WAT|-20 -10|01010|1QBA0 11B0 1nX0 11B0|32e4", "America/Adak|HST HDT|a0 90|01010101010101010101010|1Qto0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326", "America/Anchorage|AKST AKDT|90 80|01010101010101010101010|1Qtn0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4", "America/Santo_Domingo|AST|40|0||29e5", "America/Fortaleza|-03|30|0||34e5", "America/Asuncion|-03 -04|30 40|01010101010101010101010|1QyP0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5", "America/Panama|EST|50|0||15e5", "America/Mexico_City|CST CDT|60 50|01010101010101010101010|1QBI0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|20e6", "America/Managua|CST|60|0||22e5", "America/La_Paz|-04|40|0||19e5", "America/Lima|-05|50|0||11e6", "America/Denver|MST MDT|70 60|01010101010101010101010|1Qtl0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5", "America/Campo_Grande|-03 -04|30 40|01010101|1QkP0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4", "America/Caracas|-0430 -04|4u 40|01|1QMT0|29e5", "America/Chicago|CST CDT|60 50|01010101010101010101010|1Qtk0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5", "America/Chihuahua|MST MDT|70 60|01010101010101010101010|1QBJ0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|81e4", "America/Phoenix|MST|70|0||42e5", "America/Whitehorse|PST PDT MST|80 70 70|01010101012|1Qtm0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3", "America/New_York|EST EDT|50 40|01010101010101010101010|1Qtj0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6", "America/Los_Angeles|PST PDT|80 70|01010101010101010101010|1Qtm0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6", "America/Halifax|AST ADT|40 30|01010101010101010101010|1Qti0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4", "America/Godthab|-03 -02|30 20|01010101010101010101010|1QyN0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3", "America/Grand_Turk|AST EDT EST|40 40 50|0121212121212121212|1Vkv0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2", "America/Havana|CST CDT|50 40|01010101010101010101010|1Qth0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5", "America/Metlakatla|AKST AKDT PST|90 80 80|010101201010101010101010|1Qtn0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2", "America/Miquelon|-03 -02|30 20|01010101010101010101010|1Qth0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2", "America/Noronha|-02|20|0||30e2", "America/Port-au-Prince|EST EDT|50 40|010101010101010101010|1SST0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5", "Antarctica/Palmer|-03 -04|30 40|010|1QSr0 Ap0|40", "America/Santiago|-03 -04|30 40|01010101010101010101010|1QSr0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5", "America/Sao_Paulo|-02 -03|20 30|01010101|1QkO0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6", "Atlantic/Azores|-01 +00|10 0|01010101010101010101010|1QyN0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4", "America/St_Johns|NST NDT|3u 2u|01010101010101010101010|1Qthu 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4", "Antarctica/Casey|+08 +11|-80 -b0|01010101|1RWg0 3m10 1o30 14k0 1kr0 12l0 1o01|10", "Asia/Bangkok|+07|-70|0||15e6", "Asia/Vladivostok|+10|-a0|0||60e4", "Australia/Sydney|AEDT AEST|-b0 -a0|01010101010101010101010|1QBs0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5", "Asia/Tashkent|+05|-50|0||23e5", "Pacific/Auckland|NZDT NZST|-d0 -c0|01010101010101010101010|1QBq0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00|14e5", "Asia/Baghdad|+03|-30|0||66e5", "Antarctica/Troll|+00 +02|0 -20|01010101010101010101010|1QyN0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40", "Asia/Dhaka|+06|-60|0||16e6", "Asia/Amman|EET EEST|-20 -30|01010101010101010101010|1QAK0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00|25e5", "Asia/Kamchatka|+12|-c0|0||18e4", "Asia/Dubai|+04|-40|0||39e5", "Asia/Barnaul|+06 +07|-60 -70|01|1QyI0|", "Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|1QyK0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5", "Asia/Kuala_Lumpur|+08|-80|0||71e5", "Asia/Kolkata|IST|-5u|0||15e6", "Asia/Chita|+08 +09|-80 -90|01|1QyG0|33e4", "Asia/Ulaanbaatar|+08 +09|-80 -90|010|1Qyi0 1cJ0|12e5", "Asia/Shanghai|CST|-80|0||23e6", "Asia/Colombo|+0530|-5u|0||22e5", "Asia/Damascus|EET EEST|-20 -30|01010101010101010101010|1QxW0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5", "Asia/Yakutsk|+09|-90|0||28e4", "Asia/Famagusta|EET EEST +03|-20 -30 -30|0120101010101010101010|1QyN0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|", "Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|1Qyn0 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0|18e5", "Asia/Hong_Kong|HKT|-80|0||73e5", "Asia/Hovd|+07 +08|-70 -80|010|1Qyj0 1cJ0|81e3", "Europe/Istanbul|EET EEST +03|-20 -30 -30|012|1QyN0 15w0|13e6", "Asia/Jakarta|WIB|-70|0||31e6", "Asia/Jayapura|WIT|-90|0||26e4", "Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|1Qy00 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4", "Asia/Kabul|+0430|-4u|0||46e5", "Asia/Karachi|PKT|-50|0||24e6", "Asia/Kathmandu|+0545|-5J|0||12e5", "Asia/Magadan|+10 +11|-a0 -b0|01|1QJQ0|95e3", "Asia/Makassar|WITA|-80|0||15e5", "Asia/Manila|PST|-80|0||24e6", "Europe/Athens|EET EEST|-20 -30|01010101010101010101010|1QyN0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5", "Asia/Novosibirsk|+06 +07|-60 -70|01|1Rmk0|15e5", "Asia/Pyongyang|KST KST|-8u -90|01|1VGf0|29e5", "Asia/Qyzylorda|+06 +05|-60 -50|01|1Xei0|73e4", "Asia/Rangoon|+0630|-6u|0||48e5", "Asia/Sakhalin|+10 +11|-a0 -b0|01|1QyE0|58e4", "Asia/Seoul|KST|-90|0||23e6", "Pacific/Bougainville|+11|-b0|0||18e4", "Asia/Tehran|+0330 +0430|-3u -4u|01010101010101010101010|1Qwku 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6", "Asia/Tokyo|JST|-90|0||38e6", "Asia/Tomsk|+06 +07|-60 -70|01|1QXU0|10e5", "Europe/Lisbon|WET WEST|0 -10|01010101010101010101010|1QyN0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5", "Atlantic/Cape_Verde|-01|10|0||50e4", "Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|1QBsu 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5", "Australia/Brisbane|AEST|-a0|0||20e5", "Australia/Darwin|ACST|-9u|0||12e4", "Australia/Eucla|+0845|-8J|0||368", "Australia/Lord_Howe|+11 +1030|-b0 -au|01010101010101010101010|1QBr0 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu|347", "Australia/Perth|AWST|-80|0||18e5", "Pacific/Easter|-05 -06|50 60|01010101010101010101010|1QSr0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2", "Europe/Dublin|GMT IST|0 -10|01010101010101010101010|1QyN0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5", "Etc/GMT-1|+01|-10|0||", "Pacific/Fakaofo|+13|-d0|0||483", "Pacific/Kiritimati|+14|-e0|0||51e2", "Etc/GMT-2|+02|-20|0||", "Pacific/Tahiti|-10|a0|0||18e4", "Pacific/Niue|-11|b0|0||12e2", "Etc/GMT+12|-12|c0|0||", "Pacific/Galapagos|-06|60|0||25e3", "Etc/GMT+7|-07|70|0||", "Pacific/Pitcairn|-08|80|0||56", "Pacific/Gambier|-09|90|0||125", "Etc/UTC|UTC|0|0||", "Europe/Ulyanovsk|+03 +04|-30 -40|01|1QyL0|13e5", "Europe/London|GMT BST|0 -10|01010101010101010101010|1QyN0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6", "Europe/Chisinau|EET EEST|-20 -30|01010101010101010101010|1QyM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4", "Europe/Moscow|MSK|-30|0||16e6", "Europe/Saratov|+03 +04|-30 -40|01|1Sfz0|", "Europe/Volgograd|+03 +04|-30 -40|010|1WQL0 5gn0|10e5", "Pacific/Honolulu|HST|a0|0||37e4", "MET|MET MEST|-10 -20|01010101010101010101010|1QyN0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|", "Pacific/Chatham|+1345 +1245|-dJ -cJ|01010101010101010101010|1QBq0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00|600", "Pacific/Apia|+14 +13|-e0 -d0|010101010101|1QBq0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3", "Pacific/Fiji|+13 +12|-d0 -c0|010101010101010101010|1Q6C0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 4q00 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0|88e4", "Pacific/Guam|ChST|-a0|0||17e4", "Pacific/Marquesas|-0930|9u|0||86e2", "Pacific/Pago_Pago|SST|b0|0||37e2", "Pacific/Norfolk|+11 +12|-b0 -c0|0101010101010101|219P0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4", "Pacific/Tongatapu|+13 +14|-d0 -e0|010|1S4d0 s00|75e3" ],
        links: [ "Africa/Abidjan|Africa/Accra", "Africa/Abidjan|Africa/Bamako", "Africa/Abidjan|Africa/Banjul", "Africa/Abidjan|Africa/Bissau", "Africa/Abidjan|Africa/Conakry", "Africa/Abidjan|Africa/Dakar", "Africa/Abidjan|Africa/Freetown", "Africa/Abidjan|Africa/Lome", "Africa/Abidjan|Africa/Monrovia", "Africa/Abidjan|Africa/Nouakchott", "Africa/Abidjan|Africa/Ouagadougou", "Africa/Abidjan|Africa/Timbuktu", "Africa/Abidjan|America/Danmarkshavn", "Africa/Abidjan|Atlantic/Reykjavik", "Africa/Abidjan|Atlantic/St_Helena", "Africa/Abidjan|Etc/GMT", "Africa/Abidjan|Etc/GMT+0", "Africa/Abidjan|Etc/GMT-0", "Africa/Abidjan|Etc/GMT0", "Africa/Abidjan|Etc/Greenwich", "Africa/Abidjan|GMT", "Africa/Abidjan|GMT+0", "Africa/Abidjan|GMT-0", "Africa/Abidjan|GMT0", "Africa/Abidjan|Greenwich", "Africa/Abidjan|Iceland", "Africa/Algiers|Africa/Tunis", "Africa/Cairo|Africa/Tripoli", "Africa/Cairo|Egypt", "Africa/Cairo|Europe/Kaliningrad", "Africa/Cairo|Libya", "Africa/Casablanca|Africa/El_Aaiun", "Africa/Johannesburg|Africa/Maseru", "Africa/Johannesburg|Africa/Mbabane", "Africa/Lagos|Africa/Bangui", "Africa/Lagos|Africa/Brazzaville", "Africa/Lagos|Africa/Douala", "Africa/Lagos|Africa/Kinshasa", "Africa/Lagos|Africa/Libreville", "Africa/Lagos|Africa/Luanda", "Africa/Lagos|Africa/Malabo", "Africa/Lagos|Africa/Ndjamena", "Africa/Lagos|Africa/Niamey", "Africa/Lagos|Africa/Porto-Novo", "Africa/Maputo|Africa/Blantyre", "Africa/Maputo|Africa/Bujumbura", "Africa/Maputo|Africa/Gaborone", "Africa/Maputo|Africa/Harare", "Africa/Maputo|Africa/Kigali", "Africa/Maputo|Africa/Lubumbashi", "Africa/Maputo|Africa/Lusaka", "Africa/Nairobi|Africa/Addis_Ababa", "Africa/Nairobi|Africa/Asmara", "Africa/Nairobi|Africa/Asmera", "Africa/Nairobi|Africa/Dar_es_Salaam", "Africa/Nairobi|Africa/Djibouti", "Africa/Nairobi|Africa/Kampala", "Africa/Nairobi|Africa/Mogadishu", "Africa/Nairobi|Indian/Antananarivo", "Africa/Nairobi|Indian/Comoro", "Africa/Nairobi|Indian/Mayotte", "America/Adak|America/Atka", "America/Adak|US/Aleutian", "America/Anchorage|America/Juneau", "America/Anchorage|America/Nome", "America/Anchorage|America/Sitka", "America/Anchorage|America/Yakutat", "America/Anchorage|US/Alaska", "America/Campo_Grande|America/Cuiaba", "America/Chicago|America/Indiana/Knox", "America/Chicago|America/Indiana/Tell_City", "America/Chicago|America/Knox_IN", "America/Chicago|America/Matamoros", "America/Chicago|America/Menominee", "America/Chicago|America/North_Dakota/Beulah", "America/Chicago|America/North_Dakota/Center", "America/Chicago|America/North_Dakota/New_Salem", "America/Chicago|America/Rainy_River", "America/Chicago|America/Rankin_Inlet", "America/Chicago|America/Resolute", "America/Chicago|America/Winnipeg", "America/Chicago|CST6CDT", "America/Chicago|Canada/Central", "America/Chicago|US/Central", "America/Chicago|US/Indiana-Starke", "America/Chihuahua|America/Mazatlan", "America/Chihuahua|Mexico/BajaSur", "America/Denver|America/Boise", "America/Denver|America/Cambridge_Bay", "America/Denver|America/Edmonton", "America/Denver|America/Inuvik", "America/Denver|America/Ojinaga", "America/Denver|America/Shiprock", "America/Denver|America/Yellowknife", "America/Denver|Canada/Mountain", "America/Denver|MST7MDT", "America/Denver|Navajo", "America/Denver|US/Mountain", "America/Fortaleza|America/Araguaina", "America/Fortaleza|America/Argentina/Buenos_Aires", "America/Fortaleza|America/Argentina/Catamarca", "America/Fortaleza|America/Argentina/ComodRivadavia", "America/Fortaleza|America/Argentina/Cordoba", "America/Fortaleza|America/Argentina/Jujuy", "America/Fortaleza|America/Argentina/La_Rioja", "America/Fortaleza|America/Argentina/Mendoza", "America/Fortaleza|America/Argentina/Rio_Gallegos", "America/Fortaleza|America/Argentina/Salta", "America/Fortaleza|America/Argentina/San_Juan", "America/Fortaleza|America/Argentina/San_Luis", "America/Fortaleza|America/Argentina/Tucuman", "America/Fortaleza|America/Argentina/Ushuaia", "America/Fortaleza|America/Bahia", "America/Fortaleza|America/Belem", "America/Fortaleza|America/Buenos_Aires", "America/Fortaleza|America/Catamarca", "America/Fortaleza|America/Cayenne", "America/Fortaleza|America/Cordoba", "America/Fortaleza|America/Jujuy", "America/Fortaleza|America/Maceio", "America/Fortaleza|America/Mendoza", "America/Fortaleza|America/Montevideo", "America/Fortaleza|America/Paramaribo", "America/Fortaleza|America/Recife", "America/Fortaleza|America/Rosario", "America/Fortaleza|America/Santarem", "America/Fortaleza|Antarctica/Rothera", "America/Fortaleza|Atlantic/Stanley", "America/Fortaleza|Etc/GMT+3", "America/Godthab|America/Nuuk", "America/Halifax|America/Glace_Bay", "America/Halifax|America/Goose_Bay", "America/Halifax|America/Moncton", "America/Halifax|America/Thule", "America/Halifax|Atlantic/Bermuda", "America/Halifax|Canada/Atlantic", "America/Havana|Cuba", "America/La_Paz|America/Boa_Vista", "America/La_Paz|America/Guyana", "America/La_Paz|America/Manaus", "America/La_Paz|America/Porto_Velho", "America/La_Paz|Brazil/West", "America/La_Paz|Etc/GMT+4", "America/Lima|America/Bogota", "America/Lima|America/Eirunepe", "America/Lima|America/Guayaquil", "America/Lima|America/Porto_Acre", "America/Lima|America/Rio_Branco", "America/Lima|Brazil/Acre", "America/Lima|Etc/GMT+5", "America/Los_Angeles|America/Ensenada", "America/Los_Angeles|America/Santa_Isabel", "America/Los_Angeles|America/Tijuana", "America/Los_Angeles|America/Vancouver", "America/Los_Angeles|Canada/Pacific", "America/Los_Angeles|Mexico/BajaNorte", "America/Los_Angeles|PST8PDT", "America/Los_Angeles|US/Pacific", "America/Managua|America/Belize", "America/Managua|America/Costa_Rica", "America/Managua|America/El_Salvador", "America/Managua|America/Guatemala", "America/Managua|America/Regina", "America/Managua|America/Swift_Current", "America/Managua|America/Tegucigalpa", "America/Managua|Canada/Saskatchewan", "America/Mexico_City|America/Bahia_Banderas", "America/Mexico_City|America/Merida", "America/Mexico_City|America/Monterrey", "America/Mexico_City|Mexico/General", "America/New_York|America/Detroit", "America/New_York|America/Fort_Wayne", "America/New_York|America/Indiana/Indianapolis", "America/New_York|America/Indiana/Marengo", "America/New_York|America/Indiana/Petersburg", "America/New_York|America/Indiana/Vevay", "America/New_York|America/Indiana/Vincennes", "America/New_York|America/Indiana/Winamac", "America/New_York|America/Indianapolis", "America/New_York|America/Iqaluit", "America/New_York|America/Kentucky/Louisville", "America/New_York|America/Kentucky/Monticello", "America/New_York|America/Louisville", "America/New_York|America/Montreal", "America/New_York|America/Nassau", "America/New_York|America/Nipigon", "America/New_York|America/Pangnirtung", "America/New_York|America/Thunder_Bay", "America/New_York|America/Toronto", "America/New_York|Canada/Eastern", "America/New_York|EST5EDT", "America/New_York|US/East-Indiana", "America/New_York|US/Eastern", "America/New_York|US/Michigan", "America/Noronha|Atlantic/South_Georgia", "America/Noronha|Brazil/DeNoronha", "America/Noronha|Etc/GMT+2", "America/Panama|America/Atikokan", "America/Panama|America/Cancun", "America/Panama|America/Cayman", "America/Panama|America/Coral_Harbour", "America/Panama|America/Jamaica", "America/Panama|EST", "America/Panama|Jamaica", "America/Phoenix|America/Creston", "America/Phoenix|America/Dawson_Creek", "America/Phoenix|America/Fort_Nelson", "America/Phoenix|America/Hermosillo", "America/Phoenix|MST", "America/Phoenix|US/Arizona", "America/Santiago|Chile/Continental", "America/Santo_Domingo|America/Anguilla", "America/Santo_Domingo|America/Antigua", "America/Santo_Domingo|America/Aruba", "America/Santo_Domingo|America/Barbados", "America/Santo_Domingo|America/Blanc-Sablon", "America/Santo_Domingo|America/Curacao", "America/Santo_Domingo|America/Dominica", "America/Santo_Domingo|America/Grenada", "America/Santo_Domingo|America/Guadeloupe", "America/Santo_Domingo|America/Kralendijk", "America/Santo_Domingo|America/Lower_Princes", "America/Santo_Domingo|America/Marigot", "America/Santo_Domingo|America/Martinique", "America/Santo_Domingo|America/Montserrat", "America/Santo_Domingo|America/Port_of_Spain", "America/Santo_Domingo|America/Puerto_Rico", "America/Santo_Domingo|America/St_Barthelemy", "America/Santo_Domingo|America/St_Kitts", "America/Santo_Domingo|America/St_Lucia", "America/Santo_Domingo|America/St_Thomas", "America/Santo_Domingo|America/St_Vincent", "America/Santo_Domingo|America/Tortola", "America/Santo_Domingo|America/Virgin", "America/Sao_Paulo|Brazil/East", "America/St_Johns|Canada/Newfoundland", "America/Whitehorse|America/Dawson", "America/Whitehorse|Canada/Yukon", "Antarctica/Palmer|America/Punta_Arenas", "Asia/Baghdad|Antarctica/Syowa", "Asia/Baghdad|Asia/Aden", "Asia/Baghdad|Asia/Bahrain", "Asia/Baghdad|Asia/Kuwait", "Asia/Baghdad|Asia/Qatar", "Asia/Baghdad|Asia/Riyadh", "Asia/Baghdad|Etc/GMT-3", "Asia/Baghdad|Europe/Kirov", "Asia/Baghdad|Europe/Minsk", "Asia/Bangkok|Antarctica/Davis", "Asia/Bangkok|Asia/Ho_Chi_Minh", "Asia/Bangkok|Asia/Krasnoyarsk", "Asia/Bangkok|Asia/Novokuznetsk", "Asia/Bangkok|Asia/Phnom_Penh", "Asia/Bangkok|Asia/Saigon", "Asia/Bangkok|Asia/Vientiane", "Asia/Bangkok|Etc/GMT-7", "Asia/Bangkok|Indian/Christmas", "Asia/Dhaka|Antarctica/Vostok", "Asia/Dhaka|Asia/Almaty", "Asia/Dhaka|Asia/Bishkek", "Asia/Dhaka|Asia/Dacca", "Asia/Dhaka|Asia/Kashgar", "Asia/Dhaka|Asia/Omsk", "Asia/Dhaka|Asia/Qostanay", "Asia/Dhaka|Asia/Thimbu", "Asia/Dhaka|Asia/Thimphu", "Asia/Dhaka|Asia/Urumqi", "Asia/Dhaka|Etc/GMT-6", "Asia/Dhaka|Indian/Chagos", "Asia/Dubai|Asia/Baku", "Asia/Dubai|Asia/Muscat", "Asia/Dubai|Asia/Tbilisi", "Asia/Dubai|Asia/Yerevan", "Asia/Dubai|Etc/GMT-4", "Asia/Dubai|Europe/Samara", "Asia/Dubai|Indian/Mahe", "Asia/Dubai|Indian/Mauritius", "Asia/Dubai|Indian/Reunion", "Asia/Gaza|Asia/Hebron", "Asia/Hong_Kong|Hongkong", "Asia/Jakarta|Asia/Pontianak", "Asia/Jerusalem|Asia/Tel_Aviv", "Asia/Jerusalem|Israel", "Asia/Kamchatka|Asia/Anadyr", "Asia/Kamchatka|Etc/GMT-12", "Asia/Kamchatka|Kwajalein", "Asia/Kamchatka|Pacific/Funafuti", "Asia/Kamchatka|Pacific/Kwajalein", "Asia/Kamchatka|Pacific/Majuro", "Asia/Kamchatka|Pacific/Nauru", "Asia/Kamchatka|Pacific/Tarawa", "Asia/Kamchatka|Pacific/Wake", "Asia/Kamchatka|Pacific/Wallis", "Asia/Kathmandu|Asia/Katmandu", "Asia/Kolkata|Asia/Calcutta", "Asia/Kuala_Lumpur|Asia/Brunei", "Asia/Kuala_Lumpur|Asia/Irkutsk", "Asia/Kuala_Lumpur|Asia/Kuching", "Asia/Kuala_Lumpur|Asia/Singapore", "Asia/Kuala_Lumpur|Etc/GMT-8", "Asia/Kuala_Lumpur|Singapore", "Asia/Makassar|Asia/Ujung_Pandang", "Asia/Rangoon|Asia/Yangon", "Asia/Rangoon|Indian/Cocos", "Asia/Seoul|ROK", "Asia/Shanghai|Asia/Chongqing", "Asia/Shanghai|Asia/Chungking", "Asia/Shanghai|Asia/Harbin", "Asia/Shanghai|Asia/Macao", "Asia/Shanghai|Asia/Macau", "Asia/Shanghai|Asia/Taipei", "Asia/Shanghai|PRC", "Asia/Shanghai|ROC", "Asia/Tashkent|Antarctica/Mawson", "Asia/Tashkent|Asia/Aqtau", "Asia/Tashkent|Asia/Aqtobe", "Asia/Tashkent|Asia/Ashgabat", "Asia/Tashkent|Asia/Ashkhabad", "Asia/Tashkent|Asia/Atyrau", "Asia/Tashkent|Asia/Dushanbe", "Asia/Tashkent|Asia/Oral", "Asia/Tashkent|Asia/Samarkand", "Asia/Tashkent|Asia/Yekaterinburg", "Asia/Tashkent|Etc/GMT-5", "Asia/Tashkent|Indian/Kerguelen", "Asia/Tashkent|Indian/Maldives", "Asia/Tehran|Iran", "Asia/Tokyo|Japan", "Asia/Ulaanbaatar|Asia/Choibalsan", "Asia/Ulaanbaatar|Asia/Ulan_Bator", "Asia/Vladivostok|Antarctica/DumontDUrville", "Asia/Vladivostok|Asia/Ust-Nera", "Asia/Vladivostok|Etc/GMT-10", "Asia/Vladivostok|Pacific/Chuuk", "Asia/Vladivostok|Pacific/Port_Moresby", "Asia/Vladivostok|Pacific/Truk", "Asia/Vladivostok|Pacific/Yap", "Asia/Yakutsk|Asia/Dili", "Asia/Yakutsk|Asia/Khandyga", "Asia/Yakutsk|Etc/GMT-9", "Asia/Yakutsk|Pacific/Palau", "Atlantic/Azores|America/Scoresbysund", "Atlantic/Cape_Verde|Etc/GMT+1", "Australia/Adelaide|Australia/Broken_Hill", "Australia/Adelaide|Australia/South", "Australia/Adelaide|Australia/Yancowinna", "Australia/Brisbane|Australia/Lindeman", "Australia/Brisbane|Australia/Queensland", "Australia/Darwin|Australia/North", "Australia/Lord_Howe|Australia/LHI", "Australia/Perth|Australia/West", "Australia/Sydney|Antarctica/Macquarie", "Australia/Sydney|Australia/ACT", "Australia/Sydney|Australia/Canberra", "Australia/Sydney|Australia/Currie", "Australia/Sydney|Australia/Hobart", "Australia/Sydney|Australia/Melbourne", "Australia/Sydney|Australia/NSW", "Australia/Sydney|Australia/Tasmania", "Australia/Sydney|Australia/Victoria", "Etc/UTC|Etc/UCT", "Etc/UTC|Etc/Universal", "Etc/UTC|Etc/Zulu", "Etc/UTC|UCT", "Etc/UTC|UTC", "Etc/UTC|Universal", "Etc/UTC|Zulu", "Europe/Athens|Asia/Nicosia", "Europe/Athens|EET", "Europe/Athens|Europe/Bucharest", "Europe/Athens|Europe/Helsinki", "Europe/Athens|Europe/Kiev", "Europe/Athens|Europe/Mariehamn", "Europe/Athens|Europe/Nicosia", "Europe/Athens|Europe/Riga", "Europe/Athens|Europe/Sofia", "Europe/Athens|Europe/Tallinn", "Europe/Athens|Europe/Uzhgorod", "Europe/Athens|Europe/Vilnius", "Europe/Athens|Europe/Zaporozhye", "Europe/Chisinau|Europe/Tiraspol", "Europe/Dublin|Eire", "Europe/Istanbul|Asia/Istanbul", "Europe/Istanbul|Turkey", "Europe/Lisbon|Atlantic/Canary", "Europe/Lisbon|Atlantic/Faeroe", "Europe/Lisbon|Atlantic/Faroe", "Europe/Lisbon|Atlantic/Madeira", "Europe/Lisbon|Portugal", "Europe/Lisbon|WET", "Europe/London|Europe/Belfast", "Europe/London|Europe/Guernsey", "Europe/London|Europe/Isle_of_Man", "Europe/London|Europe/Jersey", "Europe/London|GB", "Europe/London|GB-Eire", "Europe/Moscow|Europe/Simferopol", "Europe/Moscow|W-SU", "Europe/Paris|Africa/Ceuta", "Europe/Paris|Arctic/Longyearbyen", "Europe/Paris|Atlantic/Jan_Mayen", "Europe/Paris|CET", "Europe/Paris|Europe/Amsterdam", "Europe/Paris|Europe/Andorra", "Europe/Paris|Europe/Belgrade", "Europe/Paris|Europe/Berlin", "Europe/Paris|Europe/Bratislava", "Europe/Paris|Europe/Brussels", "Europe/Paris|Europe/Budapest", "Europe/Paris|Europe/Busingen", "Europe/Paris|Europe/Copenhagen", "Europe/Paris|Europe/Gibraltar", "Europe/Paris|Europe/Ljubljana", "Europe/Paris|Europe/Luxembourg", "Europe/Paris|Europe/Madrid", "Europe/Paris|Europe/Malta", "Europe/Paris|Europe/Monaco", "Europe/Paris|Europe/Oslo", "Europe/Paris|Europe/Podgorica", "Europe/Paris|Europe/Prague", "Europe/Paris|Europe/Rome", "Europe/Paris|Europe/San_Marino", "Europe/Paris|Europe/Sarajevo", "Europe/Paris|Europe/Skopje", "Europe/Paris|Europe/Stockholm", "Europe/Paris|Europe/Tirane", "Europe/Paris|Europe/Vaduz", "Europe/Paris|Europe/Vatican", "Europe/Paris|Europe/Vienna", "Europe/Paris|Europe/Warsaw", "Europe/Paris|Europe/Zagreb", "Europe/Paris|Europe/Zurich", "Europe/Paris|Poland", "Europe/Ulyanovsk|Europe/Astrakhan", "Pacific/Auckland|Antarctica/McMurdo", "Pacific/Auckland|Antarctica/South_Pole", "Pacific/Auckland|NZ", "Pacific/Bougainville|Asia/Srednekolymsk", "Pacific/Bougainville|Etc/GMT-11", "Pacific/Bougainville|Pacific/Efate", "Pacific/Bougainville|Pacific/Guadalcanal", "Pacific/Bougainville|Pacific/Kosrae", "Pacific/Bougainville|Pacific/Noumea", "Pacific/Bougainville|Pacific/Pohnpei", "Pacific/Bougainville|Pacific/Ponape", "Pacific/Chatham|NZ-CHAT", "Pacific/Easter|Chile/EasterIsland", "Pacific/Fakaofo|Etc/GMT-13", "Pacific/Fakaofo|Pacific/Enderbury", "Pacific/Fakaofo|Pacific/Kanton", "Pacific/Galapagos|Etc/GMT+6", "Pacific/Gambier|Etc/GMT+9", "Pacific/Guam|Pacific/Saipan", "Pacific/Honolulu|HST", "Pacific/Honolulu|Pacific/Johnston", "Pacific/Honolulu|US/Hawaii", "Pacific/Kiritimati|Etc/GMT-14", "Pacific/Niue|Etc/GMT+11", "Pacific/Pago_Pago|Pacific/Midway", "Pacific/Pago_Pago|Pacific/Samoa", "Pacific/Pago_Pago|US/Samoa", "Pacific/Pitcairn|Etc/GMT+8", "Pacific/Tahiti|Etc/GMT+10", "Pacific/Tahiti|Pacific/Rarotonga" ],
        countries: [ "AD|Europe/Andorra", "AE|Asia/Dubai", "AF|Asia/Kabul", "AG|America/Port_of_Spain America/Antigua", "AI|America/Port_of_Spain America/Anguilla", "AL|Europe/Tirane", "AM|Asia/Yerevan", "AO|Africa/Lagos Africa/Luanda", "AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo", "AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia", "AS|Pacific/Pago_Pago", "AT|Europe/Vienna", "AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla", "AW|America/Curacao America/Aruba", "AX|Europe/Helsinki Europe/Mariehamn", "AZ|Asia/Baku", "BA|Europe/Belgrade Europe/Sarajevo", "BB|America/Barbados", "BD|Asia/Dhaka", "BE|Europe/Brussels", "BF|Africa/Abidjan Africa/Ouagadougou", "BG|Europe/Sofia", "BH|Asia/Qatar Asia/Bahrain", "BI|Africa/Maputo Africa/Bujumbura", "BJ|Africa/Lagos Africa/Porto-Novo", "BL|America/Port_of_Spain America/St_Barthelemy", "BM|Atlantic/Bermuda", "BN|Asia/Brunei", "BO|America/La_Paz", "BQ|America/Curacao America/Kralendijk", "BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco", "BS|America/Nassau", "BT|Asia/Thimphu", "BW|Africa/Maputo Africa/Gaborone", "BY|Europe/Minsk", "BZ|America/Belize", "CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver", "CC|Indian/Cocos", "CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi", "CF|Africa/Lagos Africa/Bangui", "CG|Africa/Lagos Africa/Brazzaville", "CH|Europe/Zurich", "CI|Africa/Abidjan", "CK|Pacific/Rarotonga", "CL|America/Santiago America/Punta_Arenas Pacific/Easter", "CM|Africa/Lagos Africa/Douala", "CN|Asia/Shanghai Asia/Urumqi", "CO|America/Bogota", "CR|America/Costa_Rica", "CU|America/Havana", "CV|Atlantic/Cape_Verde", "CW|America/Curacao", "CX|Indian/Christmas", "CY|Asia/Nicosia Asia/Famagusta", "CZ|Europe/Prague", "DE|Europe/Zurich Europe/Berlin Europe/Busingen", "DJ|Africa/Nairobi Africa/Djibouti", "DK|Europe/Copenhagen", "DM|America/Port_of_Spain America/Dominica", "DO|America/Santo_Domingo", "DZ|Africa/Algiers", "EC|America/Guayaquil Pacific/Galapagos", "EE|Europe/Tallinn", "EG|Africa/Cairo", "EH|Africa/El_Aaiun", "ER|Africa/Nairobi Africa/Asmara", "ES|Europe/Madrid Africa/Ceuta Atlantic/Canary", "ET|Africa/Nairobi Africa/Addis_Ababa", "FI|Europe/Helsinki", "FJ|Pacific/Fiji", "FK|Atlantic/Stanley", "FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae", "FO|Atlantic/Faroe", "FR|Europe/Paris", "GA|Africa/Lagos Africa/Libreville", "GB|Europe/London", "GD|America/Port_of_Spain America/Grenada", "GE|Asia/Tbilisi", "GF|America/Cayenne", "GG|Europe/London Europe/Guernsey", "GH|Africa/Accra", "GI|Europe/Gibraltar", "GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule", "GM|Africa/Abidjan Africa/Banjul", "GN|Africa/Abidjan Africa/Conakry", "GP|America/Port_of_Spain America/Guadeloupe", "GQ|Africa/Lagos Africa/Malabo", "GR|Europe/Athens", "GS|Atlantic/South_Georgia", "GT|America/Guatemala", "GU|Pacific/Guam", "GW|Africa/Bissau", "GY|America/Guyana", "HK|Asia/Hong_Kong", "HN|America/Tegucigalpa", "HR|Europe/Belgrade Europe/Zagreb", "HT|America/Port-au-Prince", "HU|Europe/Budapest", "ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura", "IE|Europe/Dublin", "IL|Asia/Jerusalem", "IM|Europe/London Europe/Isle_of_Man", "IN|Asia/Kolkata", "IO|Indian/Chagos", "IQ|Asia/Baghdad", "IR|Asia/Tehran", "IS|Atlantic/Reykjavik", "IT|Europe/Rome", "JE|Europe/London Europe/Jersey", "JM|America/Jamaica", "JO|Asia/Amman", "JP|Asia/Tokyo", "KE|Africa/Nairobi", "KG|Asia/Bishkek", "KH|Asia/Bangkok Asia/Phnom_Penh", "KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati", "KM|Africa/Nairobi Indian/Comoro", "KN|America/Port_of_Spain America/St_Kitts", "KP|Asia/Pyongyang", "KR|Asia/Seoul", "KW|Asia/Riyadh Asia/Kuwait", "KY|America/Panama America/Cayman", "KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral", "LA|Asia/Bangkok Asia/Vientiane", "LB|Asia/Beirut", "LC|America/Port_of_Spain America/St_Lucia", "LI|Europe/Zurich Europe/Vaduz", "LK|Asia/Colombo", "LR|Africa/Monrovia", "LS|Africa/Johannesburg Africa/Maseru", "LT|Europe/Vilnius", "LU|Europe/Luxembourg", "LV|Europe/Riga", "LY|Africa/Tripoli", "MA|Africa/Casablanca", "MC|Europe/Monaco", "MD|Europe/Chisinau", "ME|Europe/Belgrade Europe/Podgorica", "MF|America/Port_of_Spain America/Marigot", "MG|Africa/Nairobi Indian/Antananarivo", "MH|Pacific/Majuro Pacific/Kwajalein", "MK|Europe/Belgrade Europe/Skopje", "ML|Africa/Abidjan Africa/Bamako", "MM|Asia/Yangon", "MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan", "MO|Asia/Macau", "MP|Pacific/Guam Pacific/Saipan", "MQ|America/Martinique", "MR|Africa/Abidjan Africa/Nouakchott", "MS|America/Port_of_Spain America/Montserrat", "MT|Europe/Malta", "MU|Indian/Mauritius", "MV|Indian/Maldives", "MW|Africa/Maputo Africa/Blantyre", "MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas", "MY|Asia/Kuala_Lumpur Asia/Kuching", "MZ|Africa/Maputo", "NA|Africa/Windhoek", "NC|Pacific/Noumea", "NE|Africa/Lagos Africa/Niamey", "NF|Pacific/Norfolk", "NG|Africa/Lagos", "NI|America/Managua", "NL|Europe/Amsterdam", "NO|Europe/Oslo", "NP|Asia/Kathmandu", "NR|Pacific/Nauru", "NU|Pacific/Niue", "NZ|Pacific/Auckland Pacific/Chatham", "OM|Asia/Dubai Asia/Muscat", "PA|America/Panama", "PE|America/Lima", "PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier", "PG|Pacific/Port_Moresby Pacific/Bougainville", "PH|Asia/Manila", "PK|Asia/Karachi", "PL|Europe/Warsaw", "PM|America/Miquelon", "PN|Pacific/Pitcairn", "PR|America/Puerto_Rico", "PS|Asia/Gaza Asia/Hebron", "PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores", "PW|Pacific/Palau", "PY|America/Asuncion", "QA|Asia/Qatar", "RE|Indian/Reunion", "RO|Europe/Bucharest", "RS|Europe/Belgrade", "RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr", "RW|Africa/Maputo Africa/Kigali", "SA|Asia/Riyadh", "SB|Pacific/Guadalcanal", "SC|Indian/Mahe", "SD|Africa/Khartoum", "SE|Europe/Stockholm", "SG|Asia/Singapore", "SH|Africa/Abidjan Atlantic/St_Helena", "SI|Europe/Belgrade Europe/Ljubljana", "SJ|Europe/Oslo Arctic/Longyearbyen", "SK|Europe/Prague Europe/Bratislava", "SL|Africa/Abidjan Africa/Freetown", "SM|Europe/Rome Europe/San_Marino", "SN|Africa/Abidjan Africa/Dakar", "SO|Africa/Nairobi Africa/Mogadishu", "SR|America/Paramaribo", "SS|Africa/Juba", "ST|Africa/Sao_Tome", "SV|America/El_Salvador", "SX|America/Curacao America/Lower_Princes", "SY|Asia/Damascus", "SZ|Africa/Johannesburg Africa/Mbabane", "TC|America/Grand_Turk", "TD|Africa/Ndjamena", "TF|Indian/Reunion Indian/Kerguelen", "TG|Africa/Abidjan Africa/Lome", "TH|Asia/Bangkok", "TJ|Asia/Dushanbe", "TK|Pacific/Fakaofo", "TL|Asia/Dili", "TM|Asia/Ashgabat", "TN|Africa/Tunis", "TO|Pacific/Tongatapu", "TR|Europe/Istanbul", "TT|America/Port_of_Spain", "TV|Pacific/Funafuti", "TW|Asia/Taipei", "TZ|Africa/Nairobi Africa/Dar_es_Salaam", "UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye", "UG|Africa/Nairobi Africa/Kampala", "UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway", "US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu", "UY|America/Montevideo", "UZ|Asia/Samarkand Asia/Tashkent", "VA|Europe/Rome Europe/Vatican", "VC|America/Port_of_Spain America/St_Vincent", "VE|America/Caracas", "VG|America/Port_of_Spain America/Tortola", "VI|America/Port_of_Spain America/St_Thomas", "VN|Asia/Bangkok Asia/Ho_Chi_Minh", "VU|Pacific/Efate", "WF|Pacific/Wallis", "WS|Pacific/Apia", "YE|Asia/Riyadh Asia/Aden", "YT|Africa/Nairobi Indian/Mayotte", "ZA|Africa/Johannesburg", "ZM|Africa/Maputo Africa/Lusaka", "ZW|Africa/Maputo Africa/Harare" ]
    }), e;
}), function(e, t) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function(e) {
        if (!e.document) throw new Error("jQuery requires a window with a document");
        return t(e);
    } : t(e);
}("undefined" != typeof window ? window : this, function(e, t) {
    function n(e) {
        var t = "length" in e && e.length, n = re.type(e);
        return "function" !== n && !re.isWindow(e) && (!(1 !== e.nodeType || !t) || ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e));
    }
    function i(e, t, n) {
        if (re.isFunction(t)) return re.grep(e, function(e, i) {
            return !!t.call(e, i, e) !== n;
        });
        if (t.nodeType) return re.grep(e, function(e) {
            return e === t !== n;
        });
        if ("string" == typeof t) {
            if (de.test(t)) return re.filter(t, e, n);
            t = re.filter(t, e);
        }
        return re.grep(e, function(e) {
            return re.inArray(e, t) >= 0 !== n;
        });
    }
    function r(e, t) {
        do e = e[t]; while (e && 1 !== e.nodeType);
        return e;
    }
    function a(e) {
        var t = _e[e] = {};
        return re.each(e.match(Ae) || [], function(e, n) {
            t[n] = !0;
        }), t;
    }
    function o() {
        pe.addEventListener ? (pe.removeEventListener("DOMContentLoaded", s, !1), e.removeEventListener("load", s, !1)) : (pe.detachEvent("onreadystatechange", s), 
        e.detachEvent("onload", s));
    }
    function s() {
        (pe.addEventListener || "load" === event.type || "complete" === pe.readyState) && (o(), 
        re.ready());
    }
    function c(e, t, n) {
        if (void 0 === n && 1 === e.nodeType) {
            var i = "data-" + t.replace(ke, "-$1").toLowerCase();
            if (n = e.getAttribute(i), "string" == typeof n) {
                try {
                    n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : we.test(n) ? re.parseJSON(n) : n);
                } catch (r) {}
                re.data(e, t, n);
            } else n = void 0;
        }
        return n;
    }
    function u(e) {
        var t;
        for (t in e) if (("data" !== t || !re.isEmptyObject(e[t])) && "toJSON" !== t) return !1;
        return !0;
    }
    function l(e, t, n, i) {
        if (re.acceptData(e)) {
            var r, a, o = re.expando, s = e.nodeType, c = s ? re.cache : e, u = s ? e[o] : e[o] && o;
            if (u && c[u] && (i || c[u].data) || void 0 !== n || "string" != typeof t) return u || (u = s ? e[o] = X.pop() || re.guid++ : o), 
            c[u] || (c[u] = s ? {} : {
                toJSON: re.noop
            }), "object" != typeof t && "function" != typeof t || (i ? c[u] = re.extend(c[u], t) : c[u].data = re.extend(c[u].data, t)), 
            a = c[u], i || (a.data || (a.data = {}), a = a.data), void 0 !== n && (a[re.camelCase(t)] = n), 
            "string" == typeof t ? (r = a[t], null == r && (r = a[re.camelCase(t)])) : r = a, 
            r;
        }
    }
    function f(e, t, n) {
        if (re.acceptData(e)) {
            var i, r, a = e.nodeType, o = a ? re.cache : e, s = a ? e[re.expando] : re.expando;
            if (o[s]) {
                if (t && (i = n ? o[s] : o[s].data)) {
                    re.isArray(t) ? t = t.concat(re.map(t, re.camelCase)) : t in i ? t = [ t ] : (t = re.camelCase(t), 
                    t = t in i ? [ t ] : t.split(" ")), r = t.length;
                    for (;r--; ) delete i[t[r]];
                    if (n ? !u(i) : !re.isEmptyObject(i)) return;
                }
                (n || (delete o[s].data, u(o[s]))) && (a ? re.cleanData([ e ], !0) : ne.deleteExpando || o != o.window ? delete o[s] : o[s] = null);
            }
        }
    }
    function d() {
        return !0;
    }
    function h() {
        return !1;
    }
    function p() {
        try {
            return pe.activeElement;
        } catch (e) {}
    }
    function m(e) {
        var t = Ie.split("|"), n = e.createDocumentFragment();
        if (n.createElement) for (;t.length; ) n.createElement(t.pop());
        return n;
    }
    function g(e, t) {
        var n, i, r = 0, a = typeof e.getElementsByTagName !== xe ? e.getElementsByTagName(t || "*") : typeof e.querySelectorAll !== xe ? e.querySelectorAll(t || "*") : void 0;
        if (!a) for (a = [], n = e.childNodes || e; null != (i = n[r]); r++) !t || re.nodeName(i, t) ? a.push(i) : re.merge(a, g(i, t));
        return void 0 === t || t && re.nodeName(e, t) ? re.merge([ e ], a) : a;
    }
    function v(e) {
        Pe.test(e.type) && (e.defaultChecked = e.checked);
    }
    function y(e, t) {
        return re.nodeName(e, "table") && re.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e;
    }
    function A(e) {
        return e.type = (null !== re.find.attr(e, "type")) + "/" + e.type, e;
    }
    function _(e) {
        var t = Ue.exec(e.type);
        return t ? e.type = t[1] : e.removeAttribute("type"), e;
    }
    function b(e, t) {
        for (var n, i = 0; null != (n = e[i]); i++) re._data(n, "globalEval", !t || re._data(t[i], "globalEval"));
    }
    function T(e, t) {
        if (1 === t.nodeType && re.hasData(e)) {
            var n, i, r, a = re._data(e), o = re._data(t, a), s = a.events;
            if (s) {
                delete o.handle, o.events = {};
                for (n in s) for (i = 0, r = s[n].length; i < r; i++) re.event.add(t, n, s[n][i]);
            }
            o.data && (o.data = re.extend({}, o.data));
        }
    }
    function x(e, t) {
        var n, i, r;
        if (1 === t.nodeType) {
            if (n = t.nodeName.toLowerCase(), !ne.noCloneEvent && t[re.expando]) {
                r = re._data(t);
                for (i in r.events) re.removeEvent(t, i, r.handle);
                t.removeAttribute(re.expando);
            }
            "script" === n && t.text !== e.text ? (A(t).text = e.text, _(t)) : "object" === n ? (t.parentNode && (t.outerHTML = e.outerHTML), 
            ne.html5Clone && e.innerHTML && !re.trim(t.innerHTML) && (t.innerHTML = e.innerHTML)) : "input" === n && Pe.test(e.type) ? (t.defaultChecked = t.checked = e.checked, 
            t.value !== e.value && (t.value = e.value)) : "option" === n ? t.defaultSelected = t.selected = e.defaultSelected : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue);
        }
    }
    function w(t, n) {
        var i, r = re(n.createElement(t)).appendTo(n.body), a = e.getDefaultComputedStyle && (i = e.getDefaultComputedStyle(r[0])) ? i.display : re.css(r[0], "display");
        return r.detach(), a;
    }
    function k(e) {
        var t = pe, n = Je[e];
        return n || (n = w(e, t), "none" !== n && n || (Ze = (Ze || re("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement), 
        t = (Ze[0].contentWindow || Ze[0].contentDocument).document, t.write(), t.close(), 
        n = w(e, t), Ze.detach()), Je[e] = n), n;
    }
    function E(e, t) {
        return {
            get: function() {
                var n = e();
                if (null != n) return n ? void delete this.get : (this.get = t).apply(this, arguments);
            }
        };
    }
    function S(e, t) {
        if (t in e) return t;
        for (var n = t.charAt(0).toUpperCase() + t.slice(1), i = t, r = dt.length; r--; ) if (t = dt[r] + n, 
        t in e) return t;
        return i;
    }
    function M(e, t) {
        for (var n, i, r, a = [], o = 0, s = e.length; o < s; o++) i = e[o], i.style && (a[o] = re._data(i, "olddisplay"), 
        n = i.style.display, t ? (a[o] || "none" !== n || (i.style.display = ""), "" === i.style.display && Me(i) && (a[o] = re._data(i, "olddisplay", k(i.nodeName)))) : (r = Me(i), 
        (n && "none" !== n || !r) && re._data(i, "olddisplay", r ? n : re.css(i, "display"))));
        for (o = 0; o < s; o++) i = e[o], i.style && (t && "none" !== i.style.display && "" !== i.style.display || (i.style.display = t ? a[o] || "" : "none"));
        return e;
    }
    function C(e, t, n) {
        var i = ct.exec(t);
        return i ? Math.max(0, i[1] - (n || 0)) + (i[2] || "px") : t;
    }
    function P(e, t, n, i, r) {
        for (var a = n === (i ? "border" : "content") ? 4 : "width" === t ? 1 : 0, o = 0; a < 4; a += 2) "margin" === n && (o += re.css(e, n + Se[a], !0, r)), 
        i ? ("content" === n && (o -= re.css(e, "padding" + Se[a], !0, r)), "margin" !== n && (o -= re.css(e, "border" + Se[a] + "Width", !0, r))) : (o += re.css(e, "padding" + Se[a], !0, r), 
        "padding" !== n && (o += re.css(e, "border" + Se[a] + "Width", !0, r)));
        return o;
    }
    function D(e, t, n) {
        var i = !0, r = "width" === t ? e.offsetWidth : e.offsetHeight, a = et(e), o = ne.boxSizing && "border-box" === re.css(e, "boxSizing", !1, a);
        if (r <= 0 || null == r) {
            if (r = tt(e, t, a), (r < 0 || null == r) && (r = e.style[t]), it.test(r)) return r;
            i = o && (ne.boxSizingReliable() || r === e.style[t]), r = parseFloat(r) || 0;
        }
        return r + P(e, t, n || (o ? "border" : "content"), i, a) + "px";
    }
    function O(e, t, n, i, r) {
        return new O.prototype.init(e, t, n, i, r);
    }
    function N() {
        return setTimeout(function() {
            ht = void 0;
        }), ht = re.now();
    }
    function z(e, t) {
        var n, i = {
            height: e
        }, r = 0;
        for (t = t ? 1 : 0; r < 4; r += 2 - t) n = Se[r], i["margin" + n] = i["padding" + n] = e;
        return t && (i.opacity = i.width = e), i;
    }
    function L(e, t, n) {
        for (var i, r = (At[t] || []).concat(At["*"]), a = 0, o = r.length; a < o; a++) if (i = r[a].call(n, t, e)) return i;
    }
    function I(e, t, n) {
        var i, r, a, o, s, c, u, l, f = this, d = {}, h = e.style, p = e.nodeType && Me(e), m = re._data(e, "fxshow");
        n.queue || (s = re._queueHooks(e, "fx"), null == s.unqueued && (s.unqueued = 0, 
        c = s.empty.fire, s.empty.fire = function() {
            s.unqueued || c();
        }), s.unqueued++, f.always(function() {
            f.always(function() {
                s.unqueued--, re.queue(e, "fx").length || s.empty.fire();
            });
        })), 1 === e.nodeType && ("height" in t || "width" in t) && (n.overflow = [ h.overflow, h.overflowX, h.overflowY ], 
        u = re.css(e, "display"), l = "none" === u ? re._data(e, "olddisplay") || k(e.nodeName) : u, 
        "inline" === l && "none" === re.css(e, "float") && (ne.inlineBlockNeedsLayout && "inline" !== k(e.nodeName) ? h.zoom = 1 : h.display = "inline-block")), 
        n.overflow && (h.overflow = "hidden", ne.shrinkWrapBlocks() || f.always(function() {
            h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2];
        }));
        for (i in t) if (r = t[i], mt.exec(r)) {
            if (delete t[i], a = a || "toggle" === r, r === (p ? "hide" : "show")) {
                if ("show" !== r || !m || void 0 === m[i]) continue;
                p = !0;
            }
            d[i] = m && m[i] || re.style(e, i);
        } else u = void 0;
        if (re.isEmptyObject(d)) "inline" === ("none" === u ? k(e.nodeName) : u) && (h.display = u); else {
            m ? "hidden" in m && (p = m.hidden) : m = re._data(e, "fxshow", {}), a && (m.hidden = !p), 
            p ? re(e).show() : f.done(function() {
                re(e).hide();
            }), f.done(function() {
                var t;
                re._removeData(e, "fxshow");
                for (t in d) re.style(e, t, d[t]);
            });
            for (i in d) o = L(p ? m[i] : 0, i, f), i in m || (m[i] = o.start, p && (o.end = o.start, 
            o.start = "width" === i || "height" === i ? 1 : 0));
        }
    }
    function j(e, t) {
        var n, i, r, a, o;
        for (n in e) if (i = re.camelCase(n), r = t[i], a = e[n], re.isArray(a) && (r = a[1], 
        a = e[n] = a[0]), n !== i && (e[i] = a, delete e[n]), o = re.cssHooks[i], o && "expand" in o) {
            a = o.expand(a), delete e[i];
            for (n in a) n in e || (e[n] = a[n], t[n] = r);
        } else t[i] = r;
    }
    function B(e, t, n) {
        var i, r, a = 0, o = yt.length, s = re.Deferred().always(function() {
            delete c.elem;
        }), c = function() {
            if (r) return !1;
            for (var t = ht || N(), n = Math.max(0, u.startTime + u.duration - t), i = n / u.duration || 0, a = 1 - i, o = 0, c = u.tweens.length; o < c; o++) u.tweens[o].run(a);
            return s.notifyWith(e, [ u, a, n ]), a < 1 && c ? n : (s.resolveWith(e, [ u ]), 
            !1);
        }, u = s.promise({
            elem: e,
            props: re.extend({}, t),
            opts: re.extend(!0, {
                specialEasing: {}
            }, n),
            originalProperties: t,
            originalOptions: n,
            startTime: ht || N(),
            duration: n.duration,
            tweens: [],
            createTween: function(t, n) {
                var i = re.Tween(e, u.opts, t, n, u.opts.specialEasing[t] || u.opts.easing);
                return u.tweens.push(i), i;
            },
            stop: function(t) {
                var n = 0, i = t ? u.tweens.length : 0;
                if (r) return this;
                for (r = !0; n < i; n++) u.tweens[n].run(1);
                return t ? s.resolveWith(e, [ u, t ]) : s.rejectWith(e, [ u, t ]), this;
            }
        }), l = u.props;
        for (j(l, u.opts.specialEasing); a < o; a++) if (i = yt[a].call(u, e, l, u.opts)) return i;
        return re.map(l, L, u), re.isFunction(u.opts.start) && u.opts.start.call(e, u), 
        re.fx.timer(re.extend(c, {
            elem: e,
            anim: u,
            queue: u.opts.queue
        })), u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always);
    }
    function R(e) {
        return function(t, n) {
            "string" != typeof t && (n = t, t = "*");
            var i, r = 0, a = t.toLowerCase().match(Ae) || [];
            if (re.isFunction(n)) for (;i = a[r++]; ) "+" === i.charAt(0) ? (i = i.slice(1) || "*", 
            (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n);
        };
    }
    function F(e, t, n, i) {
        function r(s) {
            var c;
            return a[s] = !0, re.each(e[s] || [], function(e, s) {
                var u = s(t, n, i);
                return "string" != typeof u || o || a[u] ? o ? !(c = u) : void 0 : (t.dataTypes.unshift(u), 
                r(u), !1);
            }), c;
        }
        var a = {}, o = e === Wt;
        return r(t.dataTypes[0]) || !a["*"] && r("*");
    }
    function Y(e, t) {
        var n, i, r = re.ajaxSettings.flatOptions || {};
        for (i in t) void 0 !== t[i] && ((r[i] ? e : n || (n = {}))[i] = t[i]);
        return n && re.extend(!0, e, n), e;
    }
    function q(e, t, n) {
        for (var i, r, a, o, s = e.contents, c = e.dataTypes; "*" === c[0]; ) c.shift(), 
        void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
        if (r) for (o in s) if (s[o] && s[o].test(r)) {
            c.unshift(o);
            break;
        }
        if (c[0] in n) a = c[0]; else {
            for (o in n) {
                if (!c[0] || e.converters[o + " " + c[0]]) {
                    a = o;
                    break;
                }
                i || (i = o);
            }
            a = a || i;
        }
        if (a) return a !== c[0] && c.unshift(a), n[a];
    }
    function W(e, t, n, i) {
        var r, a, o, s, c, u = {}, l = e.dataTypes.slice();
        if (l[1]) for (o in e.converters) u[o.toLowerCase()] = e.converters[o];
        for (a = l.shift(); a; ) if (e.responseFields[a] && (n[e.responseFields[a]] = t), 
        !c && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), c = a, a = l.shift()) if ("*" === a) a = c; else if ("*" !== c && c !== a) {
            if (o = u[c + " " + a] || u["* " + a], !o) for (r in u) if (s = r.split(" "), s[1] === a && (o = u[c + " " + s[0]] || u["* " + s[0]])) {
                o === !0 ? o = u[r] : u[r] !== !0 && (a = s[0], l.unshift(s[1]));
                break;
            }
            if (o !== !0) if (o && e["throws"]) t = o(t); else try {
                t = o(t);
            } catch (f) {
                return {
                    state: "parsererror",
                    error: o ? f : "No conversion from " + c + " to " + a
                };
            }
        }
        return {
            state: "success",
            data: t
        };
    }
    function H(e, t, n, i) {
        var r;
        if (re.isArray(t)) re.each(t, function(t, r) {
            n || Ut.test(e) ? i(e, r) : H(e + "[" + ("object" == typeof r ? t : "") + "]", r, n, i);
        }); else if (n || "object" !== re.type(t)) i(e, t); else for (r in t) H(e + "[" + r + "]", t[r], n, i);
    }
    function V() {
        try {
            return new e.XMLHttpRequest();
        } catch (t) {}
    }
    function G() {
        try {
            return new e.ActiveXObject("Microsoft.XMLHTTP");
        } catch (t) {}
    }
    function U(e) {
        return re.isWindow(e) ? e : 9 === e.nodeType && (e.defaultView || e.parentWindow);
    }
    var X = [], K = X.slice, $ = X.concat, Q = X.push, Z = X.indexOf, J = {}, ee = J.toString, te = J.hasOwnProperty, ne = {}, ie = "1.11.3", re = function(e, t) {
        return new re.fn.init(e, t);
    }, ae = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, oe = /^-ms-/, se = /-([\da-z])/gi, ce = function(e, t) {
        return t.toUpperCase();
    };
    re.fn = re.prototype = {
        jquery: ie,
        constructor: re,
        selector: "",
        length: 0,
        toArray: function() {
            return K.call(this);
        },
        get: function(e) {
            return null != e ? e < 0 ? this[e + this.length] : this[e] : K.call(this);
        },
        pushStack: function(e) {
            var t = re.merge(this.constructor(), e);
            return t.prevObject = this, t.context = this.context, t;
        },
        each: function(e, t) {
            return re.each(this, e, t);
        },
        map: function(e) {
            return this.pushStack(re.map(this, function(t, n) {
                return e.call(t, n, t);
            }));
        },
        slice: function() {
            return this.pushStack(K.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        eq: function(e) {
            var t = this.length, n = +e + (e < 0 ? t : 0);
            return this.pushStack(n >= 0 && n < t ? [ this[n] ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor(null);
        },
        push: Q,
        sort: X.sort,
        splice: X.splice
    }, re.extend = re.fn.extend = function() {
        var e, t, n, i, r, a, o = arguments[0] || {}, s = 1, c = arguments.length, u = !1;
        for ("boolean" == typeof o && (u = o, o = arguments[s] || {}, s++), "object" == typeof o || re.isFunction(o) || (o = {}), 
        s === c && (o = this, s--); s < c; s++) if (null != (r = arguments[s])) for (i in r) e = o[i], 
        n = r[i], o !== n && (u && n && (re.isPlainObject(n) || (t = re.isArray(n))) ? (t ? (t = !1, 
        a = e && re.isArray(e) ? e : []) : a = e && re.isPlainObject(e) ? e : {}, o[i] = re.extend(u, a, n)) : void 0 !== n && (o[i] = n));
        return o;
    }, re.extend({
        expando: "jQuery" + (ie + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(e) {
            throw new Error(e);
        },
        noop: function() {},
        isFunction: function(e) {
            return "function" === re.type(e);
        },
        isArray: Array.isArray || function(e) {
            return "array" === re.type(e);
        },
        isWindow: function(e) {
            return null != e && e == e.window;
        },
        isNumeric: function(e) {
            return !re.isArray(e) && e - parseFloat(e) + 1 >= 0;
        },
        isEmptyObject: function(e) {
            var t;
            for (t in e) return !1;
            return !0;
        },
        isPlainObject: function(e) {
            var t;
            if (!e || "object" !== re.type(e) || e.nodeType || re.isWindow(e)) return !1;
            try {
                if (e.constructor && !te.call(e, "constructor") && !te.call(e.constructor.prototype, "isPrototypeOf")) return !1;
            } catch (n) {
                return !1;
            }
            if (ne.ownLast) for (t in e) return te.call(e, t);
            for (t in e) ;
            return void 0 === t || te.call(e, t);
        },
        type: function(e) {
            return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? J[ee.call(e)] || "object" : typeof e;
        },
        globalEval: function(t) {
            t && re.trim(t) && (e.execScript || function(t) {
                e.eval.call(e, t);
            })(t);
        },
        camelCase: function(e) {
            return e.replace(oe, "ms-").replace(se, ce);
        },
        nodeName: function(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
        },
        each: function(e, t, i) {
            var r, a = 0, o = e.length, s = n(e);
            if (i) {
                if (s) for (;a < o && (r = t.apply(e[a], i), r !== !1); a++) ; else for (a in e) if (r = t.apply(e[a], i), 
                r === !1) break;
            } else if (s) for (;a < o && (r = t.call(e[a], a, e[a]), r !== !1); a++) ; else for (a in e) if (r = t.call(e[a], a, e[a]), 
            r === !1) break;
            return e;
        },
        trim: function(e) {
            return null == e ? "" : (e + "").replace(ae, "");
        },
        makeArray: function(e, t) {
            var i = t || [];
            return null != e && (n(Object(e)) ? re.merge(i, "string" == typeof e ? [ e ] : e) : Q.call(i, e)), 
            i;
        },
        inArray: function(e, t, n) {
            var i;
            if (t) {
                if (Z) return Z.call(t, e, n);
                for (i = t.length, n = n ? n < 0 ? Math.max(0, i + n) : n : 0; n < i; n++) if (n in t && t[n] === e) return n;
            }
            return -1;
        },
        merge: function(e, t) {
            for (var n = +t.length, i = 0, r = e.length; i < n; ) e[r++] = t[i++];
            if (n !== n) for (;void 0 !== t[i]; ) e[r++] = t[i++];
            return e.length = r, e;
        },
        grep: function(e, t, n) {
            for (var i, r = [], a = 0, o = e.length, s = !n; a < o; a++) i = !t(e[a], a), i !== s && r.push(e[a]);
            return r;
        },
        map: function(e, t, i) {
            var r, a = 0, o = e.length, s = n(e), c = [];
            if (s) for (;a < o; a++) r = t(e[a], a, i), null != r && c.push(r); else for (a in e) r = t(e[a], a, i), 
            null != r && c.push(r);
            return $.apply([], c);
        },
        guid: 1,
        proxy: function(e, t) {
            var n, i, r;
            if ("string" == typeof t && (r = e[t], t = e, e = r), re.isFunction(e)) return n = K.call(arguments, 2), 
            i = function() {
                return e.apply(t || this, n.concat(K.call(arguments)));
            }, i.guid = e.guid = e.guid || re.guid++, i;
        },
        now: function() {
            return +new Date();
        },
        support: ne
    }), re.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(e, t) {
        J["[object " + t + "]"] = t.toLowerCase();
    });
    var ue = function(e) {
        function t(e, t, n, i) {
            var r, a, o, s, c, u, f, h, p, m;
            if ((t ? t.ownerDocument || t : F) !== O && D(t), t = t || O, n = n || [], s = t.nodeType, 
            "string" != typeof e || !e || 1 !== s && 9 !== s && 11 !== s) return n;
            if (!i && z) {
                if (11 !== s && (r = ye.exec(e))) if (o = r[1]) {
                    if (9 === s) {
                        if (a = t.getElementById(o), !a || !a.parentNode) return n;
                        if (a.id === o) return n.push(a), n;
                    } else if (t.ownerDocument && (a = t.ownerDocument.getElementById(o)) && B(t, a) && a.id === o) return n.push(a), 
                    n;
                } else {
                    if (r[2]) return Z.apply(n, t.getElementsByTagName(e)), n;
                    if ((o = r[3]) && b.getElementsByClassName) return Z.apply(n, t.getElementsByClassName(o)), 
                    n;
                }
                if (b.qsa && (!L || !L.test(e))) {
                    if (h = f = R, p = t, m = 1 !== s && e, 1 === s && "object" !== t.nodeName.toLowerCase()) {
                        for (u = k(e), (f = t.getAttribute("id")) ? h = f.replace(_e, "\\$&") : t.setAttribute("id", h), 
                        h = "[id='" + h + "'] ", c = u.length; c--; ) u[c] = h + d(u[c]);
                        p = Ae.test(e) && l(t.parentNode) || t, m = u.join(",");
                    }
                    if (m) try {
                        return Z.apply(n, p.querySelectorAll(m)), n;
                    } catch (g) {} finally {
                        f || t.removeAttribute("id");
                    }
                }
            }
            return S(e.replace(ce, "$1"), t, n, i);
        }
        function n() {
            function e(n, i) {
                return t.push(n + " ") > T.cacheLength && delete e[t.shift()], e[n + " "] = i;
            }
            var t = [];
            return e;
        }
        function i(e) {
            return e[R] = !0, e;
        }
        function r(e) {
            var t = O.createElement("div");
            try {
                return !!e(t);
            } catch (n) {
                return !1;
            } finally {
                t.parentNode && t.parentNode.removeChild(t), t = null;
            }
        }
        function a(e, t) {
            for (var n = e.split("|"), i = e.length; i--; ) T.attrHandle[n[i]] = t;
        }
        function o(e, t) {
            var n = t && e, i = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || U) - (~e.sourceIndex || U);
            if (i) return i;
            if (n) for (;n = n.nextSibling; ) if (n === t) return -1;
            return e ? 1 : -1;
        }
        function s(e) {
            return function(t) {
                var n = t.nodeName.toLowerCase();
                return "input" === n && t.type === e;
            };
        }
        function c(e) {
            return function(t) {
                var n = t.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && t.type === e;
            };
        }
        function u(e) {
            return i(function(t) {
                return t = +t, i(function(n, i) {
                    for (var r, a = e([], n.length, t), o = a.length; o--; ) n[r = a[o]] && (n[r] = !(i[r] = n[r]));
                });
            });
        }
        function l(e) {
            return e && "undefined" != typeof e.getElementsByTagName && e;
        }
        function f() {}
        function d(e) {
            for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
            return i;
        }
        function h(e, t, n) {
            var i = t.dir, r = n && "parentNode" === i, a = q++;
            return t.first ? function(t, n, a) {
                for (;t = t[i]; ) if (1 === t.nodeType || r) return e(t, n, a);
            } : function(t, n, o) {
                var s, c, u = [ Y, a ];
                if (o) {
                    for (;t = t[i]; ) if ((1 === t.nodeType || r) && e(t, n, o)) return !0;
                } else for (;t = t[i]; ) if (1 === t.nodeType || r) {
                    if (c = t[R] || (t[R] = {}), (s = c[i]) && s[0] === Y && s[1] === a) return u[2] = s[2];
                    if (c[i] = u, u[2] = e(t, n, o)) return !0;
                }
            };
        }
        function p(e) {
            return e.length > 1 ? function(t, n, i) {
                for (var r = e.length; r--; ) if (!e[r](t, n, i)) return !1;
                return !0;
            } : e[0];
        }
        function m(e, n, i) {
            for (var r = 0, a = n.length; r < a; r++) t(e, n[r], i);
            return i;
        }
        function g(e, t, n, i, r) {
            for (var a, o = [], s = 0, c = e.length, u = null != t; s < c; s++) (a = e[s]) && (n && !n(a, i, r) || (o.push(a), 
            u && t.push(s)));
            return o;
        }
        function v(e, t, n, r, a, o) {
            return r && !r[R] && (r = v(r)), a && !a[R] && (a = v(a, o)), i(function(i, o, s, c) {
                var u, l, f, d = [], h = [], p = o.length, v = i || m(t || "*", s.nodeType ? [ s ] : s, []), y = !e || !i && t ? v : g(v, d, e, s, c), A = n ? a || (i ? e : p || r) ? [] : o : y;
                if (n && n(y, A, s, c), r) for (u = g(A, h), r(u, [], s, c), l = u.length; l--; ) (f = u[l]) && (A[h[l]] = !(y[h[l]] = f));
                if (i) {
                    if (a || e) {
                        if (a) {
                            for (u = [], l = A.length; l--; ) (f = A[l]) && u.push(y[l] = f);
                            a(null, A = [], u, c);
                        }
                        for (l = A.length; l--; ) (f = A[l]) && (u = a ? ee(i, f) : d[l]) > -1 && (i[u] = !(o[u] = f));
                    }
                } else A = g(A === o ? A.splice(p, A.length) : A), a ? a(null, o, A, c) : Z.apply(o, A);
            });
        }
        function y(e) {
            for (var t, n, i, r = e.length, a = T.relative[e[0].type], o = a || T.relative[" "], s = a ? 1 : 0, c = h(function(e) {
                return e === t;
            }, o, !0), u = h(function(e) {
                return ee(t, e) > -1;
            }, o, !0), l = [ function(e, n, i) {
                var r = !a && (i || n !== M) || ((t = n).nodeType ? c(e, n, i) : u(e, n, i));
                return t = null, r;
            } ]; s < r; s++) if (n = T.relative[e[s].type]) l = [ h(p(l), n) ]; else {
                if (n = T.filter[e[s].type].apply(null, e[s].matches), n[R]) {
                    for (i = ++s; i < r && !T.relative[e[i].type]; i++) ;
                    return v(s > 1 && p(l), s > 1 && d(e.slice(0, s - 1).concat({
                        value: " " === e[s - 2].type ? "*" : ""
                    })).replace(ce, "$1"), n, s < i && y(e.slice(s, i)), i < r && y(e = e.slice(i)), i < r && d(e));
                }
                l.push(n);
            }
            return p(l);
        }
        function A(e, n) {
            var r = n.length > 0, a = e.length > 0, o = function(i, o, s, c, u) {
                var l, f, d, h = 0, p = "0", m = i && [], v = [], y = M, A = i || a && T.find.TAG("*", u), _ = Y += null == y ? 1 : Math.random() || .1, b = A.length;
                for (u && (M = o !== O && o); p !== b && null != (l = A[p]); p++) {
                    if (a && l) {
                        for (f = 0; d = e[f++]; ) if (d(l, o, s)) {
                            c.push(l);
                            break;
                        }
                        u && (Y = _);
                    }
                    r && ((l = !d && l) && h--, i && m.push(l));
                }
                if (h += p, r && p !== h) {
                    for (f = 0; d = n[f++]; ) d(m, v, o, s);
                    if (i) {
                        if (h > 0) for (;p--; ) m[p] || v[p] || (v[p] = $.call(c));
                        v = g(v);
                    }
                    Z.apply(c, v), u && !i && v.length > 0 && h + n.length > 1 && t.uniqueSort(c);
                }
                return u && (Y = _, M = y), m;
            };
            return r ? i(o) : o;
        }
        var _, b, T, x, w, k, E, S, M, C, P, D, O, N, z, L, I, j, B, R = "sizzle" + 1 * new Date(), F = e.document, Y = 0, q = 0, W = n(), H = n(), V = n(), G = function(e, t) {
            return e === t && (P = !0), 0;
        }, U = 1 << 31, X = {}.hasOwnProperty, K = [], $ = K.pop, Q = K.push, Z = K.push, J = K.slice, ee = function(e, t) {
            for (var n = 0, i = e.length; n < i; n++) if (e[n] === t) return n;
            return -1;
        }, te = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", ne = "[\\x20\\t\\r\\n\\f]", ie = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+", re = ie.replace("w", "w#"), ae = "\\[" + ne + "*(" + ie + ")(?:" + ne + "*([*^$|!~]?=)" + ne + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + re + "))|)" + ne + "*\\]", oe = ":(" + ie + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + ae + ")*)|.*)\\)|)", se = new RegExp(ne + "+", "g"), ce = new RegExp("^" + ne + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ne + "+$", "g"), ue = new RegExp("^" + ne + "*," + ne + "*"), le = new RegExp("^" + ne + "*([>+~]|" + ne + ")" + ne + "*"), fe = new RegExp("=" + ne + "*([^\\]'\"]*?)" + ne + "*\\]", "g"), de = new RegExp(oe), he = new RegExp("^" + re + "$"), pe = {
            ID: new RegExp("^#(" + ie + ")"),
            CLASS: new RegExp("^\\.(" + ie + ")"),
            TAG: new RegExp("^(" + ie.replace("w", "w*") + ")"),
            ATTR: new RegExp("^" + ae),
            PSEUDO: new RegExp("^" + oe),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + ne + "*(even|odd|(([+-]|)(\\d*)n|)" + ne + "*(?:([+-]|)" + ne + "*(\\d+)|))" + ne + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + te + ")$", "i"),
            needsContext: new RegExp("^" + ne + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + ne + "*((?:-\\d)?\\d*)" + ne + "*\\)|)(?=[^-]|$)", "i")
        }, me = /^(?:input|select|textarea|button)$/i, ge = /^h\d$/i, ve = /^[^{]+\{\s*\[native \w/, ye = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, Ae = /[+~]/, _e = /'|\\/g, be = new RegExp("\\\\([\\da-f]{1,6}" + ne + "?|(" + ne + ")|.)", "ig"), Te = function(e, t, n) {
            var i = "0x" + t - 65536;
            return i !== i || n ? t : i < 0 ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320);
        }, xe = function() {
            D();
        };
        try {
            Z.apply(K = J.call(F.childNodes), F.childNodes), K[F.childNodes.length].nodeType;
        } catch (we) {
            Z = {
                apply: K.length ? function(e, t) {
                    Q.apply(e, J.call(t));
                } : function(e, t) {
                    for (var n = e.length, i = 0; e[n++] = t[i++]; ) ;
                    e.length = n - 1;
                }
            };
        }
        b = t.support = {}, w = t.isXML = function(e) {
            var t = e && (e.ownerDocument || e).documentElement;
            return !!t && "HTML" !== t.nodeName;
        }, D = t.setDocument = function(e) {
            var t, n, i = e ? e.ownerDocument || e : F;
            return i !== O && 9 === i.nodeType && i.documentElement ? (O = i, N = i.documentElement, 
            n = i.defaultView, n && n !== n.top && (n.addEventListener ? n.addEventListener("unload", xe, !1) : n.attachEvent && n.attachEvent("onunload", xe)), 
            z = !w(i), b.attributes = r(function(e) {
                return e.className = "i", !e.getAttribute("className");
            }), b.getElementsByTagName = r(function(e) {
                return e.appendChild(i.createComment("")), !e.getElementsByTagName("*").length;
            }), b.getElementsByClassName = ve.test(i.getElementsByClassName), b.getById = r(function(e) {
                return N.appendChild(e).id = R, !i.getElementsByName || !i.getElementsByName(R).length;
            }), b.getById ? (T.find.ID = function(e, t) {
                if ("undefined" != typeof t.getElementById && z) {
                    var n = t.getElementById(e);
                    return n && n.parentNode ? [ n ] : [];
                }
            }, T.filter.ID = function(e) {
                var t = e.replace(be, Te);
                return function(e) {
                    return e.getAttribute("id") === t;
                };
            }) : (delete T.find.ID, T.filter.ID = function(e) {
                var t = e.replace(be, Te);
                return function(e) {
                    var n = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");
                    return n && n.value === t;
                };
            }), T.find.TAG = b.getElementsByTagName ? function(e, t) {
                return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : b.qsa ? t.querySelectorAll(e) : void 0;
            } : function(e, t) {
                var n, i = [], r = 0, a = t.getElementsByTagName(e);
                if ("*" === e) {
                    for (;n = a[r++]; ) 1 === n.nodeType && i.push(n);
                    return i;
                }
                return a;
            }, T.find.CLASS = b.getElementsByClassName && function(e, t) {
                if (z) return t.getElementsByClassName(e);
            }, I = [], L = [], (b.qsa = ve.test(i.querySelectorAll)) && (r(function(e) {
                N.appendChild(e).innerHTML = "<a id='" + R + "'></a><select id='" + R + "-\f]' msallowcapture=''><option selected=''></option></select>", 
                e.querySelectorAll("[msallowcapture^='']").length && L.push("[*^$]=" + ne + "*(?:''|\"\")"), 
                e.querySelectorAll("[selected]").length || L.push("\\[" + ne + "*(?:value|" + te + ")"), 
                e.querySelectorAll("[id~=" + R + "-]").length || L.push("~="), e.querySelectorAll(":checked").length || L.push(":checked"), 
                e.querySelectorAll("a#" + R + "+*").length || L.push(".#.+[+~]");
            }), r(function(e) {
                var t = i.createElement("input");
                t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && L.push("name" + ne + "*[*^$|!~]?="), 
                e.querySelectorAll(":enabled").length || L.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), 
                L.push(",.*:");
            })), (b.matchesSelector = ve.test(j = N.matches || N.webkitMatchesSelector || N.mozMatchesSelector || N.oMatchesSelector || N.msMatchesSelector)) && r(function(e) {
                b.disconnectedMatch = j.call(e, "div"), j.call(e, "[s!='']:x"), I.push("!=", oe);
            }), L = L.length && new RegExp(L.join("|")), I = I.length && new RegExp(I.join("|")), 
            t = ve.test(N.compareDocumentPosition), B = t || ve.test(N.contains) ? function(e, t) {
                var n = 9 === e.nodeType ? e.documentElement : e, i = t && t.parentNode;
                return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)));
            } : function(e, t) {
                if (t) for (;t = t.parentNode; ) if (t === e) return !0;
                return !1;
            }, G = t ? function(e, t) {
                if (e === t) return P = !0, 0;
                var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                return n ? n : (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1, 
                1 & n || !b.sortDetached && t.compareDocumentPosition(e) === n ? e === i || e.ownerDocument === F && B(F, e) ? -1 : t === i || t.ownerDocument === F && B(F, t) ? 1 : C ? ee(C, e) - ee(C, t) : 0 : 4 & n ? -1 : 1);
            } : function(e, t) {
                if (e === t) return P = !0, 0;
                var n, r = 0, a = e.parentNode, s = t.parentNode, c = [ e ], u = [ t ];
                if (!a || !s) return e === i ? -1 : t === i ? 1 : a ? -1 : s ? 1 : C ? ee(C, e) - ee(C, t) : 0;
                if (a === s) return o(e, t);
                for (n = e; n = n.parentNode; ) c.unshift(n);
                for (n = t; n = n.parentNode; ) u.unshift(n);
                for (;c[r] === u[r]; ) r++;
                return r ? o(c[r], u[r]) : c[r] === F ? -1 : u[r] === F ? 1 : 0;
            }, i) : O;
        }, t.matches = function(e, n) {
            return t(e, null, null, n);
        }, t.matchesSelector = function(e, n) {
            if ((e.ownerDocument || e) !== O && D(e), n = n.replace(fe, "='$1']"), b.matchesSelector && z && (!I || !I.test(n)) && (!L || !L.test(n))) try {
                var i = j.call(e, n);
                if (i || b.disconnectedMatch || e.document && 11 !== e.document.nodeType) return i;
            } catch (r) {}
            return t(n, O, null, [ e ]).length > 0;
        }, t.contains = function(e, t) {
            return (e.ownerDocument || e) !== O && D(e), B(e, t);
        }, t.attr = function(e, t) {
            (e.ownerDocument || e) !== O && D(e);
            var n = T.attrHandle[t.toLowerCase()], i = n && X.call(T.attrHandle, t.toLowerCase()) ? n(e, t, !z) : void 0;
            return void 0 !== i ? i : b.attributes || !z ? e.getAttribute(t) : (i = e.getAttributeNode(t)) && i.specified ? i.value : null;
        }, t.error = function(e) {
            throw new Error("Syntax error, unrecognized expression: " + e);
        }, t.uniqueSort = function(e) {
            var t, n = [], i = 0, r = 0;
            if (P = !b.detectDuplicates, C = !b.sortStable && e.slice(0), e.sort(G), P) {
                for (;t = e[r++]; ) t === e[r] && (i = n.push(r));
                for (;i--; ) e.splice(n[i], 1);
            }
            return C = null, e;
        }, x = t.getText = function(e) {
            var t, n = "", i = 0, r = e.nodeType;
            if (r) {
                if (1 === r || 9 === r || 11 === r) {
                    if ("string" == typeof e.textContent) return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling) n += x(e);
                } else if (3 === r || 4 === r) return e.nodeValue;
            } else for (;t = e[i++]; ) n += x(t);
            return n;
        }, T = t.selectors = {
            cacheLength: 50,
            createPseudo: i,
            match: pe,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(e) {
                    return e[1] = e[1].replace(be, Te), e[3] = (e[3] || e[4] || e[5] || "").replace(be, Te), 
                    "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                },
                CHILD: function(e) {
                    return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || t.error(e[0]), 
                    e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && t.error(e[0]), 
                    e;
                },
                PSEUDO: function(e) {
                    var t, n = !e[6] && e[2];
                    return pe.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && de.test(n) && (t = k(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), 
                    e[2] = n.slice(0, t)), e.slice(0, 3));
                }
            },
            filter: {
                TAG: function(e) {
                    var t = e.replace(be, Te).toLowerCase();
                    return "*" === e ? function() {
                        return !0;
                    } : function(e) {
                        return e.nodeName && e.nodeName.toLowerCase() === t;
                    };
                },
                CLASS: function(e) {
                    var t = W[e + " "];
                    return t || (t = new RegExp("(^|" + ne + ")" + e + "(" + ne + "|$)")) && W(e, function(e) {
                        return t.test("string" == typeof e.className && e.className || "undefined" != typeof e.getAttribute && e.getAttribute("class") || "");
                    });
                },
                ATTR: function(e, n, i) {
                    return function(r) {
                        var a = t.attr(r, e);
                        return null == a ? "!=" === n : !n || (a += "", "=" === n ? a === i : "!=" === n ? a !== i : "^=" === n ? i && 0 === a.indexOf(i) : "*=" === n ? i && a.indexOf(i) > -1 : "$=" === n ? i && a.slice(-i.length) === i : "~=" === n ? (" " + a.replace(se, " ") + " ").indexOf(i) > -1 : "|=" === n && (a === i || a.slice(0, i.length + 1) === i + "-"));
                    };
                },
                CHILD: function(e, t, n, i, r) {
                    var a = "nth" !== e.slice(0, 3), o = "last" !== e.slice(-4), s = "of-type" === t;
                    return 1 === i && 0 === r ? function(e) {
                        return !!e.parentNode;
                    } : function(t, n, c) {
                        var u, l, f, d, h, p, m = a !== o ? "nextSibling" : "previousSibling", g = t.parentNode, v = s && t.nodeName.toLowerCase(), y = !c && !s;
                        if (g) {
                            if (a) {
                                for (;m; ) {
                                    for (f = t; f = f[m]; ) if (s ? f.nodeName.toLowerCase() === v : 1 === f.nodeType) return !1;
                                    p = m = "only" === e && !p && "nextSibling";
                                }
                                return !0;
                            }
                            if (p = [ o ? g.firstChild : g.lastChild ], o && y) {
                                for (l = g[R] || (g[R] = {}), u = l[e] || [], h = u[0] === Y && u[1], d = u[0] === Y && u[2], 
                                f = h && g.childNodes[h]; f = ++h && f && f[m] || (d = h = 0) || p.pop(); ) if (1 === f.nodeType && ++d && f === t) {
                                    l[e] = [ Y, h, d ];
                                    break;
                                }
                            } else if (y && (u = (t[R] || (t[R] = {}))[e]) && u[0] === Y) d = u[1]; else for (;(f = ++h && f && f[m] || (d = h = 0) || p.pop()) && ((s ? f.nodeName.toLowerCase() !== v : 1 !== f.nodeType) || !++d || (y && ((f[R] || (f[R] = {}))[e] = [ Y, d ]), 
                            f !== t)); ) ;
                            return d -= r, d === i || d % i === 0 && d / i >= 0;
                        }
                    };
                },
                PSEUDO: function(e, n) {
                    var r, a = T.pseudos[e] || T.setFilters[e.toLowerCase()] || t.error("unsupported pseudo: " + e);
                    return a[R] ? a(n) : a.length > 1 ? (r = [ e, e, "", n ], T.setFilters.hasOwnProperty(e.toLowerCase()) ? i(function(e, t) {
                        for (var i, r = a(e, n), o = r.length; o--; ) i = ee(e, r[o]), e[i] = !(t[i] = r[o]);
                    }) : function(e) {
                        return a(e, 0, r);
                    }) : a;
                }
            },
            pseudos: {
                not: i(function(e) {
                    var t = [], n = [], r = E(e.replace(ce, "$1"));
                    return r[R] ? i(function(e, t, n, i) {
                        for (var a, o = r(e, null, i, []), s = e.length; s--; ) (a = o[s]) && (e[s] = !(t[s] = a));
                    }) : function(e, i, a) {
                        return t[0] = e, r(t, null, a, n), t[0] = null, !n.pop();
                    };
                }),
                has: i(function(e) {
                    return function(n) {
                        return t(e, n).length > 0;
                    };
                }),
                contains: i(function(e) {
                    return e = e.replace(be, Te), function(t) {
                        return (t.textContent || t.innerText || x(t)).indexOf(e) > -1;
                    };
                }),
                lang: i(function(e) {
                    return he.test(e || "") || t.error("unsupported lang: " + e), e = e.replace(be, Te).toLowerCase(), 
                    function(t) {
                        var n;
                        do if (n = z ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return n = n.toLowerCase(), 
                        n === e || 0 === n.indexOf(e + "-"); while ((t = t.parentNode) && 1 === t.nodeType);
                        return !1;
                    };
                }),
                target: function(t) {
                    var n = e.location && e.location.hash;
                    return n && n.slice(1) === t.id;
                },
                root: function(e) {
                    return e === N;
                },
                focus: function(e) {
                    return e === O.activeElement && (!O.hasFocus || O.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                },
                enabled: function(e) {
                    return e.disabled === !1;
                },
                disabled: function(e) {
                    return e.disabled === !0;
                },
                checked: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && !!e.checked || "option" === t && !!e.selected;
                },
                selected: function(e) {
                    return e.parentNode && e.parentNode.selectedIndex, e.selected === !0;
                },
                empty: function(e) {
                    for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                    return !0;
                },
                parent: function(e) {
                    return !T.pseudos.empty(e);
                },
                header: function(e) {
                    return ge.test(e.nodeName);
                },
                input: function(e) {
                    return me.test(e.nodeName);
                },
                button: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && "button" === e.type || "button" === t;
                },
                text: function(e) {
                    var t;
                    return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                },
                first: u(function() {
                    return [ 0 ];
                }),
                last: u(function(e, t) {
                    return [ t - 1 ];
                }),
                eq: u(function(e, t, n) {
                    return [ n < 0 ? n + t : n ];
                }),
                even: u(function(e, t) {
                    for (var n = 0; n < t; n += 2) e.push(n);
                    return e;
                }),
                odd: u(function(e, t) {
                    for (var n = 1; n < t; n += 2) e.push(n);
                    return e;
                }),
                lt: u(function(e, t, n) {
                    for (var i = n < 0 ? n + t : n; --i >= 0; ) e.push(i);
                    return e;
                }),
                gt: u(function(e, t, n) {
                    for (var i = n < 0 ? n + t : n; ++i < t; ) e.push(i);
                    return e;
                })
            }
        }, T.pseudos.nth = T.pseudos.eq;
        for (_ in {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        }) T.pseudos[_] = s(_);
        for (_ in {
            submit: !0,
            reset: !0
        }) T.pseudos[_] = c(_);
        return f.prototype = T.filters = T.pseudos, T.setFilters = new f(), k = t.tokenize = function(e, n) {
            var i, r, a, o, s, c, u, l = H[e + " "];
            if (l) return n ? 0 : l.slice(0);
            for (s = e, c = [], u = T.preFilter; s; ) {
                i && !(r = ue.exec(s)) || (r && (s = s.slice(r[0].length) || s), c.push(a = [])), 
                i = !1, (r = le.exec(s)) && (i = r.shift(), a.push({
                    value: i,
                    type: r[0].replace(ce, " ")
                }), s = s.slice(i.length));
                for (o in T.filter) !(r = pe[o].exec(s)) || u[o] && !(r = u[o](r)) || (i = r.shift(), 
                a.push({
                    value: i,
                    type: o,
                    matches: r
                }), s = s.slice(i.length));
                if (!i) break;
            }
            return n ? s.length : s ? t.error(e) : H(e, c).slice(0);
        }, E = t.compile = function(e, t) {
            var n, i = [], r = [], a = V[e + " "];
            if (!a) {
                for (t || (t = k(e)), n = t.length; n--; ) a = y(t[n]), a[R] ? i.push(a) : r.push(a);
                a = V(e, A(r, i)), a.selector = e;
            }
            return a;
        }, S = t.select = function(e, t, n, i) {
            var r, a, o, s, c, u = "function" == typeof e && e, f = !i && k(e = u.selector || e);
            if (n = n || [], 1 === f.length) {
                if (a = f[0] = f[0].slice(0), a.length > 2 && "ID" === (o = a[0]).type && b.getById && 9 === t.nodeType && z && T.relative[a[1].type]) {
                    if (t = (T.find.ID(o.matches[0].replace(be, Te), t) || [])[0], !t) return n;
                    u && (t = t.parentNode), e = e.slice(a.shift().value.length);
                }
                for (r = pe.needsContext.test(e) ? 0 : a.length; r-- && (o = a[r], !T.relative[s = o.type]); ) if ((c = T.find[s]) && (i = c(o.matches[0].replace(be, Te), Ae.test(a[0].type) && l(t.parentNode) || t))) {
                    if (a.splice(r, 1), e = i.length && d(a), !e) return Z.apply(n, i), n;
                    break;
                }
            }
            return (u || E(e, f))(i, t, !z, n, Ae.test(e) && l(t.parentNode) || t), n;
        }, b.sortStable = R.split("").sort(G).join("") === R, b.detectDuplicates = !!P, 
        D(), b.sortDetached = r(function(e) {
            return 1 & e.compareDocumentPosition(O.createElement("div"));
        }), r(function(e) {
            return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href");
        }) || a("type|href|height|width", function(e, t, n) {
            if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
        }), b.attributes && r(function(e) {
            return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
        }) || a("value", function(e, t, n) {
            if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
        }), r(function(e) {
            return null == e.getAttribute("disabled");
        }) || a(te, function(e, t, n) {
            var i;
            if (!n) return e[t] === !0 ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null;
        }), t;
    }(e);
    re.find = ue, re.expr = ue.selectors, re.expr[":"] = re.expr.pseudos, re.unique = ue.uniqueSort, 
    re.text = ue.getText, re.isXMLDoc = ue.isXML, re.contains = ue.contains;
    var le = re.expr.match.needsContext, fe = /^<(\w+)\s*\/?>(?:<\/\1>|)$/, de = /^.[^:#\[\.,]*$/;
    re.filter = function(e, t, n) {
        var i = t[0];
        return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === i.nodeType ? re.find.matchesSelector(i, e) ? [ i ] : [] : re.find.matches(e, re.grep(t, function(e) {
            return 1 === e.nodeType;
        }));
    }, re.fn.extend({
        find: function(e) {
            var t, n = [], i = this, r = i.length;
            if ("string" != typeof e) return this.pushStack(re(e).filter(function() {
                for (t = 0; t < r; t++) if (re.contains(i[t], this)) return !0;
            }));
            for (t = 0; t < r; t++) re.find(e, i[t], n);
            return n = this.pushStack(r > 1 ? re.unique(n) : n), n.selector = this.selector ? this.selector + " " + e : e, 
            n;
        },
        filter: function(e) {
            return this.pushStack(i(this, e || [], !1));
        },
        not: function(e) {
            return this.pushStack(i(this, e || [], !0));
        },
        is: function(e) {
            return !!i(this, "string" == typeof e && le.test(e) ? re(e) : e || [], !1).length;
        }
    });
    var he, pe = e.document, me = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/, ge = re.fn.init = function(e, t) {
        var n, i;
        if (!e) return this;
        if ("string" == typeof e) {
            if (n = "<" === e.charAt(0) && ">" === e.charAt(e.length - 1) && e.length >= 3 ? [ null, e, null ] : me.exec(e), 
            !n || !n[1] && t) return !t || t.jquery ? (t || he).find(e) : this.constructor(t).find(e);
            if (n[1]) {
                if (t = t instanceof re ? t[0] : t, re.merge(this, re.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : pe, !0)), 
                fe.test(n[1]) && re.isPlainObject(t)) for (n in t) re.isFunction(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
                return this;
            }
            if (i = pe.getElementById(n[2]), i && i.parentNode) {
                if (i.id !== n[2]) return he.find(e);
                this.length = 1, this[0] = i;
            }
            return this.context = pe, this.selector = e, this;
        }
        return e.nodeType ? (this.context = this[0] = e, this.length = 1, this) : re.isFunction(e) ? "undefined" != typeof he.ready ? he.ready(e) : e(re) : (void 0 !== e.selector && (this.selector = e.selector, 
        this.context = e.context), re.makeArray(e, this));
    };
    ge.prototype = re.fn, he = re(pe);
    var ve = /^(?:parents|prev(?:Until|All))/, ye = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
    };
    re.extend({
        dir: function(e, t, n) {
            for (var i = [], r = e[t]; r && 9 !== r.nodeType && (void 0 === n || 1 !== r.nodeType || !re(r).is(n)); ) 1 === r.nodeType && i.push(r), 
            r = r[t];
            return i;
        },
        sibling: function(e, t) {
            for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
            return n;
        }
    }), re.fn.extend({
        has: function(e) {
            var t, n = re(e, this), i = n.length;
            return this.filter(function() {
                for (t = 0; t < i; t++) if (re.contains(this, n[t])) return !0;
            });
        },
        closest: function(e, t) {
            for (var n, i = 0, r = this.length, a = [], o = le.test(e) || "string" != typeof e ? re(e, t || this.context) : 0; i < r; i++) for (n = this[i]; n && n !== t; n = n.parentNode) if (n.nodeType < 11 && (o ? o.index(n) > -1 : 1 === n.nodeType && re.find.matchesSelector(n, e))) {
                a.push(n);
                break;
            }
            return this.pushStack(a.length > 1 ? re.unique(a) : a);
        },
        index: function(e) {
            return e ? "string" == typeof e ? re.inArray(this[0], re(e)) : re.inArray(e.jquery ? e[0] : e, this) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
        },
        add: function(e, t) {
            return this.pushStack(re.unique(re.merge(this.get(), re(e, t))));
        },
        addBack: function(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
        }
    }), re.each({
        parent: function(e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null;
        },
        parents: function(e) {
            return re.dir(e, "parentNode");
        },
        parentsUntil: function(e, t, n) {
            return re.dir(e, "parentNode", n);
        },
        next: function(e) {
            return r(e, "nextSibling");
        },
        prev: function(e) {
            return r(e, "previousSibling");
        },
        nextAll: function(e) {
            return re.dir(e, "nextSibling");
        },
        prevAll: function(e) {
            return re.dir(e, "previousSibling");
        },
        nextUntil: function(e, t, n) {
            return re.dir(e, "nextSibling", n);
        },
        prevUntil: function(e, t, n) {
            return re.dir(e, "previousSibling", n);
        },
        siblings: function(e) {
            return re.sibling((e.parentNode || {}).firstChild, e);
        },
        children: function(e) {
            return re.sibling(e.firstChild);
        },
        contents: function(e) {
            return re.nodeName(e, "iframe") ? e.contentDocument || e.contentWindow.document : re.merge([], e.childNodes);
        }
    }, function(e, t) {
        re.fn[e] = function(n, i) {
            var r = re.map(this, t, n);
            return "Until" !== e.slice(-5) && (i = n), i && "string" == typeof i && (r = re.filter(i, r)), 
            this.length > 1 && (ye[e] || (r = re.unique(r)), ve.test(e) && (r = r.reverse())), 
            this.pushStack(r);
        };
    });
    var Ae = /\S+/g, _e = {};
    re.Callbacks = function(e) {
        e = "string" == typeof e ? _e[e] || a(e) : re.extend({}, e);
        var t, n, i, r, o, s, c = [], u = !e.once && [], l = function(a) {
            for (n = e.memory && a, i = !0, o = s || 0, s = 0, r = c.length, t = !0; c && o < r; o++) if (c[o].apply(a[0], a[1]) === !1 && e.stopOnFalse) {
                n = !1;
                break;
            }
            t = !1, c && (u ? u.length && l(u.shift()) : n ? c = [] : f.disable());
        }, f = {
            add: function() {
                if (c) {
                    var i = c.length;
                    !function a(t) {
                        re.each(t, function(t, n) {
                            var i = re.type(n);
                            "function" === i ? e.unique && f.has(n) || c.push(n) : n && n.length && "string" !== i && a(n);
                        });
                    }(arguments), t ? r = c.length : n && (s = i, l(n));
                }
                return this;
            },
            remove: function() {
                return c && re.each(arguments, function(e, n) {
                    for (var i; (i = re.inArray(n, c, i)) > -1; ) c.splice(i, 1), t && (i <= r && r--, 
                    i <= o && o--);
                }), this;
            },
            has: function(e) {
                return e ? re.inArray(e, c) > -1 : !(!c || !c.length);
            },
            empty: function() {
                return c = [], r = 0, this;
            },
            disable: function() {
                return c = u = n = void 0, this;
            },
            disabled: function() {
                return !c;
            },
            lock: function() {
                return u = void 0, n || f.disable(), this;
            },
            locked: function() {
                return !u;
            },
            fireWith: function(e, n) {
                return !c || i && !u || (n = n || [], n = [ e, n.slice ? n.slice() : n ], t ? u.push(n) : l(n)), 
                this;
            },
            fire: function() {
                return f.fireWith(this, arguments), this;
            },
            fired: function() {
                return !!i;
            }
        };
        return f;
    }, re.extend({
        Deferred: function(e) {
            var t = [ [ "resolve", "done", re.Callbacks("once memory"), "resolved" ], [ "reject", "fail", re.Callbacks("once memory"), "rejected" ], [ "notify", "progress", re.Callbacks("memory") ] ], n = "pending", i = {
                state: function() {
                    return n;
                },
                always: function() {
                    return r.done(arguments).fail(arguments), this;
                },
                then: function() {
                    var e = arguments;
                    return re.Deferred(function(n) {
                        re.each(t, function(t, a) {
                            var o = re.isFunction(e[t]) && e[t];
                            r[a[1]](function() {
                                var e = o && o.apply(this, arguments);
                                e && re.isFunction(e.promise) ? e.promise().done(n.resolve).fail(n.reject).progress(n.notify) : n[a[0] + "With"](this === i ? n.promise() : this, o ? [ e ] : arguments);
                            });
                        }), e = null;
                    }).promise();
                },
                promise: function(e) {
                    return null != e ? re.extend(e, i) : i;
                }
            }, r = {};
            return i.pipe = i.then, re.each(t, function(e, a) {
                var o = a[2], s = a[3];
                i[a[1]] = o.add, s && o.add(function() {
                    n = s;
                }, t[1 ^ e][2].disable, t[2][2].lock), r[a[0]] = function() {
                    return r[a[0] + "With"](this === r ? i : this, arguments), this;
                }, r[a[0] + "With"] = o.fireWith;
            }), i.promise(r), e && e.call(r, r), r;
        },
        when: function(e) {
            var t, n, i, r = 0, a = K.call(arguments), o = a.length, s = 1 !== o || e && re.isFunction(e.promise) ? o : 0, c = 1 === s ? e : re.Deferred(), u = function(e, n, i) {
                return function(r) {
                    n[e] = this, i[e] = arguments.length > 1 ? K.call(arguments) : r, i === t ? c.notifyWith(n, i) : --s || c.resolveWith(n, i);
                };
            };
            if (o > 1) for (t = new Array(o), n = new Array(o), i = new Array(o); r < o; r++) a[r] && re.isFunction(a[r].promise) ? a[r].promise().done(u(r, i, a)).fail(c.reject).progress(u(r, n, t)) : --s;
            return s || c.resolveWith(i, a), c.promise();
        }
    });
    var be;
    re.fn.ready = function(e) {
        return re.ready.promise().done(e), this;
    }, re.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function(e) {
            e ? re.readyWait++ : re.ready(!0);
        },
        ready: function(e) {
            if (e === !0 ? !--re.readyWait : !re.isReady) {
                if (!pe.body) return setTimeout(re.ready);
                re.isReady = !0, e !== !0 && --re.readyWait > 0 || (be.resolveWith(pe, [ re ]), 
                re.fn.triggerHandler && (re(pe).triggerHandler("ready"), re(pe).off("ready")));
            }
        }
    }), re.ready.promise = function(t) {
        if (!be) if (be = re.Deferred(), "complete" === pe.readyState) setTimeout(re.ready); else if (pe.addEventListener) pe.addEventListener("DOMContentLoaded", s, !1), 
        e.addEventListener("load", s, !1); else {
            pe.attachEvent("onreadystatechange", s), e.attachEvent("onload", s);
            var n = !1;
            try {
                n = null == e.frameElement && pe.documentElement;
            } catch (i) {}
            n && n.doScroll && !function r() {
                if (!re.isReady) {
                    try {
                        n.doScroll("left");
                    } catch (e) {
                        return setTimeout(r, 50);
                    }
                    o(), re.ready();
                }
            }();
        }
        return be.promise(t);
    };
    var Te, xe = "undefined";
    for (Te in re(ne)) break;
    ne.ownLast = "0" !== Te, ne.inlineBlockNeedsLayout = !1, re(function() {
        var e, t, n, i;
        n = pe.getElementsByTagName("body")[0], n && n.style && (t = pe.createElement("div"), 
        i = pe.createElement("div"), i.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", 
        n.appendChild(i).appendChild(t), typeof t.style.zoom !== xe && (t.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1", 
        ne.inlineBlockNeedsLayout = e = 3 === t.offsetWidth, e && (n.style.zoom = 1)), n.removeChild(i));
    }), function() {
        var e = pe.createElement("div");
        if (null == ne.deleteExpando) {
            ne.deleteExpando = !0;
            try {
                delete e.test;
            } catch (t) {
                ne.deleteExpando = !1;
            }
        }
        e = null;
    }(), re.acceptData = function(e) {
        var t = re.noData[(e.nodeName + " ").toLowerCase()], n = +e.nodeType || 1;
        return (1 === n || 9 === n) && (!t || t !== !0 && e.getAttribute("classid") === t);
    };
    var we = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, ke = /([A-Z])/g;
    re.extend({
        cache: {},
        noData: {
            "applet ": !0,
            "embed ": !0,
            "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
        },
        hasData: function(e) {
            return e = e.nodeType ? re.cache[e[re.expando]] : e[re.expando], !!e && !u(e);
        },
        data: function(e, t, n) {
            return l(e, t, n);
        },
        removeData: function(e, t) {
            return f(e, t);
        },
        _data: function(e, t, n) {
            return l(e, t, n, !0);
        },
        _removeData: function(e, t) {
            return f(e, t, !0);
        }
    }), re.fn.extend({
        data: function(e, t) {
            var n, i, r, a = this[0], o = a && a.attributes;
            if (void 0 === e) {
                if (this.length && (r = re.data(a), 1 === a.nodeType && !re._data(a, "parsedAttrs"))) {
                    for (n = o.length; n--; ) o[n] && (i = o[n].name, 0 === i.indexOf("data-") && (i = re.camelCase(i.slice(5)), 
                    c(a, i, r[i])));
                    re._data(a, "parsedAttrs", !0);
                }
                return r;
            }
            return "object" == typeof e ? this.each(function() {
                re.data(this, e);
            }) : arguments.length > 1 ? this.each(function() {
                re.data(this, e, t);
            }) : a ? c(a, e, re.data(a, e)) : void 0;
        },
        removeData: function(e) {
            return this.each(function() {
                re.removeData(this, e);
            });
        }
    }), re.extend({
        queue: function(e, t, n) {
            var i;
            if (e) return t = (t || "fx") + "queue", i = re._data(e, t), n && (!i || re.isArray(n) ? i = re._data(e, t, re.makeArray(n)) : i.push(n)), 
            i || [];
        },
        dequeue: function(e, t) {
            t = t || "fx";
            var n = re.queue(e, t), i = n.length, r = n.shift(), a = re._queueHooks(e, t), o = function() {
                re.dequeue(e, t);
            };
            "inprogress" === r && (r = n.shift(), i--), r && ("fx" === t && n.unshift("inprogress"), 
            delete a.stop, r.call(e, o, a)), !i && a && a.empty.fire();
        },
        _queueHooks: function(e, t) {
            var n = t + "queueHooks";
            return re._data(e, n) || re._data(e, n, {
                empty: re.Callbacks("once memory").add(function() {
                    re._removeData(e, t + "queue"), re._removeData(e, n);
                })
            });
        }
    }), re.fn.extend({
        queue: function(e, t) {
            var n = 2;
            return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? re.queue(this[0], e) : void 0 === t ? this : this.each(function() {
                var n = re.queue(this, e, t);
                re._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && re.dequeue(this, e);
            });
        },
        dequeue: function(e) {
            return this.each(function() {
                re.dequeue(this, e);
            });
        },
        clearQueue: function(e) {
            return this.queue(e || "fx", []);
        },
        promise: function(e, t) {
            var n, i = 1, r = re.Deferred(), a = this, o = this.length, s = function() {
                --i || r.resolveWith(a, [ a ]);
            };
            for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; o--; ) n = re._data(a[o], e + "queueHooks"), 
            n && n.empty && (i++, n.empty.add(s));
            return s(), r.promise(t);
        }
    });
    var Ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, Se = [ "Top", "Right", "Bottom", "Left" ], Me = function(e, t) {
        return e = t || e, "none" === re.css(e, "display") || !re.contains(e.ownerDocument, e);
    }, Ce = re.access = function(e, t, n, i, r, a, o) {
        var s = 0, c = e.length, u = null == n;
        if ("object" === re.type(n)) {
            r = !0;
            for (s in n) re.access(e, t, s, n[s], !0, a, o);
        } else if (void 0 !== i && (r = !0, re.isFunction(i) || (o = !0), u && (o ? (t.call(e, i), 
        t = null) : (u = t, t = function(e, t, n) {
            return u.call(re(e), n);
        })), t)) for (;s < c; s++) t(e[s], n, o ? i : i.call(e[s], s, t(e[s], n)));
        return r ? e : u ? t.call(e) : c ? t(e[0], n) : a;
    }, Pe = /^(?:checkbox|radio)$/i;
    !function() {
        var e = pe.createElement("input"), t = pe.createElement("div"), n = pe.createDocumentFragment();
        if (t.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", 
        ne.leadingWhitespace = 3 === t.firstChild.nodeType, ne.tbody = !t.getElementsByTagName("tbody").length, 
        ne.htmlSerialize = !!t.getElementsByTagName("link").length, ne.html5Clone = "<:nav></:nav>" !== pe.createElement("nav").cloneNode(!0).outerHTML, 
        e.type = "checkbox", e.checked = !0, n.appendChild(e), ne.appendChecked = e.checked, 
        t.innerHTML = "<textarea>x</textarea>", ne.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue, 
        n.appendChild(t), t.innerHTML = "<input type='radio' checked='checked' name='t'/>", 
        ne.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked, ne.noCloneEvent = !0, 
        t.attachEvent && (t.attachEvent("onclick", function() {
            ne.noCloneEvent = !1;
        }), t.cloneNode(!0).click()), null == ne.deleteExpando) {
            ne.deleteExpando = !0;
            try {
                delete t.test;
            } catch (i) {
                ne.deleteExpando = !1;
            }
        }
    }(), function() {
        var t, n, i = pe.createElement("div");
        for (t in {
            submit: !0,
            change: !0,
            focusin: !0
        }) n = "on" + t, (ne[t + "Bubbles"] = n in e) || (i.setAttribute(n, "t"), ne[t + "Bubbles"] = i.attributes[n].expando === !1);
        i = null;
    }();
    var De = /^(?:input|select|textarea)$/i, Oe = /^key/, Ne = /^(?:mouse|pointer|contextmenu)|click/, ze = /^(?:focusinfocus|focusoutblur)$/, Le = /^([^.]*)(?:\.(.+)|)$/;
    re.event = {
        global: {},
        add: function(e, t, n, i, r) {
            var a, o, s, c, u, l, f, d, h, p, m, g = re._data(e);
            if (g) {
                for (n.handler && (c = n, n = c.handler, r = c.selector), n.guid || (n.guid = re.guid++), 
                (o = g.events) || (o = g.events = {}), (l = g.handle) || (l = g.handle = function(e) {
                    return typeof re === xe || e && re.event.triggered === e.type ? void 0 : re.event.dispatch.apply(l.elem, arguments);
                }, l.elem = e), t = (t || "").match(Ae) || [ "" ], s = t.length; s--; ) a = Le.exec(t[s]) || [], 
                h = m = a[1], p = (a[2] || "").split(".").sort(), h && (u = re.event.special[h] || {}, 
                h = (r ? u.delegateType : u.bindType) || h, u = re.event.special[h] || {}, f = re.extend({
                    type: h,
                    origType: m,
                    data: i,
                    handler: n,
                    guid: n.guid,
                    selector: r,
                    needsContext: r && re.expr.match.needsContext.test(r),
                    namespace: p.join(".")
                }, c), (d = o[h]) || (d = o[h] = [], d.delegateCount = 0, u.setup && u.setup.call(e, i, p, l) !== !1 || (e.addEventListener ? e.addEventListener(h, l, !1) : e.attachEvent && e.attachEvent("on" + h, l))), 
                u.add && (u.add.call(e, f), f.handler.guid || (f.handler.guid = n.guid)), r ? d.splice(d.delegateCount++, 0, f) : d.push(f), 
                re.event.global[h] = !0);
                e = null;
            }
        },
        remove: function(e, t, n, i, r) {
            var a, o, s, c, u, l, f, d, h, p, m, g = re.hasData(e) && re._data(e);
            if (g && (l = g.events)) {
                for (t = (t || "").match(Ae) || [ "" ], u = t.length; u--; ) if (s = Le.exec(t[u]) || [], 
                h = m = s[1], p = (s[2] || "").split(".").sort(), h) {
                    for (f = re.event.special[h] || {}, h = (i ? f.delegateType : f.bindType) || h, 
                    d = l[h] || [], s = s[2] && new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)"), 
                    c = a = d.length; a--; ) o = d[a], !r && m !== o.origType || n && n.guid !== o.guid || s && !s.test(o.namespace) || i && i !== o.selector && ("**" !== i || !o.selector) || (d.splice(a, 1), 
                    o.selector && d.delegateCount--, f.remove && f.remove.call(e, o));
                    c && !d.length && (f.teardown && f.teardown.call(e, p, g.handle) !== !1 || re.removeEvent(e, h, g.handle), 
                    delete l[h]);
                } else for (h in l) re.event.remove(e, h + t[u], n, i, !0);
                re.isEmptyObject(l) && (delete g.handle, re._removeData(e, "events"));
            }
        },
        trigger: function(t, n, i, r) {
            var a, o, s, c, u, l, f, d = [ i || pe ], h = te.call(t, "type") ? t.type : t, p = te.call(t, "namespace") ? t.namespace.split(".") : [];
            if (s = l = i = i || pe, 3 !== i.nodeType && 8 !== i.nodeType && !ze.test(h + re.event.triggered) && (h.indexOf(".") >= 0 && (p = h.split("."), 
            h = p.shift(), p.sort()), o = h.indexOf(":") < 0 && "on" + h, t = t[re.expando] ? t : new re.Event(h, "object" == typeof t && t), 
            t.isTrigger = r ? 2 : 3, t.namespace = p.join("."), t.namespace_re = t.namespace ? new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, 
            t.result = void 0, t.target || (t.target = i), n = null == n ? [ t ] : re.makeArray(n, [ t ]), 
            u = re.event.special[h] || {}, r || !u.trigger || u.trigger.apply(i, n) !== !1)) {
                if (!r && !u.noBubble && !re.isWindow(i)) {
                    for (c = u.delegateType || h, ze.test(c + h) || (s = s.parentNode); s; s = s.parentNode) d.push(s), 
                    l = s;
                    l === (i.ownerDocument || pe) && d.push(l.defaultView || l.parentWindow || e);
                }
                for (f = 0; (s = d[f++]) && !t.isPropagationStopped(); ) t.type = f > 1 ? c : u.bindType || h, 
                a = (re._data(s, "events") || {})[t.type] && re._data(s, "handle"), a && a.apply(s, n), 
                a = o && s[o], a && a.apply && re.acceptData(s) && (t.result = a.apply(s, n), t.result === !1 && t.preventDefault());
                if (t.type = h, !r && !t.isDefaultPrevented() && (!u._default || u._default.apply(d.pop(), n) === !1) && re.acceptData(i) && o && i[h] && !re.isWindow(i)) {
                    l = i[o], l && (i[o] = null), re.event.triggered = h;
                    try {
                        i[h]();
                    } catch (m) {}
                    re.event.triggered = void 0, l && (i[o] = l);
                }
                return t.result;
            }
        },
        dispatch: function(e) {
            e = re.event.fix(e);
            var t, n, i, r, a, o = [], s = K.call(arguments), c = (re._data(this, "events") || {})[e.type] || [], u = re.event.special[e.type] || {};
            if (s[0] = e, e.delegateTarget = this, !u.preDispatch || u.preDispatch.call(this, e) !== !1) {
                for (o = re.event.handlers.call(this, e, c), t = 0; (r = o[t++]) && !e.isPropagationStopped(); ) for (e.currentTarget = r.elem, 
                a = 0; (i = r.handlers[a++]) && !e.isImmediatePropagationStopped(); ) e.namespace_re && !e.namespace_re.test(i.namespace) || (e.handleObj = i, 
                e.data = i.data, n = ((re.event.special[i.origType] || {}).handle || i.handler).apply(r.elem, s), 
                void 0 !== n && (e.result = n) === !1 && (e.preventDefault(), e.stopPropagation()));
                return u.postDispatch && u.postDispatch.call(this, e), e.result;
            }
        },
        handlers: function(e, t) {
            var n, i, r, a, o = [], s = t.delegateCount, c = e.target;
            if (s && c.nodeType && (!e.button || "click" !== e.type)) for (;c != this; c = c.parentNode || this) if (1 === c.nodeType && (c.disabled !== !0 || "click" !== e.type)) {
                for (r = [], a = 0; a < s; a++) i = t[a], n = i.selector + " ", void 0 === r[n] && (r[n] = i.needsContext ? re(n, this).index(c) >= 0 : re.find(n, this, null, [ c ]).length), 
                r[n] && r.push(i);
                r.length && o.push({
                    elem: c,
                    handlers: r
                });
            }
            return s < t.length && o.push({
                elem: this,
                handlers: t.slice(s)
            }), o;
        },
        fix: function(e) {
            if (e[re.expando]) return e;
            var t, n, i, r = e.type, a = e, o = this.fixHooks[r];
            for (o || (this.fixHooks[r] = o = Ne.test(r) ? this.mouseHooks : Oe.test(r) ? this.keyHooks : {}), 
            i = o.props ? this.props.concat(o.props) : this.props, e = new re.Event(a), t = i.length; t--; ) n = i[t], 
            e[n] = a[n];
            return e.target || (e.target = a.srcElement || pe), 3 === e.target.nodeType && (e.target = e.target.parentNode), 
            e.metaKey = !!e.metaKey, o.filter ? o.filter(e, a) : e;
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function(e, t) {
                return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), 
                e;
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(e, t) {
                var n, i, r, a = t.button, o = t.fromElement;
                return null == e.pageX && null != t.clientX && (i = e.target.ownerDocument || pe, 
                r = i.documentElement, n = i.body, e.pageX = t.clientX + (r && r.scrollLeft || n && n.scrollLeft || 0) - (r && r.clientLeft || n && n.clientLeft || 0), 
                e.pageY = t.clientY + (r && r.scrollTop || n && n.scrollTop || 0) - (r && r.clientTop || n && n.clientTop || 0)), 
                !e.relatedTarget && o && (e.relatedTarget = o === e.target ? t.toElement : o), e.which || void 0 === a || (e.which = 1 & a ? 1 : 2 & a ? 3 : 4 & a ? 2 : 0), 
                e;
            }
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    if (this !== p() && this.focus) try {
                        return this.focus(), !1;
                    } catch (e) {}
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    if (this === p() && this.blur) return this.blur(), !1;
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    if (re.nodeName(this, "input") && "checkbox" === this.type && this.click) return this.click(), 
                    !1;
                },
                _default: function(e) {
                    return re.nodeName(e.target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                }
            }
        },
        simulate: function(e, t, n, i) {
            var r = re.extend(new re.Event(), n, {
                type: e,
                isSimulated: !0,
                originalEvent: {}
            });
            i ? re.event.trigger(r, null, t) : re.event.dispatch.call(t, r), r.isDefaultPrevented() && n.preventDefault();
        }
    }, re.removeEvent = pe.removeEventListener ? function(e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n, !1);
    } : function(e, t, n) {
        var i = "on" + t;
        e.detachEvent && (typeof e[i] === xe && (e[i] = null), e.detachEvent(i, n));
    }, re.Event = function(e, t) {
        return this instanceof re.Event ? (e && e.type ? (this.originalEvent = e, this.type = e.type, 
        this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && e.returnValue === !1 ? d : h) : this.type = e, 
        t && re.extend(this, t), this.timeStamp = e && e.timeStamp || re.now(), void (this[re.expando] = !0)) : new re.Event(e, t);
    }, re.Event.prototype = {
        isDefaultPrevented: h,
        isPropagationStopped: h,
        isImmediatePropagationStopped: h,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = d, e && (e.preventDefault ? e.preventDefault() : e.returnValue = !1);
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = d, e && (e.stopPropagation && e.stopPropagation(), e.cancelBubble = !0);
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = d, e && e.stopImmediatePropagation && e.stopImmediatePropagation(), 
            this.stopPropagation();
        }
    }, re.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(e, t) {
        re.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function(e) {
                var n, i = this, r = e.relatedTarget, a = e.handleObj;
                return r && (r === i || re.contains(i, r)) || (e.type = a.origType, n = a.handler.apply(this, arguments), 
                e.type = t), n;
            }
        };
    }), ne.submitBubbles || (re.event.special.submit = {
        setup: function() {
            return !re.nodeName(this, "form") && void re.event.add(this, "click._submit keypress._submit", function(e) {
                var t = e.target, n = re.nodeName(t, "input") || re.nodeName(t, "button") ? t.form : void 0;
                n && !re._data(n, "submitBubbles") && (re.event.add(n, "submit._submit", function(e) {
                    e._submit_bubble = !0;
                }), re._data(n, "submitBubbles", !0));
            });
        },
        postDispatch: function(e) {
            e._submit_bubble && (delete e._submit_bubble, this.parentNode && !e.isTrigger && re.event.simulate("submit", this.parentNode, e, !0));
        },
        teardown: function() {
            return !re.nodeName(this, "form") && void re.event.remove(this, "._submit");
        }
    }), ne.changeBubbles || (re.event.special.change = {
        setup: function() {
            return De.test(this.nodeName) ? ("checkbox" !== this.type && "radio" !== this.type || (re.event.add(this, "propertychange._change", function(e) {
                "checked" === e.originalEvent.propertyName && (this._just_changed = !0);
            }), re.event.add(this, "click._change", function(e) {
                this._just_changed && !e.isTrigger && (this._just_changed = !1), re.event.simulate("change", this, e, !0);
            })), !1) : void re.event.add(this, "beforeactivate._change", function(e) {
                var t = e.target;
                De.test(t.nodeName) && !re._data(t, "changeBubbles") && (re.event.add(t, "change._change", function(e) {
                    !this.parentNode || e.isSimulated || e.isTrigger || re.event.simulate("change", this.parentNode, e, !0);
                }), re._data(t, "changeBubbles", !0));
            });
        },
        handle: function(e) {
            var t = e.target;
            if (this !== t || e.isSimulated || e.isTrigger || "radio" !== t.type && "checkbox" !== t.type) return e.handleObj.handler.apply(this, arguments);
        },
        teardown: function() {
            return re.event.remove(this, "._change"), !De.test(this.nodeName);
        }
    }), ne.focusinBubbles || re.each({
        focus: "focusin",
        blur: "focusout"
    }, function(e, t) {
        var n = function(e) {
            re.event.simulate(t, e.target, re.event.fix(e), !0);
        };
        re.event.special[t] = {
            setup: function() {
                var i = this.ownerDocument || this, r = re._data(i, t);
                r || i.addEventListener(e, n, !0), re._data(i, t, (r || 0) + 1);
            },
            teardown: function() {
                var i = this.ownerDocument || this, r = re._data(i, t) - 1;
                r ? re._data(i, t, r) : (i.removeEventListener(e, n, !0), re._removeData(i, t));
            }
        };
    }), re.fn.extend({
        on: function(e, t, n, i, r) {
            var a, o;
            if ("object" == typeof e) {
                "string" != typeof t && (n = n || t, t = void 0);
                for (a in e) this.on(a, t, n, e[a], r);
                return this;
            }
            if (null == n && null == i ? (i = t, n = t = void 0) : null == i && ("string" == typeof t ? (i = n, 
            n = void 0) : (i = n, n = t, t = void 0)), i === !1) i = h; else if (!i) return this;
            return 1 === r && (o = i, i = function(e) {
                return re().off(e), o.apply(this, arguments);
            }, i.guid = o.guid || (o.guid = re.guid++)), this.each(function() {
                re.event.add(this, e, i, n, t);
            });
        },
        one: function(e, t, n, i) {
            return this.on(e, t, n, i, 1);
        },
        off: function(e, t, n) {
            var i, r;
            if (e && e.preventDefault && e.handleObj) return i = e.handleObj, re(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), 
            this;
            if ("object" == typeof e) {
                for (r in e) this.off(r, t, e[r]);
                return this;
            }
            return t !== !1 && "function" != typeof t || (n = t, t = void 0), n === !1 && (n = h), 
            this.each(function() {
                re.event.remove(this, e, n, t);
            });
        },
        trigger: function(e, t) {
            return this.each(function() {
                re.event.trigger(e, t, this);
            });
        },
        triggerHandler: function(e, t) {
            var n = this[0];
            if (n) return re.event.trigger(e, t, n, !0);
        }
    });
    var Ie = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video", je = / jQuery\d+="(?:null|\d+)"/g, Be = new RegExp("<(?:" + Ie + ")[\\s/>]", "i"), Re = /^\s+/, Fe = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi, Ye = /<([\w:]+)/, qe = /<tbody/i, We = /<|&#?\w+;/, He = /<(?:script|style|link)/i, Ve = /checked\s*(?:[^=]|=\s*.checked.)/i, Ge = /^$|\/(?:java|ecma)script/i, Ue = /^true\/(.*)/, Xe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g, Ke = {
        option: [ 1, "<select multiple='multiple'>", "</select>" ],
        legend: [ 1, "<fieldset>", "</fieldset>" ],
        area: [ 1, "<map>", "</map>" ],
        param: [ 1, "<object>", "</object>" ],
        thead: [ 1, "<table>", "</table>" ],
        tr: [ 2, "<table><tbody>", "</tbody></table>" ],
        col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
        td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
        _default: ne.htmlSerialize ? [ 0, "", "" ] : [ 1, "X<div>", "</div>" ]
    }, $e = m(pe), Qe = $e.appendChild(pe.createElement("div"));
    Ke.optgroup = Ke.option, Ke.tbody = Ke.tfoot = Ke.colgroup = Ke.caption = Ke.thead, 
    Ke.th = Ke.td, re.extend({
        clone: function(e, t, n) {
            var i, r, a, o, s, c = re.contains(e.ownerDocument, e);
            if (ne.html5Clone || re.isXMLDoc(e) || !Be.test("<" + e.nodeName + ">") ? a = e.cloneNode(!0) : (Qe.innerHTML = e.outerHTML, 
            Qe.removeChild(a = Qe.firstChild)), !(ne.noCloneEvent && ne.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || re.isXMLDoc(e))) for (i = g(a), 
            s = g(e), o = 0; null != (r = s[o]); ++o) i[o] && x(r, i[o]);
            if (t) if (n) for (s = s || g(e), i = i || g(a), o = 0; null != (r = s[o]); o++) T(r, i[o]); else T(e, a);
            return i = g(a, "script"), i.length > 0 && b(i, !c && g(e, "script")), i = s = r = null, 
            a;
        },
        buildFragment: function(e, t, n, i) {
            for (var r, a, o, s, c, u, l, f = e.length, d = m(t), h = [], p = 0; p < f; p++) if (a = e[p], 
            a || 0 === a) if ("object" === re.type(a)) re.merge(h, a.nodeType ? [ a ] : a); else if (We.test(a)) {
                for (s = s || d.appendChild(t.createElement("div")), c = (Ye.exec(a) || [ "", "" ])[1].toLowerCase(), 
                l = Ke[c] || Ke._default, s.innerHTML = l[1] + a.replace(Fe, "<$1></$2>") + l[2], 
                r = l[0]; r--; ) s = s.lastChild;
                if (!ne.leadingWhitespace && Re.test(a) && h.push(t.createTextNode(Re.exec(a)[0])), 
                !ne.tbody) for (a = "table" !== c || qe.test(a) ? "<table>" !== l[1] || qe.test(a) ? 0 : s : s.firstChild, 
                r = a && a.childNodes.length; r--; ) re.nodeName(u = a.childNodes[r], "tbody") && !u.childNodes.length && a.removeChild(u);
                for (re.merge(h, s.childNodes), s.textContent = ""; s.firstChild; ) s.removeChild(s.firstChild);
                s = d.lastChild;
            } else h.push(t.createTextNode(a));
            for (s && d.removeChild(s), ne.appendChecked || re.grep(g(h, "input"), v), p = 0; a = h[p++]; ) if ((!i || re.inArray(a, i) === -1) && (o = re.contains(a.ownerDocument, a), 
            s = g(d.appendChild(a), "script"), o && b(s), n)) for (r = 0; a = s[r++]; ) Ge.test(a.type || "") && n.push(a);
            return s = null, d;
        },
        cleanData: function(e, t) {
            for (var n, i, r, a, o = 0, s = re.expando, c = re.cache, u = ne.deleteExpando, l = re.event.special; null != (n = e[o]); o++) if ((t || re.acceptData(n)) && (r = n[s], 
            a = r && c[r])) {
                if (a.events) for (i in a.events) l[i] ? re.event.remove(n, i) : re.removeEvent(n, i, a.handle);
                c[r] && (delete c[r], u ? delete n[s] : typeof n.removeAttribute !== xe ? n.removeAttribute(s) : n[s] = null, 
                X.push(r));
            }
        }
    }), re.fn.extend({
        text: function(e) {
            return Ce(this, function(e) {
                return void 0 === e ? re.text(this) : this.empty().append((this[0] && this[0].ownerDocument || pe).createTextNode(e));
            }, null, e, arguments.length);
        },
        append: function() {
            return this.domManip(arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = y(this, e);
                    t.appendChild(e);
                }
            });
        },
        prepend: function() {
            return this.domManip(arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = y(this, e);
                    t.insertBefore(e, t.firstChild);
                }
            });
        },
        before: function() {
            return this.domManip(arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this);
            });
        },
        after: function() {
            return this.domManip(arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
            });
        },
        remove: function(e, t) {
            for (var n, i = e ? re.filter(e, this) : this, r = 0; null != (n = i[r]); r++) t || 1 !== n.nodeType || re.cleanData(g(n)), 
            n.parentNode && (t && re.contains(n.ownerDocument, n) && b(g(n, "script")), n.parentNode.removeChild(n));
            return this;
        },
        empty: function() {
            for (var e, t = 0; null != (e = this[t]); t++) {
                for (1 === e.nodeType && re.cleanData(g(e, !1)); e.firstChild; ) e.removeChild(e.firstChild);
                e.options && re.nodeName(e, "select") && (e.options.length = 0);
            }
            return this;
        },
        clone: function(e, t) {
            return e = null != e && e, t = null == t ? e : t, this.map(function() {
                return re.clone(this, e, t);
            });
        },
        html: function(e) {
            return Ce(this, function(e) {
                var t = this[0] || {}, n = 0, i = this.length;
                if (void 0 === e) return 1 === t.nodeType ? t.innerHTML.replace(je, "") : void 0;
                if ("string" == typeof e && !He.test(e) && (ne.htmlSerialize || !Be.test(e)) && (ne.leadingWhitespace || !Re.test(e)) && !Ke[(Ye.exec(e) || [ "", "" ])[1].toLowerCase()]) {
                    e = e.replace(Fe, "<$1></$2>");
                    try {
                        for (;n < i; n++) t = this[n] || {}, 1 === t.nodeType && (re.cleanData(g(t, !1)), 
                        t.innerHTML = e);
                        t = 0;
                    } catch (r) {}
                }
                t && this.empty().append(e);
            }, null, e, arguments.length);
        },
        replaceWith: function() {
            var e = arguments[0];
            return this.domManip(arguments, function(t) {
                e = this.parentNode, re.cleanData(g(this)), e && e.replaceChild(t, this);
            }), e && (e.length || e.nodeType) ? this : this.remove();
        },
        detach: function(e) {
            return this.remove(e, !0);
        },
        domManip: function(e, t) {
            e = $.apply([], e);
            var n, i, r, a, o, s, c = 0, u = this.length, l = this, f = u - 1, d = e[0], h = re.isFunction(d);
            if (h || u > 1 && "string" == typeof d && !ne.checkClone && Ve.test(d)) return this.each(function(n) {
                var i = l.eq(n);
                h && (e[0] = d.call(this, n, i.html())), i.domManip(e, t);
            });
            if (u && (s = re.buildFragment(e, this[0].ownerDocument, !1, this), n = s.firstChild, 
            1 === s.childNodes.length && (s = n), n)) {
                for (a = re.map(g(s, "script"), A), r = a.length; c < u; c++) i = s, c !== f && (i = re.clone(i, !0, !0), 
                r && re.merge(a, g(i, "script"))), t.call(this[c], i, c);
                if (r) for (o = a[a.length - 1].ownerDocument, re.map(a, _), c = 0; c < r; c++) i = a[c], 
                Ge.test(i.type || "") && !re._data(i, "globalEval") && re.contains(o, i) && (i.src ? re._evalUrl && re._evalUrl(i.src) : re.globalEval((i.text || i.textContent || i.innerHTML || "").replace(Xe, "")));
                s = n = null;
            }
            return this;
        }
    }), re.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(e, t) {
        re.fn[e] = function(e) {
            for (var n, i = 0, r = [], a = re(e), o = a.length - 1; i <= o; i++) n = i === o ? this : this.clone(!0), 
            re(a[i])[t](n), Q.apply(r, n.get());
            return this.pushStack(r);
        };
    });
    var Ze, Je = {};
    !function() {
        var e;
        ne.shrinkWrapBlocks = function() {
            if (null != e) return e;
            e = !1;
            var t, n, i;
            return n = pe.getElementsByTagName("body")[0], n && n.style ? (t = pe.createElement("div"), 
            i = pe.createElement("div"), i.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", 
            n.appendChild(i).appendChild(t), typeof t.style.zoom !== xe && (t.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1", 
            t.appendChild(pe.createElement("div")).style.width = "5px", e = 3 !== t.offsetWidth), 
            n.removeChild(i), e) : void 0;
        };
    }();
    var et, tt, nt = /^margin/, it = new RegExp("^(" + Ee + ")(?!px)[a-z%]+$", "i"), rt = /^(top|right|bottom|left)$/;
    e.getComputedStyle ? (et = function(t) {
        return t.ownerDocument.defaultView.opener ? t.ownerDocument.defaultView.getComputedStyle(t, null) : e.getComputedStyle(t, null);
    }, tt = function(e, t, n) {
        var i, r, a, o, s = e.style;
        return n = n || et(e), o = n ? n.getPropertyValue(t) || n[t] : void 0, n && ("" !== o || re.contains(e.ownerDocument, e) || (o = re.style(e, t)), 
        it.test(o) && nt.test(t) && (i = s.width, r = s.minWidth, a = s.maxWidth, s.minWidth = s.maxWidth = s.width = o, 
        o = n.width, s.width = i, s.minWidth = r, s.maxWidth = a)), void 0 === o ? o : o + "";
    }) : pe.documentElement.currentStyle && (et = function(e) {
        return e.currentStyle;
    }, tt = function(e, t, n) {
        var i, r, a, o, s = e.style;
        return n = n || et(e), o = n ? n[t] : void 0, null == o && s && s[t] && (o = s[t]), 
        it.test(o) && !rt.test(t) && (i = s.left, r = e.runtimeStyle, a = r && r.left, a && (r.left = e.currentStyle.left), 
        s.left = "fontSize" === t ? "1em" : o, o = s.pixelLeft + "px", s.left = i, a && (r.left = a)), 
        void 0 === o ? o : o + "" || "auto";
    }), function() {
        function t() {
            var t, n, i, r;
            n = pe.getElementsByTagName("body")[0], n && n.style && (t = pe.createElement("div"), 
            i = pe.createElement("div"), i.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", 
            n.appendChild(i).appendChild(t), t.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute", 
            a = o = !1, c = !0, e.getComputedStyle && (a = "1%" !== (e.getComputedStyle(t, null) || {}).top, 
            o = "4px" === (e.getComputedStyle(t, null) || {
                width: "4px"
            }).width, r = t.appendChild(pe.createElement("div")), r.style.cssText = t.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", 
            r.style.marginRight = r.style.width = "0", t.style.width = "1px", c = !parseFloat((e.getComputedStyle(r, null) || {}).marginRight), 
            t.removeChild(r)), t.innerHTML = "<table><tr><td></td><td>t</td></tr></table>", 
            r = t.getElementsByTagName("td"), r[0].style.cssText = "margin:0;border:0;padding:0;display:none", 
            s = 0 === r[0].offsetHeight, s && (r[0].style.display = "", r[1].style.display = "none", 
            s = 0 === r[0].offsetHeight), n.removeChild(i));
        }
        var n, i, r, a, o, s, c;
        n = pe.createElement("div"), n.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", 
        r = n.getElementsByTagName("a")[0], i = r && r.style, i && (i.cssText = "float:left;opacity:.5", 
        ne.opacity = "0.5" === i.opacity, ne.cssFloat = !!i.cssFloat, n.style.backgroundClip = "content-box", 
        n.cloneNode(!0).style.backgroundClip = "", ne.clearCloneStyle = "content-box" === n.style.backgroundClip, 
        ne.boxSizing = "" === i.boxSizing || "" === i.MozBoxSizing || "" === i.WebkitBoxSizing, 
        re.extend(ne, {
            reliableHiddenOffsets: function() {
                return null == s && t(), s;
            },
            boxSizingReliable: function() {
                return null == o && t(), o;
            },
            pixelPosition: function() {
                return null == a && t(), a;
            },
            reliableMarginRight: function() {
                return null == c && t(), c;
            }
        }));
    }(), re.swap = function(e, t, n, i) {
        var r, a, o = {};
        for (a in t) o[a] = e.style[a], e.style[a] = t[a];
        r = n.apply(e, i || []);
        for (a in t) e.style[a] = o[a];
        return r;
    };
    var at = /alpha\([^)]*\)/i, ot = /opacity\s*=\s*([^)]*)/, st = /^(none|table(?!-c[ea]).+)/, ct = new RegExp("^(" + Ee + ")(.*)$", "i"), ut = new RegExp("^([+-])=(" + Ee + ")", "i"), lt = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, ft = {
        letterSpacing: "0",
        fontWeight: "400"
    }, dt = [ "Webkit", "O", "Moz", "ms" ];
    re.extend({
        cssHooks: {
            opacity: {
                get: function(e, t) {
                    if (t) {
                        var n = tt(e, "opacity");
                        return "" === n ? "1" : n;
                    }
                }
            }
        },
        cssNumber: {
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {
            "float": ne.cssFloat ? "cssFloat" : "styleFloat"
        },
        style: function(e, t, n, i) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var r, a, o, s = re.camelCase(t), c = e.style;
                if (t = re.cssProps[s] || (re.cssProps[s] = S(c, s)), o = re.cssHooks[t] || re.cssHooks[s], 
                void 0 === n) return o && "get" in o && void 0 !== (r = o.get(e, !1, i)) ? r : c[t];
                if (a = typeof n, "string" === a && (r = ut.exec(n)) && (n = (r[1] + 1) * r[2] + parseFloat(re.css(e, t)), 
                a = "number"), null != n && n === n && ("number" !== a || re.cssNumber[s] || (n += "px"), 
                ne.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (c[t] = "inherit"), 
                !(o && "set" in o && void 0 === (n = o.set(e, n, i))))) try {
                    c[t] = n;
                } catch (u) {}
            }
        },
        css: function(e, t, n, i) {
            var r, a, o, s = re.camelCase(t);
            return t = re.cssProps[s] || (re.cssProps[s] = S(e.style, s)), o = re.cssHooks[t] || re.cssHooks[s], 
            o && "get" in o && (a = o.get(e, !0, n)), void 0 === a && (a = tt(e, t, i)), "normal" === a && t in ft && (a = ft[t]), 
            "" === n || n ? (r = parseFloat(a), n === !0 || re.isNumeric(r) ? r || 0 : a) : a;
        }
    }), re.each([ "height", "width" ], function(e, t) {
        re.cssHooks[t] = {
            get: function(e, n, i) {
                if (n) return st.test(re.css(e, "display")) && 0 === e.offsetWidth ? re.swap(e, lt, function() {
                    return D(e, t, i);
                }) : D(e, t, i);
            },
            set: function(e, n, i) {
                var r = i && et(e);
                return C(e, n, i ? P(e, t, i, ne.boxSizing && "border-box" === re.css(e, "boxSizing", !1, r), r) : 0);
            }
        };
    }), ne.opacity || (re.cssHooks.opacity = {
        get: function(e, t) {
            return ot.test((t && e.currentStyle ? e.currentStyle.filter : e.style.filter) || "") ? .01 * parseFloat(RegExp.$1) + "" : t ? "1" : "";
        },
        set: function(e, t) {
            var n = e.style, i = e.currentStyle, r = re.isNumeric(t) ? "alpha(opacity=" + 100 * t + ")" : "", a = i && i.filter || n.filter || "";
            n.zoom = 1, (t >= 1 || "" === t) && "" === re.trim(a.replace(at, "")) && n.removeAttribute && (n.removeAttribute("filter"), 
            "" === t || i && !i.filter) || (n.filter = at.test(a) ? a.replace(at, r) : a + " " + r);
        }
    }), re.cssHooks.marginRight = E(ne.reliableMarginRight, function(e, t) {
        if (t) return re.swap(e, {
            display: "inline-block"
        }, tt, [ e, "marginRight" ]);
    }), re.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(e, t) {
        re.cssHooks[e + t] = {
            expand: function(n) {
                for (var i = 0, r = {}, a = "string" == typeof n ? n.split(" ") : [ n ]; i < 4; i++) r[e + Se[i] + t] = a[i] || a[i - 2] || a[0];
                return r;
            }
        }, nt.test(e) || (re.cssHooks[e + t].set = C);
    }), re.fn.extend({
        css: function(e, t) {
            return Ce(this, function(e, t, n) {
                var i, r, a = {}, o = 0;
                if (re.isArray(t)) {
                    for (i = et(e), r = t.length; o < r; o++) a[t[o]] = re.css(e, t[o], !1, i);
                    return a;
                }
                return void 0 !== n ? re.style(e, t, n) : re.css(e, t);
            }, e, t, arguments.length > 1);
        },
        show: function() {
            return M(this, !0);
        },
        hide: function() {
            return M(this);
        },
        toggle: function(e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                Me(this) ? re(this).show() : re(this).hide();
            });
        }
    }), re.Tween = O, O.prototype = {
        constructor: O,
        init: function(e, t, n, i, r, a) {
            this.elem = e, this.prop = n, this.easing = r || "swing", this.options = t, this.start = this.now = this.cur(), 
            this.end = i, this.unit = a || (re.cssNumber[n] ? "" : "px");
        },
        cur: function() {
            var e = O.propHooks[this.prop];
            return e && e.get ? e.get(this) : O.propHooks._default.get(this);
        },
        run: function(e) {
            var t, n = O.propHooks[this.prop];
            return this.options.duration ? this.pos = t = re.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, 
            this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), 
            n && n.set ? n.set(this) : O.propHooks._default.set(this), this;
        }
    }, O.prototype.init.prototype = O.prototype, O.propHooks = {
        _default: {
            get: function(e) {
                var t;
                return null == e.elem[e.prop] || e.elem.style && null != e.elem.style[e.prop] ? (t = re.css(e.elem, e.prop, ""), 
                t && "auto" !== t ? t : 0) : e.elem[e.prop];
            },
            set: function(e) {
                re.fx.step[e.prop] ? re.fx.step[e.prop](e) : e.elem.style && (null != e.elem.style[re.cssProps[e.prop]] || re.cssHooks[e.prop]) ? re.style(e.elem, e.prop, e.now + e.unit) : e.elem[e.prop] = e.now;
            }
        }
    }, O.propHooks.scrollTop = O.propHooks.scrollLeft = {
        set: function(e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        }
    }, re.easing = {
        linear: function(e) {
            return e;
        },
        swing: function(e) {
            return .5 - Math.cos(e * Math.PI) / 2;
        }
    }, re.fx = O.prototype.init, re.fx.step = {};
    var ht, pt, mt = /^(?:toggle|show|hide)$/, gt = new RegExp("^(?:([+-])=|)(" + Ee + ")([a-z%]*)$", "i"), vt = /queueHooks$/, yt = [ I ], At = {
        "*": [ function(e, t) {
            var n = this.createTween(e, t), i = n.cur(), r = gt.exec(t), a = r && r[3] || (re.cssNumber[e] ? "" : "px"), o = (re.cssNumber[e] || "px" !== a && +i) && gt.exec(re.css(n.elem, e)), s = 1, c = 20;
            if (o && o[3] !== a) {
                a = a || o[3], r = r || [], o = +i || 1;
                do s = s || ".5", o /= s, re.style(n.elem, e, o + a); while (s !== (s = n.cur() / i) && 1 !== s && --c);
            }
            return r && (o = n.start = +o || +i || 0, n.unit = a, n.end = r[1] ? o + (r[1] + 1) * r[2] : +r[2]), 
            n;
        } ]
    };
    re.Animation = re.extend(B, {
        tweener: function(e, t) {
            re.isFunction(e) ? (t = e, e = [ "*" ]) : e = e.split(" ");
            for (var n, i = 0, r = e.length; i < r; i++) n = e[i], At[n] = At[n] || [], At[n].unshift(t);
        },
        prefilter: function(e, t) {
            t ? yt.unshift(e) : yt.push(e);
        }
    }), re.speed = function(e, t, n) {
        var i = e && "object" == typeof e ? re.extend({}, e) : {
            complete: n || !n && t || re.isFunction(e) && e,
            duration: e,
            easing: n && t || t && !re.isFunction(t) && t
        };
        return i.duration = re.fx.off ? 0 : "number" == typeof i.duration ? i.duration : i.duration in re.fx.speeds ? re.fx.speeds[i.duration] : re.fx.speeds._default, 
        null != i.queue && i.queue !== !0 || (i.queue = "fx"), i.old = i.complete, i.complete = function() {
            re.isFunction(i.old) && i.old.call(this), i.queue && re.dequeue(this, i.queue);
        }, i;
    }, re.fn.extend({
        fadeTo: function(e, t, n, i) {
            return this.filter(Me).css("opacity", 0).show().end().animate({
                opacity: t
            }, e, n, i);
        },
        animate: function(e, t, n, i) {
            var r = re.isEmptyObject(e), a = re.speed(t, n, i), o = function() {
                var t = B(this, re.extend({}, e), a);
                (r || re._data(this, "finish")) && t.stop(!0);
            };
            return o.finish = o, r || a.queue === !1 ? this.each(o) : this.queue(a.queue, o);
        },
        stop: function(e, t, n) {
            var i = function(e) {
                var t = e.stop;
                delete e.stop, t(n);
            };
            return "string" != typeof e && (n = t, t = e, e = void 0), t && e !== !1 && this.queue(e || "fx", []), 
            this.each(function() {
                var t = !0, r = null != e && e + "queueHooks", a = re.timers, o = re._data(this);
                if (r) o[r] && o[r].stop && i(o[r]); else for (r in o) o[r] && o[r].stop && vt.test(r) && i(o[r]);
                for (r = a.length; r--; ) a[r].elem !== this || null != e && a[r].queue !== e || (a[r].anim.stop(n), 
                t = !1, a.splice(r, 1));
                !t && n || re.dequeue(this, e);
            });
        },
        finish: function(e) {
            return e !== !1 && (e = e || "fx"), this.each(function() {
                var t, n = re._data(this), i = n[e + "queue"], r = n[e + "queueHooks"], a = re.timers, o = i ? i.length : 0;
                for (n.finish = !0, re.queue(this, e, []), r && r.stop && r.stop.call(this, !0), 
                t = a.length; t--; ) a[t].elem === this && a[t].queue === e && (a[t].anim.stop(!0), 
                a.splice(t, 1));
                for (t = 0; t < o; t++) i[t] && i[t].finish && i[t].finish.call(this);
                delete n.finish;
            });
        }
    }), re.each([ "toggle", "show", "hide" ], function(e, t) {
        var n = re.fn[t];
        re.fn[t] = function(e, i, r) {
            return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(z(t, !0), e, i, r);
        };
    }), re.each({
        slideDown: z("show"),
        slideUp: z("hide"),
        slideToggle: z("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(e, t) {
        re.fn[e] = function(e, n, i) {
            return this.animate(t, e, n, i);
        };
    }), re.timers = [], re.fx.tick = function() {
        var e, t = re.timers, n = 0;
        for (ht = re.now(); n < t.length; n++) e = t[n], e() || t[n] !== e || t.splice(n--, 1);
        t.length || re.fx.stop(), ht = void 0;
    }, re.fx.timer = function(e) {
        re.timers.push(e), e() ? re.fx.start() : re.timers.pop();
    }, re.fx.interval = 13, re.fx.start = function() {
        pt || (pt = setInterval(re.fx.tick, re.fx.interval));
    }, re.fx.stop = function() {
        clearInterval(pt), pt = null;
    }, re.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    }, re.fn.delay = function(e, t) {
        return e = re.fx ? re.fx.speeds[e] || e : e, t = t || "fx", this.queue(t, function(t, n) {
            var i = setTimeout(t, e);
            n.stop = function() {
                clearTimeout(i);
            };
        });
    }, function() {
        var e, t, n, i, r;
        t = pe.createElement("div"), t.setAttribute("className", "t"), t.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", 
        i = t.getElementsByTagName("a")[0], n = pe.createElement("select"), r = n.appendChild(pe.createElement("option")), 
        e = t.getElementsByTagName("input")[0], i.style.cssText = "top:1px", ne.getSetAttribute = "t" !== t.className, 
        ne.style = /top/.test(i.getAttribute("style")), ne.hrefNormalized = "/a" === i.getAttribute("href"), 
        ne.checkOn = !!e.value, ne.optSelected = r.selected, ne.enctype = !!pe.createElement("form").enctype, 
        n.disabled = !0, ne.optDisabled = !r.disabled, e = pe.createElement("input"), e.setAttribute("value", ""), 
        ne.input = "" === e.getAttribute("value"), e.value = "t", e.setAttribute("type", "radio"), 
        ne.radioValue = "t" === e.value;
    }();
    var _t = /\r/g;
    re.fn.extend({
        val: function(e) {
            var t, n, i, r = this[0];
            {
                if (arguments.length) return i = re.isFunction(e), this.each(function(n) {
                    var r;
                    1 === this.nodeType && (r = i ? e.call(this, n, re(this).val()) : e, null == r ? r = "" : "number" == typeof r ? r += "" : re.isArray(r) && (r = re.map(r, function(e) {
                        return null == e ? "" : e + "";
                    })), t = re.valHooks[this.type] || re.valHooks[this.nodeName.toLowerCase()], t && "set" in t && void 0 !== t.set(this, r, "value") || (this.value = r));
                });
                if (r) return t = re.valHooks[r.type] || re.valHooks[r.nodeName.toLowerCase()], 
                t && "get" in t && void 0 !== (n = t.get(r, "value")) ? n : (n = r.value, "string" == typeof n ? n.replace(_t, "") : null == n ? "" : n);
            }
        }
    }), re.extend({
        valHooks: {
            option: {
                get: function(e) {
                    var t = re.find.attr(e, "value");
                    return null != t ? t : re.trim(re.text(e));
                }
            },
            select: {
                get: function(e) {
                    for (var t, n, i = e.options, r = e.selectedIndex, a = "select-one" === e.type || r < 0, o = a ? null : [], s = a ? r + 1 : i.length, c = r < 0 ? s : a ? r : 0; c < s; c++) if (n = i[c], 
                    (n.selected || c === r) && (ne.optDisabled ? !n.disabled : null === n.getAttribute("disabled")) && (!n.parentNode.disabled || !re.nodeName(n.parentNode, "optgroup"))) {
                        if (t = re(n).val(), a) return t;
                        o.push(t);
                    }
                    return o;
                },
                set: function(e, t) {
                    for (var n, i, r = e.options, a = re.makeArray(t), o = r.length; o--; ) if (i = r[o], 
                    re.inArray(re.valHooks.option.get(i), a) >= 0) try {
                        i.selected = n = !0;
                    } catch (s) {
                        i.scrollHeight;
                    } else i.selected = !1;
                    return n || (e.selectedIndex = -1), r;
                }
            }
        }
    }), re.each([ "radio", "checkbox" ], function() {
        re.valHooks[this] = {
            set: function(e, t) {
                if (re.isArray(t)) return e.checked = re.inArray(re(e).val(), t) >= 0;
            }
        }, ne.checkOn || (re.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value;
        });
    });
    var bt, Tt, xt = re.expr.attrHandle, wt = /^(?:checked|selected)$/i, kt = ne.getSetAttribute, Et = ne.input;
    re.fn.extend({
        attr: function(e, t) {
            return Ce(this, re.attr, e, t, arguments.length > 1);
        },
        removeAttr: function(e) {
            return this.each(function() {
                re.removeAttr(this, e);
            });
        }
    }), re.extend({
        attr: function(e, t, n) {
            var i, r, a = e.nodeType;
            if (e && 3 !== a && 8 !== a && 2 !== a) return typeof e.getAttribute === xe ? re.prop(e, t, n) : (1 === a && re.isXMLDoc(e) || (t = t.toLowerCase(), 
            i = re.attrHooks[t] || (re.expr.match.bool.test(t) ? Tt : bt)), void 0 === n ? i && "get" in i && null !== (r = i.get(e, t)) ? r : (r = re.find.attr(e, t), 
            null == r ? void 0 : r) : null !== n ? i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e.setAttribute(t, n + ""), 
            n) : void re.removeAttr(e, t));
        },
        removeAttr: function(e, t) {
            var n, i, r = 0, a = t && t.match(Ae);
            if (a && 1 === e.nodeType) for (;n = a[r++]; ) i = re.propFix[n] || n, re.expr.match.bool.test(n) ? Et && kt || !wt.test(n) ? e[i] = !1 : e[re.camelCase("default-" + n)] = e[i] = !1 : re.attr(e, n, ""), 
            e.removeAttribute(kt ? n : i);
        },
        attrHooks: {
            type: {
                set: function(e, t) {
                    if (!ne.radioValue && "radio" === t && re.nodeName(e, "input")) {
                        var n = e.value;
                        return e.setAttribute("type", t), n && (e.value = n), t;
                    }
                }
            }
        }
    }), Tt = {
        set: function(e, t, n) {
            return t === !1 ? re.removeAttr(e, n) : Et && kt || !wt.test(n) ? e.setAttribute(!kt && re.propFix[n] || n, n) : e[re.camelCase("default-" + n)] = e[n] = !0, 
            n;
        }
    }, re.each(re.expr.match.bool.source.match(/\w+/g), function(e, t) {
        var n = xt[t] || re.find.attr;
        xt[t] = Et && kt || !wt.test(t) ? function(e, t, i) {
            var r, a;
            return i || (a = xt[t], xt[t] = r, r = null != n(e, t, i) ? t.toLowerCase() : null, 
            xt[t] = a), r;
        } : function(e, t, n) {
            if (!n) return e[re.camelCase("default-" + t)] ? t.toLowerCase() : null;
        };
    }), Et && kt || (re.attrHooks.value = {
        set: function(e, t, n) {
            return re.nodeName(e, "input") ? void (e.defaultValue = t) : bt && bt.set(e, t, n);
        }
    }), kt || (bt = {
        set: function(e, t, n) {
            var i = e.getAttributeNode(n);
            if (i || e.setAttributeNode(i = e.ownerDocument.createAttribute(n)), i.value = t += "", 
            "value" === n || t === e.getAttribute(n)) return t;
        }
    }, xt.id = xt.name = xt.coords = function(e, t, n) {
        var i;
        if (!n) return (i = e.getAttributeNode(t)) && "" !== i.value ? i.value : null;
    }, re.valHooks.button = {
        get: function(e, t) {
            var n = e.getAttributeNode(t);
            if (n && n.specified) return n.value;
        },
        set: bt.set
    }, re.attrHooks.contenteditable = {
        set: function(e, t, n) {
            bt.set(e, "" !== t && t, n);
        }
    }, re.each([ "width", "height" ], function(e, t) {
        re.attrHooks[t] = {
            set: function(e, n) {
                if ("" === n) return e.setAttribute(t, "auto"), n;
            }
        };
    })), ne.style || (re.attrHooks.style = {
        get: function(e) {
            return e.style.cssText || void 0;
        },
        set: function(e, t) {
            return e.style.cssText = t + "";
        }
    });
    var St = /^(?:input|select|textarea|button|object)$/i, Mt = /^(?:a|area)$/i;
    re.fn.extend({
        prop: function(e, t) {
            return Ce(this, re.prop, e, t, arguments.length > 1);
        },
        removeProp: function(e) {
            return e = re.propFix[e] || e, this.each(function() {
                try {
                    this[e] = void 0, delete this[e];
                } catch (t) {}
            });
        }
    }), re.extend({
        propFix: {
            "for": "htmlFor",
            "class": "className"
        },
        prop: function(e, t, n) {
            var i, r, a, o = e.nodeType;
            if (e && 3 !== o && 8 !== o && 2 !== o) return a = 1 !== o || !re.isXMLDoc(e), a && (t = re.propFix[t] || t, 
            r = re.propHooks[t]), void 0 !== n ? r && "set" in r && void 0 !== (i = r.set(e, n, t)) ? i : e[t] = n : r && "get" in r && null !== (i = r.get(e, t)) ? i : e[t];
        },
        propHooks: {
            tabIndex: {
                get: function(e) {
                    var t = re.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : St.test(e.nodeName) || Mt.test(e.nodeName) && e.href ? 0 : -1;
                }
            }
        }
    }), ne.hrefNormalized || re.each([ "href", "src" ], function(e, t) {
        re.propHooks[t] = {
            get: function(e) {
                return e.getAttribute(t, 4);
            }
        };
    }), ne.optSelected || (re.propHooks.selected = {
        get: function(e) {
            var t = e.parentNode;
            return t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex), null;
        }
    }), re.each([ "tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable" ], function() {
        re.propFix[this.toLowerCase()] = this;
    }), ne.enctype || (re.propFix.enctype = "encoding");
    var Ct = /[\t\r\n\f]/g;
    re.fn.extend({
        addClass: function(e) {
            var t, n, i, r, a, o, s = 0, c = this.length, u = "string" == typeof e && e;
            if (re.isFunction(e)) return this.each(function(t) {
                re(this).addClass(e.call(this, t, this.className));
            });
            if (u) for (t = (e || "").match(Ae) || []; s < c; s++) if (n = this[s], i = 1 === n.nodeType && (n.className ? (" " + n.className + " ").replace(Ct, " ") : " ")) {
                for (a = 0; r = t[a++]; ) i.indexOf(" " + r + " ") < 0 && (i += r + " ");
                o = re.trim(i), n.className !== o && (n.className = o);
            }
            return this;
        },
        removeClass: function(e) {
            var t, n, i, r, a, o, s = 0, c = this.length, u = 0 === arguments.length || "string" == typeof e && e;
            if (re.isFunction(e)) return this.each(function(t) {
                re(this).removeClass(e.call(this, t, this.className));
            });
            if (u) for (t = (e || "").match(Ae) || []; s < c; s++) if (n = this[s], i = 1 === n.nodeType && (n.className ? (" " + n.className + " ").replace(Ct, " ") : "")) {
                for (a = 0; r = t[a++]; ) for (;i.indexOf(" " + r + " ") >= 0; ) i = i.replace(" " + r + " ", " ");
                o = e ? re.trim(i) : "", n.className !== o && (n.className = o);
            }
            return this;
        },
        toggleClass: function(e, t) {
            var n = typeof e;
            return "boolean" == typeof t && "string" === n ? t ? this.addClass(e) : this.removeClass(e) : re.isFunction(e) ? this.each(function(n) {
                re(this).toggleClass(e.call(this, n, this.className, t), t);
            }) : this.each(function() {
                if ("string" === n) for (var t, i = 0, r = re(this), a = e.match(Ae) || []; t = a[i++]; ) r.hasClass(t) ? r.removeClass(t) : r.addClass(t); else n !== xe && "boolean" !== n || (this.className && re._data(this, "__className__", this.className), 
                this.className = this.className || e === !1 ? "" : re._data(this, "__className__") || "");
            });
        },
        hasClass: function(e) {
            for (var t = " " + e + " ", n = 0, i = this.length; n < i; n++) if (1 === this[n].nodeType && (" " + this[n].className + " ").replace(Ct, " ").indexOf(t) >= 0) return !0;
            return !1;
        }
    }), re.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(e, t) {
        re.fn[t] = function(e, n) {
            return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
        };
    }), re.fn.extend({
        hover: function(e, t) {
            return this.mouseenter(e).mouseleave(t || e);
        },
        bind: function(e, t, n) {
            return this.on(e, null, t, n);
        },
        unbind: function(e, t) {
            return this.off(e, null, t);
        },
        delegate: function(e, t, n, i) {
            return this.on(t, e, n, i);
        },
        undelegate: function(e, t, n) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
        }
    });
    var Pt = re.now(), Dt = /\?/, Ot = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
    re.parseJSON = function(t) {
        if (e.JSON && e.JSON.parse) return e.JSON.parse(t + "");
        var n, i = null, r = re.trim(t + "");
        return r && !re.trim(r.replace(Ot, function(e, t, r, a) {
            return n && t && (i = 0), 0 === i ? e : (n = r || t, i += !a - !r, "");
        })) ? Function("return " + r)() : re.error("Invalid JSON: " + t);
    }, re.parseXML = function(t) {
        var n, i;
        if (!t || "string" != typeof t) return null;
        try {
            e.DOMParser ? (i = new DOMParser(), n = i.parseFromString(t, "text/xml")) : (n = new ActiveXObject("Microsoft.XMLDOM"), 
            n.async = "false", n.loadXML(t));
        } catch (r) {
            n = void 0;
        }
        return n && n.documentElement && !n.getElementsByTagName("parsererror").length || re.error("Invalid XML: " + t), 
        n;
    };
    var Nt, zt, Lt = /#.*$/, It = /([?&])_=[^&]*/, jt = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm, Bt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, Rt = /^(?:GET|HEAD)$/, Ft = /^\/\//, Yt = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/, qt = {}, Wt = {}, Ht = "*/".concat("*");
    try {
        zt = location.href;
    } catch (Vt) {
        zt = pe.createElement("a"), zt.href = "", zt = zt.href;
    }
    Nt = Yt.exec(zt.toLowerCase()) || [], re.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: zt,
            type: "GET",
            isLocal: Bt.test(Nt[1]),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Ht,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /xml/,
                html: /html/,
                json: /json/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": re.parseJSON,
                "text xml": re.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(e, t) {
            return t ? Y(Y(e, re.ajaxSettings), t) : Y(re.ajaxSettings, e);
        },
        ajaxPrefilter: R(qt),
        ajaxTransport: R(Wt),
        ajax: function(e, t) {
            function n(e, t, n, i) {
                var r, l, v, y, _, T = t;
                2 !== A && (A = 2, s && clearTimeout(s), u = void 0, o = i || "", b.readyState = e > 0 ? 4 : 0, 
                r = e >= 200 && e < 300 || 304 === e, n && (y = q(f, b, n)), y = W(f, y, b, r), 
                r ? (f.ifModified && (_ = b.getResponseHeader("Last-Modified"), _ && (re.lastModified[a] = _), 
                _ = b.getResponseHeader("etag"), _ && (re.etag[a] = _)), 204 === e || "HEAD" === f.type ? T = "nocontent" : 304 === e ? T = "notmodified" : (T = y.state, 
                l = y.data, v = y.error, r = !v)) : (v = T, !e && T || (T = "error", e < 0 && (e = 0))), 
                b.status = e, b.statusText = (t || T) + "", r ? p.resolveWith(d, [ l, T, b ]) : p.rejectWith(d, [ b, T, v ]), 
                b.statusCode(g), g = void 0, c && h.trigger(r ? "ajaxSuccess" : "ajaxError", [ b, f, r ? l : v ]), 
                m.fireWith(d, [ b, T ]), c && (h.trigger("ajaxComplete", [ b, f ]), --re.active || re.event.trigger("ajaxStop")));
            }
            "object" == typeof e && (t = e, e = void 0), t = t || {};
            var i, r, a, o, s, c, u, l, f = re.ajaxSetup({}, t), d = f.context || f, h = f.context && (d.nodeType || d.jquery) ? re(d) : re.event, p = re.Deferred(), m = re.Callbacks("once memory"), g = f.statusCode || {}, v = {}, y = {}, A = 0, _ = "canceled", b = {
                readyState: 0,
                getResponseHeader: function(e) {
                    var t;
                    if (2 === A) {
                        if (!l) for (l = {}; t = jt.exec(o); ) l[t[1].toLowerCase()] = t[2];
                        t = l[e.toLowerCase()];
                    }
                    return null == t ? null : t;
                },
                getAllResponseHeaders: function() {
                    return 2 === A ? o : null;
                },
                setRequestHeader: function(e, t) {
                    var n = e.toLowerCase();
                    return A || (e = y[n] = y[n] || e, v[e] = t), this;
                },
                overrideMimeType: function(e) {
                    return A || (f.mimeType = e), this;
                },
                statusCode: function(e) {
                    var t;
                    if (e) if (A < 2) for (t in e) g[t] = [ g[t], e[t] ]; else b.always(e[b.status]);
                    return this;
                },
                abort: function(e) {
                    var t = e || _;
                    return u && u.abort(t), n(0, t), this;
                }
            };
            if (p.promise(b).complete = m.add, b.success = b.done, b.error = b.fail, f.url = ((e || f.url || zt) + "").replace(Lt, "").replace(Ft, Nt[1] + "//"), 
            f.type = t.method || t.type || f.method || f.type, f.dataTypes = re.trim(f.dataType || "*").toLowerCase().match(Ae) || [ "" ], 
            null == f.crossDomain && (i = Yt.exec(f.url.toLowerCase()), f.crossDomain = !(!i || i[1] === Nt[1] && i[2] === Nt[2] && (i[3] || ("http:" === i[1] ? "80" : "443")) === (Nt[3] || ("http:" === Nt[1] ? "80" : "443")))), 
            f.data && f.processData && "string" != typeof f.data && (f.data = re.param(f.data, f.traditional)), 
            F(qt, f, t, b), 2 === A) return b;
            c = re.event && f.global, c && 0 === re.active++ && re.event.trigger("ajaxStart"), 
            f.type = f.type.toUpperCase(), f.hasContent = !Rt.test(f.type), a = f.url, f.hasContent || (f.data && (a = f.url += (Dt.test(a) ? "&" : "?") + f.data, 
            delete f.data), f.cache === !1 && (f.url = It.test(a) ? a.replace(It, "$1_=" + Pt++) : a + (Dt.test(a) ? "&" : "?") + "_=" + Pt++)), 
            f.ifModified && (re.lastModified[a] && b.setRequestHeader("If-Modified-Since", re.lastModified[a]), 
            re.etag[a] && b.setRequestHeader("If-None-Match", re.etag[a])), (f.data && f.hasContent && f.contentType !== !1 || t.contentType) && b.setRequestHeader("Content-Type", f.contentType), 
            b.setRequestHeader("Accept", f.dataTypes[0] && f.accepts[f.dataTypes[0]] ? f.accepts[f.dataTypes[0]] + ("*" !== f.dataTypes[0] ? ", " + Ht + "; q=0.01" : "") : f.accepts["*"]);
            for (r in f.headers) b.setRequestHeader(r, f.headers[r]);
            if (f.beforeSend && (f.beforeSend.call(d, b, f) === !1 || 2 === A)) return b.abort();
            _ = "abort";
            for (r in {
                success: 1,
                error: 1,
                complete: 1
            }) b[r](f[r]);
            if (u = F(Wt, f, t, b)) {
                b.readyState = 1, c && h.trigger("ajaxSend", [ b, f ]), f.async && f.timeout > 0 && (s = setTimeout(function() {
                    b.abort("timeout");
                }, f.timeout));
                try {
                    A = 1, u.send(v, n);
                } catch (T) {
                    if (!(A < 2)) throw T;
                    n(-1, T);
                }
            } else n(-1, "No Transport");
            return b;
        },
        getJSON: function(e, t, n) {
            return re.get(e, t, n, "json");
        },
        getScript: function(e, t) {
            return re.get(e, void 0, t, "script");
        }
    }), re.each([ "get", "post" ], function(e, t) {
        re[t] = function(e, n, i, r) {
            return re.isFunction(n) && (r = r || i, i = n, n = void 0), re.ajax({
                url: e,
                type: t,
                dataType: r,
                data: n,
                success: i
            });
        };
    }), re._evalUrl = function(e) {
        return re.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            async: !1,
            global: !1,
            "throws": !0
        });
    }, re.fn.extend({
        wrapAll: function(e) {
            if (re.isFunction(e)) return this.each(function(t) {
                re(this).wrapAll(e.call(this, t));
            });
            if (this[0]) {
                var t = re(e, this[0].ownerDocument).eq(0).clone(!0);
                this[0].parentNode && t.insertBefore(this[0]), t.map(function() {
                    for (var e = this; e.firstChild && 1 === e.firstChild.nodeType; ) e = e.firstChild;
                    return e;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(e) {
            return re.isFunction(e) ? this.each(function(t) {
                re(this).wrapInner(e.call(this, t));
            }) : this.each(function() {
                var t = re(this), n = t.contents();
                n.length ? n.wrapAll(e) : t.append(e);
            });
        },
        wrap: function(e) {
            var t = re.isFunction(e);
            return this.each(function(n) {
                re(this).wrapAll(t ? e.call(this, n) : e);
            });
        },
        unwrap: function() {
            return this.parent().each(function() {
                re.nodeName(this, "body") || re(this).replaceWith(this.childNodes);
            }).end();
        }
    }), re.expr.filters.hidden = function(e) {
        return e.offsetWidth <= 0 && e.offsetHeight <= 0 || !ne.reliableHiddenOffsets() && "none" === (e.style && e.style.display || re.css(e, "display"));
    }, re.expr.filters.visible = function(e) {
        return !re.expr.filters.hidden(e);
    };
    var Gt = /%20/g, Ut = /\[\]$/, Xt = /\r?\n/g, Kt = /^(?:submit|button|image|reset|file)$/i, $t = /^(?:input|select|textarea|keygen)/i;
    re.param = function(e, t) {
        var n, i = [], r = function(e, t) {
            t = re.isFunction(t) ? t() : null == t ? "" : t, i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t);
        };
        if (void 0 === t && (t = re.ajaxSettings && re.ajaxSettings.traditional), re.isArray(e) || e.jquery && !re.isPlainObject(e)) re.each(e, function() {
            r(this.name, this.value);
        }); else for (n in e) H(n, e[n], t, r);
        return i.join("&").replace(Gt, "+");
    }, re.fn.extend({
        serialize: function() {
            return re.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                var e = re.prop(this, "elements");
                return e ? re.makeArray(e) : this;
            }).filter(function() {
                var e = this.type;
                return this.name && !re(this).is(":disabled") && $t.test(this.nodeName) && !Kt.test(e) && (this.checked || !Pe.test(e));
            }).map(function(e, t) {
                var n = re(this).val();
                return null == n ? null : re.isArray(n) ? re.map(n, function(e) {
                    return {
                        name: t.name,
                        value: e.replace(Xt, "\r\n")
                    };
                }) : {
                    name: t.name,
                    value: n.replace(Xt, "\r\n")
                };
            }).get();
        }
    }), re.ajaxSettings.xhr = void 0 !== e.ActiveXObject ? function() {
        return !this.isLocal && /^(get|post|head|put|delete|options)$/i.test(this.type) && V() || G();
    } : V;
    var Qt = 0, Zt = {}, Jt = re.ajaxSettings.xhr();
    e.attachEvent && e.attachEvent("onunload", function() {
        for (var e in Zt) Zt[e](void 0, !0);
    }), ne.cors = !!Jt && "withCredentials" in Jt, Jt = ne.ajax = !!Jt, Jt && re.ajaxTransport(function(e) {
        if (!e.crossDomain || ne.cors) {
            var t;
            return {
                send: function(n, i) {
                    var r, a = e.xhr(), o = ++Qt;
                    if (a.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields) for (r in e.xhrFields) a[r] = e.xhrFields[r];
                    e.mimeType && a.overrideMimeType && a.overrideMimeType(e.mimeType), e.crossDomain || n["X-Requested-With"] || (n["X-Requested-With"] = "XMLHttpRequest");
                    for (r in n) void 0 !== n[r] && a.setRequestHeader(r, n[r] + "");
                    a.send(e.hasContent && e.data || null), t = function(n, r) {
                        var s, c, u;
                        if (t && (r || 4 === a.readyState)) if (delete Zt[o], t = void 0, a.onreadystatechange = re.noop, 
                        r) 4 !== a.readyState && a.abort(); else {
                            u = {}, s = a.status, "string" == typeof a.responseText && (u.text = a.responseText);
                            try {
                                c = a.statusText;
                            } catch (l) {
                                c = "";
                            }
                            s || !e.isLocal || e.crossDomain ? 1223 === s && (s = 204) : s = u.text ? 200 : 404;
                        }
                        u && i(s, c, u, a.getAllResponseHeaders());
                    }, e.async ? 4 === a.readyState ? setTimeout(t) : a.onreadystatechange = Zt[o] = t : t();
                },
                abort: function() {
                    t && t(void 0, !0);
                }
            };
        }
    }), re.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /(?:java|ecma)script/
        },
        converters: {
            "text script": function(e) {
                return re.globalEval(e), e;
            }
        }
    }), re.ajaxPrefilter("script", function(e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET", e.global = !1);
    }), re.ajaxTransport("script", function(e) {
        if (e.crossDomain) {
            var t, n = pe.head || re("head")[0] || pe.documentElement;
            return {
                send: function(i, r) {
                    t = pe.createElement("script"), t.async = !0, e.scriptCharset && (t.charset = e.scriptCharset), 
                    t.src = e.url, t.onload = t.onreadystatechange = function(e, n) {
                        (n || !t.readyState || /loaded|complete/.test(t.readyState)) && (t.onload = t.onreadystatechange = null, 
                        t.parentNode && t.parentNode.removeChild(t), t = null, n || r(200, "success"));
                    }, n.insertBefore(t, n.firstChild);
                },
                abort: function() {
                    t && t.onload(void 0, !0);
                }
            };
        }
    });
    var en = [], tn = /(=)\?(?=&|$)|\?\?/;
    re.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var e = en.pop() || re.expando + "_" + Pt++;
            return this[e] = !0, e;
        }
    }), re.ajaxPrefilter("json jsonp", function(t, n, i) {
        var r, a, o, s = t.jsonp !== !1 && (tn.test(t.url) ? "url" : "string" == typeof t.data && !(t.contentType || "").indexOf("application/x-www-form-urlencoded") && tn.test(t.data) && "data");
        if (s || "jsonp" === t.dataTypes[0]) return r = t.jsonpCallback = re.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, 
        s ? t[s] = t[s].replace(tn, "$1" + r) : t.jsonp !== !1 && (t.url += (Dt.test(t.url) ? "&" : "?") + t.jsonp + "=" + r), 
        t.converters["script json"] = function() {
            return o || re.error(r + " was not called"), o[0];
        }, t.dataTypes[0] = "json", a = e[r], e[r] = function() {
            o = arguments;
        }, i.always(function() {
            e[r] = a, t[r] && (t.jsonpCallback = n.jsonpCallback, en.push(r)), o && re.isFunction(a) && a(o[0]), 
            o = a = void 0;
        }), "script";
    }), re.parseHTML = function(e, t, n) {
        if (!e || "string" != typeof e) return null;
        "boolean" == typeof t && (n = t, t = !1), t = t || pe;
        var i = fe.exec(e), r = !n && [];
        return i ? [ t.createElement(i[1]) ] : (i = re.buildFragment([ e ], t, r), r && r.length && re(r).remove(), 
        re.merge([], i.childNodes));
    };
    var nn = re.fn.load;
    re.fn.load = function(e, t, n) {
        if ("string" != typeof e && nn) return nn.apply(this, arguments);
        var i, r, a, o = this, s = e.indexOf(" ");
        return s >= 0 && (i = re.trim(e.slice(s, e.length)), e = e.slice(0, s)), re.isFunction(t) ? (n = t, 
        t = void 0) : t && "object" == typeof t && (a = "POST"), o.length > 0 && re.ajax({
            url: e,
            type: a,
            dataType: "html",
            data: t
        }).done(function(e) {
            r = arguments, o.html(i ? re("<div>").append(re.parseHTML(e)).find(i) : e);
        }).complete(n && function(e, t) {
            o.each(n, r || [ e.responseText, t, e ]);
        }), this;
    }, re.each([ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function(e, t) {
        re.fn[t] = function(e) {
            return this.on(t, e);
        };
    }), re.expr.filters.animated = function(e) {
        return re.grep(re.timers, function(t) {
            return e === t.elem;
        }).length;
    };
    var rn = e.document.documentElement;
    re.offset = {
        setOffset: function(e, t, n) {
            var i, r, a, o, s, c, u, l = re.css(e, "position"), f = re(e), d = {};
            "static" === l && (e.style.position = "relative"), s = f.offset(), a = re.css(e, "top"), 
            c = re.css(e, "left"), u = ("absolute" === l || "fixed" === l) && re.inArray("auto", [ a, c ]) > -1, 
            u ? (i = f.position(), o = i.top, r = i.left) : (o = parseFloat(a) || 0, r = parseFloat(c) || 0), 
            re.isFunction(t) && (t = t.call(e, n, s)), null != t.top && (d.top = t.top - s.top + o), 
            null != t.left && (d.left = t.left - s.left + r), "using" in t ? t.using.call(e, d) : f.css(d);
        }
    }, re.fn.extend({
        offset: function(e) {
            if (arguments.length) return void 0 === e ? this : this.each(function(t) {
                re.offset.setOffset(this, e, t);
            });
            var t, n, i = {
                top: 0,
                left: 0
            }, r = this[0], a = r && r.ownerDocument;
            if (a) return t = a.documentElement, re.contains(t, r) ? (typeof r.getBoundingClientRect !== xe && (i = r.getBoundingClientRect()), 
            n = U(a), {
                top: i.top + (n.pageYOffset || t.scrollTop) - (t.clientTop || 0),
                left: i.left + (n.pageXOffset || t.scrollLeft) - (t.clientLeft || 0)
            }) : i;
        },
        position: function() {
            if (this[0]) {
                var e, t, n = {
                    top: 0,
                    left: 0
                }, i = this[0];
                return "fixed" === re.css(i, "position") ? t = i.getBoundingClientRect() : (e = this.offsetParent(), 
                t = this.offset(), re.nodeName(e[0], "html") || (n = e.offset()), n.top += re.css(e[0], "borderTopWidth", !0), 
                n.left += re.css(e[0], "borderLeftWidth", !0)), {
                    top: t.top - n.top - re.css(i, "marginTop", !0),
                    left: t.left - n.left - re.css(i, "marginLeft", !0)
                };
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var e = this.offsetParent || rn; e && !re.nodeName(e, "html") && "static" === re.css(e, "position"); ) e = e.offsetParent;
                return e || rn;
            });
        }
    }), re.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(e, t) {
        var n = /Y/.test(t);
        re.fn[e] = function(i) {
            return Ce(this, function(e, i, r) {
                var a = U(e);
                return void 0 === r ? a ? t in a ? a[t] : a.document.documentElement[i] : e[i] : void (a ? a.scrollTo(n ? re(a).scrollLeft() : r, n ? r : re(a).scrollTop()) : e[i] = r);
            }, e, i, arguments.length, null);
        };
    }), re.each([ "top", "left" ], function(e, t) {
        re.cssHooks[t] = E(ne.pixelPosition, function(e, n) {
            if (n) return n = tt(e, t), it.test(n) ? re(e).position()[t] + "px" : n;
        });
    }), re.each({
        Height: "height",
        Width: "width"
    }, function(e, t) {
        re.each({
            padding: "inner" + e,
            content: t,
            "": "outer" + e
        }, function(n, i) {
            re.fn[i] = function(i, r) {
                var a = arguments.length && (n || "boolean" != typeof i), o = n || (i === !0 || r === !0 ? "margin" : "border");
                return Ce(this, function(t, n, i) {
                    var r;
                    return re.isWindow(t) ? t.document.documentElement["client" + e] : 9 === t.nodeType ? (r = t.documentElement, 
                    Math.max(t.body["scroll" + e], r["scroll" + e], t.body["offset" + e], r["offset" + e], r["client" + e])) : void 0 === i ? re.css(t, n, o) : re.style(t, n, i, o);
                }, t, a ? i : void 0, a, null);
            };
        });
    }), re.fn.size = function() {
        return this.length;
    }, re.fn.andSelf = re.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function() {
        return re;
    });
    var an = e.jQuery, on = e.$;
    return re.noConflict = function(t) {
        return e.$ === re && (e.$ = on), t && e.jQuery === re && (e.jQuery = an), re;
    }, typeof t === xe && (e.jQuery = e.$ = re), re;
});

var EasyAutocomplete = function(e) {
    return e.Configuration = function(e) {
        function t() {
            if ("xml" === e.dataType && (e.getValue || (e.getValue = function(e) {
                return $(e).text();
            }), e.list || (e.list = {}), e.list.sort || (e.list.sort = {}), e.list.sort.method = function(t, n) {
                return t = e.getValue(t), n = e.getValue(n), t < n ? -1 : t > n ? 1 : 0;
            }, e.list.match || (e.list.match = {}), e.list.match.method = function(e, t) {
                return e.search(t) > -1;
            }), void 0 !== e.categories && e.categories instanceof Array) {
                for (var t = [], n = 0, i = e.categories.length; n < i; n += 1) {
                    var r = e.categories[n];
                    for (var a in s.categories[0]) void 0 === r[a] && (r[a] = s.categories[0][a]);
                    t.push(r);
                }
                e.categories = t;
            }
        }
        function n() {
            function t(e, n) {
                var i = e || {};
                for (var r in e) void 0 !== n[r] && null !== n[r] && ("object" != typeof n[r] || n[r] instanceof Array ? i[r] = n[r] : t(e[r], n[r]));
                return void 0 !== n.data && null !== n.data && "object" == typeof n.data && (i.data = n.data), 
                i;
            }
            s = t(s, e);
        }
        function i() {
            if ("list-required" !== s.url && "function" != typeof s.url) {
                var t = s.url;
                s.url = function() {
                    return t;
                };
            }
            if (void 0 !== s.ajaxSettings.url && "function" != typeof s.ajaxSettings.url) {
                var t = s.ajaxSettings.url;
                s.ajaxSettings.url = function() {
                    return t;
                };
            }
            if ("string" == typeof s.listLocation) {
                var n = s.listLocation;
                "XML" === s.dataType.toUpperCase() ? s.listLocation = function(e) {
                    return $(e).find(n);
                } : s.listLocation = function(e) {
                    return e[n];
                };
            }
            if ("string" == typeof s.getValue) {
                var i = s.getValue;
                s.getValue = function(e) {
                    return e[i];
                };
            }
            void 0 !== e.categories && (s.categoriesAssigned = !0);
        }
        function r() {
            void 0 !== e.ajaxSettings && "object" == typeof e.ajaxSettings ? s.ajaxSettings = e.ajaxSettings : s.ajaxSettings = {};
        }
        function a(e) {
            return void 0 !== s[e] && null !== s[e];
        }
        function o(e, t) {
            function n(t, i) {
                for (var r in i) void 0 === t[r] && e.log("Property '" + r + "' does not exist in EasyAutocomplete options API."), 
                "object" == typeof t[r] && $.inArray(r, c) === -1 && n(t[r], i[r]);
            }
            n(s, t);
        }
        var s = {
            data: "list-required",
            url: "list-required",
            dataType: "json",
            listLocation: function(e) {
                return e;
            },
            xmlElementName: "",
            getValue: function(e) {
                return e;
            },
            autocompleteOff: !0,
            placeholder: !1,
            ajaxCallback: function() {},
            matchResponseProperty: !1,
            list: {
                sort: {
                    enabled: !1,
                    method: function(e, t) {
                        return e = s.getValue(e), t = s.getValue(t), e < t ? -1 : e > t ? 1 : 0;
                    }
                },
                maxNumberOfElements: 6,
                hideOnEmptyPhrase: !0,
                match: {
                    enabled: !1,
                    caseSensitive: !1,
                    method: function(e, t) {
                        return e.search(t) > -1;
                    }
                },
                showAnimation: {
                    type: "normal",
                    time: 400,
                    callback: function() {}
                },
                hideAnimation: {
                    type: "normal",
                    time: 400,
                    callback: function() {}
                },
                onClickEvent: function() {},
                onSelectItemEvent: function() {},
                onLoadEvent: function() {},
                onChooseEvent: function() {},
                onKeyEnterEvent: function() {},
                onMouseOverEvent: function() {},
                onMouseOutEvent: function() {},
                onShowListEvent: function() {},
                onHideListEvent: function() {}
            },
            highlightPhrase: !0,
            theme: "",
            cssClasses: "",
            minCharNumber: 0,
            requestDelay: 0,
            adjustWidth: !0,
            ajaxSettings: {},
            preparePostData: function(e, t) {
                return e;
            },
            loggerEnabled: !0,
            template: "",
            categoriesAssigned: !1,
            categories: [ {
                maxNumberOfElements: 4
            } ]
        }, c = [ "ajaxSettings", "template" ];
        this.get = function(e) {
            return s[e];
        }, this.equals = function(e, t) {
            return !(!a(e) || s[e] !== t);
        }, this.checkDataUrlProperties = function() {
            return !("list-required" === s.url && "list-required" === s.data);
        }, this.checkRequiredProperties = function() {
            for (var e in s) if ("required" === s[e]) return logger.error("Option " + e + " must be defined"), 
            !1;
            return !0;
        }, this.printPropertiesThatDoesntExist = function(e, t) {
            o(e, t);
        }, t(), n(), s.loggerEnabled === !0 && o(console, e), r(), i();
    }, e;
}(EasyAutocomplete || {}), EasyAutocomplete = function(e) {
    return e.Logger = function() {
        this.error = function(e) {
            console.log("ERROR: " + e);
        }, this.warning = function(e) {
            console.log("WARNING: " + e);
        };
    }, e;
}(EasyAutocomplete || {}), EasyAutocomplete = function(e) {
    return e.Constants = function() {
        var e = {
            CONTAINER_CLASS: "easy-autocomplete-container",
            CONTAINER_ID: "eac-container-",
            WRAPPER_CSS_CLASS: "easy-autocomplete"
        };
        this.getValue = function(t) {
            return e[t];
        };
    }, e;
}(EasyAutocomplete || {}), EasyAutocomplete = function(e) {
    return e.ListBuilderService = function(e, t) {
        function n(t, n) {
            function i() {
                var i, r = {};
                return void 0 !== t.xmlElementName && (r.xmlElementName = t.xmlElementName), void 0 !== t.listLocation ? i = t.listLocation : void 0 !== e.get("listLocation") && (i = e.get("listLocation")), 
                void 0 !== i ? "string" == typeof i ? r.data = $(n).find(i) : "function" == typeof i && (r.data = i(n)) : r.data = n, 
                r;
            }
            function r() {
                var e = {};
                return void 0 !== t.listLocation ? "string" == typeof t.listLocation ? e.data = n[t.listLocation] : "function" == typeof t.listLocation && (e.data = t.listLocation(n)) : e.data = n, 
                e;
            }
            var a = {};
            if (a = "XML" === e.get("dataType").toUpperCase() ? i() : r(), void 0 !== t.header && (a.header = t.header), 
            void 0 !== t.maxNumberOfElements && (a.maxNumberOfElements = t.maxNumberOfElements), 
            void 0 !== e.get("list").maxNumberOfElements && (a.maxListSize = e.get("list").maxNumberOfElements), 
            void 0 !== t.getValue) if ("string" == typeof t.getValue) {
                var o = t.getValue;
                a.getValue = function(e) {
                    return e[o];
                };
            } else "function" == typeof t.getValue && (a.getValue = t.getValue); else a.getValue = e.get("getValue");
            return a;
        }
        function i(t) {
            var n = [];
            return void 0 === t.xmlElementName && (t.xmlElementName = e.get("xmlElementName")), 
            $(t.data).find(t.xmlElementName).each(function() {
                n.push(this);
            }), n;
        }
        this.init = function(t) {
            var n = [], i = {};
            return i.data = e.get("listLocation")(t), i.getValue = e.get("getValue"), i.maxListSize = e.get("list").maxNumberOfElements, 
            n.push(i), n;
        }, this.updateCategories = function(t, i) {
            if (e.get("categoriesAssigned")) {
                t = [];
                for (var r = 0; r < e.get("categories").length; r += 1) {
                    var a = n(e.get("categories")[r], i);
                    t.push(a);
                }
            }
            return t;
        }, this.convertXml = function(t) {
            if ("XML" === e.get("dataType").toUpperCase()) for (var n = 0; n < t.length; n += 1) t[n].data = i(t[n]);
            return t;
        }, this.processData = function(n, i) {
            for (var r = 0, a = n.length; r < a; r += 1) n[r].data = t(e, n[r], i);
            return n;
        }, this.checkIfDataExists = function(e) {
            for (var t = 0, n = e.length; t < n; t += 1) if (void 0 !== e[t].data && e[t].data instanceof Array && e[t].data.length > 0) return !0;
            return !1;
        };
    }, e;
}(EasyAutocomplete || {}), EasyAutocomplete = function(e) {
    return e.proccess = function(t, n, i) {
        function r(e, n) {
            var i = [], r = "";
            if (t.get("list").match.enabled) for (var o = 0, s = e.length; o < s; o += 1) r = t.get("getValue")(e[o]), 
            a(r, n) && i.push(e[o]); else i = e;
            return i;
        }
        function a(e, n) {
            return t.get("list").match.caseSensitive || ("string" == typeof e && (e = e.toLowerCase()), 
            n = n.toLowerCase()), t.get("list").match.method(e, n);
        }
        function o(e) {
            return void 0 !== n.maxNumberOfElements && e.length > n.maxNumberOfElements && (e = e.slice(0, n.maxNumberOfElements)), 
            e;
        }
        function s(e) {
            return t.get("list").sort.enabled && e.sort(t.get("list").sort.method), e;
        }
        e.proccess.match = a;
        var c = n.data, u = i;
        return c = r(c, u), c = o(c), c = s(c);
    }, e;
}(EasyAutocomplete || {}), EasyAutocomplete = function(e) {
    return e.Template = function(e) {
        var t = {
            basic: {
                type: "basic",
                method: function(e) {
                    return e;
                },
                cssClass: ""
            },
            description: {
                type: "description",
                fields: {
                    description: "description"
                },
                method: function(e) {
                    return e + " - description";
                },
                cssClass: "eac-description"
            },
            iconLeft: {
                type: "iconLeft",
                fields: {
                    icon: ""
                },
                method: function(e) {
                    return e;
                },
                cssClass: "eac-icon-left"
            },
            iconRight: {
                type: "iconRight",
                fields: {
                    iconSrc: ""
                },
                method: function(e) {
                    return e;
                },
                cssClass: "eac-icon-right"
            },
            links: {
                type: "links",
                fields: {
                    link: ""
                },
                method: function(e) {
                    return e;
                },
                cssClass: ""
            },
            custom: {
                type: "custom",
                method: function() {},
                cssClass: ""
            }
        }, n = function(e) {
            var n, i = e.fields;
            return "description" === e.type ? (n = t.description.method, "string" == typeof i.description ? n = function(e, t) {
                return e + " - <span>" + t[i.description] + "</span>";
            } : "function" == typeof i.description && (n = function(e, t) {
                return e + " - <span>" + i.description(t) + "</span>";
            }), n) : "iconRight" === e.type ? ("string" == typeof i.iconSrc ? n = function(e, t) {
                return e + "<img class='eac-icon' src='" + t[i.iconSrc] + "' />";
            } : "function" == typeof i.iconSrc && (n = function(e, t) {
                return e + "<img class='eac-icon' src='" + i.iconSrc(t) + "' />";
            }), n) : "iconLeft" === e.type ? ("string" == typeof i.iconSrc ? n = function(e, t) {
                return "<img class='eac-icon' src='" + t[i.iconSrc] + "' />" + e;
            } : "function" == typeof i.iconSrc && (n = function(e, t) {
                return "<img class='eac-icon' src='" + i.iconSrc(t) + "' />" + e;
            }), n) : "links" === e.type ? ("string" == typeof i.link ? n = function(e, t) {
                return "<a href='" + t[i.link] + "' >" + e + "</a>";
            } : "function" == typeof i.link && (n = function(e, t) {
                return "<a href='" + i.link(t) + "' >" + e + "</a>";
            }), n) : "custom" === e.type ? e.method : t.basic.method;
        }, i = function(e) {
            return e && e.type && e.type && t[e.type] ? n(e) : t.basic.method;
        }, r = function(e) {
            var n = function() {
                return "";
            };
            return e && e.type && e.type && t[e.type] ? function() {
                var n = t[e.type].cssClass;
                return function() {
                    return n;
                };
            }() : n;
        };
        this.getTemplateClass = r(e), this.build = i(e);
    }, e;
}(EasyAutocomplete || {}), EasyAutocomplete = function(e) {
    return e.main = function(t, n) {
        function i() {
            return 0 === A.length ? void m.error("Input field doesn't exist.") : p.checkDataUrlProperties() ? p.checkRequiredProperties() ? (r(), 
            void o()) : void m.error("Will not work without mentioned properties.") : void m.error("One of options variables 'data' or 'url' must be defined.");
        }
        function r() {
            function e() {
                var e = $("<div>"), n = h.getValue("WRAPPER_CSS_CLASS");
                p.get("theme") && "" !== p.get("theme") && (n += " eac-" + p.get("theme")), p.get("cssClasses") && "" !== p.get("cssClasses") && (n += " " + p.get("cssClasses")), 
                "" !== g.getTemplateClass() && (n += " " + g.getTemplateClass()), e.addClass(n), 
                A.wrap(e), p.get("adjustWidth") === !0 && t();
            }
            function t() {
                var e = A.outerWidth();
                A.parent().css("width", e);
            }
            function n() {
                A.unwrap();
            }
            function i() {
                var e = $("<div>").addClass(h.getValue("CONTAINER_CLASS"));
                e.attr("id", a()).prepend($("<ul>")), function() {
                    e.on("show.eac", function() {
                        if (A.is(":focus")) {
                            switch (p.get("list").showAnimation.type) {
                              case "slide":
                                var t = p.get("list").showAnimation.time, n = p.get("list").showAnimation.callback;
                                e.find("ul").slideDown(t, n);
                                break;

                              case "fade":
                                var t = p.get("list").showAnimation.time, n = p.get("list").showAnimation.callback;
                                e.find("ul").fadeIn(t), n;
                                break;

                              default:
                                e.find("ul").show();
                            }
                            p.get("list").onShowListEvent();
                        }
                    }).on("hide.eac", function() {
                        switch (p.get("list").hideAnimation.type) {
                          case "slide":
                            var t = p.get("list").hideAnimation.time, n = p.get("list").hideAnimation.callback;
                            e.find("ul").slideUp(t, n);
                            break;

                          case "fade":
                            var t = p.get("list").hideAnimation.time, n = p.get("list").hideAnimation.callback;
                            e.find("ul").fadeOut(t, n);
                            break;

                          default:
                            e.find("ul").hide();
                        }
                        p.get("list").onHideListEvent();
                    }).on("selectElement.eac", function() {
                        e.find("ul li").removeClass("selected"), e.find("ul li").eq(T).addClass("selected"), 
                        p.get("list").onSelectItemEvent();
                    }).on("loadElements.eac", function(t, n, i) {
                        var r = "", a = e.find("ul");
                        a.empty().detach(), b = [];
                        for (var s = 0, c = 0, l = n.length; c < l; c += 1) {
                            var f = n[c].data;
                            if (0 !== f.length) {
                                void 0 !== n[c].header && n[c].header.length > 0 && a.append("<div class='eac-category' >" + n[c].header + "</div>");
                                for (var d = 0, h = f.length; d < h && s < n[c].maxListSize; d += 1) r = $("<li><div class='eac-item'></div></li>"), 
                                function() {
                                    var e = d, t = s, a = n[c].getValue(f[e]);
                                    r.find(" > div").on("click", function() {
                                        A.val(a).trigger("change"), T = t, u(t), p.get("list").onClickEvent(), p.get("list").onChooseEvent();
                                    }).mouseover(function() {
                                        T = t, u(t), p.get("list").onMouseOverEvent();
                                    }).mouseout(function() {
                                        p.get("list").onMouseOutEvent();
                                    }).html(g.build(o(a, i), f[e]));
                                }(), a.append(r), b.push(f[d]), s += 1;
                            }
                        }
                        e.append(a), p.get("list").onLoadEvent();
                    });
                }(), A.after(e);
            }
            function r() {
                A.next("." + h.getValue("CONTAINER_CLASS")).remove();
            }
            function o(e, t) {
                return p.get("highlightPhrase") && "" !== t ? c(e, t) : e;
            }
            function s(e) {
                return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
            }
            function c(e, t) {
                var n = s(t);
                return (e + "").replace(new RegExp("(" + n + ")", "gi"), "<b>$1</b>");
            }
            A.parent().hasClass(h.getValue("WRAPPER_CSS_CLASS")) && (r(), n()), e(), i(), _ = $("#" + a()), 
            p.get("placeholder") && A.attr("placeholder", p.get("placeholder"));
        }
        function a() {
            var e = A.attr("id");
            return e = h.getValue("CONTAINER_ID") + e;
        }
        function o() {
            function e() {
                y("autocompleteOff", !0) && h(), t(), n(), i(), r(), a(), o();
            }
            function t() {
                A.focusout(function() {
                    var e, t = A.val();
                    p.get("list").match.caseSensitive || (t = t.toLowerCase());
                    for (var n = 0, i = b.length; n < i; n += 1) if (e = p.get("getValue")(b[n]), p.get("list").match.caseSensitive || (e = e.toLowerCase()), 
                    e === t) return T = n, void u(T);
                });
            }
            function n() {
                A.off("keyup").keyup(function(e) {
                    function t(e) {
                        function t() {
                            var e = {}, t = p.get("ajaxSettings") || {};
                            for (var n in t) e[n] = t[n];
                            return e;
                        }
                        function n(e, t) {
                            return p.get("matchResponseProperty") === !1 || ("string" == typeof p.get("matchResponseProperty") ? t[p.get("matchResponseProperty")] === e : "function" != typeof p.get("matchResponseProperty") || p.get("matchResponseProperty")(t) === e);
                        }
                        if (!(e.length < p.get("minCharNumber"))) {
                            if ("list-required" !== p.get("data")) {
                                var i = p.get("data"), r = v.init(i);
                                r = v.updateCategories(r, i), r = v.processData(r, e), l(r, e), A.parent().find("li").length > 0 ? s() : c();
                            }
                            var a = t();
                            void 0 !== a.url && "" !== a.url || (a.url = p.get("url")), void 0 !== a.dataType && "" !== a.dataType || (a.dataType = p.get("dataType")), 
                            void 0 !== a.url && "list-required" !== a.url && (a.url = a.url(e), a.data = p.get("preparePostData")(a.data, e), 
                            $.ajax(a).done(function(t) {
                                var i = v.init(t);
                                i = v.updateCategories(i, t), i = v.convertXml(i), n(e, t) && (i = v.processData(i, e), 
                                l(i, e)), v.checkIfDataExists(i) && A.parent().find("li").length > 0 ? s() : c(), 
                                p.get("ajaxCallback")();
                            }).fail(function() {
                                m.warning("Fail to load response data");
                            }).always(function() {}));
                        }
                    }
                    switch (e.keyCode) {
                      case 27:
                        c(), f();
                        break;

                      case 38:
                        e.preventDefault(), b.length > 0 && T > 0 && (T -= 1, A.val(p.get("getValue")(b[T])), 
                        u(T));
                        break;

                      case 40:
                        e.preventDefault(), b.length > 0 && T < b.length - 1 && (T += 1, A.val(p.get("getValue")(b[T])), 
                        u(T));
                        break;

                      default:
                        if (e.keyCode > 40 || 8 === e.keyCode || 0 === e.keyCode) {
                            var n = A.val();
                            p.get("list").hideOnEmptyPhrase !== !0 || 8 !== e.keyCode || "" !== n ? p.get("requestDelay") > 0 ? (void 0 !== d && clearTimeout(d), 
                            d = setTimeout(function() {
                                t(n);
                            }, p.get("requestDelay"))) : t(n) : c();
                        }
                    }
                });
            }
            function i() {
                A.on("keydown", function(e) {
                    e = e || window.event;
                    var t = e.keyCode;
                    if (38 === t) return suppressKeypress = !0, !1;
                }).keydown(function(e) {
                    13 === e.keyCode && T > -1 && (A.val(p.get("getValue")(b[T])), p.get("list").onKeyEnterEvent(), 
                    p.get("list").onChooseEvent(), T = -1, c(), e.preventDefault());
                });
            }
            function r() {
                A.off("keypress");
            }
            function a() {
                A.focus(function() {
                    "" !== A.val() && b.length > 0 && (T = -1, s());
                });
            }
            function o() {
                A.blur(function() {
                    setTimeout(function() {
                        T = -1, c();
                    }, 250);
                });
            }
            function h() {
                A.attr("autocomplete", "off");
            }
            e();
        }
        function s() {
            _.trigger("show.eac");
        }
        function c() {
            _.trigger("hide.eac");
        }
        function u(e) {
            _.trigger("selectElement.eac", e);
        }
        function l(e, t) {
            _.trigger("loadElements.eac", [ e, t ]);
        }
        function f() {
            A.trigger("blur");
        }
        var d, h = new e.Constants(), p = new e.Configuration(n), m = new e.Logger(), g = new e.Template(n.template), v = new e.ListBuilderService(p, e.proccess), y = p.equals, A = t, _ = "", b = [], T = -1;
        e.consts = h, this.getConstants = function() {
            return h;
        }, this.getConfiguration = function() {
            return p;
        }, this.getContainer = function() {
            return _;
        }, this.getSelectedItemIndex = function() {
            return T;
        }, this.getItems = function() {
            return b;
        }, this.getItemData = function(e) {
            return b.length < e || void 0 === b[e] ? -1 : b[e];
        }, this.getSelectedItemData = function() {
            return this.getItemData(T);
        }, this.build = function() {
            r();
        }, this.init = function() {
            i();
        };
    }, e.eacHandles = [], e.getHandle = function(t) {
        return e.eacHandles[t];
    }, e.inputHasId = function(e) {
        return void 0 !== $(e).attr("id") && $(e).attr("id").length > 0;
    }, e.assignRandomId = function(t) {
        var n = "";
        do n = "eac-" + Math.floor(1e4 * Math.random()); while (0 !== $("#" + n).length);
        elementId = e.consts.getValue("CONTAINER_ID") + n, $(t).attr("id", n);
    }, e.setHandle = function(t, n) {
        e.eacHandles[n] = t;
    }, e;
}(EasyAutocomplete || {});

!function(e) {
    e.fn.easyAutocomplete = function(t) {
        return this.each(function() {
            var n = e(this), i = new EasyAutocomplete.main(n, t);
            EasyAutocomplete.inputHasId(n) || EasyAutocomplete.assignRandomId(n), i.init(), 
            EasyAutocomplete.setHandle(i, n.attr("id"));
        });
    }, e.fn.getSelectedItemIndex = function() {
        var t = e(this).attr("id");
        return void 0 !== t ? EasyAutocomplete.getHandle(t).getSelectedItemIndex() : -1;
    }, e.fn.getItems = function() {
        var t = e(this).attr("id");
        return void 0 !== t ? EasyAutocomplete.getHandle(t).getItems() : -1;
    }, e.fn.getItemData = function(t) {
        var n = e(this).attr("id");
        return void 0 !== n && t > -1 ? EasyAutocomplete.getHandle(n).getItemData(t) : -1;
    }, e.fn.getSelectedItemData = function() {
        var t = e(this).attr("id");
        return void 0 !== t ? EasyAutocomplete.getHandle(t).getSelectedItemData() : -1;
    };
}(jQuery), function(e) {
    function t() {
        return o++, o;
    }
    try {
        var n = new Blob([ "var fakeIdToId = {};onmessage = function (event) {	var data = event.data,		name = data.name,		fakeId = data.fakeId,		time;	if(data.hasOwnProperty('time')) {		time = data.time;	}	switch (name) {		case 'setInterval':			fakeIdToId[fakeId] = setInterval(function () {				postMessage({fakeId: fakeId});			}, time);			break;		case 'clearInterval':			if (fakeIdToId.hasOwnProperty (fakeId)) {				clearInterval(fakeIdToId[fakeId]);				delete fakeIdToId[fakeId];			}			break;		case 'setTimeout':			fakeIdToId[fakeId] = setTimeout(function () {				postMessage({fakeId: fakeId});				if (fakeIdToId.hasOwnProperty (fakeId)) {					delete fakeIdToId[fakeId];				}			}, time);			break;		case 'clearTimeout':			if (fakeIdToId.hasOwnProperty (fakeId)) {				clearTimeout(fakeIdToId[fakeId]);				delete fakeIdToId[fakeId];			}			break;	}}" ]);
        e = window.URL.createObjectURL(n);
    } catch (i) {}
    var r, a = {}, o = 0, s = "HackTimer.js by turuslan: ";
    if ("undefined" != typeof Worker) try {
        r = new Worker(e), window.setInterval = function(e, n) {
            var i = t();
            return a[i] = {
                callback: e,
                parameters: Array.prototype.slice.call(arguments, 2)
            }, r.postMessage({
                name: "setInterval",
                fakeId: i,
                time: n
            }), i;
        }, window.clearInterval = function(e) {
            a.hasOwnProperty(e) && (delete a[e], r.postMessage({
                name: "clearInterval",
                fakeId: e
            }));
        }, window.setTimeout = function(e, n) {
            var i = t();
            return a[i] = {
                callback: e,
                parameters: Array.prototype.slice.call(arguments, 2)
            }, r.postMessage({
                name: "setTimeout",
                fakeId: i,
                time: n
            }), i;
        }, window.clearTimeout = function(e) {
            a.hasOwnProperty(e) && (delete a[e], r.postMessage({
                name: "clearTimeout",
                fakeId: e
            }));
        }, r.onmessage = function(e) {
            var t, n, i, r = e.data, o = r.fakeId;
            if (a.hasOwnProperty(o) && (t = a[o], i = t.callback, n = t.parameters), "string" == typeof i) try {
                i = new Function(i);
            } catch (c) {
                console.log(s + "Error parsing callback code string: ", c);
            }
            "function" == typeof i && i.apply(window, n);
        }, r.onerror = function(e) {
            console.log(e);
        }, console.log(s + "Initialisation succeeded");
    } catch (i) {
        console.log(s + "Initialisation failed"), console.error(i);
    } else console.log(s + "Initialisation failed - HTML5 Web Worker is not supported");
}("HackTimerWorker.js"), function(e, t, n, i) {
    "use strict";
    function r(e, t, n) {
        return setTimeout(l(e, n), t);
    }
    function a(e, t, n) {
        return !!Array.isArray(e) && (o(e, n[t], n), !0);
    }
    function o(e, t, n) {
        var r;
        if (e) if (e.forEach) e.forEach(t, n); else if (e.length !== i) for (r = 0; r < e.length; ) t.call(n, e[r], r, e), 
        r++; else for (r in e) e.hasOwnProperty(r) && t.call(n, e[r], r, e);
    }
    function s(e, t, n) {
        for (var r = Object.keys(t), a = 0; a < r.length; ) (!n || n && e[r[a]] === i) && (e[r[a]] = t[r[a]]), 
        a++;
        return e;
    }
    function c(e, t) {
        return s(e, t, !0);
    }
    function u(e, t, n) {
        var i, r = t.prototype;
        i = e.prototype = Object.create(r), i.constructor = e, i._super = r, n && s(i, n);
    }
    function l(e, t) {
        return function() {
            return e.apply(t, arguments);
        };
    }
    function f(e, t) {
        return typeof e == le ? e.apply(t ? t[0] || i : i, t) : e;
    }
    function d(e, t) {
        return e === i ? t : e;
    }
    function h(e, t, n) {
        o(v(t), function(t) {
            e.addEventListener(t, n, !1);
        });
    }
    function p(e, t, n) {
        o(v(t), function(t) {
            e.removeEventListener(t, n, !1);
        });
    }
    function m(e, t) {
        for (;e; ) {
            if (e == t) return !0;
            e = e.parentNode;
        }
        return !1;
    }
    function g(e, t) {
        return e.indexOf(t) > -1;
    }
    function v(e) {
        return e.trim().split(/\s+/g);
    }
    function y(e, t, n) {
        if (e.indexOf && !n) return e.indexOf(t);
        for (var i = 0; i < e.length; ) {
            if (n && e[i][n] == t || !n && e[i] === t) return i;
            i++;
        }
        return -1;
    }
    function A(e) {
        return Array.prototype.slice.call(e, 0);
    }
    function _(e, t, n) {
        for (var i = [], r = [], a = 0; a < e.length; ) {
            var o = t ? e[a][t] : e[a];
            y(r, o) < 0 && i.push(e[a]), r[a] = o, a++;
        }
        return n && (i = t ? i.sort(function(e, n) {
            return e[t] > n[t];
        }) : i.sort()), i;
    }
    function b(e, t) {
        for (var n, r, a = t[0].toUpperCase() + t.slice(1), o = 0; o < ce.length; ) {
            if (n = ce[o], r = n ? n + a : t, r in e) return r;
            o++;
        }
        return i;
    }
    function T() {
        return pe++;
    }
    function x(t) {
        var n = t.ownerDocument || t;
        return n.defaultView || n.parentWindow || e;
    }
    function w(e, t) {
        var n = this;
        this.manager = e, this.callback = t, this.element = e.element, this.target = e.options.inputTarget, 
        this.domHandler = function(t) {
            f(e.options.enable, [ e ]) && n.handler(t);
        }, this.init();
    }
    function k(e) {
        var t, n = e.options.inputClass;
        return new (t = n ? n : ve ? R : ye ? q : ge ? H : B)(e, E);
    }
    function E(e, t, n) {
        var i = n.pointers.length, r = n.changedPointers.length, a = t & we && i - r === 0, o = t & (Ee | Se) && i - r === 0;
        n.isFirst = !!a, n.isFinal = !!o, a && (e.session = {}), n.eventType = t, S(e, n), 
        e.emit("hammer.input", n), e.recognize(n), e.session.prevInput = n;
    }
    function S(e, t) {
        var n = e.session, i = t.pointers, r = i.length;
        n.firstInput || (n.firstInput = P(t)), r > 1 && !n.firstMultiple ? n.firstMultiple = P(t) : 1 === r && (n.firstMultiple = !1);
        var a = n.firstInput, o = n.firstMultiple, s = o ? o.center : a.center, c = t.center = D(i);
        t.timeStamp = he(), t.deltaTime = t.timeStamp - a.timeStamp, t.angle = L(s, c), 
        t.distance = z(s, c), M(n, t), t.offsetDirection = N(t.deltaX, t.deltaY);
        var u = O(t.deltaTime, t.deltaX, t.deltaY);
        t.overallVelocityX = u.x, t.overallVelocityY = u.y, t.overallVelocity = de(u.x) > de(u.y) ? u.x : u.y, 
        t.scale = o ? j(o.pointers, i) : 1, t.rotation = o ? I(o.pointers, i) : 0, t.maxPointers = n.prevInput ? t.pointers.length > n.prevInput.maxPointers ? t.pointers.length : n.prevInput.maxPointers : t.pointers.length, 
        C(n, t);
        var l = e.element;
        m(t.srcEvent.target, l) && (l = t.srcEvent.target), t.target = l;
    }
    function M(e, t) {
        var n = t.center, i = e.offsetDelta || {}, r = e.prevDelta || {}, a = e.prevInput || {};
        t.eventType !== we && a.eventType !== Ee || (r = e.prevDelta = {
            x: a.deltaX || 0,
            y: a.deltaY || 0
        }, i = e.offsetDelta = {
            x: n.x,
            y: n.y
        }), t.deltaX = r.x + (n.x - i.x), t.deltaY = r.y + (n.y - i.y);
    }
    function C(e, t) {
        var n, r, a, o, s = e.lastInterval || t, c = t.timeStamp - s.timeStamp;
        if (t.eventType != Se && (c > xe || s.velocity === i)) {
            var u = t.deltaX - s.deltaX, l = t.deltaY - s.deltaY, f = O(c, u, l);
            r = f.x, a = f.y, n = de(f.x) > de(f.y) ? f.x : f.y, o = N(u, l), e.lastInterval = t;
        } else n = s.velocity, r = s.velocityX, a = s.velocityY, o = s.direction;
        t.velocity = n, t.velocityX = r, t.velocityY = a, t.direction = o;
    }
    function P(e) {
        for (var t = [], n = 0; n < e.pointers.length; ) t[n] = {
            clientX: fe(e.pointers[n].clientX),
            clientY: fe(e.pointers[n].clientY)
        }, n++;
        return {
            timeStamp: he(),
            pointers: t,
            center: D(t),
            deltaX: e.deltaX,
            deltaY: e.deltaY
        };
    }
    function D(e) {
        var t = e.length;
        if (1 === t) return {
            x: fe(e[0].clientX),
            y: fe(e[0].clientY)
        };
        for (var n = 0, i = 0, r = 0; r < t; ) n += e[r].clientX, i += e[r].clientY, r++;
        return {
            x: fe(n / t),
            y: fe(i / t)
        };
    }
    function O(e, t, n) {
        return {
            x: t / e || 0,
            y: n / e || 0
        };
    }
    function N(e, t) {
        return e === t ? Me : de(e) >= de(t) ? e < 0 ? Ce : Pe : t < 0 ? De : Oe;
    }
    function z(e, t, n) {
        n || (n = Ie);
        var i = t[n[0]] - e[n[0]], r = t[n[1]] - e[n[1]];
        return Math.sqrt(i * i + r * r);
    }
    function L(e, t, n) {
        n || (n = Ie);
        var i = t[n[0]] - e[n[0]], r = t[n[1]] - e[n[1]];
        return 180 * Math.atan2(r, i) / Math.PI;
    }
    function I(e, t) {
        return L(t[1], t[0], je) + L(e[1], e[0], je);
    }
    function j(e, t) {
        return z(t[0], t[1], je) / z(e[0], e[1], je);
    }
    function B() {
        this.evEl = Re, this.evWin = Fe, this.allow = !0, this.pressed = !1, w.apply(this, arguments);
    }
    function R() {
        this.evEl = We, this.evWin = He, w.apply(this, arguments), this.store = this.manager.session.pointerEvents = [];
    }
    function F() {
        this.evTarget = Ge, this.evWin = Ue, this.started = !1, w.apply(this, arguments);
    }
    function Y(e, t) {
        var n = A(e.touches), i = A(e.changedTouches);
        return t & (Ee | Se) && (n = _(n.concat(i), "identifier", !0)), [ n, i ];
    }
    function q() {
        this.evTarget = Ke, this.targetIds = {}, w.apply(this, arguments);
    }
    function W(e, t) {
        var n = A(e.touches), i = this.targetIds;
        if (t & (we | ke) && 1 === n.length) return i[n[0].identifier] = !0, [ n, n ];
        var r, a, o = A(e.changedTouches), s = [], c = this.target;
        if (a = n.filter(function(e) {
            return m(e.target, c);
        }), t === we) for (r = 0; r < a.length; ) i[a[r].identifier] = !0, r++;
        for (r = 0; r < o.length; ) i[o[r].identifier] && s.push(o[r]), t & (Ee | Se) && delete i[o[r].identifier], 
        r++;
        return s.length ? [ _(a.concat(s), "identifier", !0), s ] : void 0;
    }
    function H() {
        w.apply(this, arguments);
        var e = l(this.handler, this);
        this.touch = new q(this.manager, e), this.mouse = new B(this.manager, e);
    }
    function V(e, t) {
        this.manager = e, this.set(t);
    }
    function G(e) {
        if (g(e, tt)) return tt;
        var t = g(e, nt), n = g(e, it);
        return t && n ? nt + " " + it : t || n ? t ? nt : it : g(e, et) ? et : Je;
    }
    function U(e) {
        e = s({}, e || {}), this.id = T(), this.manager = null, this.options = c(e, this.defaults), 
        this.options.enable = d(this.options.enable, !0), this.state = rt, this.simultaneous = {}, 
        this.requireFail = [];
    }
    function X(e) {
        return e & ut ? "cancel" : e & st ? "end" : e & ot ? "move" : e & at ? "start" : "";
    }
    function K(e) {
        return e == Oe ? "down" : e == De ? "up" : e == Ce ? "left" : e == Pe ? "right" : "";
    }
    function $(e, t) {
        var n = t.manager;
        return n ? n.get(e) : e;
    }
    function Q() {
        U.apply(this, arguments);
    }
    function Z() {
        Q.apply(this, arguments), this.pX = null, this.pY = null;
    }
    function J() {
        Q.apply(this, arguments);
    }
    function ee() {
        U.apply(this, arguments), this._timer = null, this._input = null;
    }
    function te() {
        Q.apply(this, arguments);
    }
    function ne() {
        Q.apply(this, arguments);
    }
    function ie() {
        U.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, 
        this._input = null, this.count = 0;
    }
    function re(e, t) {
        return t = t || {}, t.recognizers = d(t.recognizers, re.defaults.preset), new ae(e, t);
    }
    function ae(e, t) {
        t = t || {}, this.options = c(t, re.defaults), this.options.inputTarget = this.options.inputTarget || e, 
        this.handlers = {}, this.session = {}, this.recognizers = [], this.element = e, 
        this.input = k(this), this.touchAction = new V(this, this.options.touchAction), 
        oe(this, !0), o(t.recognizers, function(e) {
            var t = this.add(new e[0](e[1]));
            e[2] && t.recognizeWith(e[2]), e[3] && t.requireFailure(e[3]);
        }, this);
    }
    function oe(e, t) {
        var n = e.element;
        n.style && o(e.options.cssProps, function(e, i) {
            n.style[b(n.style, i)] = t ? e : "";
        });
    }
    function se(e, n) {
        var i = t.createEvent("Event");
        i.initEvent(e, !0, !0), i.gesture = n, n.target.dispatchEvent(i);
    }
    var ce = [ "", "webkit", "moz", "MS", "ms", "o" ], ue = t.createElement("div"), le = "function", fe = Math.round, de = Math.abs, he = Date.now, pe = 1, me = /mobile|tablet|ip(ad|hone|od)|android/i, ge = "ontouchstart" in e, ve = b(e, "PointerEvent") !== i, ye = ge && me.test(navigator.userAgent), Ae = "touch", _e = "pen", be = "mouse", Te = "kinect", xe = 25, we = 1, ke = 2, Ee = 4, Se = 8, Me = 1, Ce = 2, Pe = 4, De = 8, Oe = 16, Ne = Ce | Pe, ze = De | Oe, Le = Ne | ze, Ie = [ "x", "y" ], je = [ "clientX", "clientY" ];
    w.prototype = {
        handler: function() {},
        init: function() {
            this.evEl && h(this.element, this.evEl, this.domHandler), this.evTarget && h(this.target, this.evTarget, this.domHandler), 
            this.evWin && h(x(this.element), this.evWin, this.domHandler);
        },
        destroy: function() {
            this.evEl && p(this.element, this.evEl, this.domHandler), this.evTarget && p(this.target, this.evTarget, this.domHandler), 
            this.evWin && p(x(this.element), this.evWin, this.domHandler);
        }
    };
    var Be = {
        mousedown: we,
        mousemove: ke,
        mouseup: Ee
    }, Re = "mousedown", Fe = "mousemove mouseup";
    u(B, w, {
        handler: function(e) {
            var t = Be[e.type];
            t & we && 0 === e.button && (this.pressed = !0), t & ke && 1 !== e.which && (t = Ee), 
            this.pressed && this.allow && (t & Ee && (this.pressed = !1), this.callback(this.manager, t, {
                pointers: [ e ],
                changedPointers: [ e ],
                pointerType: be,
                srcEvent: e
            }));
        }
    });
    var Ye = {
        pointerdown: we,
        pointermove: ke,
        pointerup: Ee,
        pointercancel: Se,
        pointerout: Se
    }, qe = {
        2: Ae,
        3: _e,
        4: be,
        5: Te
    }, We = "pointerdown", He = "pointermove pointerup pointercancel";
    e.MSPointerEvent && (We = "MSPointerDown", He = "MSPointerMove MSPointerUp MSPointerCancel"), 
    u(R, w, {
        handler: function(e) {
            var t = this.store, n = !1, i = e.type.toLowerCase().replace("ms", ""), r = Ye[i], a = qe[e.pointerType] || e.pointerType, o = a == Ae, s = y(t, e.pointerId, "pointerId");
            r & we && (0 === e.button || o) ? s < 0 && (t.push(e), s = t.length - 1) : r & (Ee | Se) && (n = !0), 
            s < 0 || (t[s] = e, this.callback(this.manager, r, {
                pointers: t,
                changedPointers: [ e ],
                pointerType: a,
                srcEvent: e
            }), n && t.splice(s, 1));
        }
    });
    var Ve = {
        touchstart: we,
        touchmove: ke,
        touchend: Ee,
        touchcancel: Se
    }, Ge = "touchstart", Ue = "touchstart touchmove touchend touchcancel";
    u(F, w, {
        handler: function(e) {
            var t = Ve[e.type];
            if (t === we && (this.started = !0), this.started) {
                var n = Y.call(this, e, t);
                t & (Ee | Se) && n[0].length - n[1].length === 0 && (this.started = !1), this.callback(this.manager, t, {
                    pointers: n[0],
                    changedPointers: n[1],
                    pointerType: Ae,
                    srcEvent: e
                });
            }
        }
    });
    var Xe = {
        touchstart: we,
        touchmove: ke,
        touchend: Ee,
        touchcancel: Se
    }, Ke = "touchstart touchmove touchend touchcancel";
    u(q, w, {
        handler: function(e) {
            var t = Xe[e.type], n = W.call(this, e, t);
            n && this.callback(this.manager, t, {
                pointers: n[0],
                changedPointers: n[1],
                pointerType: Ae,
                srcEvent: e
            });
        }
    }), u(H, w, {
        handler: function(e, t, n) {
            var i = n.pointerType == Ae, r = n.pointerType == be;
            if (i) this.mouse.allow = !1; else if (r && !this.mouse.allow) return;
            t & (Ee | Se) && (this.mouse.allow = !0), this.callback(e, t, n);
        },
        destroy: function() {
            this.touch.destroy(), this.mouse.destroy();
        }
    });
    var $e = b(ue.style, "touchAction"), Qe = $e !== i, Ze = "compute", Je = "auto", et = "manipulation", tt = "none", nt = "pan-x", it = "pan-y";
    V.prototype = {
        set: function(e) {
            e == Ze && (e = this.compute()), Qe && this.manager.element.style && (this.manager.element.style[$e] = e), 
            this.actions = e.toLowerCase().trim();
        },
        update: function() {
            this.set(this.manager.options.touchAction);
        },
        compute: function() {
            var e = [];
            return o(this.manager.recognizers, function(t) {
                f(t.options.enable, [ t ]) && (e = e.concat(t.getTouchAction()));
            }), G(e.join(" "));
        },
        preventDefaults: function(e) {
            if (!Qe) {
                var t = e.srcEvent, n = e.offsetDirection;
                if (this.manager.session.prevented) return void t.preventDefault();
                var i = this.actions, r = g(i, tt), a = g(i, it), o = g(i, nt);
                if (r) {
                    var s = 1 === e.pointers.length, c = e.distance < 2, u = e.deltaTime < 250;
                    if (s && c && u) return;
                }
                return r || a && n & Ne || o && n & ze ? this.preventSrc(t) : void 0;
            }
        },
        preventSrc: function(e) {
            this.manager.session.prevented = !0, e.preventDefault();
        }
    };
    var rt = 1, at = 2, ot = 4, st = 8, ct = st, ut = 16, lt = 32;
    U.prototype = {
        defaults: {},
        set: function(e) {
            return s(this.options, e), this.manager && this.manager.touchAction.update(), this;
        },
        recognizeWith: function(e) {
            if (a(e, "recognizeWith", this)) return this;
            var t = this.simultaneous;
            return e = $(e, this), t[e.id] || (t[e.id] = e, e.recognizeWith(this)), this;
        },
        dropRecognizeWith: function(e) {
            return a(e, "dropRecognizeWith", this) ? this : (e = $(e, this), delete this.simultaneous[e.id], 
            this);
        },
        requireFailure: function(e) {
            if (a(e, "requireFailure", this)) return this;
            var t = this.requireFail;
            return e = $(e, this), y(t, e) === -1 && (t.push(e), e.requireFailure(this)), this;
        },
        dropRequireFailure: function(e) {
            if (a(e, "dropRequireFailure", this)) return this;
            e = $(e, this);
            var t = y(this.requireFail, e);
            return t > -1 && this.requireFail.splice(t, 1), this;
        },
        hasRequireFailures: function() {
            return this.requireFail.length > 0;
        },
        canRecognizeWith: function(e) {
            return !!this.simultaneous[e.id];
        },
        emit: function(e) {
            function t(t) {
                n.manager.emit(t, e);
            }
            var n = this, i = this.state;
            i < st && t(n.options.event + X(i)), t(n.options.event), e.additionalEvent && t(e.additionalEvent), 
            i >= st && t(n.options.event + X(i));
        },
        tryEmit: function(e) {
            return this.canEmit() ? this.emit(e) : void (this.state = lt);
        },
        canEmit: function() {
            for (var e = 0; e < this.requireFail.length; ) {
                if (!(this.requireFail[e].state & (lt | rt))) return !1;
                e++;
            }
            return !0;
        },
        recognize: function(e) {
            var t = s({}, e);
            return f(this.options.enable, [ this, t ]) ? (this.state & (ct | ut | lt) && (this.state = rt), 
            this.state = this.process(t), void (this.state & (at | ot | st | ut) && this.tryEmit(t))) : (this.reset(), 
            void (this.state = lt));
        },
        process: function(e) {},
        getTouchAction: function() {},
        reset: function() {}
    }, u(Q, U, {
        defaults: {
            pointers: 1
        },
        attrTest: function(e) {
            var t = this.options.pointers;
            return 0 === t || e.pointers.length === t;
        },
        process: function(e) {
            var t = this.state, n = e.eventType, i = t & (at | ot), r = this.attrTest(e);
            return i && (n & Se || !r) ? t | ut : i || r ? n & Ee ? t | st : t & at ? t | ot : at : lt;
        }
    }), u(Z, Q, {
        defaults: {
            event: "pan",
            threshold: 10,
            pointers: 1,
            direction: Le
        },
        getTouchAction: function() {
            var e = this.options.direction, t = [];
            return e & Ne && t.push(nt), e & ze && t.push(it), t;
        },
        directionTest: function(e) {
            var t = this.options, n = !0, i = e.distance, r = e.direction, a = e.deltaX, o = e.deltaY;
            return r & t.direction || (t.direction & Ne ? (r = 0 === a ? Me : a < 0 ? Ce : Pe, 
            n = a != this.pX, i = Math.abs(e.deltaX)) : (r = 0 === o ? Me : o < 0 ? De : Oe, 
            n = o != this.pY, i = Math.abs(e.deltaY))), e.direction = r, n && i > t.threshold && r & t.direction;
        },
        attrTest: function(e) {
            return Q.prototype.attrTest.call(this, e) && (this.state & at || !(this.state & at) && this.directionTest(e));
        },
        emit: function(e) {
            this.pX = e.deltaX, this.pY = e.deltaY;
            var t = K(e.direction);
            t && (e.additionalEvent = this.options.event + t), this._super.emit.call(this, e);
        }
    }), u(J, Q, {
        defaults: {
            event: "pinch",
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [ tt ];
        },
        attrTest: function(e) {
            return this._super.attrTest.call(this, e) && (Math.abs(e.scale - 1) > this.options.threshold || this.state & at);
        },
        emit: function(e) {
            if (1 !== e.scale) {
                var t = e.scale < 1 ? "in" : "out";
                e.additionalEvent = this.options.event + t;
            }
            this._super.emit.call(this, e);
        }
    }), u(ee, U, {
        defaults: {
            event: "press",
            pointers: 1,
            time: 500,
            threshold: 5
        },
        getTouchAction: function() {
            return [ Je ];
        },
        process: function(e) {
            var t = this.options, n = e.pointers.length === t.pointers, i = e.distance < t.threshold, a = e.deltaTime > t.time;
            if (this._input = e, !i || !n || e.eventType & (Ee | Se) && !a) this.reset(); else if (e.eventType & we) this.reset(), 
            this._timer = r(function() {
                this.state = ct, this.tryEmit();
            }, t.time, this); else if (e.eventType & Ee) return ct;
            return lt;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function(e) {
            this.state === ct && (e && e.eventType & Ee ? this.manager.emit(this.options.event + "up", e) : (this._input.timeStamp = he(), 
            this.manager.emit(this.options.event, this._input)));
        }
    }), u(te, Q, {
        defaults: {
            event: "rotate",
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [ tt ];
        },
        attrTest: function(e) {
            return this._super.attrTest.call(this, e) && (Math.abs(e.rotation) > this.options.threshold || this.state & at);
        }
    }), u(ne, Q, {
        defaults: {
            event: "swipe",
            threshold: 10,
            velocity: .65,
            direction: Ne | ze,
            pointers: 1
        },
        getTouchAction: function() {
            return Z.prototype.getTouchAction.call(this);
        },
        attrTest: function(e) {
            var t, n = this.options.direction;
            return n & (Ne | ze) ? t = e.overallVelocity : n & Ne ? t = e.overallVelocityX : n & ze && (t = e.overallVelocityY), 
            this._super.attrTest.call(this, e) && n & e.offsetDirection && e.distance > this.options.threshold && e.maxPointers == this.options.pointers && de(t) > this.options.velocity && e.eventType & Ee;
        },
        emit: function(e) {
            var t = K(e.offsetDirection);
            t && this.manager.emit(this.options.event + t, e), this.manager.emit(this.options.event, e);
        }
    }), u(ie, U, {
        defaults: {
            event: "tap",
            pointers: 1,
            taps: 1,
            interval: 300,
            time: 250,
            threshold: 2,
            posThreshold: 10
        },
        getTouchAction: function() {
            return [ et ];
        },
        process: function(e) {
            var t = this.options, n = e.pointers.length === t.pointers, i = e.distance < t.threshold, a = e.deltaTime < t.time;
            if (this.reset(), e.eventType & we && 0 === this.count) return this.failTimeout();
            if (i && a && n) {
                if (e.eventType != Ee) return this.failTimeout();
                var o = !this.pTime || e.timeStamp - this.pTime < t.interval, s = !this.pCenter || z(this.pCenter, e.center) < t.posThreshold;
                this.pTime = e.timeStamp, this.pCenter = e.center, s && o ? this.count += 1 : this.count = 1, 
                this._input = e;
                var c = this.count % t.taps;
                if (0 === c) return this.hasRequireFailures() ? (this._timer = r(function() {
                    this.state = ct, this.tryEmit();
                }, t.interval, this), at) : ct;
            }
            return lt;
        },
        failTimeout: function() {
            return this._timer = r(function() {
                this.state = lt;
            }, this.options.interval, this), lt;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function() {
            this.state == ct && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
        }
    }), re.VERSION = "2.0.4", re.defaults = {
        domEvents: !1,
        touchAction: Ze,
        enable: !0,
        inputTarget: null,
        inputClass: null,
        preset: [ [ te, {
            enable: !1
        } ], [ J, {
            enable: !1
        }, [ "rotate" ] ], [ ne, {
            direction: Ne
        } ], [ Z, {
            direction: Ne
        }, [ "swipe" ] ], [ ie ], [ ie, {
            event: "doubletap",
            taps: 2
        }, [ "tap" ] ], [ ee ] ],
        cssProps: {
            userSelect: "none",
            touchSelect: "none",
            touchCallout: "none",
            contentZooming: "none",
            userDrag: "none",
            tapHighlightColor: "rgba(0,0,0,0)"
        }
    };
    var ft = 1, dt = 2;
    ae.prototype = {
        set: function(e) {
            return s(this.options, e), e.touchAction && this.touchAction.update(), e.inputTarget && (this.input.destroy(), 
            this.input.target = e.inputTarget, this.input.init()), this;
        },
        stop: function(e) {
            this.session.stopped = e ? dt : ft;
        },
        recognize: function(e) {
            var t = this.session;
            if (!t.stopped) {
                this.touchAction.preventDefaults(e);
                var n, i = this.recognizers, r = t.curRecognizer;
                (!r || r && r.state & ct) && (r = t.curRecognizer = null);
                for (var a = 0; a < i.length; ) n = i[a], t.stopped === dt || r && n != r && !n.canRecognizeWith(r) ? n.reset() : n.recognize(e), 
                !r && n.state & (at | ot | st) && (r = t.curRecognizer = n), a++;
            }
        },
        get: function(e) {
            if (e instanceof U) return e;
            for (var t = this.recognizers, n = 0; n < t.length; n++) if (t[n].options.event == e) return t[n];
            return null;
        },
        add: function(e) {
            if (a(e, "add", this)) return this;
            var t = this.get(e.options.event);
            return t && this.remove(t), this.recognizers.push(e), e.manager = this, this.touchAction.update(), 
            e;
        },
        remove: function(e) {
            if (a(e, "remove", this)) return this;
            var t = this.recognizers;
            return e = this.get(e), t.splice(y(t, e), 1), this.touchAction.update(), this;
        },
        on: function(e, t) {
            var n = this.handlers;
            return o(v(e), function(e) {
                n[e] = n[e] || [], n[e].push(t);
            }), this;
        },
        off: function(e, t) {
            var n = this.handlers;
            return o(v(e), function(e) {
                t ? n[e].splice(y(n[e], t), 1) : delete n[e];
            }), this;
        },
        emit: function(e, t) {
            this.options.domEvents && se(e, t);
            var n = this.handlers[e] && this.handlers[e].slice();
            if (n && n.length) {
                t.type = e, t.preventDefault = function() {
                    t.srcEvent.preventDefault();
                };
                for (var i = 0; i < n.length; ) n[i](t), i++;
            }
        },
        destroy: function() {
            this.element && oe(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), 
            this.element = null;
        }
    }, s(re, {
        INPUT_START: we,
        INPUT_MOVE: ke,
        INPUT_END: Ee,
        INPUT_CANCEL: Se,
        STATE_POSSIBLE: rt,
        STATE_BEGAN: at,
        STATE_CHANGED: ot,
        STATE_ENDED: st,
        STATE_RECOGNIZED: ct,
        STATE_CANCELLED: ut,
        STATE_FAILED: lt,
        DIRECTION_NONE: Me,
        DIRECTION_LEFT: Ce,
        DIRECTION_RIGHT: Pe,
        DIRECTION_UP: De,
        DIRECTION_DOWN: Oe,
        DIRECTION_HORIZONTAL: Ne,
        DIRECTION_VERTICAL: ze,
        DIRECTION_ALL: Le,
        Manager: ae,
        Input: w,
        TouchAction: V,
        TouchInput: q,
        MouseInput: B,
        PointerEventInput: R,
        TouchMouseInput: H,
        SingleTouchInput: F,
        Recognizer: U,
        AttrRecognizer: Q,
        Tap: ie,
        Pan: Z,
        Swipe: ne,
        Pinch: J,
        Rotate: te,
        Press: ee,
        on: h,
        off: p,
        each: o,
        merge: c,
        extend: s,
        inherit: u,
        bindFn: l,
        prefixed: b
    }), typeof define == le && define.amd ? define(function() {
        return re;
    }) : "undefined" != typeof module && module.exports ? module.exports = re : e[n] = re;
}(window, document, "Hammer");

var Class = function() {
    var e = {};
    return {
        extend: function(t, n) {
            1 == arguments.length && (n = t, t = null);
            var i = function() {
                arguments[0] != e && this.initialize.apply(this, arguments);
            };
            "function" == typeof t && (i.prototype = new t(e));
            var r = [];
            n && n.include && (n.include.reverse ? r = r.concat(n.include.reverse()) : r.push(n.include), 
            delete n.include), n && Class.inherit(i.prototype, n);
            for (var a = 0; mixin = r[a]; a++) Class.mixin(i.prototype, mixin);
            return i;
        },
        mixin: function(e, t, n) {
            if (n = n || !1, "undefined" != typeof t && null !== t) for (var i in t) (n || !e[i] && "function" == typeof t[i]) && (e[i] = t[i]);
            return e;
        },
        inherit: function(e, t, n) {
            if (3 == arguments.length) {
                var i = e[n], r = t[n], a = r;
                r = function() {
                    var e = this.parent;
                    this.parent = i;
                    var t = a.apply(this, arguments);
                    return e ? this.parent = e : delete this.parent, t;
                }, r.valueOf = function() {
                    return a;
                }, r.toString = function() {
                    return a.toString();
                }, e[n] = r;
            } else for (var o in t) e[o] && "function" == typeof t[o] ? Class.inherit(e, t, o) : e[o] = t[o];
            return e;
        },
        singleton: function() {
            var t = arguments;
            if (2 == t.length && t[0].getInstance) {
                var n = t[0].getInstance(e);
                n && (t[0] = n);
            }
            return function(t) {
                var n = !1, i = Class.extend.apply(t.callee, t);
                return {
                    getInstance: function() {
                        return arguments[0] == e ? i : n ? n : n = new i();
                    }
                };
            }(t);
        }
    };
}();

Class.create = function() {
    return Class.extend.apply(this, arguments);
}, function() {
    var e, t;
    e = function() {
        function e(e, t) {
            var n, i;
            if (this.options = {
                target: "instafeed",
                get: "popular",
                resolution: "thumbnail",
                sortBy: "none",
                links: !0,
                mock: !1,
                useHttp: !1
            }, "object" == typeof e) for (n in e) i = e[n], this.options[n] = i;
            this.context = null != t ? t : this, this.unique = this._genKey();
        }
        return e.prototype.hasNext = function() {
            return "string" == typeof this.context.nextUrl && this.context.nextUrl.length > 0;
        }, e.prototype.next = function() {
            return !!this.hasNext() && this.run(this.context.nextUrl);
        }, e.prototype.run = function(t) {
            var n, i, r;
            if ("string" != typeof this.options.clientId && "string" != typeof this.options.accessToken) throw new Error("Missing clientId or accessToken.");
            if ("string" != typeof this.options.accessToken && "string" != typeof this.options.clientId) throw new Error("Missing clientId or accessToken.");
            return null != this.options.before && "function" == typeof this.options.before && this.options.before.call(this), 
            "undefined" != typeof document && null !== document && (r = document.createElement("script"), 
            r.id = "instafeed-fetcher", r.src = t || this._buildUrl(), n = document.getElementsByTagName("head"), 
            n[0].appendChild(r), i = "instafeedCache" + this.unique, window[i] = new e(this.options, this), 
            window[i].unique = this.unique), !0;
        }, e.prototype.parse = function(e) {
            var t, n, i, r, a, o, s, c, u, l, f, d, h, p, m, g, v, y, A, _, b, T;
            if ("object" != typeof e) {
                if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, "Invalid JSON data"), 
                !1;
                throw new Error("Invalid JSON response");
            }
            if (200 !== e.meta.code) {
                if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, e.meta.error_message), 
                !1;
                throw new Error("Error from Instagram: " + e.meta.error_message);
            }
            if (0 === e.data.length) {
                if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, "No images were returned from Instagram"), 
                !1;
                throw new Error("No images were returned from Instagram");
            }
            if (null != this.options.success && "function" == typeof this.options.success && this.options.success.call(this, e), 
            this.context.nextUrl = "", null != e.pagination && (this.context.nextUrl = e.pagination.next_url), 
            "none" !== this.options.sortBy) switch (p = "random" === this.options.sortBy ? [ "", "random" ] : this.options.sortBy.split("-"), 
            h = "least" === p[0], p[1]) {
              case "random":
                e.data.sort(function() {
                    return .5 - Math.random();
                });
                break;

              case "recent":
                e.data = this._sortBy(e.data, "created_time", h);
                break;

              case "liked":
                e.data = this._sortBy(e.data, "likes.count", h);
                break;

              case "commented":
                e.data = this._sortBy(e.data, "comments.count", h);
                break;

              default:
                throw new Error("Invalid option for sortBy: '" + this.options.sortBy + "'.");
            }
            if ("undefined" != typeof document && null !== document && this.options.mock === !1) {
                if (c = e.data, null != this.options.limit && c.length > this.options.limit && (c = c.slice(0, this.options.limit + 1 || 9e9)), 
                n = document.createDocumentFragment(), null != this.options.filter && "function" == typeof this.options.filter && (c = this._filter(c, this.options.filter)), 
                null != this.options.template && "string" == typeof this.options.template) {
                    for (r = "", o = "", l = "", m = document.createElement("div"), g = 0, A = c.length; g < A; g++) a = c[g], 
                    s = a.images[this.options.resolution].url, this.options.useHttp || (s = s.replace("http://", "//")), 
                    o = this._makeTemplate(this.options.template, {
                        model: a,
                        id: a.id,
                        link: a.link,
                        image: s,
                        caption: this._getObjectProperty(a, "caption.text"),
                        likes: a.likes.count,
                        comments: a.comments.count,
                        location: this._getObjectProperty(a, "location.name")
                    }), r += o;
                    for (m.innerHTML = r, T = [].slice.call(m.childNodes), v = 0, _ = T.length; v < _; v++) d = T[v], 
                    n.appendChild(d);
                } else for (y = 0, b = c.length; y < b; y++) a = c[y], u = document.createElement("img"), 
                s = a.images[this.options.resolution].url, this.options.useHttp || (s = s.replace("http://", "//")), 
                u.src = s, this.options.links === !0 ? (t = document.createElement("a"), t.href = a.link, 
                t.appendChild(u), n.appendChild(t)) : n.appendChild(u);
                document.getElementById(this.options.target).appendChild(n), i = document.getElementsByTagName("head")[0], 
                i.removeChild(document.getElementById("instafeed-fetcher")), f = "instafeedCache" + this.unique, 
                window[f] = void 0;
                try {
                    delete window[f];
                } catch (x) {}
            }
            return null != this.options.after && "function" == typeof this.options.after && this.options.after.call(this), 
            !0;
        }, e.prototype._buildUrl = function() {
            var e, t, n;
            switch (e = "https://api.instagram.com/v1", this.options.get) {
              case "popular":
                t = "media/popular";
                break;

              case "tagged":
                if ("string" != typeof this.options.tagName) throw new Error("No tag name specified. Use the 'tagName' option.");
                t = "tags/" + this.options.tagName + "/media/recent";
                break;

              case "location":
                if ("number" != typeof this.options.locationId) throw new Error("No location specified. Use the 'locationId' option.");
                t = "locations/" + this.options.locationId + "/media/recent";
                break;

              case "user":
                if ("number" != typeof this.options.userId) throw new Error("No user specified. Use the 'userId' option.");
                if ("string" != typeof this.options.accessToken) throw new Error("No access token. Use the 'accessToken' option.");
                t = "users/" + this.options.userId + "/media/recent";
                break;

              default:
                throw new Error("Invalid option for get: '" + this.options.get + "'.");
            }
            return n = "" + e + "/" + t, n += null != this.options.accessToken ? "?access_token=" + this.options.accessToken : "?client_id=" + this.options.clientId, 
            null != this.options.limit && (n += "&count=" + this.options.limit), n += "&callback=instafeedCache" + this.unique + ".parse";
        }, e.prototype._genKey = function() {
            var e;
            return e = function() {
                return (65536 * (1 + Math.random()) | 0).toString(16).substring(1);
            }, "" + e() + e() + e() + e();
        }, e.prototype._makeTemplate = function(e, t) {
            var n, i, r, a, o;
            for (i = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/, n = e; i.test(n); ) r = n.match(i)[1], 
            a = null != (o = this._getObjectProperty(t, r)) ? o : "", n = n.replace(i, "" + a);
            return n;
        }, e.prototype._getObjectProperty = function(e, t) {
            var n, i;
            for (t = t.replace(/\[(\w+)\]/g, ".$1"), i = t.split("."); i.length; ) {
                if (n = i.shift(), !(null != e && n in e)) return null;
                e = e[n];
            }
            return e;
        }, e.prototype._sortBy = function(e, t, n) {
            var i;
            return i = function(e, i) {
                var r, a;
                return r = this._getObjectProperty(e, t), a = this._getObjectProperty(i, t), n ? r > a ? 1 : -1 : r < a ? 1 : -1;
            }, e.sort(i.bind(this)), e;
        }, e.prototype._filter = function(e, t) {
            var n, i, r, a, o;
            for (n = [], r = function(e) {
                if (t(e)) return n.push(e);
            }, a = 0, o = e.length; a < o; a++) i = e[a], r(i);
            return n;
        }, e;
    }(), t = "undefined" != typeof exports && null !== exports ? exports : window, t.Instafeed = e;
}.call(this), window.Modernizr = function(e, t, n) {
    function i(e) {
        A.cssText = e;
    }
    function r(e, t) {
        return i(x.join(e + ";") + (t || ""));
    }
    function a(e, t) {
        return typeof e === t;
    }
    function o(e, t) {
        return !!~("" + e).indexOf(t);
    }
    function s(e, t) {
        for (var i in e) {
            var r = e[i];
            if (!o(r, "-") && A[r] !== n) return "pfx" != t || r;
        }
        return !1;
    }
    function c(e, t, i) {
        for (var r in e) {
            var o = t[e[r]];
            if (o !== n) return i === !1 ? e[r] : a(o, "function") ? o.bind(i || t) : o;
        }
        return !1;
    }
    function u(e, t, n) {
        var i = e.charAt(0).toUpperCase() + e.slice(1), r = (e + " " + k.join(i + " ") + i).split(" ");
        return a(t, "string") || a(t, "undefined") ? s(r, t) : (r = (e + " " + E.join(i + " ") + i).split(" "), 
        c(r, t, n));
    }
    function l() {
        p.input = function(n) {
            for (var i = 0, r = n.length; i < r; i++) P[n[i]] = n[i] in _;
            return P.list && (P.list = !!t.createElement("datalist") && !!e.HTMLDataListElement), 
            P;
        }("autocomplete autofocus list placeholder max min multiple pattern required step".split(" ")), 
        p.inputtypes = function(e) {
            for (var i, r, a, o = 0, s = e.length; o < s; o++) _.setAttribute("type", r = e[o]), 
            i = "text" !== _.type, i && (_.value = b, _.style.cssText = "position:absolute;visibility:hidden;", 
            /^range$/.test(r) && _.style.WebkitAppearance !== n ? (g.appendChild(_), a = t.defaultView, 
            i = a.getComputedStyle && "textfield" !== a.getComputedStyle(_, null).WebkitAppearance && 0 !== _.offsetHeight, 
            g.removeChild(_)) : /^(search|tel)$/.test(r) || (i = /^(url|email)$/.test(r) ? _.checkValidity && _.checkValidity() === !1 : _.value != b)), 
            C[e[o]] = !!i;
            return C;
        }("search tel url email datetime date month week time datetime-local number range color".split(" "));
    }
    var f, d, h = "2.8.3", p = {}, m = !0, g = t.documentElement, v = "modernizr", y = t.createElement(v), A = y.style, _ = t.createElement("input"), b = ":)", T = {}.toString, x = " -webkit- -moz- -o- -ms- ".split(" "), w = "Webkit Moz O ms", k = w.split(" "), E = w.toLowerCase().split(" "), S = {
        svg: "http://www.w3.org/2000/svg"
    }, M = {}, C = {}, P = {}, D = [], O = D.slice, N = function(e, n, i, r) {
        var a, o, s, c, u = t.createElement("div"), l = t.body, f = l || t.createElement("body");
        if (parseInt(i, 10)) for (;i--; ) s = t.createElement("div"), s.id = r ? r[i] : v + (i + 1), 
        u.appendChild(s);
        return a = [ "&#173;", '<style id="s', v, '">', e, "</style>" ].join(""), u.id = v, 
        (l ? u : f).innerHTML += a, f.appendChild(u), l || (f.style.background = "", f.style.overflow = "hidden", 
        c = g.style.overflow, g.style.overflow = "hidden", g.appendChild(f)), o = n(u, e), 
        l ? u.parentNode.removeChild(u) : (f.parentNode.removeChild(f), g.style.overflow = c), 
        !!o;
    }, z = function(t) {
        var n = e.matchMedia || e.msMatchMedia;
        if (n) return n(t) && n(t).matches || !1;
        var i;
        return N("@media " + t + " { #" + v + " { position: absolute; } }", function(t) {
            i = "absolute" == (e.getComputedStyle ? getComputedStyle(t, null) : t.currentStyle).position;
        }), i;
    }, L = function() {
        function e(e, r) {
            r = r || t.createElement(i[e] || "div"), e = "on" + e;
            var o = e in r;
            return o || (r.setAttribute || (r = t.createElement("div")), r.setAttribute && r.removeAttribute && (r.setAttribute(e, ""), 
            o = a(r[e], "function"), a(r[e], "undefined") || (r[e] = n), r.removeAttribute(e))), 
            r = null, o;
        }
        var i = {
            select: "input",
            change: "input",
            submit: "form",
            reset: "form",
            error: "img",
            load: "img",
            abort: "img"
        };
        return e;
    }(), I = {}.hasOwnProperty;
    d = a(I, "undefined") || a(I.call, "undefined") ? function(e, t) {
        return t in e && a(e.constructor.prototype[t], "undefined");
    } : function(e, t) {
        return I.call(e, t);
    }, Function.prototype.bind || (Function.prototype.bind = function(e) {
        var t = this;
        if ("function" != typeof t) throw new TypeError();
        var n = O.call(arguments, 1), i = function() {
            if (this instanceof i) {
                var r = function() {};
                r.prototype = t.prototype;
                var a = new r(), o = t.apply(a, n.concat(O.call(arguments)));
                return Object(o) === o ? o : a;
            }
            return t.apply(e, n.concat(O.call(arguments)));
        };
        return i;
    }), M.flexbox = function() {
        return u("flexWrap");
    }, M.canvas = function() {
        var e = t.createElement("canvas");
        return !!e.getContext && !!e.getContext("2d");
    }, M.canvastext = function() {
        return !!p.canvas && !!a(t.createElement("canvas").getContext("2d").fillText, "function");
    }, M.webgl = function() {
        return !!e.WebGLRenderingContext;
    }, M.touch = function() {
        var n;
        return "ontouchstart" in e || e.DocumentTouch && t instanceof DocumentTouch ? n = !0 : N([ "@media (", x.join("touch-enabled),("), v, ")", "{#modernizr{top:9px;position:absolute}}" ].join(""), function(e) {
            n = 9 === e.offsetTop;
        }), n;
    }, M.geolocation = function() {
        return "geolocation" in navigator;
    }, M.postmessage = function() {
        return !!e.postMessage;
    }, M.websqldatabase = function() {
        return !!e.openDatabase;
    }, M.indexedDB = function() {
        return !!u("indexedDB", e);
    }, M.hashchange = function() {
        return L("hashchange", e) && (t.documentMode === n || t.documentMode > 7);
    }, M.history = function() {
        return !!e.history && !!history.pushState;
    }, M.draganddrop = function() {
        var e = t.createElement("div");
        return "draggable" in e || "ondragstart" in e && "ondrop" in e;
    }, M.websockets = function() {
        return "WebSocket" in e || "MozWebSocket" in e;
    }, M.rgba = function() {
        return i("background-color:rgba(150,255,150,.5)"), o(A.backgroundColor, "rgba");
    }, M.hsla = function() {
        return i("background-color:hsla(120,40%,100%,.5)"), o(A.backgroundColor, "rgba") || o(A.backgroundColor, "hsla");
    }, M.multiplebgs = function() {
        return i("background:url(https://),url(https://),red url(https://)"), /(url\s*\(.*?){3}/.test(A.background);
    }, M.backgroundsize = function() {
        return u("backgroundSize");
    }, M.borderimage = function() {
        return u("borderImage");
    }, M.borderradius = function() {
        return u("borderRadius");
    }, M.boxshadow = function() {
        return u("boxShadow");
    }, M.textshadow = function() {
        return "" === t.createElement("div").style.textShadow;
    }, M.opacity = function() {
        return r("opacity:.55"), /^0.55$/.test(A.opacity);
    }, M.cssanimations = function() {
        return u("animationName");
    }, M.csscolumns = function() {
        return u("columnCount");
    }, M.cssgradients = function() {
        var e = "background-image:", t = "gradient(linear,left top,right bottom,from(#9f9),to(white));", n = "linear-gradient(left top,#9f9, white);";
        return i((e + "-webkit- ".split(" ").join(t + e) + x.join(n + e)).slice(0, -e.length)), 
        o(A.backgroundImage, "gradient");
    }, M.cssreflections = function() {
        return u("boxReflect");
    }, M.csstransforms = function() {
        return !!u("transform");
    }, M.csstransforms3d = function() {
        var e = !!u("perspective");
        return e && "webkitPerspective" in g.style && N("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}", function(t, n) {
            e = 9 === t.offsetLeft && 3 === t.offsetHeight;
        }), e;
    }, M.csstransitions = function() {
        return u("transition");
    }, M.fontface = function() {
        var e;
        return N('@font-face {font-family:"font";src:url("https://")}', function(n, i) {
            var r = t.getElementById("smodernizr"), a = r.sheet || r.styleSheet, o = a ? a.cssRules && a.cssRules[0] ? a.cssRules[0].cssText : a.cssText || "" : "";
            e = /src/i.test(o) && 0 === o.indexOf(i.split(" ")[0]);
        }), e;
    }, M.generatedcontent = function() {
        var e;
        return N([ "#", v, "{font:0/0 a}#", v, ':after{content:"', b, '";visibility:hidden;font:3px/1 a}' ].join(""), function(t) {
            e = t.offsetHeight >= 3;
        }), e;
    }, M.video = function() {
        var e = t.createElement("video"), n = !1;
        try {
            (n = !!e.canPlayType) && (n = new Boolean(n), n.ogg = e.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, ""), 
            n.h264 = e.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, ""), n.webm = e.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, ""));
        } catch (i) {}
        return n;
    }, M.audio = function() {
        var e = t.createElement("audio"), n = !1;
        try {
            (n = !!e.canPlayType) && (n = new Boolean(n), n.ogg = e.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""), 
            n.mp3 = e.canPlayType("audio/mpeg;").replace(/^no$/, ""), n.wav = e.canPlayType('audio/wav; codecs="1"').replace(/^no$/, ""), 
            n.m4a = (e.canPlayType("audio/x-m4a;") || e.canPlayType("audio/aac;")).replace(/^no$/, ""));
        } catch (i) {}
        return n;
    }, M.localstorage = function() {
        try {
            return localStorage.setItem(v, v), localStorage.removeItem(v), !0;
        } catch (e) {
            return !1;
        }
    }, M.sessionstorage = function() {
        try {
            return sessionStorage.setItem(v, v), sessionStorage.removeItem(v), !0;
        } catch (e) {
            return !1;
        }
    }, M.webworkers = function() {
        return !!e.Worker;
    }, M.applicationcache = function() {
        return !!e.applicationCache;
    }, M.svg = function() {
        return !!t.createElementNS && !!t.createElementNS(S.svg, "svg").createSVGRect;
    }, M.inlinesvg = function() {
        var e = t.createElement("div");
        return e.innerHTML = "<svg/>", (e.firstChild && e.firstChild.namespaceURI) == S.svg;
    }, M.smil = function() {
        return !!t.createElementNS && /SVGAnimate/.test(T.call(t.createElementNS(S.svg, "animate")));
    }, M.svgclippaths = function() {
        return !!t.createElementNS && /SVGClipPath/.test(T.call(t.createElementNS(S.svg, "clipPath")));
    };
    for (var j in M) d(M, j) && (f = j.toLowerCase(), p[f] = M[j](), D.push((p[f] ? "" : "no-") + f));
    return p.input || l(), p.addTest = function(e, t) {
        if ("object" == typeof e) for (var i in e) d(e, i) && p.addTest(i, e[i]); else {
            if (e = e.toLowerCase(), p[e] !== n) return p;
            t = "function" == typeof t ? t() : t, "undefined" != typeof m && m && (g.className += " " + (t ? "" : "no-") + e), 
            p[e] = t;
        }
        return p;
    }, i(""), y = _ = null, function(e, t) {
        function n(e, t) {
            var n = e.createElement("p"), i = e.getElementsByTagName("head")[0] || e.documentElement;
            return n.innerHTML = "x<style>" + t + "</style>", i.insertBefore(n.lastChild, i.firstChild);
        }
        function i() {
            var e = y.elements;
            return "string" == typeof e ? e.split(" ") : e;
        }
        function r(e) {
            var t = v[e[m]];
            return t || (t = {}, g++, e[m] = g, v[g] = t), t;
        }
        function a(e, n, i) {
            if (n || (n = t), l) return n.createElement(e);
            i || (i = r(n));
            var a;
            return a = i.cache[e] ? i.cache[e].cloneNode() : p.test(e) ? (i.cache[e] = i.createElem(e)).cloneNode() : i.createElem(e), 
            !a.canHaveChildren || h.test(e) || a.tagUrn ? a : i.frag.appendChild(a);
        }
        function o(e, n) {
            if (e || (e = t), l) return e.createDocumentFragment();
            n = n || r(e);
            for (var a = n.frag.cloneNode(), o = 0, s = i(), c = s.length; o < c; o++) a.createElement(s[o]);
            return a;
        }
        function s(e, t) {
            t.cache || (t.cache = {}, t.createElem = e.createElement, t.createFrag = e.createDocumentFragment, 
            t.frag = t.createFrag()), e.createElement = function(n) {
                return y.shivMethods ? a(n, e, t) : t.createElem(n);
            }, e.createDocumentFragment = Function("h,f", "return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&(" + i().join().replace(/[\w\-]+/g, function(e) {
                return t.createElem(e), t.frag.createElement(e), 'c("' + e + '")';
            }) + ");return n}")(y, t.frag);
        }
        function c(e) {
            e || (e = t);
            var i = r(e);
            return y.shivCSS && !u && !i.hasCSS && (i.hasCSS = !!n(e, "article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")), 
            l || s(e, i), e;
        }
        var u, l, f = "3.7.0", d = e.html5 || {}, h = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i, p = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i, m = "_html5shiv", g = 0, v = {};
        !function() {
            try {
                var e = t.createElement("a");
                e.innerHTML = "<xyz></xyz>", u = "hidden" in e, l = 1 == e.childNodes.length || function() {
                    t.createElement("a");
                    var e = t.createDocumentFragment();
                    return "undefined" == typeof e.cloneNode || "undefined" == typeof e.createDocumentFragment || "undefined" == typeof e.createElement;
                }();
            } catch (n) {
                u = !0, l = !0;
            }
        }();
        var y = {
            elements: d.elements || "abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output progress section summary template time video",
            version: f,
            shivCSS: d.shivCSS !== !1,
            supportsUnknownElements: l,
            shivMethods: d.shivMethods !== !1,
            type: "default",
            shivDocument: c,
            createElement: a,
            createDocumentFragment: o
        };
        e.html5 = y, c(t);
    }(this, t), p._version = h, p._prefixes = x, p._domPrefixes = E, p._cssomPrefixes = k, 
    p.mq = z, p.hasEvent = L, p.testProp = function(e) {
        return s([ e ]);
    }, p.testAllProps = u, p.testStyles = N, p.prefixed = function(e, t, n) {
        return t ? u(e, t, n) : u(e, "pfx");
    }, g.className = g.className.replace(/(^|\s)no-js(\s|$)/, "$1$2") + (m ? " js " + D.join(" ") : ""), 
    p;
}(this, this.document), function(e, t, n) {
    function i(e) {
        return "[object Function]" == g.call(e);
    }
    function r(e) {
        return "string" == typeof e;
    }
    function a() {}
    function o(e) {
        return !e || "loaded" == e || "complete" == e || "uninitialized" == e;
    }
    function s() {
        var e = v.shift();
        y = 1, e ? e.t ? p(function() {
            ("c" == e.t ? d.injectCss : d.injectJs)(e.s, 0, e.a, e.x, e.e, 1);
        }, 0) : (e(), s()) : y = 0;
    }
    function c(e, n, i, r, a, c, u) {
        function l(t) {
            if (!h && o(f.readyState) && (A.r = h = 1, !y && s(), f.onload = f.onreadystatechange = null, 
            t)) {
                "img" != e && p(function() {
                    b.removeChild(f);
                }, 50);
                for (var i in E[n]) E[n].hasOwnProperty(i) && E[n][i].onload();
            }
        }
        var u = u || d.errorTimeout, f = t.createElement(e), h = 0, g = 0, A = {
            t: i,
            s: n,
            e: a,
            a: c,
            x: u
        };
        1 === E[n] && (g = 1, E[n] = []), "object" == e ? f.data = n : (f.src = n, f.type = e), 
        f.width = f.height = "0", f.onerror = f.onload = f.onreadystatechange = function() {
            l.call(this, g);
        }, v.splice(r, 0, A), "img" != e && (g || 2 === E[n] ? (b.insertBefore(f, _ ? null : m), 
        p(l, u)) : E[n].push(f));
    }
    function u(e, t, n, i, a) {
        return y = 0, t = t || "j", r(e) ? c("c" == t ? x : T, e, t, this.i++, n, i, a) : (v.splice(this.i++, 0, e), 
        1 == v.length && s()), this;
    }
    function l() {
        var e = d;
        return e.loader = {
            load: u,
            i: 0
        }, e;
    }
    var f, d, h = t.documentElement, p = e.setTimeout, m = t.getElementsByTagName("script")[0], g = {}.toString, v = [], y = 0, A = "MozAppearance" in h.style, _ = A && !!t.createRange().compareNode, b = _ ? h : m.parentNode, h = e.opera && "[object Opera]" == g.call(e.opera), h = !!t.attachEvent && !h, T = A ? "object" : h ? "script" : "img", x = h ? "script" : T, w = Array.isArray || function(e) {
        return "[object Array]" == g.call(e);
    }, k = [], E = {}, S = {
        timeout: function(e, t) {
            return t.length && (e.timeout = t[0]), e;
        }
    };
    d = function(e) {
        function t(e) {
            var t, n, i, e = e.split("!"), r = k.length, a = e.pop(), o = e.length, a = {
                url: a,
                origUrl: a,
                prefixes: e
            };
            for (n = 0; n < o; n++) i = e[n].split("="), (t = S[i.shift()]) && (a = t(a, i));
            for (n = 0; n < r; n++) a = k[n](a);
            return a;
        }
        function o(e, r, a, o, s) {
            var c = t(e), u = c.autoCallback;
            c.url.split(".").pop().split("?").shift(), c.bypass || (r && (r = i(r) ? r : r[e] || r[o] || r[e.split("/").pop().split("?")[0]]), 
            c.instead ? c.instead(e, r, a, o, s) : (E[c.url] ? c.noexec = !0 : E[c.url] = 1, 
            a.load(c.url, c.forceCSS || !c.forceJS && "css" == c.url.split(".").pop().split("?").shift() ? "c" : n, c.noexec, c.attrs, c.timeout), 
            (i(r) || i(u)) && a.load(function() {
                l(), r && r(c.origUrl, s, o), u && u(c.origUrl, s, o), E[c.url] = 2;
            })));
        }
        function s(e, t) {
            function n(e, n) {
                if (e) {
                    if (r(e)) n || (f = function() {
                        var e = [].slice.call(arguments);
                        d.apply(this, e), h();
                    }), o(e, f, t, 0, u); else if (Object(e) === e) for (c in s = function() {
                        var t, n = 0;
                        for (t in e) e.hasOwnProperty(t) && n++;
                        return n;
                    }(), e) e.hasOwnProperty(c) && (!n && !--s && (i(f) ? f = function() {
                        var e = [].slice.call(arguments);
                        d.apply(this, e), h();
                    } : f[c] = function(e) {
                        return function() {
                            var t = [].slice.call(arguments);
                            e && e.apply(this, t), h();
                        };
                    }(d[c])), o(e[c], f, t, c, u));
                } else !n && h();
            }
            var s, c, u = !!e.test, l = e.load || e.both, f = e.callback || a, d = f, h = e.complete || a;
            n(u ? e.yep : e.nope, !!l), l && n(l);
        }
        var c, u, f = this.yepnope.loader;
        if (r(e)) o(e, 0, f, 0); else if (w(e)) for (c = 0; c < e.length; c++) u = e[c], 
        r(u) ? o(u, 0, f, 0) : w(u) ? d(u) : Object(u) === u && s(u, f); else Object(e) === e && s(e, f);
    }, d.addPrefix = function(e, t) {
        S[e] = t;
    }, d.addFilter = function(e) {
        k.push(e);
    }, d.errorTimeout = 1e4, null == t.readyState && t.addEventListener && (t.readyState = "loading", 
    t.addEventListener("DOMContentLoaded", f = function() {
        t.removeEventListener("DOMContentLoaded", f, 0), t.readyState = "complete";
    }, 0)), e.yepnope = l(), e.yepnope.executeStack = s, e.yepnope.injectJs = function(e, n, i, r, c, u) {
        var l, f, h = t.createElement("script"), r = r || d.errorTimeout;
        h.src = e;
        for (f in i) h.setAttribute(f, i[f]);
        n = u ? s : n || a, h.onreadystatechange = h.onload = function() {
            !l && o(h.readyState) && (l = 1, n(), h.onload = h.onreadystatechange = null);
        }, p(function() {
            l || (l = 1, n(1));
        }, r), c ? h.onload() : m.parentNode.insertBefore(h, m);
    }, e.yepnope.injectCss = function(e, n, i, r, o, c) {
        var u, r = t.createElement("link"), n = c ? s : n || a;
        r.href = e, r.rel = "stylesheet", r.type = "text/css";
        for (u in i) r.setAttribute(u, i[u]);
        o || (m.parentNode.insertBefore(r, m), p(n, 0));
    };
}(this, document), Modernizr.load = function() {
    yepnope.apply(window, [].slice.call(arguments, 0));
}, preloadImage = function(e, t, n) {
    function i() {
        s || (s = !0, a.css("opacity", 1), t && (n ? t(n) : t()));
    }
    function r() {
        t && (n ? t(n) : t());
    }
    var a = e, o = e.data("src"), s = !1;
    a.css("opacity", 0), a.attr("src", o), a.get(0).onload = i, a.get(0).onerror = r, 
    a.get(0).complete && i();
}, function() {
    for (var e = 0, t = [ "ms", "moz", "webkit", "o" ], n = 0; n < t.length && !window.requestAnimationFrame; ++n) window.requestAnimationFrame = window[t[n] + "RequestAnimationFrame"], 
    window.cancelAnimationFrame = window[t[n] + "CancelAnimationFrame"] || window[t[n] + "CancelRequestAnimationFrame"];
    window.requestAnimationFrame || (window.requestAnimationFrame = function(t, n) {
        var i = new Date().getTime(), r = Math.max(0, 16 - (i - e)), a = window.setTimeout(function() {
            t(i + r);
        }, r);
        return e = i + r, a;
    }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function(e) {
        clearTimeout(e);
    });
}(), resizeToFit = function(e) {
    "use strict";
    var t = e.container, n = e.image, i = e.fit, r = e.rotated, a = t.width(), o = t.height(), s = a / o, c = parseInt(n.attr("data-width")), u = parseInt(n.attr("data-height")), l = c / u, f = 0, d = 0, h = 0, p = 0;
    i ? (s > l ? (f = o * l, d = o, h = 0, p = -Math.round((f - a) / 2)) : (f = a, d = a / l, 
    h = -Math.round((d - o) / 2), p = 0), r && (s > u / c ? (f = o, d = o / l, h = -Math.round((d - o) / 2), 
    p = -Math.round((f - a) / 2)) : (f = a * l, d = a, h = -Math.round((d - o) / 2), 
    p = -Math.round((f - a) / 2)))) : s > l ? (f = a, d = a / l, h = -Math.round((d - o) / 2), 
    p = 0) : (f = o * l, d = o, h = 0, p = -Math.round((f - a) / 2)), n.css({
        width: f,
        height: d,
        top: h,
        left: p,
        position: "absolute",
        display: "block"
    }), t.css({
        position: "relative",
        display: "block",
        overflow: i ? "visible" : "hidden"
    });
};

var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;

(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function() {
    "use strict";
    _gsScope._gsDefine("plugins.CSSPlugin", [ "plugins.TweenPlugin", "TweenLite" ], function(e, t) {
        var n, i, r, a, o = function() {
            e.call(this, "css"), this._overwriteProps.length = 0, this.setRatio = o.prototype.setRatio;
        }, s = _gsScope._gsDefine.globals, c = {}, u = o.prototype = new e("css");
        u.constructor = o, o.version = "1.17.0", o.API = 2, o.defaultTransformPerspective = 0, 
        o.defaultSkewType = "compensated", o.defaultSmoothOrigin = !0, u = "px", o.suffixMap = {
            top: u,
            right: u,
            bottom: u,
            left: u,
            width: u,
            height: u,
            fontSize: u,
            padding: u,
            margin: u,
            perspective: u,
            lineHeight: ""
        };
        var l, f, d, h, p, m, g = /(?:\d|\-\d|\.\d|\-\.\d)+/g, v = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g, y = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, A = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g, _ = /(?:\d|\-|\+|=|#|\.)*/g, b = /opacity *= *([^)]*)/i, T = /opacity:([^;]*)/i, x = /alpha\(opacity *=.+?\)/i, w = /^(rgb|hsl)/, k = /([A-Z])/g, E = /-([a-z])/gi, S = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, M = function(e, t) {
            return t.toUpperCase();
        }, C = /(?:Left|Right|Width)/i, P = /(M11|M12|M21|M22)=[\d\-\.e]+/gi, D = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i, O = /,(?=[^\)]*(?:\(|$))/gi, N = Math.PI / 180, z = 180 / Math.PI, L = {}, I = document, j = function(e) {
            return I.createElementNS ? I.createElementNS("http://www.w3.org/1999/xhtml", e) : I.createElement(e);
        }, B = j("div"), R = j("img"), F = o._internals = {
            _specialProps: c
        }, Y = navigator.userAgent, q = function() {
            var e = Y.indexOf("Android"), t = j("a");
            return d = Y.indexOf("Safari") !== -1 && Y.indexOf("Chrome") === -1 && (e === -1 || Number(Y.substr(e + 8, 1)) > 3), 
            p = d && Number(Y.substr(Y.indexOf("Version/") + 8, 1)) < 6, h = Y.indexOf("Firefox") !== -1, 
            (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(Y) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(Y)) && (m = parseFloat(RegExp.$1)), 
            !!t && (t.style.cssText = "top:1px;opacity:.55;", /^0.55/.test(t.style.opacity));
        }(), W = function(e) {
            return b.test("string" == typeof e ? e : (e.currentStyle ? e.currentStyle.filter : e.style.filter) || "") ? parseFloat(RegExp.$1) / 100 : 1;
        }, H = function(e) {
            window.console && console.log(e);
        }, V = "", G = "", U = function(e, t) {
            t = t || B;
            var n, i, r = t.style;
            if (void 0 !== r[e]) return e;
            for (e = e.charAt(0).toUpperCase() + e.substr(1), n = [ "O", "Moz", "ms", "Ms", "Webkit" ], 
            i = 5; --i > -1 && void 0 === r[n[i] + e]; ) ;
            return i >= 0 ? (G = 3 === i ? "ms" : n[i], V = "-" + G.toLowerCase() + "-", G + e) : null;
        }, X = I.defaultView ? I.defaultView.getComputedStyle : function() {}, K = o.getStyle = function(e, t, n, i, r) {
            var a;
            return q || "opacity" !== t ? (!i && e.style[t] ? a = e.style[t] : (n = n || X(e)) ? a = n[t] || n.getPropertyValue(t) || n.getPropertyValue(t.replace(k, "-$1").toLowerCase()) : e.currentStyle && (a = e.currentStyle[t]), 
            null == r || a && "none" !== a && "auto" !== a && "auto auto" !== a ? a : r) : W(e);
        }, $ = F.convertToPixels = function(e, n, i, r, a) {
            if ("px" === r || !r) return i;
            if ("auto" === r || !i) return 0;
            var s, c, u, l = C.test(n), f = e, d = B.style, h = i < 0;
            if (h && (i = -i), "%" === r && n.indexOf("border") !== -1) s = i / 100 * (l ? e.clientWidth : e.clientHeight); else {
                if (d.cssText = "border:0 solid red;position:" + K(e, "position") + ";line-height:0;", 
                "%" !== r && f.appendChild) d[l ? "borderLeftWidth" : "borderTopWidth"] = i + r; else {
                    if (f = e.parentNode || I.body, c = f._gsCache, u = t.ticker.frame, c && l && c.time === u) return c.width * i / 100;
                    d[l ? "width" : "height"] = i + r;
                }
                f.appendChild(B), s = parseFloat(B[l ? "offsetWidth" : "offsetHeight"]), f.removeChild(B), 
                l && "%" === r && o.cacheWidths !== !1 && (c = f._gsCache = f._gsCache || {}, c.time = u, 
                c.width = s / i * 100), 0 !== s || a || (s = $(e, n, i, r, !0));
            }
            return h ? -s : s;
        }, Q = F.calculateOffset = function(e, t, n) {
            if ("absolute" !== K(e, "position", n)) return 0;
            var i = "left" === t ? "Left" : "Top", r = K(e, "margin" + i, n);
            return e["offset" + i] - ($(e, t, parseFloat(r), r.replace(_, "")) || 0);
        }, Z = function(e, t) {
            var n, i, r, a = {};
            if (t = t || X(e, null)) if (n = t.length) for (;--n > -1; ) r = t[n], r.indexOf("-transform") !== -1 && we !== r || (a[r.replace(E, M)] = t.getPropertyValue(r)); else for (n in t) n.indexOf("Transform") !== -1 && xe !== n || (a[n] = t[n]); else if (t = e.currentStyle || e.style) for (n in t) "string" == typeof n && void 0 === a[n] && (a[n.replace(E, M)] = t[n]);
            return q || (a.opacity = W(e)), i = Ie(e, t, !1), a.rotation = i.rotation, a.skewX = i.skewX, 
            a.scaleX = i.scaleX, a.scaleY = i.scaleY, a.x = i.x, a.y = i.y, Ee && (a.z = i.z, 
            a.rotationX = i.rotationX, a.rotationY = i.rotationY, a.scaleZ = i.scaleZ), a.filters && delete a.filters, 
            a;
        }, J = function(e, t, n, i, r) {
            var a, o, s, c = {}, u = e.style;
            for (o in n) "cssText" !== o && "length" !== o && isNaN(o) && (t[o] !== (a = n[o]) || r && r[o]) && o.indexOf("Origin") === -1 && ("number" != typeof a && "string" != typeof a || (c[o] = "auto" !== a || "left" !== o && "top" !== o ? "" !== a && "auto" !== a && "none" !== a || "string" != typeof t[o] || "" === t[o].replace(A, "") ? a : 0 : Q(e, o), 
            void 0 !== u[o] && (s = new he(u, o, u[o], s))));
            if (i) for (o in i) "className" !== o && (c[o] = i[o]);
            return {
                difs: c,
                firstMPT: s
            };
        }, ee = {
            width: [ "Left", "Right" ],
            height: [ "Top", "Bottom" ]
        }, te = [ "marginLeft", "marginRight", "marginTop", "marginBottom" ], ne = function(e, t, n) {
            var i = parseFloat("width" === t ? e.offsetWidth : e.offsetHeight), r = ee[t], a = r.length;
            for (n = n || X(e, null); --a > -1; ) i -= parseFloat(K(e, "padding" + r[a], n, !0)) || 0, 
            i -= parseFloat(K(e, "border" + r[a] + "Width", n, !0)) || 0;
            return i;
        }, ie = function(e, t) {
            null != e && "" !== e && "auto" !== e && "auto auto" !== e || (e = "0 0");
            var n = e.split(" "), i = e.indexOf("left") !== -1 ? "0%" : e.indexOf("right") !== -1 ? "100%" : n[0], r = e.indexOf("top") !== -1 ? "0%" : e.indexOf("bottom") !== -1 ? "100%" : n[1];
            return null == r ? r = "center" === i ? "50%" : "0" : "center" === r && (r = "50%"), 
            ("center" === i || isNaN(parseFloat(i)) && (i + "").indexOf("=") === -1) && (i = "50%"), 
            e = i + " " + r + (n.length > 2 ? " " + n[2] : ""), t && (t.oxp = i.indexOf("%") !== -1, 
            t.oyp = r.indexOf("%") !== -1, t.oxr = "=" === i.charAt(1), t.oyr = "=" === r.charAt(1), 
            t.ox = parseFloat(i.replace(A, "")), t.oy = parseFloat(r.replace(A, "")), t.v = e), 
            t || e;
        }, re = function(e, t) {
            return "string" == typeof e && "=" === e.charAt(1) ? parseInt(e.charAt(0) + "1", 10) * parseFloat(e.substr(2)) : parseFloat(e) - parseFloat(t);
        }, ae = function(e, t) {
            return null == e ? t : "string" == typeof e && "=" === e.charAt(1) ? parseInt(e.charAt(0) + "1", 10) * parseFloat(e.substr(2)) + t : parseFloat(e);
        }, oe = function(e, t, n, i) {
            var r, a, o, s, c, u = 1e-6;
            return null == e ? s = t : "number" == typeof e ? s = e : (r = 360, a = e.split("_"), 
            c = "=" === e.charAt(1), o = (c ? parseInt(e.charAt(0) + "1", 10) * parseFloat(a[0].substr(2)) : parseFloat(a[0])) * (e.indexOf("rad") === -1 ? 1 : z) - (c ? 0 : t), 
            a.length && (i && (i[n] = t + o), e.indexOf("short") !== -1 && (o %= r, o !== o % (r / 2) && (o = o < 0 ? o + r : o - r)), 
            e.indexOf("_cw") !== -1 && o < 0 ? o = (o + 9999999999 * r) % r - (o / r | 0) * r : e.indexOf("ccw") !== -1 && o > 0 && (o = (o - 9999999999 * r) % r - (o / r | 0) * r)), 
            s = t + o), s < u && s > -u && (s = 0), s;
        }, se = {
            aqua: [ 0, 255, 255 ],
            lime: [ 0, 255, 0 ],
            silver: [ 192, 192, 192 ],
            black: [ 0, 0, 0 ],
            maroon: [ 128, 0, 0 ],
            teal: [ 0, 128, 128 ],
            blue: [ 0, 0, 255 ],
            navy: [ 0, 0, 128 ],
            white: [ 255, 255, 255 ],
            fuchsia: [ 255, 0, 255 ],
            olive: [ 128, 128, 0 ],
            yellow: [ 255, 255, 0 ],
            orange: [ 255, 165, 0 ],
            gray: [ 128, 128, 128 ],
            purple: [ 128, 0, 128 ],
            green: [ 0, 128, 0 ],
            red: [ 255, 0, 0 ],
            pink: [ 255, 192, 203 ],
            cyan: [ 0, 255, 255 ],
            transparent: [ 255, 255, 255, 0 ]
        }, ce = function(e, t, n) {
            return e = e < 0 ? e + 1 : e > 1 ? e - 1 : e, 255 * (6 * e < 1 ? t + (n - t) * e * 6 : e < .5 ? n : 3 * e < 2 ? t + (n - t) * (2 / 3 - e) * 6 : t) + .5 | 0;
        }, ue = o.parseColor = function(e) {
            var t, n, i, r, a, o;
            return e && "" !== e ? "number" == typeof e ? [ e >> 16, e >> 8 & 255, 255 & e ] : ("," === e.charAt(e.length - 1) && (e = e.substr(0, e.length - 1)), 
            se[e] ? se[e] : "#" === e.charAt(0) ? (4 === e.length && (t = e.charAt(1), n = e.charAt(2), 
            i = e.charAt(3), e = "#" + t + t + n + n + i + i), e = parseInt(e.substr(1), 16), 
            [ e >> 16, e >> 8 & 255, 255 & e ]) : "hsl" === e.substr(0, 3) ? (e = e.match(g), 
            r = Number(e[0]) % 360 / 360, a = Number(e[1]) / 100, o = Number(e[2]) / 100, n = o <= .5 ? o * (a + 1) : o + a - o * a, 
            t = 2 * o - n, e.length > 3 && (e[3] = Number(e[3])), e[0] = ce(r + 1 / 3, t, n), 
            e[1] = ce(r, t, n), e[2] = ce(r - 1 / 3, t, n), e) : (e = e.match(g) || se.transparent, 
            e[0] = Number(e[0]), e[1] = Number(e[1]), e[2] = Number(e[2]), e.length > 3 && (e[3] = Number(e[3])), 
            e)) : se.black;
        }, le = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#.+?\\b";
        for (u in se) le += "|" + u + "\\b";
        le = new RegExp(le + ")", "gi");
        var fe = function(e, t, n, i) {
            if (null == e) return function(e) {
                return e;
            };
            var r, a = t ? (e.match(le) || [ "" ])[0] : "", o = e.split(a).join("").match(y) || [], s = e.substr(0, e.indexOf(o[0])), c = ")" === e.charAt(e.length - 1) ? ")" : "", u = e.indexOf(" ") !== -1 ? " " : ",", l = o.length, f = l > 0 ? o[0].replace(g, "") : "";
            return l ? r = t ? function(e) {
                var t, d, h, p;
                if ("number" == typeof e) e += f; else if (i && O.test(e)) {
                    for (p = e.replace(O, "|").split("|"), h = 0; h < p.length; h++) p[h] = r(p[h]);
                    return p.join(",");
                }
                if (t = (e.match(le) || [ a ])[0], d = e.split(t).join("").match(y) || [], h = d.length, 
                l > h--) for (;++h < l; ) d[h] = n ? d[(h - 1) / 2 | 0] : o[h];
                return s + d.join(u) + u + t + c + (e.indexOf("inset") !== -1 ? " inset" : "");
            } : function(e) {
                var t, a, d;
                if ("number" == typeof e) e += f; else if (i && O.test(e)) {
                    for (a = e.replace(O, "|").split("|"), d = 0; d < a.length; d++) a[d] = r(a[d]);
                    return a.join(",");
                }
                if (t = e.match(y) || [], d = t.length, l > d--) for (;++d < l; ) t[d] = n ? t[(d - 1) / 2 | 0] : o[d];
                return s + t.join(u) + c;
            } : function(e) {
                return e;
            };
        }, de = function(e) {
            return e = e.split(","), function(t, n, i, r, a, o, s) {
                var c, u = (n + "").split(" ");
                for (s = {}, c = 0; c < 4; c++) s[e[c]] = u[c] = u[c] || u[(c - 1) / 2 >> 0];
                return r.parse(t, s, a, o);
            };
        }, he = (F._setPluginRatio = function(e) {
            this.plugin.setRatio(e);
            for (var t, n, i, r, a = this.data, o = a.proxy, s = a.firstMPT, c = 1e-6; s; ) t = o[s.v], 
            s.r ? t = Math.round(t) : t < c && t > -c && (t = 0), s.t[s.p] = t, s = s._next;
            if (a.autoRotate && (a.autoRotate.rotation = o.rotation), 1 === e) for (s = a.firstMPT; s; ) {
                if (n = s.t, n.type) {
                    if (1 === n.type) {
                        for (r = n.xs0 + n.s + n.xs1, i = 1; i < n.l; i++) r += n["xn" + i] + n["xs" + (i + 1)];
                        n.e = r;
                    }
                } else n.e = n.s + n.xs0;
                s = s._next;
            }
        }, function(e, t, n, i, r) {
            this.t = e, this.p = t, this.v = n, this.r = r, i && (i._prev = this, this._next = i);
        }), pe = (F._parseToProxy = function(e, t, n, i, r, a) {
            var o, s, c, u, l, f = i, d = {}, h = {}, p = n._transform, m = L;
            for (n._transform = null, L = t, i = l = n.parse(e, t, i, r), L = m, a && (n._transform = p, 
            f && (f._prev = null, f._prev && (f._prev._next = null))); i && i !== f; ) {
                if (i.type <= 1 && (s = i.p, h[s] = i.s + i.c, d[s] = i.s, a || (u = new he(i, "s", s, u, i.r), 
                i.c = 0), 1 === i.type)) for (o = i.l; --o > 0; ) c = "xn" + o, s = i.p + "_" + c, 
                h[s] = i.data[c], d[s] = i[c], a || (u = new he(i, c, s, u, i.rxp[c]));
                i = i._next;
            }
            return {
                proxy: d,
                end: h,
                firstMPT: u,
                pt: l
            };
        }, F.CSSPropTween = function(e, t, i, r, o, s, c, u, l, f, d) {
            this.t = e, this.p = t, this.s = i, this.c = r, this.n = c || t, e instanceof pe || a.push(this.n), 
            this.r = u, this.type = s || 0, l && (this.pr = l, n = !0), this.b = void 0 === f ? i : f, 
            this.e = void 0 === d ? i + r : d, o && (this._next = o, o._prev = this);
        }), me = function(e, t, n, i, r, a) {
            var o = new pe(e, t, n, i - n, r, -1, a);
            return o.b = n, o.e = o.xs0 = i, o;
        }, ge = o.parseComplex = function(e, t, n, i, r, a, o, s, c, u) {
            n = n || a || "", o = new pe(e, t, 0, 0, o, u ? 2 : 1, null, !1, s, n, i), i += "";
            var f, d, h, p, m, y, A, _, b, T, x, k, E = n.split(", ").join(",").split(" "), S = i.split(", ").join(",").split(" "), M = E.length, C = l !== !1;
            for (i.indexOf(",") === -1 && n.indexOf(",") === -1 || (E = E.join(" ").replace(O, ", ").split(" "), 
            S = S.join(" ").replace(O, ", ").split(" "), M = E.length), M !== S.length && (E = (a || "").split(" "), 
            M = E.length), o.plugin = c, o.setRatio = u, f = 0; f < M; f++) if (p = E[f], m = S[f], 
            _ = parseFloat(p), _ || 0 === _) o.appendXtra("", _, re(m, _), m.replace(v, ""), C && m.indexOf("px") !== -1, !0); else if (r && ("#" === p.charAt(0) || se[p] || w.test(p))) k = "," === m.charAt(m.length - 1) ? ")," : ")", 
            p = ue(p), m = ue(m), b = p.length + m.length > 6, b && !q && 0 === m[3] ? (o["xs" + o.l] += o.l ? " transparent" : "transparent", 
            o.e = o.e.split(S[f]).join("transparent")) : (q || (b = !1), o.appendXtra(b ? "rgba(" : "rgb(", p[0], m[0] - p[0], ",", !0, !0).appendXtra("", p[1], m[1] - p[1], ",", !0).appendXtra("", p[2], m[2] - p[2], b ? "," : k, !0), 
            b && (p = p.length < 4 ? 1 : p[3], o.appendXtra("", p, (m.length < 4 ? 1 : m[3]) - p, k, !1))); else if (y = p.match(g)) {
                if (A = m.match(v), !A || A.length !== y.length) return o;
                for (h = 0, d = 0; d < y.length; d++) x = y[d], T = p.indexOf(x, h), o.appendXtra(p.substr(h, T - h), Number(x), re(A[d], x), "", C && "px" === p.substr(T + x.length, 2), 0 === d), 
                h = T + x.length;
                o["xs" + o.l] += p.substr(h);
            } else o["xs" + o.l] += o.l ? " " + p : p;
            if (i.indexOf("=") !== -1 && o.data) {
                for (k = o.xs0 + o.data.s, f = 1; f < o.l; f++) k += o["xs" + f] + o.data["xn" + f];
                o.e = k + o["xs" + f];
            }
            return o.l || (o.type = -1, o.xs0 = o.e), o.xfirst || o;
        }, ve = 9;
        for (u = pe.prototype, u.l = u.pr = 0; --ve > 0; ) u["xn" + ve] = 0, u["xs" + ve] = "";
        u.xs0 = "", u._next = u._prev = u.xfirst = u.data = u.plugin = u.setRatio = u.rxp = null, 
        u.appendXtra = function(e, t, n, i, r, a) {
            var o = this, s = o.l;
            return o["xs" + s] += a && s ? " " + e : e || "", n || 0 === s || o.plugin ? (o.l++, 
            o.type = o.setRatio ? 2 : 1, o["xs" + o.l] = i || "", s > 0 ? (o.data["xn" + s] = t + n, 
            o.rxp["xn" + s] = r, o["xn" + s] = t, o.plugin || (o.xfirst = new pe(o, "xn" + s, t, n, o.xfirst || o, 0, o.n, r, o.pr), 
            o.xfirst.xs0 = 0), o) : (o.data = {
                s: t + n
            }, o.rxp = {}, o.s = t, o.c = n, o.r = r, o)) : (o["xs" + s] += t + (i || ""), o);
        };
        var ye = function(e, t) {
            t = t || {}, this.p = t.prefix ? U(e) || e : e, c[e] = c[this.p] = this, this.format = t.formatter || fe(t.defaultValue, t.color, t.collapsible, t.multi), 
            t.parser && (this.parse = t.parser), this.clrs = t.color, this.multi = t.multi, 
            this.keyword = t.keyword, this.dflt = t.defaultValue, this.pr = t.priority || 0;
        }, Ae = F._registerComplexSpecialProp = function(e, t, n) {
            "object" != typeof t && (t = {
                parser: n
            });
            var i, r, a = e.split(","), o = t.defaultValue;
            for (n = n || [ o ], i = 0; i < a.length; i++) t.prefix = 0 === i && t.prefix, t.defaultValue = n[i] || o, 
            r = new ye(a[i], t);
        }, _e = function(e) {
            if (!c[e]) {
                var t = e.charAt(0).toUpperCase() + e.substr(1) + "Plugin";
                Ae(e, {
                    parser: function(e, n, i, r, a, o, u) {
                        var l = s.com.greensock.plugins[t];
                        return l ? (l._cssRegister(), c[i].parse(e, n, i, r, a, o, u)) : (H("Error: " + t + " js file not loaded."), 
                        a);
                    }
                });
            }
        };
        u = ye.prototype, u.parseComplex = function(e, t, n, i, r, a) {
            var o, s, c, u, l, f, d = this.keyword;
            if (this.multi && (O.test(n) || O.test(t) ? (s = t.replace(O, "|").split("|"), c = n.replace(O, "|").split("|")) : d && (s = [ t ], 
            c = [ n ])), c) {
                for (u = c.length > s.length ? c.length : s.length, o = 0; o < u; o++) t = s[o] = s[o] || this.dflt, 
                n = c[o] = c[o] || this.dflt, d && (l = t.indexOf(d), f = n.indexOf(d), l !== f && (f === -1 ? s[o] = s[o].split(d).join("") : l === -1 && (s[o] += " " + d)));
                t = s.join(", "), n = c.join(", ");
            }
            return ge(e, this.p, t, n, this.clrs, this.dflt, i, this.pr, r, a);
        }, u.parse = function(e, t, n, i, a, o, s) {
            return this.parseComplex(e.style, this.format(K(e, this.p, r, !1, this.dflt)), this.format(t), a, o);
        }, o.registerSpecialProp = function(e, t, n) {
            Ae(e, {
                parser: function(e, i, r, a, o, s, c) {
                    var u = new pe(e, r, 0, 0, o, 2, r, !1, n);
                    return u.plugin = s, u.setRatio = t(e, i, a._tween, r), u;
                },
                priority: n
            });
        }, o.useSVGTransformAttr = d || h;
        var be, Te = "scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","), xe = U("transform"), we = V + "transform", ke = U("transformOrigin"), Ee = null !== U("perspective"), Se = F.Transform = function() {
            this.perspective = parseFloat(o.defaultTransformPerspective) || 0, this.force3D = !(o.defaultForce3D === !1 || !Ee) && (o.defaultForce3D || "auto");
        }, Me = window.SVGElement, Ce = function(e, t, n) {
            var i, r = I.createElementNS("http://www.w3.org/2000/svg", e), a = /([a-z])([A-Z])/g;
            for (i in n) r.setAttributeNS(null, i.replace(a, "$1-$2").toLowerCase(), n[i]);
            return t.appendChild(r), r;
        }, Pe = I.documentElement, De = function() {
            var e, t, n, i = m || /Android/i.test(Y) && !window.chrome;
            return I.createElementNS && !i && (e = Ce("svg", Pe), t = Ce("rect", e, {
                width: 100,
                height: 50,
                x: 100
            }), n = t.getBoundingClientRect().width, t.style[ke] = "50% 50%", t.style[xe] = "scaleX(0.5)", 
            i = n === t.getBoundingClientRect().width && !(h && Ee), Pe.removeChild(e)), i;
        }(), Oe = function(e, t, n, i, r) {
            var a, s, c, u, l, f, d, h, p, m, g, v, y, A, _ = e._gsTransform, b = Le(e, !0);
            _ && (y = _.xOrigin, A = _.yOrigin), (!i || (a = i.split(" ")).length < 2) && (d = e.getBBox(), 
            t = ie(t).split(" "), a = [ (t[0].indexOf("%") !== -1 ? parseFloat(t[0]) / 100 * d.width : parseFloat(t[0])) + d.x, (t[1].indexOf("%") !== -1 ? parseFloat(t[1]) / 100 * d.height : parseFloat(t[1])) + d.y ]), 
            n.xOrigin = u = parseFloat(a[0]), n.yOrigin = l = parseFloat(a[1]), i && b !== ze && (f = b[0], 
            d = b[1], h = b[2], p = b[3], m = b[4], g = b[5], v = f * p - d * h, s = u * (p / v) + l * (-h / v) + (h * g - p * m) / v, 
            c = u * (-d / v) + l * (f / v) - (f * g - d * m) / v, u = n.xOrigin = a[0] = s, 
            l = n.yOrigin = a[1] = c), _ && (r || r !== !1 && o.defaultSmoothOrigin !== !1 ? (s = u - y, 
            c = l - A, _.xOffset += s * b[0] + c * b[2] - s, _.yOffset += s * b[1] + c * b[3] - c) : _.xOffset = _.yOffset = 0), 
            e.setAttribute("data-svg-origin", a.join(" "));
        }, Ne = function(e) {
            return !!(Me && "function" == typeof e.getBBox && e.getCTM && (!e.parentNode || e.parentNode.getBBox && e.parentNode.getCTM));
        }, ze = [ 1, 0, 0, 1, 0, 0 ], Le = function(e, t) {
            var n, i, r, a, o, s = e._gsTransform || new Se(), c = 1e5;
            if (xe ? i = K(e, we, null, !0) : e.currentStyle && (i = e.currentStyle.filter.match(P), 
            i = i && 4 === i.length ? [ i[0].substr(4), Number(i[2].substr(4)), Number(i[1].substr(4)), i[3].substr(4), s.x || 0, s.y || 0 ].join(",") : ""), 
            n = !i || "none" === i || "matrix(1, 0, 0, 1, 0, 0)" === i, (s.svg || e.getBBox && Ne(e)) && (n && (e.style[xe] + "").indexOf("matrix") !== -1 && (i = e.style[xe], 
            n = 0), r = e.getAttribute("transform"), n && r && (r.indexOf("matrix") !== -1 ? (i = r, 
            n = 0) : r.indexOf("translate") !== -1 && (i = "matrix(1,0,0,1," + r.match(/(?:\-|\b)[\d\-\.e]+\b/gi).join(",") + ")", 
            n = 0))), n) return ze;
            for (r = (i || "").match(/(?:\-|\b)[\d\-\.e]+\b/gi) || [], ve = r.length; --ve > -1; ) a = Number(r[ve]), 
            r[ve] = (o = a - (a |= 0)) ? (o * c + (o < 0 ? -.5 : .5) | 0) / c + a : a;
            return t && r.length > 6 ? [ r[0], r[1], r[4], r[5], r[12], r[13] ] : r;
        }, Ie = F.getTransform = function(e, n, i, a) {
            if (e._gsTransform && i && !a) return e._gsTransform;
            var s, c, u, l, f, d, h = i ? e._gsTransform || new Se() : new Se(), p = h.scaleX < 0, m = 2e-5, g = 1e5, v = Ee ? parseFloat(K(e, ke, n, !1, "0 0 0").split(" ")[2]) || h.zOrigin || 0 : 0, y = parseFloat(o.defaultTransformPerspective) || 0;
            if (h.svg = !(!e.getBBox || !Ne(e)), h.svg && (Oe(e, K(e, ke, r, !1, "50% 50%") + "", h, e.getAttribute("data-svg-origin")), 
            be = o.useSVGTransformAttr || De), s = Le(e), s !== ze) {
                if (16 === s.length) {
                    var A, _, b, T, x, w = s[0], k = s[1], E = s[2], S = s[3], M = s[4], C = s[5], P = s[6], D = s[7], O = s[8], N = s[9], L = s[10], I = s[12], j = s[13], B = s[14], R = s[11], F = Math.atan2(P, L);
                    h.zOrigin && (B = -h.zOrigin, I = O * B - s[12], j = N * B - s[13], B = L * B + h.zOrigin - s[14]), 
                    h.rotationX = F * z, F && (T = Math.cos(-F), x = Math.sin(-F), A = M * T + O * x, 
                    _ = C * T + N * x, b = P * T + L * x, O = M * -x + O * T, N = C * -x + N * T, L = P * -x + L * T, 
                    R = D * -x + R * T, M = A, C = _, P = b), F = Math.atan2(O, L), h.rotationY = F * z, 
                    F && (T = Math.cos(-F), x = Math.sin(-F), A = w * T - O * x, _ = k * T - N * x, 
                    b = E * T - L * x, N = k * x + N * T, L = E * x + L * T, R = S * x + R * T, w = A, 
                    k = _, E = b), F = Math.atan2(k, w), h.rotation = F * z, F && (T = Math.cos(-F), 
                    x = Math.sin(-F), w = w * T + M * x, _ = k * T + C * x, C = k * -x + C * T, P = E * -x + P * T, 
                    k = _), h.rotationX && Math.abs(h.rotationX) + Math.abs(h.rotation) > 359.9 && (h.rotationX = h.rotation = 0, 
                    h.rotationY += 180), h.scaleX = (Math.sqrt(w * w + k * k) * g + .5 | 0) / g, h.scaleY = (Math.sqrt(C * C + N * N) * g + .5 | 0) / g, 
                    h.scaleZ = (Math.sqrt(P * P + L * L) * g + .5 | 0) / g, h.skewX = 0, h.perspective = R ? 1 / (R < 0 ? -R : R) : 0, 
                    h.x = I, h.y = j, h.z = B, h.svg && (h.x -= h.xOrigin - (h.xOrigin * w - h.yOrigin * M), 
                    h.y -= h.yOrigin - (h.yOrigin * k - h.xOrigin * C));
                } else if ((!Ee || a || !s.length || h.x !== s[4] || h.y !== s[5] || !h.rotationX && !h.rotationY) && (void 0 === h.x || "none" !== K(e, "display", n))) {
                    var Y = s.length >= 6, q = Y ? s[0] : 1, W = s[1] || 0, H = s[2] || 0, V = Y ? s[3] : 1;
                    h.x = s[4] || 0, h.y = s[5] || 0, u = Math.sqrt(q * q + W * W), l = Math.sqrt(V * V + H * H), 
                    f = q || W ? Math.atan2(W, q) * z : h.rotation || 0, d = H || V ? Math.atan2(H, V) * z + f : h.skewX || 0, 
                    Math.abs(d) > 90 && Math.abs(d) < 270 && (p ? (u *= -1, d += f <= 0 ? 180 : -180, 
                    f += f <= 0 ? 180 : -180) : (l *= -1, d += d <= 0 ? 180 : -180)), h.scaleX = u, 
                    h.scaleY = l, h.rotation = f, h.skewX = d, Ee && (h.rotationX = h.rotationY = h.z = 0, 
                    h.perspective = y, h.scaleZ = 1), h.svg && (h.x -= h.xOrigin - (h.xOrigin * q + h.yOrigin * H), 
                    h.y -= h.yOrigin - (h.xOrigin * W + h.yOrigin * V));
                }
                h.zOrigin = v;
                for (c in h) h[c] < m && h[c] > -m && (h[c] = 0);
            }
            return i && (e._gsTransform = h, h.svg && (be && e.style[xe] ? t.delayedCall(.001, function() {
                Fe(e.style, xe);
            }) : !be && e.getAttribute("transform") && t.delayedCall(.001, function() {
                e.removeAttribute("transform");
            }))), h;
        }, je = function(e) {
            var t, n, i = this.data, r = -i.rotation * N, a = r + i.skewX * N, o = 1e5, s = (Math.cos(r) * i.scaleX * o | 0) / o, c = (Math.sin(r) * i.scaleX * o | 0) / o, u = (Math.sin(a) * -i.scaleY * o | 0) / o, l = (Math.cos(a) * i.scaleY * o | 0) / o, f = this.t.style, d = this.t.currentStyle;
            if (d) {
                n = c, c = -u, u = -n, t = d.filter, f.filter = "";
                var h, p, g = this.t.offsetWidth, v = this.t.offsetHeight, y = "absolute" !== d.position, A = "progid:DXImageTransform.Microsoft.Matrix(M11=" + s + ", M12=" + c + ", M21=" + u + ", M22=" + l, T = i.x + g * i.xPercent / 100, x = i.y + v * i.yPercent / 100;
                if (null != i.ox && (h = (i.oxp ? g * i.ox * .01 : i.ox) - g / 2, p = (i.oyp ? v * i.oy * .01 : i.oy) - v / 2, 
                T += h - (h * s + p * c), x += p - (h * u + p * l)), y ? (h = g / 2, p = v / 2, 
                A += ", Dx=" + (h - (h * s + p * c) + T) + ", Dy=" + (p - (h * u + p * l) + x) + ")") : A += ", sizingMethod='auto expand')", 
                t.indexOf("DXImageTransform.Microsoft.Matrix(") !== -1 ? f.filter = t.replace(D, A) : f.filter = A + " " + t, 
                0 !== e && 1 !== e || 1 === s && 0 === c && 0 === u && 1 === l && (y && A.indexOf("Dx=0, Dy=0") === -1 || b.test(t) && 100 !== parseFloat(RegExp.$1) || t.indexOf(t.indexOf("Alpha")) === -1 && f.removeAttribute("filter")), 
                !y) {
                    var w, k, E, S = m < 8 ? 1 : -1;
                    for (h = i.ieOffsetX || 0, p = i.ieOffsetY || 0, i.ieOffsetX = Math.round((g - ((s < 0 ? -s : s) * g + (c < 0 ? -c : c) * v)) / 2 + T), 
                    i.ieOffsetY = Math.round((v - ((l < 0 ? -l : l) * v + (u < 0 ? -u : u) * g)) / 2 + x), 
                    ve = 0; ve < 4; ve++) k = te[ve], w = d[k], n = w.indexOf("px") !== -1 ? parseFloat(w) : $(this.t, k, parseFloat(w), w.replace(_, "")) || 0, 
                    E = n !== i[k] ? ve < 2 ? -i.ieOffsetX : -i.ieOffsetY : ve < 2 ? h - i.ieOffsetX : p - i.ieOffsetY, 
                    f[k] = (i[k] = Math.round(n - E * (0 === ve || 2 === ve ? 1 : S))) + "px";
                }
            }
        }, Be = F.set3DTransformRatio = F.setTransformRatio = function(e) {
            var t, n, i, r, a, o, s, c, u, l, f, d, p, m, g, v, y, A, _, b, T, x, w, k = this.data, E = this.t.style, S = k.rotation, M = k.rotationX, C = k.rotationY, P = k.scaleX, D = k.scaleY, O = k.scaleZ, z = k.x, L = k.y, I = k.z, j = k.svg, B = k.perspective, R = k.force3D;
            if (((1 === e || 0 === e) && "auto" === R && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime) || !R) && !I && !B && !C && !M || be && j || !Ee) return void (S || k.skewX || j ? (S *= N, 
            x = k.skewX * N, w = 1e5, t = Math.cos(S) * P, r = Math.sin(S) * P, n = Math.sin(S - x) * -D, 
            a = Math.cos(S - x) * D, x && "simple" === k.skewType && (y = Math.tan(x), y = Math.sqrt(1 + y * y), 
            n *= y, a *= y, k.skewY && (t *= y, r *= y)), j && (z += k.xOrigin - (k.xOrigin * t + k.yOrigin * n) + k.xOffset, 
            L += k.yOrigin - (k.xOrigin * r + k.yOrigin * a) + k.yOffset, be && (k.xPercent || k.yPercent) && (m = this.t.getBBox(), 
            z += .01 * k.xPercent * m.width, L += .01 * k.yPercent * m.height), m = 1e-6, z < m && z > -m && (z = 0), 
            L < m && L > -m && (L = 0)), _ = (t * w | 0) / w + "," + (r * w | 0) / w + "," + (n * w | 0) / w + "," + (a * w | 0) / w + "," + z + "," + L + ")", 
            j && be ? this.t.setAttribute("transform", "matrix(" + _) : E[xe] = (k.xPercent || k.yPercent ? "translate(" + k.xPercent + "%," + k.yPercent + "%) matrix(" : "matrix(") + _) : E[xe] = (k.xPercent || k.yPercent ? "translate(" + k.xPercent + "%," + k.yPercent + "%) matrix(" : "matrix(") + P + ",0,0," + D + "," + z + "," + L + ")");
            if (h && (m = 1e-4, P < m && P > -m && (P = O = 2e-5), D < m && D > -m && (D = O = 2e-5), 
            !B || k.z || k.rotationX || k.rotationY || (B = 0)), S || k.skewX) S *= N, g = t = Math.cos(S), 
            v = r = Math.sin(S), k.skewX && (S -= k.skewX * N, g = Math.cos(S), v = Math.sin(S), 
            "simple" === k.skewType && (y = Math.tan(k.skewX * N), y = Math.sqrt(1 + y * y), 
            g *= y, v *= y, k.skewY && (t *= y, r *= y))), n = -v, a = g; else {
                if (!(C || M || 1 !== O || B || j)) return void (E[xe] = (k.xPercent || k.yPercent ? "translate(" + k.xPercent + "%," + k.yPercent + "%) translate3d(" : "translate3d(") + z + "px," + L + "px," + I + "px)" + (1 !== P || 1 !== D ? " scale(" + P + "," + D + ")" : ""));
                t = a = 1, n = r = 0;
            }
            u = 1, i = o = s = c = l = f = 0, d = B ? -1 / B : 0, p = k.zOrigin, m = 1e-6, b = ",", 
            T = "0", S = C * N, S && (g = Math.cos(S), v = Math.sin(S), s = -v, l = d * -v, 
            i = t * v, o = r * v, u = g, d *= g, t *= g, r *= g), S = M * N, S && (g = Math.cos(S), 
            v = Math.sin(S), y = n * g + i * v, A = a * g + o * v, c = u * v, f = d * v, i = n * -v + i * g, 
            o = a * -v + o * g, u *= g, d *= g, n = y, a = A), 1 !== O && (i *= O, o *= O, u *= O, 
            d *= O), 1 !== D && (n *= D, a *= D, c *= D, f *= D), 1 !== P && (t *= P, r *= P, 
            s *= P, l *= P), (p || j) && (p && (z += i * -p, L += o * -p, I += u * -p + p), 
            j && (z += k.xOrigin - (k.xOrigin * t + k.yOrigin * n) + k.xOffset, L += k.yOrigin - (k.xOrigin * r + k.yOrigin * a) + k.yOffset), 
            z < m && z > -m && (z = T), L < m && L > -m && (L = T), I < m && I > -m && (I = 0)), 
            _ = k.xPercent || k.yPercent ? "translate(" + k.xPercent + "%," + k.yPercent + "%) matrix3d(" : "matrix3d(", 
            _ += (t < m && t > -m ? T : t) + b + (r < m && r > -m ? T : r) + b + (s < m && s > -m ? T : s), 
            _ += b + (l < m && l > -m ? T : l) + b + (n < m && n > -m ? T : n) + b + (a < m && a > -m ? T : a), 
            M || C ? (_ += b + (c < m && c > -m ? T : c) + b + (f < m && f > -m ? T : f) + b + (i < m && i > -m ? T : i), 
            _ += b + (o < m && o > -m ? T : o) + b + (u < m && u > -m ? T : u) + b + (d < m && d > -m ? T : d) + b) : _ += ",0,0,0,0,1,0,", 
            _ += z + b + L + b + I + b + (B ? 1 + -I / B : 1) + ")", E[xe] = _;
        };
        u = Se.prototype, u.x = u.y = u.z = u.skewX = u.skewY = u.rotation = u.rotationX = u.rotationY = u.zOrigin = u.xPercent = u.yPercent = u.xOffset = u.yOffset = 0, 
        u.scaleX = u.scaleY = u.scaleZ = 1, Ae("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {
            parser: function(e, t, n, i, a, s, c) {
                if (i._lastParsedTransform === c) return a;
                i._lastParsedTransform = c;
                var u, l, f, d, h, p, m, g, v, y = e._gsTransform, A = i._transform = Ie(e, r, !0, c.parseTransform), _ = e.style, b = 1e-6, T = Te.length, x = c, w = {}, k = "transformOrigin";
                if ("string" == typeof x.transform && xe) f = B.style, f[xe] = x.transform, f.display = "block", 
                f.position = "absolute", I.body.appendChild(B), u = Ie(B, null, !1), I.body.removeChild(B), 
                null != x.xPercent && (u.xPercent = ae(x.xPercent, A.xPercent)), null != x.yPercent && (u.yPercent = ae(x.yPercent, A.yPercent)); else if ("object" == typeof x) {
                    if (u = {
                        scaleX: ae(null != x.scaleX ? x.scaleX : x.scale, A.scaleX),
                        scaleY: ae(null != x.scaleY ? x.scaleY : x.scale, A.scaleY),
                        scaleZ: ae(x.scaleZ, A.scaleZ),
                        x: ae(x.x, A.x),
                        y: ae(x.y, A.y),
                        z: ae(x.z, A.z),
                        xPercent: ae(x.xPercent, A.xPercent),
                        yPercent: ae(x.yPercent, A.yPercent),
                        perspective: ae(x.transformPerspective, A.perspective)
                    }, m = x.directionalRotation, null != m) if ("object" == typeof m) for (f in m) x[f] = m[f]; else x.rotation = m;
                    "string" == typeof x.x && x.x.indexOf("%") !== -1 && (u.x = 0, u.xPercent = ae(x.x, A.xPercent)), 
                    "string" == typeof x.y && x.y.indexOf("%") !== -1 && (u.y = 0, u.yPercent = ae(x.y, A.yPercent)), 
                    u.rotation = oe("rotation" in x ? x.rotation : "shortRotation" in x ? x.shortRotation + "_short" : "rotationZ" in x ? x.rotationZ : A.rotation, A.rotation, "rotation", w), 
                    Ee && (u.rotationX = oe("rotationX" in x ? x.rotationX : "shortRotationX" in x ? x.shortRotationX + "_short" : A.rotationX || 0, A.rotationX, "rotationX", w), 
                    u.rotationY = oe("rotationY" in x ? x.rotationY : "shortRotationY" in x ? x.shortRotationY + "_short" : A.rotationY || 0, A.rotationY, "rotationY", w)), 
                    u.skewX = null == x.skewX ? A.skewX : oe(x.skewX, A.skewX), u.skewY = null == x.skewY ? A.skewY : oe(x.skewY, A.skewY), 
                    (l = u.skewY - A.skewY) && (u.skewX += l, u.rotation += l);
                }
                for (Ee && null != x.force3D && (A.force3D = x.force3D, p = !0), A.skewType = x.skewType || A.skewType || o.defaultSkewType, 
                h = A.force3D || A.z || A.rotationX || A.rotationY || u.z || u.rotationX || u.rotationY || u.perspective, 
                h || null == x.scale || (u.scaleZ = 1); --T > -1; ) n = Te[T], d = u[n] - A[n], 
                (d > b || d < -b || null != x[n] || null != L[n]) && (p = !0, a = new pe(A, n, A[n], d, a), 
                n in w && (a.e = w[n]), a.xs0 = 0, a.plugin = s, i._overwriteProps.push(a.n));
                return d = x.transformOrigin, A.svg && (d || x.svgOrigin) && (g = A.xOffset, v = A.yOffset, 
                Oe(e, ie(d), u, x.svgOrigin, x.smoothOrigin), a = me(A, "xOrigin", (y ? A : u).xOrigin, u.xOrigin, a, k), 
                a = me(A, "yOrigin", (y ? A : u).yOrigin, u.yOrigin, a, k), g === A.xOffset && v === A.yOffset || (a = me(A, "xOffset", y ? g : A.xOffset, A.xOffset, a, k), 
                a = me(A, "yOffset", y ? v : A.yOffset, A.yOffset, a, k)), d = be ? null : "0px 0px"), 
                (d || Ee && h && A.zOrigin) && (xe ? (p = !0, n = ke, d = (d || K(e, n, r, !1, "50% 50%")) + "", 
                a = new pe(_, n, 0, 0, a, -1, k), a.b = _[n], a.plugin = s, Ee ? (f = A.zOrigin, 
                d = d.split(" "), A.zOrigin = (d.length > 2 && (0 === f || "0px" !== d[2]) ? parseFloat(d[2]) : f) || 0, 
                a.xs0 = a.e = d[0] + " " + (d[1] || "50%") + " 0px", a = new pe(A, "zOrigin", 0, 0, a, -1, a.n), 
                a.b = f, a.xs0 = a.e = A.zOrigin) : a.xs0 = a.e = d) : ie(d + "", A)), p && (i._transformType = A.svg && be || !h && 3 !== this._transformType ? 2 : 3), 
                a;
            },
            prefix: !0
        }), Ae("boxShadow", {
            defaultValue: "0px 0px 0px 0px #999",
            prefix: !0,
            color: !0,
            multi: !0,
            keyword: "inset"
        }), Ae("borderRadius", {
            defaultValue: "0px",
            parser: function(e, t, n, a, o, s) {
                t = this.format(t);
                var c, u, l, f, d, h, p, m, g, v, y, A, _, b, T, x, w = [ "borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius" ], k = e.style;
                for (g = parseFloat(e.offsetWidth), v = parseFloat(e.offsetHeight), c = t.split(" "), 
                u = 0; u < w.length; u++) this.p.indexOf("border") && (w[u] = U(w[u])), d = f = K(e, w[u], r, !1, "0px"), 
                d.indexOf(" ") !== -1 && (f = d.split(" "), d = f[0], f = f[1]), h = l = c[u], p = parseFloat(d), 
                A = d.substr((p + "").length), _ = "=" === h.charAt(1), _ ? (m = parseInt(h.charAt(0) + "1", 10), 
                h = h.substr(2), m *= parseFloat(h), y = h.substr((m + "").length - (m < 0 ? 1 : 0)) || "") : (m = parseFloat(h), 
                y = h.substr((m + "").length)), "" === y && (y = i[n] || A), y !== A && (b = $(e, "borderLeft", p, A), 
                T = $(e, "borderTop", p, A), "%" === y ? (d = b / g * 100 + "%", f = T / v * 100 + "%") : "em" === y ? (x = $(e, "borderLeft", 1, "em"), 
                d = b / x + "em", f = T / x + "em") : (d = b + "px", f = T + "px"), _ && (h = parseFloat(d) + m + y, 
                l = parseFloat(f) + m + y)), o = ge(k, w[u], d + " " + f, h + " " + l, !1, "0px", o);
                return o;
            },
            prefix: !0,
            formatter: fe("0px 0px 0px 0px", !1, !0)
        }), Ae("backgroundPosition", {
            defaultValue: "0 0",
            parser: function(e, t, n, i, a, o) {
                var s, c, u, l, f, d, h = "background-position", p = r || X(e, null), g = this.format((p ? m ? p.getPropertyValue(h + "-x") + " " + p.getPropertyValue(h + "-y") : p.getPropertyValue(h) : e.currentStyle.backgroundPositionX + " " + e.currentStyle.backgroundPositionY) || "0 0"), v = this.format(t);
                if (g.indexOf("%") !== -1 != (v.indexOf("%") !== -1) && (d = K(e, "backgroundImage").replace(S, ""), 
                d && "none" !== d)) {
                    for (s = g.split(" "), c = v.split(" "), R.setAttribute("src", d), u = 2; --u > -1; ) g = s[u], 
                    l = g.indexOf("%") !== -1, l !== (c[u].indexOf("%") !== -1) && (f = 0 === u ? e.offsetWidth - R.width : e.offsetHeight - R.height, 
                    s[u] = l ? parseFloat(g) / 100 * f + "px" : parseFloat(g) / f * 100 + "%");
                    g = s.join(" ");
                }
                return this.parseComplex(e.style, g, v, a, o);
            },
            formatter: ie
        }), Ae("backgroundSize", {
            defaultValue: "0 0",
            formatter: ie
        }), Ae("perspective", {
            defaultValue: "0px",
            prefix: !0
        }), Ae("perspectiveOrigin", {
            defaultValue: "50% 50%",
            prefix: !0
        }), Ae("transformStyle", {
            prefix: !0
        }), Ae("backfaceVisibility", {
            prefix: !0
        }), Ae("userSelect", {
            prefix: !0
        }), Ae("margin", {
            parser: de("marginTop,marginRight,marginBottom,marginLeft")
        }), Ae("padding", {
            parser: de("paddingTop,paddingRight,paddingBottom,paddingLeft")
        }), Ae("clip", {
            defaultValue: "rect(0px,0px,0px,0px)",
            parser: function(e, t, n, i, a, o) {
                var s, c, u;
                return m < 9 ? (c = e.currentStyle, u = m < 8 ? " " : ",", s = "rect(" + c.clipTop + u + c.clipRight + u + c.clipBottom + u + c.clipLeft + ")", 
                t = this.format(t).split(",").join(u)) : (s = this.format(K(e, this.p, r, !1, this.dflt)), 
                t = this.format(t)), this.parseComplex(e.style, s, t, a, o);
            }
        }), Ae("textShadow", {
            defaultValue: "0px 0px 0px #999",
            color: !0,
            multi: !0
        }), Ae("autoRound,strictUnits", {
            parser: function(e, t, n, i, r) {
                return r;
            }
        }), Ae("border", {
            defaultValue: "0px solid #000",
            parser: function(e, t, n, i, a, o) {
                return this.parseComplex(e.style, this.format(K(e, "borderTopWidth", r, !1, "0px") + " " + K(e, "borderTopStyle", r, !1, "solid") + " " + K(e, "borderTopColor", r, !1, "#000")), this.format(t), a, o);
            },
            color: !0,
            formatter: function(e) {
                var t = e.split(" ");
                return t[0] + " " + (t[1] || "solid") + " " + (e.match(le) || [ "#000" ])[0];
            }
        }), Ae("borderWidth", {
            parser: de("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")
        }), Ae("float,cssFloat,styleFloat", {
            parser: function(e, t, n, i, r, a) {
                var o = e.style, s = "cssFloat" in o ? "cssFloat" : "styleFloat";
                return new pe(o, s, 0, 0, r, -1, n, !1, 0, o[s], t);
            }
        });
        var Re = function(e) {
            var t, n = this.t, i = n.filter || K(this.data, "filter") || "", r = this.s + this.c * e | 0;
            100 === r && (i.indexOf("atrix(") === -1 && i.indexOf("radient(") === -1 && i.indexOf("oader(") === -1 ? (n.removeAttribute("filter"), 
            t = !K(this.data, "filter")) : (n.filter = i.replace(x, ""), t = !0)), t || (this.xn1 && (n.filter = i = i || "alpha(opacity=" + r + ")"), 
            i.indexOf("pacity") === -1 ? 0 === r && this.xn1 || (n.filter = i + " alpha(opacity=" + r + ")") : n.filter = i.replace(b, "opacity=" + r));
        };
        Ae("opacity,alpha,autoAlpha", {
            defaultValue: "1",
            parser: function(e, t, n, i, a, o) {
                var s = parseFloat(K(e, "opacity", r, !1, "1")), c = e.style, u = "autoAlpha" === n;
                return "string" == typeof t && "=" === t.charAt(1) && (t = ("-" === t.charAt(0) ? -1 : 1) * parseFloat(t.substr(2)) + s), 
                u && 1 === s && "hidden" === K(e, "visibility", r) && 0 !== t && (s = 0), q ? a = new pe(c, "opacity", s, t - s, a) : (a = new pe(c, "opacity", 100 * s, 100 * (t - s), a), 
                a.xn1 = u ? 1 : 0, c.zoom = 1, a.type = 2, a.b = "alpha(opacity=" + a.s + ")", a.e = "alpha(opacity=" + (a.s + a.c) + ")", 
                a.data = e, a.plugin = o, a.setRatio = Re), u && (a = new pe(c, "visibility", 0, 0, a, -1, null, !1, 0, 0 !== s ? "inherit" : "hidden", 0 === t ? "hidden" : "inherit"), 
                a.xs0 = "inherit", i._overwriteProps.push(a.n), i._overwriteProps.push(n)), a;
            }
        });
        var Fe = function(e, t) {
            t && (e.removeProperty ? ("ms" !== t.substr(0, 2) && "webkit" !== t.substr(0, 6) || (t = "-" + t), 
            e.removeProperty(t.replace(k, "-$1").toLowerCase())) : e.removeAttribute(t));
        }, Ye = function(e) {
            if (this.t._gsClassPT = this, 1 === e || 0 === e) {
                this.t.setAttribute("class", 0 === e ? this.b : this.e);
                for (var t = this.data, n = this.t.style; t; ) t.v ? n[t.p] = t.v : Fe(n, t.p), 
                t = t._next;
                1 === e && this.t._gsClassPT === this && (this.t._gsClassPT = null);
            } else this.t.getAttribute("class") !== this.e && this.t.setAttribute("class", this.e);
        };
        Ae("className", {
            parser: function(e, t, i, a, o, s, c) {
                var u, l, f, d, h, p = e.getAttribute("class") || "", m = e.style.cssText;
                if (o = a._classNamePT = new pe(e, i, 0, 0, o, 2), o.setRatio = Ye, o.pr = -11, 
                n = !0, o.b = p, l = Z(e, r), f = e._gsClassPT) {
                    for (d = {}, h = f.data; h; ) d[h.p] = 1, h = h._next;
                    f.setRatio(1);
                }
                return e._gsClassPT = o, o.e = "=" !== t.charAt(1) ? t : p.replace(new RegExp("\\s*\\b" + t.substr(2) + "\\b"), "") + ("+" === t.charAt(0) ? " " + t.substr(2) : ""), 
                e.setAttribute("class", o.e), u = J(e, l, Z(e), c, d), e.setAttribute("class", p), 
                o.data = u.firstMPT, e.style.cssText = m, o = o.xfirst = a.parse(e, u.difs, o, s);
            }
        });
        var qe = function(e) {
            if ((1 === e || 0 === e) && this.data._totalTime === this.data._totalDuration && "isFromStart" !== this.data.data) {
                var t, n, i, r, a, o = this.t.style, s = c.transform.parse;
                if ("all" === this.e) o.cssText = "", r = !0; else for (t = this.e.split(" ").join("").split(","), 
                i = t.length; --i > -1; ) n = t[i], c[n] && (c[n].parse === s ? r = !0 : n = "transformOrigin" === n ? ke : c[n].p), 
                Fe(o, n);
                r && (Fe(o, xe), a = this.t._gsTransform, a && (a.svg && this.t.removeAttribute("data-svg-origin"), 
                delete this.t._gsTransform));
            }
        };
        for (Ae("clearProps", {
            parser: function(e, t, i, r, a) {
                return a = new pe(e, i, 0, 0, a, 2), a.setRatio = qe, a.e = t, a.pr = -10, a.data = r._tween, 
                n = !0, a;
            }
        }), u = "bezier,throwProps,physicsProps,physics2D".split(","), ve = u.length; ve--; ) _e(u[ve]);
        u = o.prototype, u._firstPT = u._lastParsedTransform = u._transform = null, u._onInitTween = function(e, t, s) {
            if (!e.nodeType) return !1;
            this._target = e, this._tween = s, this._vars = t, l = t.autoRound, n = !1, i = t.suffixMap || o.suffixMap, 
            r = X(e, ""), a = this._overwriteProps;
            var u, h, m, g, v, y, A, _, b, x = e.style;
            if (f && "" === x.zIndex && (u = K(e, "zIndex", r), "auto" !== u && "" !== u || this._addLazySet(x, "zIndex", 0)), 
            "string" == typeof t && (g = x.cssText, u = Z(e, r), x.cssText = g + ";" + t, u = J(e, u, Z(e)).difs, 
            !q && T.test(t) && (u.opacity = parseFloat(RegExp.$1)), t = u, x.cssText = g), t.className ? this._firstPT = h = c.className.parse(e, t.className, "className", this, null, null, t) : this._firstPT = h = this.parse(e, t, null), 
            this._transformType) {
                for (b = 3 === this._transformType, xe ? d && (f = !0, "" === x.zIndex && (A = K(e, "zIndex", r), 
                "auto" !== A && "" !== A || this._addLazySet(x, "zIndex", 0)), p && this._addLazySet(x, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (b ? "visible" : "hidden"))) : x.zoom = 1, 
                m = h; m && m._next; ) m = m._next;
                _ = new pe(e, "transform", 0, 0, null, 2), this._linkCSSP(_, null, m), _.setRatio = xe ? Be : je, 
                _.data = this._transform || Ie(e, r, !0), _.tween = s, _.pr = -1, a.pop();
            }
            if (n) {
                for (;h; ) {
                    for (y = h._next, m = g; m && m.pr > h.pr; ) m = m._next;
                    (h._prev = m ? m._prev : v) ? h._prev._next = h : g = h, (h._next = m) ? m._prev = h : v = h, 
                    h = y;
                }
                this._firstPT = g;
            }
            return !0;
        }, u.parse = function(e, t, n, a) {
            var o, s, u, f, d, h, p, m, g, v, y = e.style;
            for (o in t) h = t[o], s = c[o], s ? n = s.parse(e, h, o, this, n, a, t) : (d = K(e, o, r) + "", 
            g = "string" == typeof h, "color" === o || "fill" === o || "stroke" === o || o.indexOf("Color") !== -1 || g && w.test(h) ? (g || (h = ue(h), 
            h = (h.length > 3 ? "rgba(" : "rgb(") + h.join(",") + ")"), n = ge(y, o, d, h, !0, "transparent", n, 0, a)) : !g || h.indexOf(" ") === -1 && h.indexOf(",") === -1 ? (u = parseFloat(d), 
            p = u || 0 === u ? d.substr((u + "").length) : "", "" !== d && "auto" !== d || ("width" === o || "height" === o ? (u = ne(e, o, r), 
            p = "px") : "left" === o || "top" === o ? (u = Q(e, o, r), p = "px") : (u = "opacity" !== o ? 0 : 1, 
            p = "")), v = g && "=" === h.charAt(1), v ? (f = parseInt(h.charAt(0) + "1", 10), 
            h = h.substr(2), f *= parseFloat(h), m = h.replace(_, "")) : (f = parseFloat(h), 
            m = g ? h.replace(_, "") : ""), "" === m && (m = o in i ? i[o] : p), h = f || 0 === f ? (v ? f + u : f) + m : t[o], 
            p !== m && "" !== m && (f || 0 === f) && u && (u = $(e, o, u, p), "%" === m ? (u /= $(e, o, 100, "%") / 100, 
            t.strictUnits !== !0 && (d = u + "%")) : "em" === m ? u /= $(e, o, 1, "em") : "px" !== m && (f = $(e, o, f, m), 
            m = "px"), v && (f || 0 === f) && (h = f + u + m)), v && (f += u), !u && 0 !== u || !f && 0 !== f ? void 0 !== y[o] && (h || h + "" != "NaN" && null != h) ? (n = new pe(y, o, f || u || 0, 0, n, -1, o, !1, 0, d, h), 
            n.xs0 = "none" !== h || "display" !== o && o.indexOf("Style") === -1 ? h : d) : H("invalid " + o + " tween value: " + t[o]) : (n = new pe(y, o, u, f - u, n, 0, o, l !== !1 && ("px" === m || "zIndex" === o), 0, d, h), 
            n.xs0 = m)) : n = ge(y, o, d, h, !0, null, n, 0, a)), a && n && !n.plugin && (n.plugin = a);
            return n;
        }, u.setRatio = function(e) {
            var t, n, i, r = this._firstPT, a = 1e-6;
            if (1 !== e || this._tween._time !== this._tween._duration && 0 !== this._tween._time) if (e || this._tween._time !== this._tween._duration && 0 !== this._tween._time || this._tween._rawPrevTime === -1e-6) for (;r; ) {
                if (t = r.c * e + r.s, r.r ? t = Math.round(t) : t < a && t > -a && (t = 0), r.type) if (1 === r.type) if (i = r.l, 
                2 === i) r.t[r.p] = r.xs0 + t + r.xs1 + r.xn1 + r.xs2; else if (3 === i) r.t[r.p] = r.xs0 + t + r.xs1 + r.xn1 + r.xs2 + r.xn2 + r.xs3; else if (4 === i) r.t[r.p] = r.xs0 + t + r.xs1 + r.xn1 + r.xs2 + r.xn2 + r.xs3 + r.xn3 + r.xs4; else if (5 === i) r.t[r.p] = r.xs0 + t + r.xs1 + r.xn1 + r.xs2 + r.xn2 + r.xs3 + r.xn3 + r.xs4 + r.xn4 + r.xs5; else {
                    for (n = r.xs0 + t + r.xs1, i = 1; i < r.l; i++) n += r["xn" + i] + r["xs" + (i + 1)];
                    r.t[r.p] = n;
                } else r.type === -1 ? r.t[r.p] = r.xs0 : r.setRatio && r.setRatio(e); else r.t[r.p] = t + r.xs0;
                r = r._next;
            } else for (;r; ) 2 !== r.type ? r.t[r.p] = r.b : r.setRatio(e), r = r._next; else for (;r; ) {
                if (2 !== r.type) if (r.r && r.type !== -1) if (t = Math.round(r.s + r.c), r.type) {
                    if (1 === r.type) {
                        for (i = r.l, n = r.xs0 + t + r.xs1, i = 1; i < r.l; i++) n += r["xn" + i] + r["xs" + (i + 1)];
                        r.t[r.p] = n;
                    }
                } else r.t[r.p] = t + r.xs0; else r.t[r.p] = r.e; else r.setRatio(e);
                r = r._next;
            }
        }, u._enableTransforms = function(e) {
            this._transform = this._transform || Ie(this._target, r, !0), this._transformType = this._transform.svg && be || !e && 3 !== this._transformType ? 2 : 3;
        };
        var We = function(e) {
            this.t[this.p] = this.e, this.data._linkCSSP(this, this._next, null, !0);
        };
        u._addLazySet = function(e, t, n) {
            var i = this._firstPT = new pe(e, t, 0, 0, this._firstPT, 2);
            i.e = n, i.setRatio = We, i.data = this;
        }, u._linkCSSP = function(e, t, n, i) {
            return e && (t && (t._prev = e), e._next && (e._next._prev = e._prev), e._prev ? e._prev._next = e._next : this._firstPT === e && (this._firstPT = e._next, 
            i = !0), n ? n._next = e : i || null !== this._firstPT || (this._firstPT = e), e._next = t, 
            e._prev = n), e;
        }, u._kill = function(t) {
            var n, i, r, a = t;
            if (t.autoAlpha || t.alpha) {
                a = {};
                for (i in t) a[i] = t[i];
                a.opacity = 1, a.autoAlpha && (a.visibility = 1);
            }
            return t.className && (n = this._classNamePT) && (r = n.xfirst, r && r._prev ? this._linkCSSP(r._prev, n._next, r._prev._prev) : r === this._firstPT && (this._firstPT = n._next), 
            n._next && this._linkCSSP(n._next, n._next._next, r._prev), this._classNamePT = null), 
            e.prototype._kill.call(this, a);
        };
        var He = function(e, t, n) {
            var i, r, a, o;
            if (e.slice) for (r = e.length; --r > -1; ) He(e[r], t, n); else for (i = e.childNodes, 
            r = i.length; --r > -1; ) a = i[r], o = a.type, a.style && (t.push(Z(a)), n && n.push(a)), 
            1 !== o && 9 !== o && 11 !== o || !a.childNodes.length || He(a, t, n);
        };
        return o.cascadeTo = function(e, n, i) {
            var r, a, o, s, c = t.to(e, n, i), u = [ c ], l = [], f = [], d = [], h = t._internals.reservedProps;
            for (e = c._targets || c.target, He(e, l, d), c.render(n, !0, !0), He(e, f), c.render(0, !0, !0), 
            c._enabled(!0), r = d.length; --r > -1; ) if (a = J(d[r], l[r], f[r]), a.firstMPT) {
                a = a.difs;
                for (o in i) h[o] && (a[o] = i[o]);
                s = {};
                for (o in a) s[o] = l[r][o];
                u.push(t.fromTo(d[r], n, s, a));
            }
            return u;
        }, e.activate([ o ]), o;
    }, !0);
}), _gsScope._gsDefine && _gsScope._gsQueue.pop()(), function(e) {
    "use strict";
    var t = function() {
        return (_gsScope.GreenSockGlobals || _gsScope)[e];
    };
    "function" == typeof define && define.amd ? define([ "TweenLite" ], t) : "undefined" != typeof module && module.exports && (require("../TweenLite.js"), 
    module.exports = t());
}("CSSPlugin");

var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;

(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function() {
    "use strict";
    _gsScope._gsDefine.plugin({
        propName: "directionalRotation",
        version: "0.2.1",
        API: 2,
        init: function(e, t, n) {
            "object" != typeof t && (t = {
                rotation: t
            }), this.finals = {};
            var i, r, a, o, s, c, u = t.useRadians === !0 ? 2 * Math.PI : 360, l = 1e-6;
            for (i in t) "useRadians" !== i && (c = (t[i] + "").split("_"), r = c[0], a = parseFloat("function" != typeof e[i] ? e[i] : e[i.indexOf("set") || "function" != typeof e["get" + i.substr(3)] ? i : "get" + i.substr(3)]()), 
            o = this.finals[i] = "string" == typeof r && "=" === r.charAt(1) ? a + parseInt(r.charAt(0) + "1", 10) * Number(r.substr(2)) : Number(r) || 0, 
            s = o - a, c.length && (r = c.join("_"), r.indexOf("short") !== -1 && (s %= u, s !== s % (u / 2) && (s = s < 0 ? s + u : s - u)), 
            r.indexOf("_cw") !== -1 && s < 0 ? s = (s + 9999999999 * u) % u - (s / u | 0) * u : r.indexOf("ccw") !== -1 && s > 0 && (s = (s - 9999999999 * u) % u - (s / u | 0) * u)), 
            (s > l || s < -l) && (this._addTween(e, i, a, a + s, i), this._overwriteProps.push(i)));
            return !0;
        },
        set: function(e) {
            var t;
            if (1 !== e) this._super.setRatio.call(this, e); else for (t = this._firstPT; t; ) t.f ? t.t[t.p](this.finals[t.p]) : t.t[t.p] = this.finals[t.p], 
            t = t._next;
        }
    })._autoCSS = !0;
}), _gsScope._gsDefine && _gsScope._gsQueue.pop()(), function(e, t) {
    "use strict";
    var n = e.GreenSockGlobals = e.GreenSockGlobals || e;
    if (!n.TweenLite) {
        var i, r, a, o, s, c = function(e) {
            var t, i = e.split("."), r = n;
            for (t = 0; t < i.length; t++) r[i[t]] = r = r[i[t]] || {};
            return r;
        }, u = c("com.greensock"), l = 1e-10, f = function(e) {
            var t, n = [], i = e.length;
            for (t = 0; t !== i; n.push(e[t++])) ;
            return n;
        }, d = function() {}, h = function() {
            var e = Object.prototype.toString, t = e.call([]);
            return function(n) {
                return null != n && (n instanceof Array || "object" == typeof n && !!n.push && e.call(n) === t);
            };
        }(), p = {}, m = function(i, r, a, o) {
            this.sc = p[i] ? p[i].sc : [], p[i] = this, this.gsClass = null, this.func = a;
            var s = [];
            this.check = function(u) {
                for (var l, f, d, h, g = r.length, v = g; --g > -1; ) (l = p[r[g]] || new m(r[g], [])).gsClass ? (s[g] = l.gsClass, 
                v--) : u && l.sc.push(this);
                if (0 === v && a) for (f = ("com.greensock." + i).split("."), d = f.pop(), h = c(f.join("."))[d] = this.gsClass = a.apply(a, s), 
                o && (n[d] = h, "function" == typeof define && define.amd ? define((e.GreenSockAMDPath ? e.GreenSockAMDPath + "/" : "") + i.split(".").pop(), [], function() {
                    return h;
                }) : i === t && "undefined" != typeof module && module.exports && (module.exports = h)), 
                g = 0; g < this.sc.length; g++) this.sc[g].check();
            }, this.check(!0);
        }, g = e._gsDefine = function(e, t, n, i) {
            return new m(e, t, n, i);
        }, v = u._class = function(e, t, n) {
            return t = t || function() {}, g(e, [], function() {
                return t;
            }, n), t;
        };
        g.globals = n;
        var y = [ 0, 0, 1, 1 ], A = [], _ = v("easing.Ease", function(e, t, n, i) {
            this._func = e, this._type = n || 0, this._power = i || 0, this._params = t ? y.concat(t) : y;
        }, !0), b = _.map = {}, T = _.register = function(e, t, n, i) {
            for (var r, a, o, s, c = t.split(","), l = c.length, f = (n || "easeIn,easeOut,easeInOut").split(","); --l > -1; ) for (a = c[l], 
            r = i ? v("easing." + a, null, !0) : u.easing[a] || {}, o = f.length; --o > -1; ) s = f[o], 
            b[a + "." + s] = b[s + a] = r[s] = e.getRatio ? e : e[s] || new e();
        };
        for (a = _.prototype, a._calcEnd = !1, a.getRatio = function(e) {
            if (this._func) return this._params[0] = e, this._func.apply(null, this._params);
            var t = this._type, n = this._power, i = 1 === t ? 1 - e : 2 === t ? e : e < .5 ? 2 * e : 2 * (1 - e);
            return 1 === n ? i *= i : 2 === n ? i *= i * i : 3 === n ? i *= i * i * i : 4 === n && (i *= i * i * i * i), 
            1 === t ? 1 - i : 2 === t ? i : e < .5 ? i / 2 : 1 - i / 2;
        }, i = [ "Linear", "Quad", "Cubic", "Quart", "Quint,Strong" ], r = i.length; --r > -1; ) a = i[r] + ",Power" + r, 
        T(new _(null, null, 1, r), a, "easeOut", !0), T(new _(null, null, 2, r), a, "easeIn" + (0 === r ? ",easeNone" : "")), 
        T(new _(null, null, 3, r), a, "easeInOut");
        b.linear = u.easing.Linear.easeIn, b.swing = u.easing.Quad.easeInOut;
        var x = v("events.EventDispatcher", function(e) {
            this._listeners = {}, this._eventTarget = e || this;
        });
        a = x.prototype, a.addEventListener = function(e, t, n, i, r) {
            r = r || 0;
            var a, c, u = this._listeners[e], l = 0;
            for (null == u && (this._listeners[e] = u = []), c = u.length; --c > -1; ) a = u[c], 
            a.c === t && a.s === n ? u.splice(c, 1) : 0 === l && a.pr < r && (l = c + 1);
            u.splice(l, 0, {
                c: t,
                s: n,
                up: i,
                pr: r
            }), this !== o || s || o.wake();
        }, a.removeEventListener = function(e, t) {
            var n, i = this._listeners[e];
            if (i) for (n = i.length; --n > -1; ) if (i[n].c === t) return void i.splice(n, 1);
        }, a.dispatchEvent = function(e) {
            var t, n, i, r = this._listeners[e];
            if (r) for (t = r.length, n = this._eventTarget; --t > -1; ) i = r[t], i && (i.up ? i.c.call(i.s || n, {
                type: e,
                target: n
            }) : i.c.call(i.s || n));
        };
        var w = e.requestAnimationFrame, k = e.cancelAnimationFrame, E = Date.now || function() {
            return new Date().getTime();
        }, S = E();
        for (i = [ "ms", "moz", "webkit", "o" ], r = i.length; --r > -1 && !w; ) w = e[i[r] + "RequestAnimationFrame"], 
        k = e[i[r] + "CancelAnimationFrame"] || e[i[r] + "CancelRequestAnimationFrame"];
        v("Ticker", function(e, t) {
            var n, i, r, a, c, u = this, f = E(), h = t !== !1 && w, p = 500, m = 33, g = "tick", v = function(e) {
                var t, o, s = E() - S;
                s > p && (f += s - m), S += s, u.time = (S - f) / 1e3, t = u.time - c, (!n || t > 0 || e === !0) && (u.frame++, 
                c += t + (t >= a ? .004 : a - t), o = !0), e !== !0 && (r = i(v)), o && u.dispatchEvent(g);
            };
            x.call(u), u.time = u.frame = 0, u.tick = function() {
                v(!0);
            }, u.lagSmoothing = function(e, t) {
                p = e || 1 / l, m = Math.min(t, p, 0);
            }, u.sleep = function() {
                null != r && (h && k ? k(r) : clearTimeout(r), i = d, r = null, u === o && (s = !1));
            }, u.wake = function() {
                null !== r ? u.sleep() : u.frame > 10 && (S = E() - p + 5), i = 0 === n ? d : h && w ? w : function(e) {
                    return setTimeout(e, 1e3 * (c - u.time) + 1 | 0);
                }, u === o && (s = !0), v(2);
            }, u.fps = function(e) {
                return arguments.length ? (n = e, a = 1 / (n || 60), c = this.time + a, void u.wake()) : n;
            }, u.useRAF = function(e) {
                return arguments.length ? (u.sleep(), h = e, void u.fps(n)) : h;
            }, u.fps(e), setTimeout(function() {
                h && u.frame < 5 && u.useRAF(!1);
            }, 1500);
        }), a = u.Ticker.prototype = new u.events.EventDispatcher(), a.constructor = u.Ticker;
        var M = v("core.Animation", function(e, t) {
            if (this.vars = t = t || {}, this._duration = this._totalDuration = e || 0, this._delay = Number(t.delay) || 0, 
            this._timeScale = 1, this._active = t.immediateRender === !0, this.data = t.data, 
            this._reversed = t.reversed === !0, W) {
                s || o.wake();
                var n = this.vars.useFrames ? q : W;
                n.add(this, n._time), this.vars.paused && this.paused(!0);
            }
        });
        o = M.ticker = new u.Ticker(), a = M.prototype, a._dirty = a._gc = a._initted = a._paused = !1, 
        a._totalTime = a._time = 0, a._rawPrevTime = -1, a._next = a._last = a._onUpdate = a._timeline = a.timeline = null, 
        a._paused = !1;
        var C = function() {
            s && E() - S > 2e3 && o.wake(), setTimeout(C, 2e3);
        };
        C(), a.play = function(e, t) {
            return null != e && this.seek(e, t), this.reversed(!1).paused(!1);
        }, a.pause = function(e, t) {
            return null != e && this.seek(e, t), this.paused(!0);
        }, a.resume = function(e, t) {
            return null != e && this.seek(e, t), this.paused(!1);
        }, a.seek = function(e, t) {
            return this.totalTime(Number(e), t !== !1);
        }, a.restart = function(e, t) {
            return this.reversed(!1).paused(!1).totalTime(e ? -this._delay : 0, t !== !1, !0);
        }, a.reverse = function(e, t) {
            return null != e && this.seek(e || this.totalDuration(), t), this.reversed(!0).paused(!1);
        }, a.render = function(e, t, n) {}, a.invalidate = function() {
            return this._time = this._totalTime = 0, this._initted = this._gc = !1, this._rawPrevTime = -1, 
            !this._gc && this.timeline || this._enabled(!0), this;
        }, a.isActive = function() {
            var e, t = this._timeline, n = this._startTime;
            return !t || !this._gc && !this._paused && t.isActive() && (e = t.rawTime()) >= n && e < n + this.totalDuration() / this._timeScale;
        }, a._enabled = function(e, t) {
            return s || o.wake(), this._gc = !e, this._active = this.isActive(), t !== !0 && (e && !this.timeline ? this._timeline.add(this, this._startTime - this._delay) : !e && this.timeline && this._timeline._remove(this, !0)), 
            !1;
        }, a._kill = function(e, t) {
            return this._enabled(!1, !1);
        }, a.kill = function(e, t) {
            return this._kill(e, t), this;
        }, a._uncache = function(e) {
            for (var t = e ? this : this.timeline; t; ) t._dirty = !0, t = t.timeline;
            return this;
        }, a._swapSelfInParams = function(e) {
            for (var t = e.length, n = e.concat(); --t > -1; ) "{self}" === e[t] && (n[t] = this);
            return n;
        }, a._callback = function(e) {
            var t = this.vars;
            t[e].apply(t[e + "Scope"] || t.callbackScope || this, t[e + "Params"] || A);
        }, a.eventCallback = function(e, t, n, i) {
            if ("on" === (e || "").substr(0, 2)) {
                var r = this.vars;
                if (1 === arguments.length) return r[e];
                null == t ? delete r[e] : (r[e] = t, r[e + "Params"] = h(n) && n.join("").indexOf("{self}") !== -1 ? this._swapSelfInParams(n) : n, 
                r[e + "Scope"] = i), "onUpdate" === e && (this._onUpdate = t);
            }
            return this;
        }, a.delay = function(e) {
            return arguments.length ? (this._timeline.smoothChildTiming && this.startTime(this._startTime + e - this._delay), 
            this._delay = e, this) : this._delay;
        }, a.duration = function(e) {
            return arguments.length ? (this._duration = this._totalDuration = e, this._uncache(!0), 
            this._timeline.smoothChildTiming && this._time > 0 && this._time < this._duration && 0 !== e && this.totalTime(this._totalTime * (e / this._duration), !0), 
            this) : (this._dirty = !1, this._duration);
        }, a.totalDuration = function(e) {
            return this._dirty = !1, arguments.length ? this.duration(e) : this._totalDuration;
        }, a.time = function(e, t) {
            return arguments.length ? (this._dirty && this.totalDuration(), this.totalTime(e > this._duration ? this._duration : e, t)) : this._time;
        }, a.totalTime = function(e, t, n) {
            if (s || o.wake(), !arguments.length) return this._totalTime;
            if (this._timeline) {
                if (e < 0 && !n && (e += this.totalDuration()), this._timeline.smoothChildTiming) {
                    this._dirty && this.totalDuration();
                    var i = this._totalDuration, r = this._timeline;
                    if (e > i && !n && (e = i), this._startTime = (this._paused ? this._pauseTime : r._time) - (this._reversed ? i - e : e) / this._timeScale, 
                    r._dirty || this._uncache(!1), r._timeline) for (;r._timeline; ) r._timeline._time !== (r._startTime + r._totalTime) / r._timeScale && r.totalTime(r._totalTime, !0), 
                    r = r._timeline;
                }
                this._gc && this._enabled(!0, !1), this._totalTime === e && 0 !== this._duration || (this.render(e, t, !1), 
                z.length && V());
            }
            return this;
        }, a.progress = a.totalProgress = function(e, t) {
            return arguments.length ? this.totalTime(this.duration() * e, t) : this._time / this.duration();
        }, a.startTime = function(e) {
            return arguments.length ? (e !== this._startTime && (this._startTime = e, this.timeline && this.timeline._sortChildren && this.timeline.add(this, e - this._delay)), 
            this) : this._startTime;
        }, a.endTime = function(e) {
            return this._startTime + (0 != e ? this.totalDuration() : this.duration()) / this._timeScale;
        }, a.timeScale = function(e) {
            if (!arguments.length) return this._timeScale;
            if (e = e || l, this._timeline && this._timeline.smoothChildTiming) {
                var t = this._pauseTime, n = t || 0 === t ? t : this._timeline.totalTime();
                this._startTime = n - (n - this._startTime) * this._timeScale / e;
            }
            return this._timeScale = e, this._uncache(!1);
        }, a.reversed = function(e) {
            return arguments.length ? (e != this._reversed && (this._reversed = e, this.totalTime(this._timeline && !this._timeline.smoothChildTiming ? this.totalDuration() - this._totalTime : this._totalTime, !0)), 
            this) : this._reversed;
        }, a.paused = function(e) {
            if (!arguments.length) return this._paused;
            var t, n, i = this._timeline;
            return e != this._paused && i && (s || e || o.wake(), t = i.rawTime(), n = t - this._pauseTime, 
            !e && i.smoothChildTiming && (this._startTime += n, this._uncache(!1)), this._pauseTime = e ? t : null, 
            this._paused = e, this._active = this.isActive(), !e && 0 !== n && this._initted && this.duration() && this.render(i.smoothChildTiming ? this._totalTime : (t - this._startTime) / this._timeScale, !0, !0)), 
            this._gc && !e && this._enabled(!0, !1), this;
        };
        var P = v("core.SimpleTimeline", function(e) {
            M.call(this, 0, e), this.autoRemoveChildren = this.smoothChildTiming = !0;
        });
        a = P.prototype = new M(), a.constructor = P, a.kill()._gc = !1, a._first = a._last = a._recent = null, 
        a._sortChildren = !1, a.add = a.insert = function(e, t, n, i) {
            var r, a;
            if (e._startTime = Number(t || 0) + e._delay, e._paused && this !== e._timeline && (e._pauseTime = e._startTime + (this.rawTime() - e._startTime) / e._timeScale), 
            e.timeline && e.timeline._remove(e, !0), e.timeline = e._timeline = this, e._gc && e._enabled(!0, !0), 
            r = this._last, this._sortChildren) for (a = e._startTime; r && r._startTime > a; ) r = r._prev;
            return r ? (e._next = r._next, r._next = e) : (e._next = this._first, this._first = e), 
            e._next ? e._next._prev = e : this._last = e, e._prev = r, this._recent = e, this._timeline && this._uncache(!0), 
            this;
        }, a._remove = function(e, t) {
            return e.timeline === this && (t || e._enabled(!1, !0), e._prev ? e._prev._next = e._next : this._first === e && (this._first = e._next), 
            e._next ? e._next._prev = e._prev : this._last === e && (this._last = e._prev), 
            e._next = e._prev = e.timeline = null, e === this._recent && (this._recent = this._last), 
            this._timeline && this._uncache(!0)), this;
        }, a.render = function(e, t, n) {
            var i, r = this._first;
            for (this._totalTime = this._time = this._rawPrevTime = e; r; ) i = r._next, (r._active || e >= r._startTime && !r._paused) && (r._reversed ? r.render((r._dirty ? r.totalDuration() : r._totalDuration) - (e - r._startTime) * r._timeScale, t, n) : r.render((e - r._startTime) * r._timeScale, t, n)), 
            r = i;
        }, a.rawTime = function() {
            return s || o.wake(), this._totalTime;
        };
        var D = v("TweenLite", function(t, n, i) {
            if (M.call(this, n, i), this.render = D.prototype.render, null == t) throw "Cannot tween a null target.";
            this.target = t = "string" != typeof t ? t : D.selector(t) || t;
            var r, a, o, s = t.jquery || t.length && t !== e && t[0] && (t[0] === e || t[0].nodeType && t[0].style && !t.nodeType), c = this.vars.overwrite;
            if (this._overwrite = c = null == c ? Y[D.defaultOverwrite] : "number" == typeof c ? c >> 0 : Y[c], 
            (s || t instanceof Array || t.push && h(t)) && "number" != typeof t[0]) for (this._targets = o = f(t), 
            this._propLookup = [], this._siblings = [], r = 0; r < o.length; r++) a = o[r], 
            a ? "string" != typeof a ? a.length && a !== e && a[0] && (a[0] === e || a[0].nodeType && a[0].style && !a.nodeType) ? (o.splice(r--, 1), 
            this._targets = o = o.concat(f(a))) : (this._siblings[r] = G(a, this, !1), 1 === c && this._siblings[r].length > 1 && X(a, this, null, 1, this._siblings[r])) : (a = o[r--] = D.selector(a), 
            "string" == typeof a && o.splice(r + 1, 1)) : o.splice(r--, 1); else this._propLookup = {}, 
            this._siblings = G(t, this, !1), 1 === c && this._siblings.length > 1 && X(t, this, null, 1, this._siblings);
            (this.vars.immediateRender || 0 === n && 0 === this._delay && this.vars.immediateRender !== !1) && (this._time = -l, 
            this.render(-this._delay));
        }, !0), O = function(t) {
            return t && t.length && t !== e && t[0] && (t[0] === e || t[0].nodeType && t[0].style && !t.nodeType);
        }, N = function(e, t) {
            var n, i = {};
            for (n in e) F[n] || n in t && "transform" !== n && "x" !== n && "y" !== n && "width" !== n && "height" !== n && "className" !== n && "border" !== n || !(!j[n] || j[n] && j[n]._autoCSS) || (i[n] = e[n], 
            delete e[n]);
            e.css = i;
        };
        a = D.prototype = new M(), a.constructor = D, a.kill()._gc = !1, a.ratio = 0, a._firstPT = a._targets = a._overwrittenProps = a._startAt = null, 
        a._notifyPluginsOfEnabled = a._lazy = !1, D.version = "1.17.0", D.defaultEase = a._ease = new _(null, null, 1, 1), 
        D.defaultOverwrite = "auto", D.ticker = o, D.autoSleep = 120, D.lagSmoothing = function(e, t) {
            o.lagSmoothing(e, t);
        }, D.selector = e.$ || e.jQuery || function(t) {
            var n = e.$ || e.jQuery;
            return n ? (D.selector = n, n(t)) : "undefined" == typeof document ? t : document.querySelectorAll ? document.querySelectorAll(t) : document.getElementById("#" === t.charAt(0) ? t.substr(1) : t);
        };
        var z = [], L = {}, I = D._internals = {
            isArray: h,
            isSelector: O,
            lazyTweens: z
        }, j = D._plugins = {}, B = I.tweenLookup = {}, R = 0, F = I.reservedProps = {
            ease: 1,
            delay: 1,
            overwrite: 1,
            onComplete: 1,
            onCompleteParams: 1,
            onCompleteScope: 1,
            useFrames: 1,
            runBackwards: 1,
            startAt: 1,
            onUpdate: 1,
            onUpdateParams: 1,
            onUpdateScope: 1,
            onStart: 1,
            onStartParams: 1,
            onStartScope: 1,
            onReverseComplete: 1,
            onReverseCompleteParams: 1,
            onReverseCompleteScope: 1,
            onRepeat: 1,
            onRepeatParams: 1,
            onRepeatScope: 1,
            easeParams: 1,
            yoyo: 1,
            immediateRender: 1,
            repeat: 1,
            repeatDelay: 1,
            data: 1,
            paused: 1,
            reversed: 1,
            autoCSS: 1,
            lazy: 1,
            onOverwrite: 1,
            callbackScope: 1
        }, Y = {
            none: 0,
            all: 1,
            auto: 2,
            concurrent: 3,
            allOnStart: 4,
            preexisting: 5,
            "true": 1,
            "false": 0
        }, q = M._rootFramesTimeline = new P(), W = M._rootTimeline = new P(), H = 30, V = I.lazyRender = function() {
            var e, t = z.length;
            for (L = {}; --t > -1; ) e = z[t], e && e._lazy !== !1 && (e.render(e._lazy[0], e._lazy[1], !0), 
            e._lazy = !1);
            z.length = 0;
        };
        W._startTime = o.time, q._startTime = o.frame, W._active = q._active = !0, setTimeout(V, 1), 
        M._updateRoot = D.render = function() {
            var e, t, n;
            if (z.length && V(), W.render((o.time - W._startTime) * W._timeScale, !1, !1), q.render((o.frame - q._startTime) * q._timeScale, !1, !1), 
            z.length && V(), o.frame >= H) {
                H = o.frame + (parseInt(D.autoSleep, 10) || 120);
                for (n in B) {
                    for (t = B[n].tweens, e = t.length; --e > -1; ) t[e]._gc && t.splice(e, 1);
                    0 === t.length && delete B[n];
                }
                if (n = W._first, (!n || n._paused) && D.autoSleep && !q._first && 1 === o._listeners.tick.length) {
                    for (;n && n._paused; ) n = n._next;
                    n || o.sleep();
                }
            }
        }, o.addEventListener("tick", M._updateRoot);
        var G = function(e, t, n) {
            var i, r, a = e._gsTweenID;
            if (B[a || (e._gsTweenID = a = "t" + R++)] || (B[a] = {
                target: e,
                tweens: []
            }), t && (i = B[a].tweens, i[r = i.length] = t, n)) for (;--r > -1; ) i[r] === t && i.splice(r, 1);
            return B[a].tweens;
        }, U = function(e, t, n, i) {
            var r, a, o = e.vars.onOverwrite;
            return o && (r = o(e, t, n, i)), o = D.onOverwrite, o && (a = o(e, t, n, i)), r !== !1 && a !== !1;
        }, X = function(e, t, n, i, r) {
            var a, o, s, c;
            if (1 === i || i >= 4) {
                for (c = r.length, a = 0; a < c; a++) if ((s = r[a]) !== t) s._gc || s._kill(null, e, t) && (o = !0); else if (5 === i) break;
                return o;
            }
            var u, f = t._startTime + l, d = [], h = 0, p = 0 === t._duration;
            for (a = r.length; --a > -1; ) (s = r[a]) === t || s._gc || s._paused || (s._timeline !== t._timeline ? (u = u || K(t, 0, p), 
            0 === K(s, u, p) && (d[h++] = s)) : s._startTime <= f && s._startTime + s.totalDuration() / s._timeScale > f && ((p || !s._initted) && f - s._startTime <= 2e-10 || (d[h++] = s)));
            for (a = h; --a > -1; ) if (s = d[a], 2 === i && s._kill(n, e, t) && (o = !0), 2 !== i || !s._firstPT && s._initted) {
                if (2 !== i && !U(s, t)) continue;
                s._enabled(!1, !1) && (o = !0);
            }
            return o;
        }, K = function(e, t, n) {
            for (var i = e._timeline, r = i._timeScale, a = e._startTime; i._timeline; ) {
                if (a += i._startTime, r *= i._timeScale, i._paused) return -100;
                i = i._timeline;
            }
            return a /= r, a > t ? a - t : n && a === t || !e._initted && a - t < 2 * l ? l : (a += e.totalDuration() / e._timeScale / r) > t + l ? 0 : a - t - l;
        };
        a._init = function() {
            var e, t, n, i, r, a = this.vars, o = this._overwrittenProps, s = this._duration, c = !!a.immediateRender, u = a.ease;
            if (a.startAt) {
                this._startAt && (this._startAt.render(-1, !0), this._startAt.kill()), r = {};
                for (i in a.startAt) r[i] = a.startAt[i];
                if (r.overwrite = !1, r.immediateRender = !0, r.lazy = c && a.lazy !== !1, r.startAt = r.delay = null, 
                this._startAt = D.to(this.target, 0, r), c) if (this._time > 0) this._startAt = null; else if (0 !== s) return;
            } else if (a.runBackwards && 0 !== s) if (this._startAt) this._startAt.render(-1, !0), 
            this._startAt.kill(), this._startAt = null; else {
                0 !== this._time && (c = !1), n = {};
                for (i in a) F[i] && "autoCSS" !== i || (n[i] = a[i]);
                if (n.overwrite = 0, n.data = "isFromStart", n.lazy = c && a.lazy !== !1, n.immediateRender = c, 
                this._startAt = D.to(this.target, 0, n), c) {
                    if (0 === this._time) return;
                } else this._startAt._init(), this._startAt._enabled(!1), this.vars.immediateRender && (this._startAt = null);
            }
            if (this._ease = u = u ? u instanceof _ ? u : "function" == typeof u ? new _(u, a.easeParams) : b[u] || D.defaultEase : D.defaultEase, 
            a.easeParams instanceof Array && u.config && (this._ease = u.config.apply(u, a.easeParams)), 
            this._easeType = this._ease._type, this._easePower = this._ease._power, this._firstPT = null, 
            this._targets) for (e = this._targets.length; --e > -1; ) this._initProps(this._targets[e], this._propLookup[e] = {}, this._siblings[e], o ? o[e] : null) && (t = !0); else t = this._initProps(this.target, this._propLookup, this._siblings, o);
            if (t && D._onPluginEvent("_onInitAllProps", this), o && (this._firstPT || "function" != typeof this.target && this._enabled(!1, !1)), 
            a.runBackwards) for (n = this._firstPT; n; ) n.s += n.c, n.c = -n.c, n = n._next;
            this._onUpdate = a.onUpdate, this._initted = !0;
        }, a._initProps = function(t, n, i, r) {
            var a, o, s, c, u, l;
            if (null == t) return !1;
            L[t._gsTweenID] && V(), this.vars.css || t.style && t !== e && t.nodeType && j.css && this.vars.autoCSS !== !1 && N(this.vars, t);
            for (a in this.vars) {
                if (l = this.vars[a], F[a]) l && (l instanceof Array || l.push && h(l)) && l.join("").indexOf("{self}") !== -1 && (this.vars[a] = l = this._swapSelfInParams(l, this)); else if (j[a] && (c = new j[a]())._onInitTween(t, this.vars[a], this)) {
                    for (this._firstPT = u = {
                        _next: this._firstPT,
                        t: c,
                        p: "setRatio",
                        s: 0,
                        c: 1,
                        f: !0,
                        n: a,
                        pg: !0,
                        pr: c._priority
                    }, o = c._overwriteProps.length; --o > -1; ) n[c._overwriteProps[o]] = this._firstPT;
                    (c._priority || c._onInitAllProps) && (s = !0), (c._onDisable || c._onEnable) && (this._notifyPluginsOfEnabled = !0);
                } else this._firstPT = n[a] = u = {
                    _next: this._firstPT,
                    t: t,
                    p: a,
                    f: "function" == typeof t[a],
                    n: a,
                    pg: !1,
                    pr: 0
                }, u.s = u.f ? t[a.indexOf("set") || "function" != typeof t["get" + a.substr(3)] ? a : "get" + a.substr(3)]() : parseFloat(t[a]), 
                u.c = "string" == typeof l && "=" === l.charAt(1) ? parseInt(l.charAt(0) + "1", 10) * Number(l.substr(2)) : Number(l) - u.s || 0;
                u && u._next && (u._next._prev = u);
            }
            return r && this._kill(r, t) ? this._initProps(t, n, i, r) : this._overwrite > 1 && this._firstPT && i.length > 1 && X(t, this, n, this._overwrite, i) ? (this._kill(n, t), 
            this._initProps(t, n, i, r)) : (this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration) && (L[t._gsTweenID] = !0), 
            s);
        }, a.render = function(e, t, n) {
            var i, r, a, o, s = this._time, c = this._duration, u = this._rawPrevTime;
            if (e >= c) this._totalTime = this._time = c, this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1, 
            this._reversed || (i = !0, r = "onComplete", n = n || this._timeline.autoRemoveChildren), 
            0 === c && (this._initted || !this.vars.lazy || n) && (this._startTime === this._timeline._duration && (e = 0), 
            (0 === e || u < 0 || u === l && "isPause" !== this.data) && u !== e && (n = !0, 
            u > l && (r = "onReverseComplete")), this._rawPrevTime = o = !t || e || u === e ? e : l); else if (e < 1e-7) this._totalTime = this._time = 0, 
            this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0, (0 !== s || 0 === c && u > 0) && (r = "onReverseComplete", 
            i = this._reversed), e < 0 && (this._active = !1, 0 === c && (this._initted || !this.vars.lazy || n) && (u >= 0 && (u !== l || "isPause" !== this.data) && (n = !0), 
            this._rawPrevTime = o = !t || e || u === e ? e : l)), this._initted || (n = !0); else if (this._totalTime = this._time = e, 
            this._easeType) {
                var f = e / c, d = this._easeType, h = this._easePower;
                (1 === d || 3 === d && f >= .5) && (f = 1 - f), 3 === d && (f *= 2), 1 === h ? f *= f : 2 === h ? f *= f * f : 3 === h ? f *= f * f * f : 4 === h && (f *= f * f * f * f), 
                1 === d ? this.ratio = 1 - f : 2 === d ? this.ratio = f : e / c < .5 ? this.ratio = f / 2 : this.ratio = 1 - f / 2;
            } else this.ratio = this._ease.getRatio(e / c);
            if (this._time !== s || n) {
                if (!this._initted) {
                    if (this._init(), !this._initted || this._gc) return;
                    if (!n && this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration)) return this._time = this._totalTime = s, 
                    this._rawPrevTime = u, z.push(this), void (this._lazy = [ e, t ]);
                    this._time && !i ? this.ratio = this._ease.getRatio(this._time / c) : i && this._ease._calcEnd && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1));
                }
                for (this._lazy !== !1 && (this._lazy = !1), this._active || !this._paused && this._time !== s && e >= 0 && (this._active = !0), 
                0 === s && (this._startAt && (e >= 0 ? this._startAt.render(e, t, n) : r || (r = "_dummyGS")), 
                this.vars.onStart && (0 === this._time && 0 !== c || t || this._callback("onStart"))), 
                a = this._firstPT; a; ) a.f ? a.t[a.p](a.c * this.ratio + a.s) : a.t[a.p] = a.c * this.ratio + a.s, 
                a = a._next;
                this._onUpdate && (e < 0 && this._startAt && e !== -1e-4 && this._startAt.render(e, t, n), 
                t || (this._time !== s || i) && this._callback("onUpdate")), r && (this._gc && !n || (e < 0 && this._startAt && !this._onUpdate && e !== -1e-4 && this._startAt.render(e, t, n), 
                i && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), 
                !t && this.vars[r] && this._callback(r), 0 === c && this._rawPrevTime === l && o !== l && (this._rawPrevTime = 0)));
            }
        }, a._kill = function(e, t, n) {
            if ("all" === e && (e = null), null == e && (null == t || t === this.target)) return this._lazy = !1, 
            this._enabled(!1, !1);
            t = "string" != typeof t ? t || this._targets || this.target : D.selector(t) || t;
            var i, r, a, o, s, c, u, l, f, d = n && this._time && n._startTime === this._startTime && this._timeline === n._timeline;
            if ((h(t) || O(t)) && "number" != typeof t[0]) for (i = t.length; --i > -1; ) this._kill(e, t[i], n) && (c = !0); else {
                if (this._targets) {
                    for (i = this._targets.length; --i > -1; ) if (t === this._targets[i]) {
                        s = this._propLookup[i] || {}, this._overwrittenProps = this._overwrittenProps || [], 
                        r = this._overwrittenProps[i] = e ? this._overwrittenProps[i] || {} : "all";
                        break;
                    }
                } else {
                    if (t !== this.target) return !1;
                    s = this._propLookup, r = this._overwrittenProps = e ? this._overwrittenProps || {} : "all";
                }
                if (s) {
                    if (u = e || s, l = e !== r && "all" !== r && e !== s && ("object" != typeof e || !e._tempKill), 
                    n && (D.onOverwrite || this.vars.onOverwrite)) {
                        for (a in u) s[a] && (f || (f = []), f.push(a));
                        if ((f || !e) && !U(this, n, t, f)) return !1;
                    }
                    for (a in u) (o = s[a]) && (d && (o.f ? o.t[o.p](o.s) : o.t[o.p] = o.s, c = !0), 
                    o.pg && o.t._kill(u) && (c = !0), o.pg && 0 !== o.t._overwriteProps.length || (o._prev ? o._prev._next = o._next : o === this._firstPT && (this._firstPT = o._next), 
                    o._next && (o._next._prev = o._prev), o._next = o._prev = null), delete s[a]), l && (r[a] = 1);
                    !this._firstPT && this._initted && this._enabled(!1, !1);
                }
            }
            return c;
        }, a.invalidate = function() {
            return this._notifyPluginsOfEnabled && D._onPluginEvent("_onDisable", this), this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null, 
            this._notifyPluginsOfEnabled = this._active = this._lazy = !1, this._propLookup = this._targets ? {} : [], 
            M.prototype.invalidate.call(this), this.vars.immediateRender && (this._time = -l, 
            this.render(-this._delay)), this;
        }, a._enabled = function(e, t) {
            if (s || o.wake(), e && this._gc) {
                var n, i = this._targets;
                if (i) for (n = i.length; --n > -1; ) this._siblings[n] = G(i[n], this, !0); else this._siblings = G(this.target, this, !0);
            }
            return M.prototype._enabled.call(this, e, t), !(!this._notifyPluginsOfEnabled || !this._firstPT) && D._onPluginEvent(e ? "_onEnable" : "_onDisable", this);
        }, D.to = function(e, t, n) {
            return new D(e, t, n);
        }, D.from = function(e, t, n) {
            return n.runBackwards = !0, n.immediateRender = 0 != n.immediateRender, new D(e, t, n);
        }, D.fromTo = function(e, t, n, i) {
            return i.startAt = n, i.immediateRender = 0 != i.immediateRender && 0 != n.immediateRender, 
            new D(e, t, i);
        }, D.delayedCall = function(e, t, n, i, r) {
            return new D(t, 0, {
                delay: e,
                onComplete: t,
                onCompleteParams: n,
                callbackScope: i,
                onReverseComplete: t,
                onReverseCompleteParams: n,
                immediateRender: !1,
                lazy: !1,
                useFrames: r,
                overwrite: 0
            });
        }, D.set = function(e, t) {
            return new D(e, 0, t);
        }, D.getTweensOf = function(e, t) {
            if (null == e) return [];
            e = "string" != typeof e ? e : D.selector(e) || e;
            var n, i, r, a;
            if ((h(e) || O(e)) && "number" != typeof e[0]) {
                for (n = e.length, i = []; --n > -1; ) i = i.concat(D.getTweensOf(e[n], t));
                for (n = i.length; --n > -1; ) for (a = i[n], r = n; --r > -1; ) a === i[r] && i.splice(n, 1);
            } else for (i = G(e).concat(), n = i.length; --n > -1; ) (i[n]._gc || t && !i[n].isActive()) && i.splice(n, 1);
            return i;
        }, D.killTweensOf = D.killDelayedCallsTo = function(e, t, n) {
            "object" == typeof t && (n = t, t = !1);
            for (var i = D.getTweensOf(e, t), r = i.length; --r > -1; ) i[r]._kill(n, e);
        };
        var $ = v("plugins.TweenPlugin", function(e, t) {
            this._overwriteProps = (e || "").split(","), this._propName = this._overwriteProps[0], 
            this._priority = t || 0, this._super = $.prototype;
        }, !0);
        if (a = $.prototype, $.version = "1.10.1", $.API = 2, a._firstPT = null, a._addTween = function(e, t, n, i, r, a) {
            var o, s;
            if (null != i && (o = "number" == typeof i || "=" !== i.charAt(1) ? Number(i) - Number(n) : parseInt(i.charAt(0) + "1", 10) * Number(i.substr(2)))) return this._firstPT = s = {
                _next: this._firstPT,
                t: e,
                p: t,
                s: n,
                c: o,
                f: "function" == typeof e[t],
                n: r || t,
                r: a
            }, s._next && (s._next._prev = s), s;
        }, a.setRatio = function(e) {
            for (var t, n = this._firstPT, i = 1e-6; n; ) t = n.c * e + n.s, n.r ? t = Math.round(t) : t < i && t > -i && (t = 0), 
            n.f ? n.t[n.p](t) : n.t[n.p] = t, n = n._next;
        }, a._kill = function(e) {
            var t, n = this._overwriteProps, i = this._firstPT;
            if (null != e[this._propName]) this._overwriteProps = []; else for (t = n.length; --t > -1; ) null != e[n[t]] && n.splice(t, 1);
            for (;i; ) null != e[i.n] && (i._next && (i._next._prev = i._prev), i._prev ? (i._prev._next = i._next, 
            i._prev = null) : this._firstPT === i && (this._firstPT = i._next)), i = i._next;
            return !1;
        }, a._roundProps = function(e, t) {
            for (var n = this._firstPT; n; ) (e[this._propName] || null != n.n && e[n.n.split(this._propName + "_").join("")]) && (n.r = t), 
            n = n._next;
        }, D._onPluginEvent = function(e, t) {
            var n, i, r, a, o, s = t._firstPT;
            if ("_onInitAllProps" === e) {
                for (;s; ) {
                    for (o = s._next, i = r; i && i.pr > s.pr; ) i = i._next;
                    (s._prev = i ? i._prev : a) ? s._prev._next = s : r = s, (s._next = i) ? i._prev = s : a = s, 
                    s = o;
                }
                s = t._firstPT = r;
            }
            for (;s; ) s.pg && "function" == typeof s.t[e] && s.t[e]() && (n = !0), s = s._next;
            return n;
        }, $.activate = function(e) {
            for (var t = e.length; --t > -1; ) e[t].API === $.API && (j[new e[t]()._propName] = e[t]);
            return !0;
        }, g.plugin = function(e) {
            if (!(e && e.propName && e.init && e.API)) throw "illegal plugin definition.";
            var t, n = e.propName, i = e.priority || 0, r = e.overwriteProps, a = {
                init: "_onInitTween",
                set: "setRatio",
                kill: "_kill",
                round: "_roundProps",
                initAll: "_onInitAllProps"
            }, o = v("plugins." + n.charAt(0).toUpperCase() + n.substr(1) + "Plugin", function() {
                $.call(this, n, i), this._overwriteProps = r || [];
            }, e.global === !0), s = o.prototype = new $(n);
            s.constructor = o, o.API = e.API;
            for (t in a) "function" == typeof e[t] && (s[a[t]] = e[t]);
            return o.version = e.version, $.activate([ o ]), o;
        }, i = e._gsQueue) {
            for (r = 0; r < i.length; r++) i[r]();
            for (a in p) p[a].func || e.console.log("GSAP encountered missing dependency: com.greensock." + a);
        }
        s = !1;
    }
}("undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window, "TweenLite"), 
function(e) {
    function t(e) {
        e = e || {}, this.settings = e, null == e.statusInterval && (e.statusInterval = 5e3), 
        null == e.loggingDelay && (e.loggingDelay = 2e4), null == e.noProgressTimeout && (e.noProgressTimeout = 1 / 0);
        var t, i = [], r = [], a = Date.now(), o = {
            QUEUED: 0,
            WAITING: 1,
            LOADED: 2,
            ERROR: 3,
            TIMEOUT: 4
        }, s = function(e) {
            return null == e ? [] : Array.isArray(e) ? e : [ e ];
        };
        this.add = function(e) {
            e.tags = new n(e.tags), null == e.priority && (e.priority = 1 / 0), i.push({
                resource: e,
                status: o.QUEUED
            });
        }, this.addProgressListener = function(e, t) {
            r.push({
                callback: e,
                tags: new n(t)
            });
        }, this.addCompletionListener = function(e, t) {
            r.push({
                tags: new n(t),
                callback: function(t) {
                    t.completedCount === t.totalCount && e(t);
                }
            });
        };
        var c = function(e) {
            e = s(e);
            var t = function(t) {
                for (var n = t.resource, i = 1 / 0, r = 0; r < n.tags.length; r++) for (var a = 0; a < Math.min(e.length, i) && !(n.tags.all[r] === e[a] && a < i && (i = a, 
                0 === i)) && 0 !== i; a++) ;
                return i;
            };
            return function(e, n) {
                var i = t(e), r = t(n);
                return i < r ? -1 : i > r ? 1 : e.priority < n.priority ? -1 : e.priority > n.priority ? 1 : 0;
            };
        };
        this.start = function(e) {
            t = Date.now();
            var n = c(e);
            i.sort(n);
            for (var r = 0, a = i.length; r < a; r++) {
                var s = i[r];
                s.status = o.WAITING, s.resource.start(this);
            }
            setTimeout(u, 100);
        };
        var u = function() {
            for (var t = !1, n = Date.now() - a, r = n >= e.noProgressTimeout, s = n >= e.loggingDelay, c = 0, l = i.length; c < l; c++) {
                var f = i[c];
                f.status === o.WAITING && (f.resource.checkStatus && f.resource.checkStatus(), f.status === o.WAITING && (r ? f.resource.onTimeout() : t = !0));
            }
            s && t && d(), t && setTimeout(u, e.statusInterval);
        };
        this.isBusy = function() {
            for (var e = 0, t = i.length; e < t; e++) if (i[e].status === o.QUEUED || i[e].status === o.WAITING) return !0;
            return !1;
        };
        var l = function(e, t) {
            var n, s, c, u, l, d = null;
            for (n = 0, s = i.length; n < s; n++) if (i[n].resource === e) {
                d = i[n];
                break;
            }
            if (null != d && d.status === o.WAITING) for (d.status = t, a = Date.now(), c = e.tags.length, 
            n = 0, s = r.length; n < s; n++) u = r[n], l = 0 === u.tags.length || e.tags.intersects(u.tags), 
            l && f(d, u);
        };
        this.onLoad = function(e) {
            l(e, o.LOADED);
        }, this.onError = function(e) {
            l(e, o.ERROR);
        }, this.onTimeout = function(e) {
            l(e, o.TIMEOUT);
        };
        var f = function(e, t) {
            var n, r, a, s, c = 0, u = 0;
            for (n = 0, r = i.length; n < r; n++) a = i[n], s = !1, s = 0 === t.tags.length || a.resource.tags.intersects(t.tags), 
            s && (u++, a.status !== o.LOADED && a.status !== o.ERROR && a.status !== o.TIMEOUT || c++);
            t.callback({
                resource: e.resource,
                loaded: e.status === o.LOADED,
                error: e.status === o.ERROR,
                timeout: e.status === o.TIMEOUT,
                completedCount: c,
                totalCount: u
            });
        }, d = this.log = function(e) {
            if (window.console) {
                var n = Math.round((Date.now() - t) / 1e3);
                window.console.log("PxLoader elapsed: " + n + " sec");
                for (var r = 0, a = i.length; r < a; r++) {
                    var s = i[r];
                    if (e || s.status === o.WAITING) {
                        var c = "PxLoader: #" + r + " " + s.resource.getName();
                        switch (s.status) {
                          case o.QUEUED:
                            c += " (Not Started)";
                            break;

                          case o.WAITING:
                            c += " (Waiting)";
                            break;

                          case o.LOADED:
                            c += " (Loaded)";
                            break;

                          case o.ERROR:
                            c += " (Error)";
                            break;

                          case o.TIMEOUT:
                            c += " (Timeout)";
                        }
                        s.resource.tags.length > 0 && (c += " Tags: [" + s.resource.tags.all.join(",") + "]"), 
                        window.console.log(c);
                    }
                }
            }
        };
    }
    function n(e) {
        if (this.all = [], this.first = null, this.length = 0, this.lookup = {}, e) {
            if (Array.isArray(e)) this.all = e.slice(0); else if ("object" == typeof e) for (var t in e) e.hasOwnProperty(t) && this.all.push(t); else this.all.push(e);
            this.length = this.all.length, this.length > 0 && (this.first = this.all[0]);
            for (var n = 0; n < this.length; n++) this.lookup[this.all[n]] = !0;
        }
    }
    n.prototype.intersects = function(e) {
        if (0 === this.length || 0 === e.length) return !1;
        if (1 === this.length && 1 === e.length) return this.first === e.first;
        if (e.length < this.length) return e.intersects(this);
        for (var t in this.lookup) if (e.lookup[t]) return !0;
        return !1;
    }, "function" == typeof define && define.amd && define("PxLoader", [], function() {
        return t;
    }), e.PxLoader = t;
}(this), Date.now || (Date.now = function() {
    return new Date().getTime();
}), Array.isArray || (Array.isArray = function(e) {
    return "[object Array]" === Object.prototype.toString.call(e);
}), PxLoader.prototype.addImage = function(e, t, n, i) {
    var r = new PxLoaderImage(e, t, n, i);
    return this.add(r), r.img;
}, "function" == typeof define && define.amd && define("PxLoaderImage", [], function() {
    return PxLoaderImage;
});